import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int'];
};

export type AggregateBankDetail = {
  __typename?: 'AggregateBankDetail';
  _avg?: Maybe<BankDetailAvgAggregate>;
  _count?: Maybe<BankDetailCountAggregate>;
  _max?: Maybe<BankDetailMaxAggregate>;
  _min?: Maybe<BankDetailMinAggregate>;
  _sum?: Maybe<BankDetailSumAggregate>;
};

export type AggregateBenefeciary = {
  __typename?: 'AggregateBenefeciary';
  _avg?: Maybe<BenefeciaryAvgAggregate>;
  _count?: Maybe<BenefeciaryCountAggregate>;
  _max?: Maybe<BenefeciaryMaxAggregate>;
  _min?: Maybe<BenefeciaryMinAggregate>;
  _sum?: Maybe<BenefeciarySumAggregate>;
};

export type AggregateBeneficiaryCertificate = {
  __typename?: 'AggregateBeneficiaryCertificate';
  _avg?: Maybe<BeneficiaryCertificateAvgAggregate>;
  _count?: Maybe<BeneficiaryCertificateCountAggregate>;
  _max?: Maybe<BeneficiaryCertificateMaxAggregate>;
  _min?: Maybe<BeneficiaryCertificateMinAggregate>;
  _sum?: Maybe<BeneficiaryCertificateSumAggregate>;
};

export type AggregateBranch = {
  __typename?: 'AggregateBranch';
  _avg?: Maybe<BranchAvgAggregate>;
  _count?: Maybe<BranchCountAggregate>;
  _max?: Maybe<BranchMaxAggregate>;
  _min?: Maybe<BranchMinAggregate>;
  _sum?: Maybe<BranchSumAggregate>;
};

export type AggregateCaFirm = {
  __typename?: 'AggregateCAFirm';
  _avg?: Maybe<CaFirmAvgAggregate>;
  _count?: Maybe<CaFirmCountAggregate>;
  _max?: Maybe<CaFirmMaxAggregate>;
  _min?: Maybe<CaFirmMinAggregate>;
  _sum?: Maybe<CaFirmSumAggregate>;
};

export type AggregateCompany = {
  __typename?: 'AggregateCompany';
  _avg?: Maybe<CompanyAvgAggregate>;
  _count?: Maybe<CompanyCountAggregate>;
  _max?: Maybe<CompanyMaxAggregate>;
  _min?: Maybe<CompanyMinAggregate>;
  _sum?: Maybe<CompanySumAggregate>;
};

export type AggregateDocument = {
  __typename?: 'AggregateDocument';
  _avg?: Maybe<DocumentAvgAggregate>;
  _count?: Maybe<DocumentCountAggregate>;
  _max?: Maybe<DocumentMaxAggregate>;
  _min?: Maybe<DocumentMinAggregate>;
  _sum?: Maybe<DocumentSumAggregate>;
};

export type AggregateEvents = {
  __typename?: 'AggregateEvents';
  _avg?: Maybe<EventsAvgAggregate>;
  _count?: Maybe<EventsCountAggregate>;
  _max?: Maybe<EventsMaxAggregate>;
  _min?: Maybe<EventsMinAggregate>;
  _sum?: Maybe<EventsSumAggregate>;
};

export type AggregateFile = {
  __typename?: 'AggregateFile';
  _avg?: Maybe<FileAvgAggregate>;
  _count?: Maybe<FileCountAggregate>;
  _max?: Maybe<FileMaxAggregate>;
  _min?: Maybe<FileMinAggregate>;
  _sum?: Maybe<FileSumAggregate>;
};

export type AggregateFolioNumber = {
  __typename?: 'AggregateFolioNumber';
  _avg?: Maybe<FolioNumberAvgAggregate>;
  _count?: Maybe<FolioNumberCountAggregate>;
  _max?: Maybe<FolioNumberMaxAggregate>;
  _min?: Maybe<FolioNumberMinAggregate>;
  _sum?: Maybe<FolioNumberSumAggregate>;
};

export type AggregateForm15Caa = {
  __typename?: 'AggregateForm15CAA';
  _avg?: Maybe<Form15CaaAvgAggregate>;
  _count?: Maybe<Form15CaaCountAggregate>;
  _max?: Maybe<Form15CaaMaxAggregate>;
  _min?: Maybe<Form15CaaMinAggregate>;
  _sum?: Maybe<Form15CaaSumAggregate>;
};

export type AggregateForm15Cab = {
  __typename?: 'AggregateForm15CAB';
  _avg?: Maybe<Form15CabAvgAggregate>;
  _count?: Maybe<Form15CabCountAggregate>;
  _max?: Maybe<Form15CabMaxAggregate>;
  _min?: Maybe<Form15CabMinAggregate>;
  _sum?: Maybe<Form15CabSumAggregate>;
};

export type AggregateForm15Cac = {
  __typename?: 'AggregateForm15CAC';
  _avg?: Maybe<Form15CacAvgAggregate>;
  _count?: Maybe<Form15CacCountAggregate>;
  _max?: Maybe<Form15CacMaxAggregate>;
  _min?: Maybe<Form15CacMinAggregate>;
  _sum?: Maybe<Form15CacSumAggregate>;
};

export type AggregateForm15Cad = {
  __typename?: 'AggregateForm15CAD';
  _avg?: Maybe<Form15CadAvgAggregate>;
  _count?: Maybe<Form15CadCountAggregate>;
  _max?: Maybe<Form15CadMaxAggregate>;
  _min?: Maybe<Form15CadMinAggregate>;
  _sum?: Maybe<Form15CadSumAggregate>;
};

export type AggregateForm15Cb = {
  __typename?: 'AggregateForm15CB';
  _avg?: Maybe<Form15CbAvgAggregate>;
  _count?: Maybe<Form15CbCountAggregate>;
  _max?: Maybe<Form15CbMaxAggregate>;
  _min?: Maybe<Form15CbMinAggregate>;
  _sum?: Maybe<Form15CbSumAggregate>;
};

export type AggregateGroup = {
  __typename?: 'AggregateGroup';
  _avg?: Maybe<GroupAvgAggregate>;
  _count?: Maybe<GroupCountAggregate>;
  _max?: Maybe<GroupMaxAggregate>;
  _min?: Maybe<GroupMinAggregate>;
  _sum?: Maybe<GroupSumAggregate>;
};

export type AggregateRequest = {
  __typename?: 'AggregateRequest';
  _avg?: Maybe<RequestAvgAggregate>;
  _count?: Maybe<RequestCountAggregate>;
  _max?: Maybe<RequestMaxAggregate>;
  _min?: Maybe<RequestMinAggregate>;
  _sum?: Maybe<RequestSumAggregate>;
};

export type AggregateUdin = {
  __typename?: 'AggregateUdin';
  _avg?: Maybe<UdinAvgAggregate>;
  _count?: Maybe<UdinCountAggregate>;
  _max?: Maybe<UdinMaxAggregate>;
  _min?: Maybe<UdinMinAggregate>;
  _sum?: Maybe<UdinSumAggregate>;
};

export type AggregateUser = {
  __typename?: 'AggregateUser';
  _avg?: Maybe<UserAvgAggregate>;
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
  _sum?: Maybe<UserSumAggregate>;
};

export type AggregateUserAccess = {
  __typename?: 'AggregateUserAccess';
  _avg?: Maybe<UserAccessAvgAggregate>;
  _count?: Maybe<UserAccessCountAggregate>;
  _max?: Maybe<UserAccessMaxAggregate>;
  _min?: Maybe<UserAccessMinAggregate>;
  _sum?: Maybe<UserAccessSumAggregate>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token: Scalars['String'];
  user: User;
};

export type BankDetail = {
  __typename?: 'BankDetail';
  AccountNumber: Scalars['String'];
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<Branch>;
  BranchId?: Maybe<Scalars['Int']>;
  Company?: Maybe<Company>;
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy: Scalars['Int'];
  Form15CAA: Array<Form15Caa>;
  Form15CAB: Array<Form15Cab>;
  Form15CAC: Array<Form15Cac>;
  Form15CAD: Array<Form15Cad>;
  Form15CB: Array<Form15Cb>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  _count?: Maybe<BankDetailCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type BankDetailForm15CaaArgs = {
  cursor?: Maybe<Form15CaaWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CaaScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CaaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CaaWhereInput>;
};


export type BankDetailForm15CabArgs = {
  cursor?: Maybe<Form15CabWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CabScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CabOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CabWhereInput>;
};


export type BankDetailForm15CacArgs = {
  cursor?: Maybe<Form15CacWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CacScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CacOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CacWhereInput>;
};


export type BankDetailForm15CadArgs = {
  cursor?: Maybe<Form15CadWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CadScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CadOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CadWhereInput>;
};


export type BankDetailForm15CbArgs = {
  cursor?: Maybe<Form15CbWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CbScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CbOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CbWhereInput>;
};

export type BankDetailAvgAggregate = {
  __typename?: 'BankDetailAvgAggregate';
  BranchId?: Maybe<Scalars['Float']>;
  CompanyId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type BankDetailAvgOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BankDetailCount = {
  __typename?: 'BankDetailCount';
  Form15CAA: Scalars['Int'];
  Form15CAB: Scalars['Int'];
  Form15CAC: Scalars['Int'];
  Form15CAD: Scalars['Int'];
  Form15CB: Scalars['Int'];
};

export type BankDetailCountAggregate = {
  __typename?: 'BankDetailCountAggregate';
  AccountNumber: Scalars['Int'];
  AuthDealer: Scalars['Int'];
  BSRCode: Scalars['Int'];
  BankBranch: Scalars['Int'];
  BankName: Scalars['Int'];
  BranchId: Scalars['Int'];
  CompanyId: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ifsc: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BankDetailCountOrderByAggregateInput = {
  AccountNumber?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankBranch?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BankDetailCreateInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBankDetailInput>;
  Company?: Maybe<CompanyCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBankDetailInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBankDetailInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBankDetailInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBankDetailInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateManyBranchInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy: Scalars['Int'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateManyBranchInputEnvelope = {
  data: Array<BankDetailCreateManyBranchInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BankDetailCreateManyCompanyInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  BranchId?: Maybe<Scalars['Int']>;
  CreatedBy: Scalars['Int'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateManyCompanyInputEnvelope = {
  data: Array<BankDetailCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BankDetailCreateManyInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy: Scalars['Int'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateNestedManyWithoutBranchInput = {
  connect?: Maybe<Array<BankDetailWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BankDetailCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<BankDetailCreateWithoutBranchInput>>;
  createMany?: Maybe<BankDetailCreateManyBranchInputEnvelope>;
};

export type BankDetailCreateNestedManyWithoutCompanyInput = {
  connect?: Maybe<Array<BankDetailWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BankDetailCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<BankDetailCreateWithoutCompanyInput>>;
  createMany?: Maybe<BankDetailCreateManyCompanyInputEnvelope>;
};

export type BankDetailCreateNestedOneWithoutForm15CaaInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CaaInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CaaInput>;
};

export type BankDetailCreateNestedOneWithoutForm15CabInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CabInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CabInput>;
};

export type BankDetailCreateNestedOneWithoutForm15CacInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CacInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CacInput>;
};

export type BankDetailCreateNestedOneWithoutForm15CadInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CadInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CadInput>;
};

export type BankDetailCreateNestedOneWithoutForm15CbInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CbInput>;
};

export type BankDetailCreateOrConnectWithoutBranchInput = {
  create: BankDetailCreateWithoutBranchInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailCreateOrConnectWithoutCompanyInput = {
  create: BankDetailCreateWithoutCompanyInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailCreateOrConnectWithoutForm15CaaInput = {
  create: BankDetailCreateWithoutForm15CaaInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailCreateOrConnectWithoutForm15CabInput = {
  create: BankDetailCreateWithoutForm15CabInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailCreateOrConnectWithoutForm15CacInput = {
  create: BankDetailCreateWithoutForm15CacInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailCreateOrConnectWithoutForm15CadInput = {
  create: BankDetailCreateWithoutForm15CadInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailCreateOrConnectWithoutForm15CbInput = {
  create: BankDetailCreateWithoutForm15CbInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailCreateWithoutBranchInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBankDetailInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBankDetailInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBankDetailInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBankDetailInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateWithoutCompanyInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBankDetailInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBankDetailInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBankDetailInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBankDetailInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateWithoutForm15CaaInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBankDetailInput>;
  Company?: Maybe<CompanyCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBankDetailInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBankDetailInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBankDetailInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateWithoutForm15CabInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBankDetailInput>;
  Company?: Maybe<CompanyCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBankDetailInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBankDetailInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBankDetailInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateWithoutForm15CacInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBankDetailInput>;
  Company?: Maybe<CompanyCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBankDetailInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBankDetailInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBankDetailInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateWithoutForm15CadInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBankDetailInput>;
  Company?: Maybe<CompanyCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBankDetailInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBankDetailInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBankDetailInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailCreateWithoutForm15CbInput = {
  AccountNumber: Scalars['String'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBankDetailInput>;
  Company?: Maybe<CompanyCreateNestedOneWithoutBankDetailInput>;
  CreatedBy: Scalars['Int'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBankDetailInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBankDetailInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBankDetailInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBankDetailInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailGroupBy = {
  __typename?: 'BankDetailGroupBy';
  AccountNumber: Scalars['String'];
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankBranch: Scalars['String'];
  BankName: Scalars['String'];
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy: Scalars['Int'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  _avg?: Maybe<BankDetailAvgAggregate>;
  _count?: Maybe<BankDetailCountAggregate>;
  _max?: Maybe<BankDetailMaxAggregate>;
  _min?: Maybe<BankDetailMinAggregate>;
  _sum?: Maybe<BankDetailSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BankDetailListRelationFilter = {
  every?: Maybe<BankDetailWhereInput>;
  none?: Maybe<BankDetailWhereInput>;
  some?: Maybe<BankDetailWhereInput>;
};

export type BankDetailMaxAggregate = {
  __typename?: 'BankDetailMaxAggregate';
  AccountNumber?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankBranch?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailMaxOrderByAggregateInput = {
  AccountNumber?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankBranch?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BankDetailMinAggregate = {
  __typename?: 'BankDetailMinAggregate';
  AccountNumber?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankBranch?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BankDetailMinOrderByAggregateInput = {
  AccountNumber?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankBranch?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BankDetailOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BankDetailOrderByWithAggregationInput = {
  AccountNumber?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankBranch?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  _avg?: Maybe<BankDetailAvgOrderByAggregateInput>;
  _count?: Maybe<BankDetailCountOrderByAggregateInput>;
  _max?: Maybe<BankDetailMaxOrderByAggregateInput>;
  _min?: Maybe<BankDetailMinOrderByAggregateInput>;
  _sum?: Maybe<BankDetailSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BankDetailOrderByWithRelationInput = {
  AccountNumber?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankBranch?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  Branch?: Maybe<BranchOrderByWithRelationInput>;
  BranchId?: Maybe<SortOrder>;
  Company?: Maybe<CompanyOrderByWithRelationInput>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Form15CAA?: Maybe<Form15CaaOrderByRelationAggregateInput>;
  Form15CAB?: Maybe<Form15CabOrderByRelationAggregateInput>;
  Form15CAC?: Maybe<Form15CacOrderByRelationAggregateInput>;
  Form15CAD?: Maybe<Form15CadOrderByRelationAggregateInput>;
  Form15CB?: Maybe<Form15CbOrderByRelationAggregateInput>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BankDetailRelationFilter = {
  is?: Maybe<BankDetailWhereInput>;
  isNot?: Maybe<BankDetailWhereInput>;
};

export enum BankDetailScalarFieldEnum {
  AccountNumber = 'AccountNumber',
  AuthDealer = 'AuthDealer',
  BsrCode = 'BSRCode',
  BankBranch = 'BankBranch',
  BankName = 'BankName',
  BranchId = 'BranchId',
  CompanyId = 'CompanyId',
  CreatedBy = 'CreatedBy',
  UpdatedBy = 'UpdatedBy',
  CreatedAt = 'createdAt',
  Id = 'id',
  Ifsc = 'ifsc',
  UpdatedAt = 'updatedAt'
}

export type BankDetailScalarWhereInput = {
  AND?: Maybe<Array<BankDetailScalarWhereInput>>;
  AccountNumber?: Maybe<StringFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankBranch?: Maybe<StringFilter>;
  BankName?: Maybe<StringFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  CompanyId?: Maybe<IntNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  NOT?: Maybe<Array<BankDetailScalarWhereInput>>;
  OR?: Maybe<Array<BankDetailScalarWhereInput>>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BankDetailScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BankDetailScalarWhereWithAggregatesInput>>;
  AccountNumber?: Maybe<StringWithAggregatesFilter>;
  AuthDealer?: Maybe<StringWithAggregatesFilter>;
  BSRCode?: Maybe<StringWithAggregatesFilter>;
  BankBranch?: Maybe<StringWithAggregatesFilter>;
  BankName?: Maybe<StringWithAggregatesFilter>;
  BranchId?: Maybe<IntNullableWithAggregatesFilter>;
  CompanyId?: Maybe<IntNullableWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  NOT?: Maybe<Array<BankDetailScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BankDetailScalarWhereWithAggregatesInput>>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  ifsc?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BankDetailSumAggregate = {
  __typename?: 'BankDetailSumAggregate';
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type BankDetailSumOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BankDetailUpdateInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBankDetailNestedInput>;
  Company?: Maybe<CompanyUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBankDetailNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBankDetailNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBankDetailNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBankDetailNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateManyMutationInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateManyWithWhereWithoutBranchInput = {
  data: BankDetailUpdateManyMutationInput;
  where: BankDetailScalarWhereInput;
};

export type BankDetailUpdateManyWithWhereWithoutCompanyInput = {
  data: BankDetailUpdateManyMutationInput;
  where: BankDetailScalarWhereInput;
};

export type BankDetailUpdateManyWithoutBranchNestedInput = {
  connect?: Maybe<Array<BankDetailWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BankDetailCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<BankDetailCreateWithoutBranchInput>>;
  createMany?: Maybe<BankDetailCreateManyBranchInputEnvelope>;
  delete?: Maybe<Array<BankDetailWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BankDetailScalarWhereInput>>;
  disconnect?: Maybe<Array<BankDetailWhereUniqueInput>>;
  set?: Maybe<Array<BankDetailWhereUniqueInput>>;
  update?: Maybe<Array<BankDetailUpdateWithWhereUniqueWithoutBranchInput>>;
  updateMany?: Maybe<Array<BankDetailUpdateManyWithWhereWithoutBranchInput>>;
  upsert?: Maybe<Array<BankDetailUpsertWithWhereUniqueWithoutBranchInput>>;
};

export type BankDetailUpdateManyWithoutCompanyNestedInput = {
  connect?: Maybe<Array<BankDetailWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BankDetailCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<BankDetailCreateWithoutCompanyInput>>;
  createMany?: Maybe<BankDetailCreateManyCompanyInputEnvelope>;
  delete?: Maybe<Array<BankDetailWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BankDetailScalarWhereInput>>;
  disconnect?: Maybe<Array<BankDetailWhereUniqueInput>>;
  set?: Maybe<Array<BankDetailWhereUniqueInput>>;
  update?: Maybe<Array<BankDetailUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<BankDetailUpdateManyWithWhereWithoutCompanyInput>>;
  upsert?: Maybe<Array<BankDetailUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type BankDetailUpdateOneRequiredWithoutForm15CaaNestedInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CaaInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CaaInput>;
  update?: Maybe<BankDetailUpdateWithoutForm15CaaInput>;
  upsert?: Maybe<BankDetailUpsertWithoutForm15CaaInput>;
};

export type BankDetailUpdateOneRequiredWithoutForm15CabNestedInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CabInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CabInput>;
  update?: Maybe<BankDetailUpdateWithoutForm15CabInput>;
  upsert?: Maybe<BankDetailUpsertWithoutForm15CabInput>;
};

export type BankDetailUpdateOneRequiredWithoutForm15CacNestedInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CacInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CacInput>;
  update?: Maybe<BankDetailUpdateWithoutForm15CacInput>;
  upsert?: Maybe<BankDetailUpsertWithoutForm15CacInput>;
};

export type BankDetailUpdateOneRequiredWithoutForm15CadNestedInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CadInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CadInput>;
  update?: Maybe<BankDetailUpdateWithoutForm15CadInput>;
  upsert?: Maybe<BankDetailUpsertWithoutForm15CadInput>;
};

export type BankDetailUpdateOneRequiredWithoutForm15CbNestedInput = {
  connect?: Maybe<BankDetailWhereUniqueInput>;
  connectOrCreate?: Maybe<BankDetailCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<BankDetailCreateWithoutForm15CbInput>;
  update?: Maybe<BankDetailUpdateWithoutForm15CbInput>;
  upsert?: Maybe<BankDetailUpsertWithoutForm15CbInput>;
};

export type BankDetailUpdateWithWhereUniqueWithoutBranchInput = {
  data: BankDetailUpdateWithoutBranchInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailUpdateWithWhereUniqueWithoutCompanyInput = {
  data: BankDetailUpdateWithoutCompanyInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailUpdateWithoutBranchInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBankDetailNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBankDetailNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBankDetailNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBankDetailNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateWithoutCompanyInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBankDetailNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBankDetailNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBankDetailNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBankDetailNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateWithoutForm15CaaInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBankDetailNestedInput>;
  Company?: Maybe<CompanyUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBankDetailNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBankDetailNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBankDetailNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateWithoutForm15CabInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBankDetailNestedInput>;
  Company?: Maybe<CompanyUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBankDetailNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBankDetailNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBankDetailNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateWithoutForm15CacInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBankDetailNestedInput>;
  Company?: Maybe<CompanyUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBankDetailNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBankDetailNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBankDetailNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateWithoutForm15CadInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBankDetailNestedInput>;
  Company?: Maybe<CompanyUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBankDetailNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBankDetailNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBankDetailNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpdateWithoutForm15CbInput = {
  AccountNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankBranch?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBankDetailNestedInput>;
  Company?: Maybe<CompanyUpdateOneWithoutBankDetailNestedInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBankDetailNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBankDetailNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBankDetailNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBankDetailNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BankDetailUpsertWithWhereUniqueWithoutBranchInput = {
  create: BankDetailCreateWithoutBranchInput;
  update: BankDetailUpdateWithoutBranchInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailUpsertWithWhereUniqueWithoutCompanyInput = {
  create: BankDetailCreateWithoutCompanyInput;
  update: BankDetailUpdateWithoutCompanyInput;
  where: BankDetailWhereUniqueInput;
};

export type BankDetailUpsertWithoutForm15CaaInput = {
  create: BankDetailCreateWithoutForm15CaaInput;
  update: BankDetailUpdateWithoutForm15CaaInput;
};

export type BankDetailUpsertWithoutForm15CabInput = {
  create: BankDetailCreateWithoutForm15CabInput;
  update: BankDetailUpdateWithoutForm15CabInput;
};

export type BankDetailUpsertWithoutForm15CacInput = {
  create: BankDetailCreateWithoutForm15CacInput;
  update: BankDetailUpdateWithoutForm15CacInput;
};

export type BankDetailUpsertWithoutForm15CadInput = {
  create: BankDetailCreateWithoutForm15CadInput;
  update: BankDetailUpdateWithoutForm15CadInput;
};

export type BankDetailUpsertWithoutForm15CbInput = {
  create: BankDetailCreateWithoutForm15CbInput;
  update: BankDetailUpdateWithoutForm15CbInput;
};

export type BankDetailWhereInput = {
  AND?: Maybe<Array<BankDetailWhereInput>>;
  AccountNumber?: Maybe<StringFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankBranch?: Maybe<StringFilter>;
  BankName?: Maybe<StringFilter>;
  Branch?: Maybe<BranchRelationFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  Company?: Maybe<CompanyRelationFilter>;
  CompanyId?: Maybe<IntNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Form15CAA?: Maybe<Form15CaaListRelationFilter>;
  Form15CAB?: Maybe<Form15CabListRelationFilter>;
  Form15CAC?: Maybe<Form15CacListRelationFilter>;
  Form15CAD?: Maybe<Form15CadListRelationFilter>;
  Form15CB?: Maybe<Form15CbListRelationFilter>;
  NOT?: Maybe<Array<BankDetailWhereInput>>;
  OR?: Maybe<Array<BankDetailWhereInput>>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BankDetailWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type Benefeciary = {
  __typename?: 'Benefeciary';
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<Branch>;
  BranchId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates: Array<BeneficiaryCertificate>;
  City: Scalars['String'];
  Company: Company;
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document: Array<Document>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers: Array<FolioNumber>;
  Form15CAA: Array<Form15Caa>;
  Form15CAB: Array<Form15Cab>;
  Form15CAC: Array<Form15Cac>;
  Form15CAD: Array<Form15Cad>;
  Form15CB: Array<Form15Cb>;
  Group: Group;
  GroupId: Scalars['Int'];
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner: Scalars['Boolean'];
  IsBussinessDeclaration: Scalars['Boolean'];
  IsCerticateObtained: Scalars['Boolean'];
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request: Array<Request>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable: Scalars['Boolean'];
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  _count?: Maybe<BenefeciaryCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type BenefeciaryCertificatesArgs = {
  cursor?: Maybe<BeneficiaryCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<BeneficiaryCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<BeneficiaryCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BeneficiaryCertificateWhereInput>;
};


export type BenefeciaryDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type BenefeciaryFolioNumbersArgs = {
  cursor?: Maybe<FolioNumberWhereUniqueInput>;
  distinct?: Maybe<Array<FolioNumberScalarFieldEnum>>;
  orderBy?: Maybe<Array<FolioNumberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FolioNumberWhereInput>;
};


export type BenefeciaryForm15CaaArgs = {
  cursor?: Maybe<Form15CaaWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CaaScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CaaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CaaWhereInput>;
};


export type BenefeciaryForm15CabArgs = {
  cursor?: Maybe<Form15CabWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CabScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CabOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CabWhereInput>;
};


export type BenefeciaryForm15CacArgs = {
  cursor?: Maybe<Form15CacWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CacScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CacOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CacWhereInput>;
};


export type BenefeciaryForm15CadArgs = {
  cursor?: Maybe<Form15CadWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CadScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CadOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CadWhereInput>;
};


export type BenefeciaryForm15CbArgs = {
  cursor?: Maybe<Form15CbWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CbScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CbOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CbWhereInput>;
};


export type BenefeciaryRequestArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  distinct?: Maybe<Array<RequestScalarFieldEnum>>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};

export type BenefeciaryAvgAggregate = {
  __typename?: 'BenefeciaryAvgAggregate';
  BranchId?: Maybe<Scalars['Float']>;
  CompanyId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  GroupId?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type BenefeciaryAvgOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BenefeciaryCount = {
  __typename?: 'BenefeciaryCount';
  Certificates: Scalars['Int'];
  Document: Scalars['Int'];
  FolioNumbers: Scalars['Int'];
  Form15CAA: Scalars['Int'];
  Form15CAB: Scalars['Int'];
  Form15CAC: Scalars['Int'];
  Form15CAD: Scalars['Int'];
  Form15CB: Scalars['Int'];
  Request: Scalars['Int'];
};

export type BenefeciaryCountAggregate = {
  __typename?: 'BenefeciaryCountAggregate';
  AccountNumber: Scalars['Int'];
  BankAddress: Scalars['Int'];
  BankName: Scalars['Int'];
  BenefeciaryEmail: Scalars['Int'];
  BenefeciaryName: Scalars['Int'];
  BenefeciaryPhone: Scalars['Int'];
  BenefeciaryPrefix: Scalars['Int'];
  BenefeciaryStatus: Scalars['Int'];
  BranchId: Scalars['Int'];
  Building: Scalars['Int'];
  BusinessPlace: Scalars['Int'];
  City: Scalars['Int'];
  CompanyId: Scalars['Int'];
  Country: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  DocumentDate10F: Scalars['Int'];
  DocumentValidTill10F: Scalars['Int'];
  Flat: Scalars['Int'];
  GroupId: Scalars['Int'];
  Is10FAvailable: Scalars['Int'];
  IsBenefeciaryOwner: Scalars['Int'];
  IsBussinessDeclaration: Scalars['Int'];
  IsCerticateObtained: Scalars['Int'];
  Locality: Scalars['Int'];
  OtherCountry: Scalars['Int'];
  PAN: Scalars['Int'];
  PEDocumentDate: Scalars['Int'];
  PEDocumentValidFrom: Scalars['Int'];
  PEDocumentValidTill: Scalars['Int'];
  PPTClauseSatisfied: Scalars['Int'];
  Pincode: Scalars['Int'];
  RelatedParty: Scalars['Int'];
  State: Scalars['Int'];
  Street: Scalars['Int'];
  TRCAvailable: Scalars['Int'];
  TRCDocumentDate: Scalars['Int'];
  TRCDocumentValidFrom: Scalars['Int'];
  TRCDocumentValidTill: Scalars['Int'];
  TaxID: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BenefeciaryCountOrderByAggregateInput = {
  AccountNumber?: Maybe<SortOrder>;
  BankAddress?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BenefeciaryEmail?: Maybe<SortOrder>;
  BenefeciaryName?: Maybe<SortOrder>;
  BenefeciaryPhone?: Maybe<SortOrder>;
  BenefeciaryPrefix?: Maybe<SortOrder>;
  BenefeciaryStatus?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DocumentDate10F?: Maybe<SortOrder>;
  DocumentValidTill10F?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Is10FAvailable?: Maybe<SortOrder>;
  IsBenefeciaryOwner?: Maybe<SortOrder>;
  IsBussinessDeclaration?: Maybe<SortOrder>;
  IsCerticateObtained?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherCountry?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  PEDocumentDate?: Maybe<SortOrder>;
  PEDocumentValidFrom?: Maybe<SortOrder>;
  PEDocumentValidTill?: Maybe<SortOrder>;
  PPTClauseSatisfied?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  RelatedParty?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TRCAvailable?: Maybe<SortOrder>;
  TRCDocumentDate?: Maybe<SortOrder>;
  TRCDocumentValidFrom?: Maybe<SortOrder>;
  TRCDocumentValidTill?: Maybe<SortOrder>;
  TaxID?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BenefeciaryCreateInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateManyBranchInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  City: Scalars['String'];
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  GroupId: Scalars['Int'];
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateManyBranchInputEnvelope = {
  data: Array<BenefeciaryCreateManyBranchInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BenefeciaryCreateManyCompanyInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  BranchId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  GroupId: Scalars['Int'];
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateManyCompanyInputEnvelope = {
  data: Array<BenefeciaryCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BenefeciaryCreateManyGroupInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  BranchId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  City: Scalars['String'];
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateManyGroupInputEnvelope = {
  data: Array<BenefeciaryCreateManyGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BenefeciaryCreateManyInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  BranchId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  City: Scalars['String'];
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  GroupId: Scalars['Int'];
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateNestedManyWithoutBranchInput = {
  connect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BenefeciaryCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<BenefeciaryCreateWithoutBranchInput>>;
  createMany?: Maybe<BenefeciaryCreateManyBranchInputEnvelope>;
};

export type BenefeciaryCreateNestedManyWithoutCompanyInput = {
  connect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BenefeciaryCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<BenefeciaryCreateWithoutCompanyInput>>;
  createMany?: Maybe<BenefeciaryCreateManyCompanyInputEnvelope>;
};

export type BenefeciaryCreateNestedManyWithoutGroupInput = {
  connect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BenefeciaryCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<BenefeciaryCreateWithoutGroupInput>>;
  createMany?: Maybe<BenefeciaryCreateManyGroupInputEnvelope>;
};

export type BenefeciaryCreateNestedOneWithoutCertificatesInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutCertificatesInput>;
  create?: Maybe<BenefeciaryCreateWithoutCertificatesInput>;
};

export type BenefeciaryCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<BenefeciaryCreateWithoutDocumentInput>;
};

export type BenefeciaryCreateNestedOneWithoutFolioNumbersInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutFolioNumbersInput>;
  create?: Maybe<BenefeciaryCreateWithoutFolioNumbersInput>;
};

export type BenefeciaryCreateNestedOneWithoutForm15CaaInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CaaInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CaaInput>;
};

export type BenefeciaryCreateNestedOneWithoutForm15CabInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CabInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CabInput>;
};

export type BenefeciaryCreateNestedOneWithoutForm15CacInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CacInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CacInput>;
};

export type BenefeciaryCreateNestedOneWithoutForm15CadInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CadInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CadInput>;
};

export type BenefeciaryCreateNestedOneWithoutForm15CbInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CbInput>;
};

export type BenefeciaryCreateNestedOneWithoutRequestInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutRequestInput>;
  create?: Maybe<BenefeciaryCreateWithoutRequestInput>;
};

export type BenefeciaryCreateOrConnectWithoutBranchInput = {
  create: BenefeciaryCreateWithoutBranchInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutCertificatesInput = {
  create: BenefeciaryCreateWithoutCertificatesInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutCompanyInput = {
  create: BenefeciaryCreateWithoutCompanyInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutDocumentInput = {
  create: BenefeciaryCreateWithoutDocumentInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutFolioNumbersInput = {
  create: BenefeciaryCreateWithoutFolioNumbersInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutForm15CaaInput = {
  create: BenefeciaryCreateWithoutForm15CaaInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutForm15CabInput = {
  create: BenefeciaryCreateWithoutForm15CabInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutForm15CacInput = {
  create: BenefeciaryCreateWithoutForm15CacInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutForm15CadInput = {
  create: BenefeciaryCreateWithoutForm15CadInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutForm15CbInput = {
  create: BenefeciaryCreateWithoutForm15CbInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutGroupInput = {
  create: BenefeciaryCreateWithoutGroupInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateOrConnectWithoutRequestInput = {
  create: BenefeciaryCreateWithoutRequestInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryCreateWithoutBranchInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutCertificatesInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutCompanyInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutDocumentInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutFolioNumbersInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutForm15CaaInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutForm15CabInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutForm15CacInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutForm15CadInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutForm15CbInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutGroupInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  Request?: Maybe<RequestCreateNestedManyWithoutBeneficiaryInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryCreateWithoutRequestInput = {
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  Branch?: Maybe<BranchCreateNestedOneWithoutBenefeciaryInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  Certificates?: Maybe<BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput>;
  City: Scalars['String'];
  Company: CompanyCreateNestedOneWithoutBenefeciaryInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBenefeciaryInput>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  FolioNumbers?: Maybe<FolioNumberCreateNestedManyWithoutBenefeciaryInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedManyWithoutBeneficiaryInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedManyWithoutBeneficiaryInput>;
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutBeneficiaryInput>;
  Group: GroupCreateNestedOneWithoutBenefeciaryInput;
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryGroupBy = {
  __typename?: 'BenefeciaryGroupBy';
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName: Scalars['String'];
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix: Scalars['String'];
  BenefeciaryStatus: Scalars['String'];
  BranchId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  City: Scalars['String'];
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat: Scalars['String'];
  GroupId: Scalars['Int'];
  Is10FAvailable: Scalars['Boolean'];
  IsBenefeciaryOwner: Scalars['Boolean'];
  IsBussinessDeclaration: Scalars['Boolean'];
  IsCerticateObtained: Scalars['Boolean'];
  Locality: Scalars['String'];
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  RelatedParty: Scalars['Boolean'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TRCAvailable: Scalars['Boolean'];
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  _avg?: Maybe<BenefeciaryAvgAggregate>;
  _count?: Maybe<BenefeciaryCountAggregate>;
  _max?: Maybe<BenefeciaryMaxAggregate>;
  _min?: Maybe<BenefeciaryMinAggregate>;
  _sum?: Maybe<BenefeciarySumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BenefeciaryListRelationFilter = {
  every?: Maybe<BenefeciaryWhereInput>;
  none?: Maybe<BenefeciaryWhereInput>;
  some?: Maybe<BenefeciaryWhereInput>;
};

export type BenefeciaryMaxAggregate = {
  __typename?: 'BenefeciaryMaxAggregate';
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName?: Maybe<Scalars['String']>;
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix?: Maybe<Scalars['String']>;
  BenefeciaryStatus?: Maybe<Scalars['String']>;
  BranchId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat?: Maybe<Scalars['String']>;
  GroupId?: Maybe<Scalars['Int']>;
  Is10FAvailable?: Maybe<Scalars['Boolean']>;
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  RelatedParty?: Maybe<Scalars['Boolean']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryMaxOrderByAggregateInput = {
  AccountNumber?: Maybe<SortOrder>;
  BankAddress?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BenefeciaryEmail?: Maybe<SortOrder>;
  BenefeciaryName?: Maybe<SortOrder>;
  BenefeciaryPhone?: Maybe<SortOrder>;
  BenefeciaryPrefix?: Maybe<SortOrder>;
  BenefeciaryStatus?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DocumentDate10F?: Maybe<SortOrder>;
  DocumentValidTill10F?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Is10FAvailable?: Maybe<SortOrder>;
  IsBenefeciaryOwner?: Maybe<SortOrder>;
  IsBussinessDeclaration?: Maybe<SortOrder>;
  IsCerticateObtained?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherCountry?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  PEDocumentDate?: Maybe<SortOrder>;
  PEDocumentValidFrom?: Maybe<SortOrder>;
  PEDocumentValidTill?: Maybe<SortOrder>;
  PPTClauseSatisfied?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  RelatedParty?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TRCAvailable?: Maybe<SortOrder>;
  TRCDocumentDate?: Maybe<SortOrder>;
  TRCDocumentValidFrom?: Maybe<SortOrder>;
  TRCDocumentValidTill?: Maybe<SortOrder>;
  TaxID?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BenefeciaryMinAggregate = {
  __typename?: 'BenefeciaryMinAggregate';
  AccountNumber?: Maybe<Scalars['String']>;
  BankAddress?: Maybe<Scalars['String']>;
  BankName?: Maybe<Scalars['String']>;
  BenefeciaryEmail?: Maybe<Scalars['String']>;
  BenefeciaryName?: Maybe<Scalars['String']>;
  BenefeciaryPhone?: Maybe<Scalars['String']>;
  BenefeciaryPrefix?: Maybe<Scalars['String']>;
  BenefeciaryStatus?: Maybe<Scalars['String']>;
  BranchId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DocumentDate10F?: Maybe<Scalars['DateTime']>;
  DocumentValidTill10F?: Maybe<Scalars['DateTime']>;
  Flat?: Maybe<Scalars['String']>;
  GroupId?: Maybe<Scalars['Int']>;
  Is10FAvailable?: Maybe<Scalars['Boolean']>;
  IsBenefeciaryOwner?: Maybe<Scalars['Boolean']>;
  IsBussinessDeclaration?: Maybe<Scalars['Boolean']>;
  IsCerticateObtained?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  OtherCountry?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  PEDocumentDate?: Maybe<Scalars['DateTime']>;
  PEDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  PEDocumentValidTill?: Maybe<Scalars['DateTime']>;
  PPTClauseSatisfied?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  RelatedParty?: Maybe<Scalars['Boolean']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TRCAvailable?: Maybe<Scalars['Boolean']>;
  TRCDocumentDate?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidFrom?: Maybe<Scalars['DateTime']>;
  TRCDocumentValidTill?: Maybe<Scalars['DateTime']>;
  TaxID?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BenefeciaryMinOrderByAggregateInput = {
  AccountNumber?: Maybe<SortOrder>;
  BankAddress?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BenefeciaryEmail?: Maybe<SortOrder>;
  BenefeciaryName?: Maybe<SortOrder>;
  BenefeciaryPhone?: Maybe<SortOrder>;
  BenefeciaryPrefix?: Maybe<SortOrder>;
  BenefeciaryStatus?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DocumentDate10F?: Maybe<SortOrder>;
  DocumentValidTill10F?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Is10FAvailable?: Maybe<SortOrder>;
  IsBenefeciaryOwner?: Maybe<SortOrder>;
  IsBussinessDeclaration?: Maybe<SortOrder>;
  IsCerticateObtained?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherCountry?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  PEDocumentDate?: Maybe<SortOrder>;
  PEDocumentValidFrom?: Maybe<SortOrder>;
  PEDocumentValidTill?: Maybe<SortOrder>;
  PPTClauseSatisfied?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  RelatedParty?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TRCAvailable?: Maybe<SortOrder>;
  TRCDocumentDate?: Maybe<SortOrder>;
  TRCDocumentValidFrom?: Maybe<SortOrder>;
  TRCDocumentValidTill?: Maybe<SortOrder>;
  TaxID?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BenefeciaryOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BenefeciaryOrderByWithAggregationInput = {
  AccountNumber?: Maybe<SortOrder>;
  BankAddress?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BenefeciaryEmail?: Maybe<SortOrder>;
  BenefeciaryName?: Maybe<SortOrder>;
  BenefeciaryPhone?: Maybe<SortOrder>;
  BenefeciaryPrefix?: Maybe<SortOrder>;
  BenefeciaryStatus?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DocumentDate10F?: Maybe<SortOrder>;
  DocumentValidTill10F?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Is10FAvailable?: Maybe<SortOrder>;
  IsBenefeciaryOwner?: Maybe<SortOrder>;
  IsBussinessDeclaration?: Maybe<SortOrder>;
  IsCerticateObtained?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherCountry?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  PEDocumentDate?: Maybe<SortOrder>;
  PEDocumentValidFrom?: Maybe<SortOrder>;
  PEDocumentValidTill?: Maybe<SortOrder>;
  PPTClauseSatisfied?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  RelatedParty?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TRCAvailable?: Maybe<SortOrder>;
  TRCDocumentDate?: Maybe<SortOrder>;
  TRCDocumentValidFrom?: Maybe<SortOrder>;
  TRCDocumentValidTill?: Maybe<SortOrder>;
  TaxID?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  _avg?: Maybe<BenefeciaryAvgOrderByAggregateInput>;
  _count?: Maybe<BenefeciaryCountOrderByAggregateInput>;
  _max?: Maybe<BenefeciaryMaxOrderByAggregateInput>;
  _min?: Maybe<BenefeciaryMinOrderByAggregateInput>;
  _sum?: Maybe<BenefeciarySumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BenefeciaryOrderByWithRelationInput = {
  AccountNumber?: Maybe<SortOrder>;
  BankAddress?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BenefeciaryEmail?: Maybe<SortOrder>;
  BenefeciaryName?: Maybe<SortOrder>;
  BenefeciaryPhone?: Maybe<SortOrder>;
  BenefeciaryPrefix?: Maybe<SortOrder>;
  BenefeciaryStatus?: Maybe<SortOrder>;
  Branch?: Maybe<BranchOrderByWithRelationInput>;
  BranchId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  Certificates?: Maybe<BeneficiaryCertificateOrderByRelationAggregateInput>;
  City?: Maybe<SortOrder>;
  Company?: Maybe<CompanyOrderByWithRelationInput>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  DocumentDate10F?: Maybe<SortOrder>;
  DocumentValidTill10F?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  FolioNumbers?: Maybe<FolioNumberOrderByRelationAggregateInput>;
  Form15CAA?: Maybe<Form15CaaOrderByRelationAggregateInput>;
  Form15CAB?: Maybe<Form15CabOrderByRelationAggregateInput>;
  Form15CAC?: Maybe<Form15CacOrderByRelationAggregateInput>;
  Form15CAD?: Maybe<Form15CadOrderByRelationAggregateInput>;
  Form15CB?: Maybe<Form15CbOrderByRelationAggregateInput>;
  Group?: Maybe<GroupOrderByWithRelationInput>;
  GroupId?: Maybe<SortOrder>;
  Is10FAvailable?: Maybe<SortOrder>;
  IsBenefeciaryOwner?: Maybe<SortOrder>;
  IsBussinessDeclaration?: Maybe<SortOrder>;
  IsCerticateObtained?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherCountry?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  PEDocumentDate?: Maybe<SortOrder>;
  PEDocumentValidFrom?: Maybe<SortOrder>;
  PEDocumentValidTill?: Maybe<SortOrder>;
  PPTClauseSatisfied?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  RelatedParty?: Maybe<SortOrder>;
  Request?: Maybe<RequestOrderByRelationAggregateInput>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TRCAvailable?: Maybe<SortOrder>;
  TRCDocumentDate?: Maybe<SortOrder>;
  TRCDocumentValidFrom?: Maybe<SortOrder>;
  TRCDocumentValidTill?: Maybe<SortOrder>;
  TaxID?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BenefeciaryRelationFilter = {
  is?: Maybe<BenefeciaryWhereInput>;
  isNot?: Maybe<BenefeciaryWhereInput>;
};

export enum BenefeciaryScalarFieldEnum {
  AccountNumber = 'AccountNumber',
  BankAddress = 'BankAddress',
  BankName = 'BankName',
  BenefeciaryEmail = 'BenefeciaryEmail',
  BenefeciaryName = 'BenefeciaryName',
  BenefeciaryPhone = 'BenefeciaryPhone',
  BenefeciaryPrefix = 'BenefeciaryPrefix',
  BenefeciaryStatus = 'BenefeciaryStatus',
  BranchId = 'BranchId',
  Building = 'Building',
  BusinessPlace = 'BusinessPlace',
  City = 'City',
  CompanyId = 'CompanyId',
  Country = 'Country',
  CreatedBy = 'CreatedBy',
  DocumentDate10F = 'DocumentDate10F',
  DocumentValidTill10F = 'DocumentValidTill10F',
  Flat = 'Flat',
  GroupId = 'GroupId',
  Is10FAvailable = 'Is10FAvailable',
  IsBenefeciaryOwner = 'IsBenefeciaryOwner',
  IsBussinessDeclaration = 'IsBussinessDeclaration',
  IsCerticateObtained = 'IsCerticateObtained',
  Locality = 'Locality',
  OtherCountry = 'OtherCountry',
  Pan = 'PAN',
  PeDocumentDate = 'PEDocumentDate',
  PeDocumentValidFrom = 'PEDocumentValidFrom',
  PeDocumentValidTill = 'PEDocumentValidTill',
  PptClauseSatisfied = 'PPTClauseSatisfied',
  Pincode = 'Pincode',
  RelatedParty = 'RelatedParty',
  State = 'State',
  Street = 'Street',
  TrcAvailable = 'TRCAvailable',
  TrcDocumentDate = 'TRCDocumentDate',
  TrcDocumentValidFrom = 'TRCDocumentValidFrom',
  TrcDocumentValidTill = 'TRCDocumentValidTill',
  TaxId = 'TaxID',
  UpdatedBy = 'UpdatedBy',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type BenefeciaryScalarWhereInput = {
  AND?: Maybe<Array<BenefeciaryScalarWhereInput>>;
  AccountNumber?: Maybe<StringNullableFilter>;
  BankAddress?: Maybe<StringNullableFilter>;
  BankName?: Maybe<StringNullableFilter>;
  BenefeciaryEmail?: Maybe<StringNullableFilter>;
  BenefeciaryName?: Maybe<StringFilter>;
  BenefeciaryPhone?: Maybe<StringNullableFilter>;
  BenefeciaryPrefix?: Maybe<StringFilter>;
  BenefeciaryStatus?: Maybe<StringFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  City?: Maybe<StringFilter>;
  CompanyId?: Maybe<IntFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DocumentDate10F?: Maybe<DateTimeNullableFilter>;
  DocumentValidTill10F?: Maybe<DateTimeNullableFilter>;
  Flat?: Maybe<StringFilter>;
  GroupId?: Maybe<IntFilter>;
  Is10FAvailable?: Maybe<BoolFilter>;
  IsBenefeciaryOwner?: Maybe<BoolFilter>;
  IsBussinessDeclaration?: Maybe<BoolFilter>;
  IsCerticateObtained?: Maybe<BoolFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<BenefeciaryScalarWhereInput>>;
  OR?: Maybe<Array<BenefeciaryScalarWhereInput>>;
  OtherCountry?: Maybe<StringNullableFilter>;
  PAN?: Maybe<StringNullableFilter>;
  PEDocumentDate?: Maybe<DateTimeNullableFilter>;
  PEDocumentValidFrom?: Maybe<DateTimeNullableFilter>;
  PEDocumentValidTill?: Maybe<DateTimeNullableFilter>;
  PPTClauseSatisfied?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  RelatedParty?: Maybe<BoolFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  TRCAvailable?: Maybe<BoolFilter>;
  TRCDocumentDate?: Maybe<DateTimeNullableFilter>;
  TRCDocumentValidFrom?: Maybe<DateTimeNullableFilter>;
  TRCDocumentValidTill?: Maybe<DateTimeNullableFilter>;
  TaxID?: Maybe<StringNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BenefeciaryScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BenefeciaryScalarWhereWithAggregatesInput>>;
  AccountNumber?: Maybe<StringNullableWithAggregatesFilter>;
  BankAddress?: Maybe<StringNullableWithAggregatesFilter>;
  BankName?: Maybe<StringNullableWithAggregatesFilter>;
  BenefeciaryEmail?: Maybe<StringNullableWithAggregatesFilter>;
  BenefeciaryName?: Maybe<StringWithAggregatesFilter>;
  BenefeciaryPhone?: Maybe<StringNullableWithAggregatesFilter>;
  BenefeciaryPrefix?: Maybe<StringWithAggregatesFilter>;
  BenefeciaryStatus?: Maybe<StringWithAggregatesFilter>;
  BranchId?: Maybe<IntNullableWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  BusinessPlace?: Maybe<StringWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  CompanyId?: Maybe<IntWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  DocumentDate10F?: Maybe<DateTimeNullableWithAggregatesFilter>;
  DocumentValidTill10F?: Maybe<DateTimeNullableWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  GroupId?: Maybe<IntWithAggregatesFilter>;
  Is10FAvailable?: Maybe<BoolWithAggregatesFilter>;
  IsBenefeciaryOwner?: Maybe<BoolWithAggregatesFilter>;
  IsBussinessDeclaration?: Maybe<BoolWithAggregatesFilter>;
  IsCerticateObtained?: Maybe<BoolWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<BenefeciaryScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BenefeciaryScalarWhereWithAggregatesInput>>;
  OtherCountry?: Maybe<StringNullableWithAggregatesFilter>;
  PAN?: Maybe<StringNullableWithAggregatesFilter>;
  PEDocumentDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  PEDocumentValidFrom?: Maybe<DateTimeNullableWithAggregatesFilter>;
  PEDocumentValidTill?: Maybe<DateTimeNullableWithAggregatesFilter>;
  PPTClauseSatisfied?: Maybe<StringNullableWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  RelatedParty?: Maybe<BoolWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  TRCAvailable?: Maybe<BoolWithAggregatesFilter>;
  TRCDocumentDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  TRCDocumentValidFrom?: Maybe<DateTimeNullableWithAggregatesFilter>;
  TRCDocumentValidTill?: Maybe<DateTimeNullableWithAggregatesFilter>;
  TaxID?: Maybe<StringNullableWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BenefeciarySumAggregate = {
  __typename?: 'BenefeciarySumAggregate';
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type BenefeciarySumOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BenefeciaryUpdateInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateManyMutationInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateManyWithWhereWithoutBranchInput = {
  data: BenefeciaryUpdateManyMutationInput;
  where: BenefeciaryScalarWhereInput;
};

export type BenefeciaryUpdateManyWithWhereWithoutCompanyInput = {
  data: BenefeciaryUpdateManyMutationInput;
  where: BenefeciaryScalarWhereInput;
};

export type BenefeciaryUpdateManyWithWhereWithoutGroupInput = {
  data: BenefeciaryUpdateManyMutationInput;
  where: BenefeciaryScalarWhereInput;
};

export type BenefeciaryUpdateManyWithoutBranchNestedInput = {
  connect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BenefeciaryCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<BenefeciaryCreateWithoutBranchInput>>;
  createMany?: Maybe<BenefeciaryCreateManyBranchInputEnvelope>;
  delete?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BenefeciaryScalarWhereInput>>;
  disconnect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  set?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  update?: Maybe<Array<BenefeciaryUpdateWithWhereUniqueWithoutBranchInput>>;
  updateMany?: Maybe<Array<BenefeciaryUpdateManyWithWhereWithoutBranchInput>>;
  upsert?: Maybe<Array<BenefeciaryUpsertWithWhereUniqueWithoutBranchInput>>;
};

export type BenefeciaryUpdateManyWithoutCompanyNestedInput = {
  connect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BenefeciaryCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<BenefeciaryCreateWithoutCompanyInput>>;
  createMany?: Maybe<BenefeciaryCreateManyCompanyInputEnvelope>;
  delete?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BenefeciaryScalarWhereInput>>;
  disconnect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  set?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  update?: Maybe<Array<BenefeciaryUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<BenefeciaryUpdateManyWithWhereWithoutCompanyInput>>;
  upsert?: Maybe<Array<BenefeciaryUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type BenefeciaryUpdateManyWithoutGroupNestedInput = {
  connect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BenefeciaryCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<BenefeciaryCreateWithoutGroupInput>>;
  createMany?: Maybe<BenefeciaryCreateManyGroupInputEnvelope>;
  delete?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BenefeciaryScalarWhereInput>>;
  disconnect?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  set?: Maybe<Array<BenefeciaryWhereUniqueInput>>;
  update?: Maybe<Array<BenefeciaryUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: Maybe<Array<BenefeciaryUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: Maybe<Array<BenefeciaryUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type BenefeciaryUpdateOneRequiredWithoutCertificatesNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutCertificatesInput>;
  create?: Maybe<BenefeciaryCreateWithoutCertificatesInput>;
  update?: Maybe<BenefeciaryUpdateWithoutCertificatesInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutCertificatesInput>;
};

export type BenefeciaryUpdateOneRequiredWithoutFolioNumbersNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutFolioNumbersInput>;
  create?: Maybe<BenefeciaryCreateWithoutFolioNumbersInput>;
  update?: Maybe<BenefeciaryUpdateWithoutFolioNumbersInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutFolioNumbersInput>;
};

export type BenefeciaryUpdateOneRequiredWithoutForm15CaaNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CaaInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CaaInput>;
  update?: Maybe<BenefeciaryUpdateWithoutForm15CaaInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutForm15CaaInput>;
};

export type BenefeciaryUpdateOneRequiredWithoutForm15CabNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CabInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CabInput>;
  update?: Maybe<BenefeciaryUpdateWithoutForm15CabInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutForm15CabInput>;
};

export type BenefeciaryUpdateOneRequiredWithoutForm15CacNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CacInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CacInput>;
  update?: Maybe<BenefeciaryUpdateWithoutForm15CacInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutForm15CacInput>;
};

export type BenefeciaryUpdateOneRequiredWithoutForm15CadNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CadInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CadInput>;
  update?: Maybe<BenefeciaryUpdateWithoutForm15CadInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutForm15CadInput>;
};

export type BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<BenefeciaryCreateWithoutForm15CbInput>;
  update?: Maybe<BenefeciaryUpdateWithoutForm15CbInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutForm15CbInput>;
};

export type BenefeciaryUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<BenefeciaryCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BenefeciaryUpdateWithoutDocumentInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutDocumentInput>;
};

export type BenefeciaryUpdateOneWithoutRequestNestedInput = {
  connect?: Maybe<BenefeciaryWhereUniqueInput>;
  connectOrCreate?: Maybe<BenefeciaryCreateOrConnectWithoutRequestInput>;
  create?: Maybe<BenefeciaryCreateWithoutRequestInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BenefeciaryUpdateWithoutRequestInput>;
  upsert?: Maybe<BenefeciaryUpsertWithoutRequestInput>;
};

export type BenefeciaryUpdateWithWhereUniqueWithoutBranchInput = {
  data: BenefeciaryUpdateWithoutBranchInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryUpdateWithWhereUniqueWithoutCompanyInput = {
  data: BenefeciaryUpdateWithoutCompanyInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryUpdateWithWhereUniqueWithoutGroupInput = {
  data: BenefeciaryUpdateWithoutGroupInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryUpdateWithoutBranchInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutCertificatesInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutCompanyInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutDocumentInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutFolioNumbersInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutForm15CaaInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutForm15CabInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutForm15CacInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutForm15CadInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutForm15CbInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutGroupInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBeneficiaryNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpdateWithoutRequestInput = {
  AccountNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankAddress?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BankName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryEmail?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryName?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryPhone?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BenefeciaryPrefix?: Maybe<StringFieldUpdateOperationsInput>;
  BenefeciaryStatus?: Maybe<StringFieldUpdateOperationsInput>;
  Branch?: Maybe<BranchUpdateOneWithoutBenefeciaryNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  Certificates?: Maybe<BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBenefeciaryNestedInput>;
  DocumentDate10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DocumentValidTill10F?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  FolioNumbers?: Maybe<FolioNumberUpdateManyWithoutBenefeciaryNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateManyWithoutBeneficiaryNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutBeneficiaryNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutBenefeciaryNestedInput>;
  Is10FAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBenefeciaryOwner?: Maybe<BoolFieldUpdateOperationsInput>;
  IsBussinessDeclaration?: Maybe<BoolFieldUpdateOperationsInput>;
  IsCerticateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PEDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PEDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  PPTClauseSatisfied?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  RelatedParty?: Maybe<BoolFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TRCAvailable?: Maybe<BoolFieldUpdateOperationsInput>;
  TRCDocumentDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TRCDocumentValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  TaxID?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BenefeciaryUpsertWithWhereUniqueWithoutBranchInput = {
  create: BenefeciaryCreateWithoutBranchInput;
  update: BenefeciaryUpdateWithoutBranchInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryUpsertWithWhereUniqueWithoutCompanyInput = {
  create: BenefeciaryCreateWithoutCompanyInput;
  update: BenefeciaryUpdateWithoutCompanyInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryUpsertWithWhereUniqueWithoutGroupInput = {
  create: BenefeciaryCreateWithoutGroupInput;
  update: BenefeciaryUpdateWithoutGroupInput;
  where: BenefeciaryWhereUniqueInput;
};

export type BenefeciaryUpsertWithoutCertificatesInput = {
  create: BenefeciaryCreateWithoutCertificatesInput;
  update: BenefeciaryUpdateWithoutCertificatesInput;
};

export type BenefeciaryUpsertWithoutDocumentInput = {
  create: BenefeciaryCreateWithoutDocumentInput;
  update: BenefeciaryUpdateWithoutDocumentInput;
};

export type BenefeciaryUpsertWithoutFolioNumbersInput = {
  create: BenefeciaryCreateWithoutFolioNumbersInput;
  update: BenefeciaryUpdateWithoutFolioNumbersInput;
};

export type BenefeciaryUpsertWithoutForm15CaaInput = {
  create: BenefeciaryCreateWithoutForm15CaaInput;
  update: BenefeciaryUpdateWithoutForm15CaaInput;
};

export type BenefeciaryUpsertWithoutForm15CabInput = {
  create: BenefeciaryCreateWithoutForm15CabInput;
  update: BenefeciaryUpdateWithoutForm15CabInput;
};

export type BenefeciaryUpsertWithoutForm15CacInput = {
  create: BenefeciaryCreateWithoutForm15CacInput;
  update: BenefeciaryUpdateWithoutForm15CacInput;
};

export type BenefeciaryUpsertWithoutForm15CadInput = {
  create: BenefeciaryCreateWithoutForm15CadInput;
  update: BenefeciaryUpdateWithoutForm15CadInput;
};

export type BenefeciaryUpsertWithoutForm15CbInput = {
  create: BenefeciaryCreateWithoutForm15CbInput;
  update: BenefeciaryUpdateWithoutForm15CbInput;
};

export type BenefeciaryUpsertWithoutRequestInput = {
  create: BenefeciaryCreateWithoutRequestInput;
  update: BenefeciaryUpdateWithoutRequestInput;
};

export type BenefeciaryWhereInput = {
  AND?: Maybe<Array<BenefeciaryWhereInput>>;
  AccountNumber?: Maybe<StringNullableFilter>;
  BankAddress?: Maybe<StringNullableFilter>;
  BankName?: Maybe<StringNullableFilter>;
  BenefeciaryEmail?: Maybe<StringNullableFilter>;
  BenefeciaryName?: Maybe<StringFilter>;
  BenefeciaryPhone?: Maybe<StringNullableFilter>;
  BenefeciaryPrefix?: Maybe<StringFilter>;
  BenefeciaryStatus?: Maybe<StringFilter>;
  Branch?: Maybe<BranchRelationFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  Certificates?: Maybe<BeneficiaryCertificateListRelationFilter>;
  City?: Maybe<StringFilter>;
  Company?: Maybe<CompanyRelationFilter>;
  CompanyId?: Maybe<IntFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  DocumentDate10F?: Maybe<DateTimeNullableFilter>;
  DocumentValidTill10F?: Maybe<DateTimeNullableFilter>;
  Flat?: Maybe<StringFilter>;
  FolioNumbers?: Maybe<FolioNumberListRelationFilter>;
  Form15CAA?: Maybe<Form15CaaListRelationFilter>;
  Form15CAB?: Maybe<Form15CabListRelationFilter>;
  Form15CAC?: Maybe<Form15CacListRelationFilter>;
  Form15CAD?: Maybe<Form15CadListRelationFilter>;
  Form15CB?: Maybe<Form15CbListRelationFilter>;
  Group?: Maybe<GroupRelationFilter>;
  GroupId?: Maybe<IntFilter>;
  Is10FAvailable?: Maybe<BoolFilter>;
  IsBenefeciaryOwner?: Maybe<BoolFilter>;
  IsBussinessDeclaration?: Maybe<BoolFilter>;
  IsCerticateObtained?: Maybe<BoolFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<BenefeciaryWhereInput>>;
  OR?: Maybe<Array<BenefeciaryWhereInput>>;
  OtherCountry?: Maybe<StringNullableFilter>;
  PAN?: Maybe<StringNullableFilter>;
  PEDocumentDate?: Maybe<DateTimeNullableFilter>;
  PEDocumentValidFrom?: Maybe<DateTimeNullableFilter>;
  PEDocumentValidTill?: Maybe<DateTimeNullableFilter>;
  PPTClauseSatisfied?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  RelatedParty?: Maybe<BoolFilter>;
  Request?: Maybe<RequestListRelationFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  TRCAvailable?: Maybe<BoolFilter>;
  TRCDocumentDate?: Maybe<DateTimeNullableFilter>;
  TRCDocumentValidFrom?: Maybe<DateTimeNullableFilter>;
  TRCDocumentValidTill?: Maybe<DateTimeNullableFilter>;
  TaxID?: Maybe<StringNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BenefeciaryWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type BeneficiaryCertificate = {
  __typename?: 'BeneficiaryCertificate';
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  Benefeciary: Benefeciary;
  BenefeciaryId: Scalars['Int'];
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection: Scalars['String'];
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type BeneficiaryCertificateAvgAggregate = {
  __typename?: 'BeneficiaryCertificateAvgAggregate';
  BenefeciaryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type BeneficiaryCertificateAvgOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BeneficiaryCertificateCountAggregate = {
  __typename?: 'BeneficiaryCertificateCountAggregate';
  AssessingOfficerDesignation: Scalars['Int'];
  AssessingOfficerName: Scalars['Int'];
  BenefeciaryId: Scalars['Int'];
  CerticateRateTax: Scalars['Int'];
  CerticateSection: Scalars['Int'];
  CerticateValidTill: Scalars['Int'];
  CertificateNumber: Scalars['Int'];
  CertificateOrderDate: Scalars['Int'];
  CertificateThreshold: Scalars['Int'];
  CertificateValidFrom: Scalars['Int'];
  NatureOfIncome: Scalars['Int'];
  _all: Scalars['Int'];
  id: Scalars['Int'];
};

export type BeneficiaryCertificateCountOrderByAggregateInput = {
  AssessingOfficerDesignation?: Maybe<SortOrder>;
  AssessingOfficerName?: Maybe<SortOrder>;
  BenefeciaryId?: Maybe<SortOrder>;
  CerticateRateTax?: Maybe<SortOrder>;
  CerticateSection?: Maybe<SortOrder>;
  CerticateValidTill?: Maybe<SortOrder>;
  CertificateNumber?: Maybe<SortOrder>;
  CertificateOrderDate?: Maybe<SortOrder>;
  CertificateThreshold?: Maybe<SortOrder>;
  CertificateValidFrom?: Maybe<SortOrder>;
  NatureOfIncome?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BeneficiaryCertificateCreateInput = {
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  Benefeciary: BenefeciaryCreateNestedOneWithoutCertificatesInput;
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection: Scalars['String'];
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
};

export type BeneficiaryCertificateCreateManyBenefeciaryInput = {
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection: Scalars['String'];
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type BeneficiaryCertificateCreateManyBenefeciaryInputEnvelope = {
  data: Array<BeneficiaryCertificateCreateManyBenefeciaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BeneficiaryCertificateCreateManyInput = {
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  BenefeciaryId: Scalars['Int'];
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection: Scalars['String'];
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type BeneficiaryCertificateCreateNestedManyWithoutBenefeciaryInput = {
  connect?: Maybe<Array<BeneficiaryCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BeneficiaryCertificateCreateOrConnectWithoutBenefeciaryInput>>;
  create?: Maybe<Array<BeneficiaryCertificateCreateWithoutBenefeciaryInput>>;
  createMany?: Maybe<BeneficiaryCertificateCreateManyBenefeciaryInputEnvelope>;
};

export type BeneficiaryCertificateCreateOrConnectWithoutBenefeciaryInput = {
  create: BeneficiaryCertificateCreateWithoutBenefeciaryInput;
  where: BeneficiaryCertificateWhereUniqueInput;
};

export type BeneficiaryCertificateCreateWithoutBenefeciaryInput = {
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection: Scalars['String'];
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
};

export type BeneficiaryCertificateGroupBy = {
  __typename?: 'BeneficiaryCertificateGroupBy';
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  BenefeciaryId: Scalars['Int'];
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection: Scalars['String'];
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
  _avg?: Maybe<BeneficiaryCertificateAvgAggregate>;
  _count?: Maybe<BeneficiaryCertificateCountAggregate>;
  _max?: Maybe<BeneficiaryCertificateMaxAggregate>;
  _min?: Maybe<BeneficiaryCertificateMinAggregate>;
  _sum?: Maybe<BeneficiaryCertificateSumAggregate>;
  id: Scalars['Int'];
};

export type BeneficiaryCertificateListRelationFilter = {
  every?: Maybe<BeneficiaryCertificateWhereInput>;
  none?: Maybe<BeneficiaryCertificateWhereInput>;
  some?: Maybe<BeneficiaryCertificateWhereInput>;
};

export type BeneficiaryCertificateMaxAggregate = {
  __typename?: 'BeneficiaryCertificateMaxAggregate';
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  BenefeciaryId?: Maybe<Scalars['Int']>;
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection?: Maybe<Scalars['String']>;
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type BeneficiaryCertificateMaxOrderByAggregateInput = {
  AssessingOfficerDesignation?: Maybe<SortOrder>;
  AssessingOfficerName?: Maybe<SortOrder>;
  BenefeciaryId?: Maybe<SortOrder>;
  CerticateRateTax?: Maybe<SortOrder>;
  CerticateSection?: Maybe<SortOrder>;
  CerticateValidTill?: Maybe<SortOrder>;
  CertificateNumber?: Maybe<SortOrder>;
  CertificateOrderDate?: Maybe<SortOrder>;
  CertificateThreshold?: Maybe<SortOrder>;
  CertificateValidFrom?: Maybe<SortOrder>;
  NatureOfIncome?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BeneficiaryCertificateMinAggregate = {
  __typename?: 'BeneficiaryCertificateMinAggregate';
  AssessingOfficerDesignation?: Maybe<Scalars['String']>;
  AssessingOfficerName?: Maybe<Scalars['String']>;
  BenefeciaryId?: Maybe<Scalars['Int']>;
  CerticateRateTax?: Maybe<Scalars['String']>;
  CerticateSection?: Maybe<Scalars['String']>;
  CerticateValidTill?: Maybe<Scalars['DateTime']>;
  CertificateNumber?: Maybe<Scalars['String']>;
  CertificateOrderDate?: Maybe<Scalars['DateTime']>;
  CertificateThreshold?: Maybe<Scalars['String']>;
  CertificateValidFrom?: Maybe<Scalars['DateTime']>;
  NatureOfIncome?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type BeneficiaryCertificateMinOrderByAggregateInput = {
  AssessingOfficerDesignation?: Maybe<SortOrder>;
  AssessingOfficerName?: Maybe<SortOrder>;
  BenefeciaryId?: Maybe<SortOrder>;
  CerticateRateTax?: Maybe<SortOrder>;
  CerticateSection?: Maybe<SortOrder>;
  CerticateValidTill?: Maybe<SortOrder>;
  CertificateNumber?: Maybe<SortOrder>;
  CertificateOrderDate?: Maybe<SortOrder>;
  CertificateThreshold?: Maybe<SortOrder>;
  CertificateValidFrom?: Maybe<SortOrder>;
  NatureOfIncome?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BeneficiaryCertificateOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BeneficiaryCertificateOrderByWithAggregationInput = {
  AssessingOfficerDesignation?: Maybe<SortOrder>;
  AssessingOfficerName?: Maybe<SortOrder>;
  BenefeciaryId?: Maybe<SortOrder>;
  CerticateRateTax?: Maybe<SortOrder>;
  CerticateSection?: Maybe<SortOrder>;
  CerticateValidTill?: Maybe<SortOrder>;
  CertificateNumber?: Maybe<SortOrder>;
  CertificateOrderDate?: Maybe<SortOrder>;
  CertificateThreshold?: Maybe<SortOrder>;
  CertificateValidFrom?: Maybe<SortOrder>;
  NatureOfIncome?: Maybe<SortOrder>;
  _avg?: Maybe<BeneficiaryCertificateAvgOrderByAggregateInput>;
  _count?: Maybe<BeneficiaryCertificateCountOrderByAggregateInput>;
  _max?: Maybe<BeneficiaryCertificateMaxOrderByAggregateInput>;
  _min?: Maybe<BeneficiaryCertificateMinOrderByAggregateInput>;
  _sum?: Maybe<BeneficiaryCertificateSumOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
};

export type BeneficiaryCertificateOrderByWithRelationInput = {
  AssessingOfficerDesignation?: Maybe<SortOrder>;
  AssessingOfficerName?: Maybe<SortOrder>;
  Benefeciary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BenefeciaryId?: Maybe<SortOrder>;
  CerticateRateTax?: Maybe<SortOrder>;
  CerticateSection?: Maybe<SortOrder>;
  CerticateValidTill?: Maybe<SortOrder>;
  CertificateNumber?: Maybe<SortOrder>;
  CertificateOrderDate?: Maybe<SortOrder>;
  CertificateThreshold?: Maybe<SortOrder>;
  CertificateValidFrom?: Maybe<SortOrder>;
  NatureOfIncome?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export enum BeneficiaryCertificateScalarFieldEnum {
  AssessingOfficerDesignation = 'AssessingOfficerDesignation',
  AssessingOfficerName = 'AssessingOfficerName',
  BenefeciaryId = 'BenefeciaryId',
  CerticateRateTax = 'CerticateRateTax',
  CerticateSection = 'CerticateSection',
  CerticateValidTill = 'CerticateValidTill',
  CertificateNumber = 'CertificateNumber',
  CertificateOrderDate = 'CertificateOrderDate',
  CertificateThreshold = 'CertificateThreshold',
  CertificateValidFrom = 'CertificateValidFrom',
  NatureOfIncome = 'NatureOfIncome',
  Id = 'id'
}

export type BeneficiaryCertificateScalarWhereInput = {
  AND?: Maybe<Array<BeneficiaryCertificateScalarWhereInput>>;
  AssessingOfficerDesignation?: Maybe<StringNullableFilter>;
  AssessingOfficerName?: Maybe<StringNullableFilter>;
  BenefeciaryId?: Maybe<IntFilter>;
  CerticateRateTax?: Maybe<StringNullableFilter>;
  CerticateSection?: Maybe<StringFilter>;
  CerticateValidTill?: Maybe<DateTimeNullableFilter>;
  CertificateNumber?: Maybe<StringNullableFilter>;
  CertificateOrderDate?: Maybe<DateTimeNullableFilter>;
  CertificateThreshold?: Maybe<StringNullableFilter>;
  CertificateValidFrom?: Maybe<DateTimeNullableFilter>;
  NOT?: Maybe<Array<BeneficiaryCertificateScalarWhereInput>>;
  NatureOfIncome?: Maybe<StringNullableFilter>;
  OR?: Maybe<Array<BeneficiaryCertificateScalarWhereInput>>;
  id?: Maybe<IntFilter>;
};

export type BeneficiaryCertificateScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BeneficiaryCertificateScalarWhereWithAggregatesInput>>;
  AssessingOfficerDesignation?: Maybe<StringNullableWithAggregatesFilter>;
  AssessingOfficerName?: Maybe<StringNullableWithAggregatesFilter>;
  BenefeciaryId?: Maybe<IntWithAggregatesFilter>;
  CerticateRateTax?: Maybe<StringNullableWithAggregatesFilter>;
  CerticateSection?: Maybe<StringWithAggregatesFilter>;
  CerticateValidTill?: Maybe<DateTimeNullableWithAggregatesFilter>;
  CertificateNumber?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateOrderDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  CertificateThreshold?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateValidFrom?: Maybe<DateTimeNullableWithAggregatesFilter>;
  NOT?: Maybe<Array<BeneficiaryCertificateScalarWhereWithAggregatesInput>>;
  NatureOfIncome?: Maybe<StringNullableWithAggregatesFilter>;
  OR?: Maybe<Array<BeneficiaryCertificateScalarWhereWithAggregatesInput>>;
  id?: Maybe<IntWithAggregatesFilter>;
};

export type BeneficiaryCertificateSumAggregate = {
  __typename?: 'BeneficiaryCertificateSumAggregate';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type BeneficiaryCertificateSumOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BeneficiaryCertificateUpdateInput = {
  AssessingOfficerDesignation?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AssessingOfficerName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateOneRequiredWithoutCertificatesNestedInput>;
  CerticateRateTax?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CerticateSection?: Maybe<StringFieldUpdateOperationsInput>;
  CerticateValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateOrderDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateThreshold?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  NatureOfIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type BeneficiaryCertificateUpdateManyMutationInput = {
  AssessingOfficerDesignation?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AssessingOfficerName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CerticateRateTax?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CerticateSection?: Maybe<StringFieldUpdateOperationsInput>;
  CerticateValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateOrderDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateThreshold?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  NatureOfIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type BeneficiaryCertificateUpdateManyWithWhereWithoutBenefeciaryInput = {
  data: BeneficiaryCertificateUpdateManyMutationInput;
  where: BeneficiaryCertificateScalarWhereInput;
};

export type BeneficiaryCertificateUpdateManyWithoutBenefeciaryNestedInput = {
  connect?: Maybe<Array<BeneficiaryCertificateWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BeneficiaryCertificateCreateOrConnectWithoutBenefeciaryInput>>;
  create?: Maybe<Array<BeneficiaryCertificateCreateWithoutBenefeciaryInput>>;
  createMany?: Maybe<BeneficiaryCertificateCreateManyBenefeciaryInputEnvelope>;
  delete?: Maybe<Array<BeneficiaryCertificateWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BeneficiaryCertificateScalarWhereInput>>;
  disconnect?: Maybe<Array<BeneficiaryCertificateWhereUniqueInput>>;
  set?: Maybe<Array<BeneficiaryCertificateWhereUniqueInput>>;
  update?: Maybe<Array<BeneficiaryCertificateUpdateWithWhereUniqueWithoutBenefeciaryInput>>;
  updateMany?: Maybe<Array<BeneficiaryCertificateUpdateManyWithWhereWithoutBenefeciaryInput>>;
  upsert?: Maybe<Array<BeneficiaryCertificateUpsertWithWhereUniqueWithoutBenefeciaryInput>>;
};

export type BeneficiaryCertificateUpdateWithWhereUniqueWithoutBenefeciaryInput = {
  data: BeneficiaryCertificateUpdateWithoutBenefeciaryInput;
  where: BeneficiaryCertificateWhereUniqueInput;
};

export type BeneficiaryCertificateUpdateWithoutBenefeciaryInput = {
  AssessingOfficerDesignation?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AssessingOfficerName?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CerticateRateTax?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CerticateSection?: Maybe<StringFieldUpdateOperationsInput>;
  CerticateValidTill?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateOrderDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateThreshold?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateValidFrom?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  NatureOfIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type BeneficiaryCertificateUpsertWithWhereUniqueWithoutBenefeciaryInput = {
  create: BeneficiaryCertificateCreateWithoutBenefeciaryInput;
  update: BeneficiaryCertificateUpdateWithoutBenefeciaryInput;
  where: BeneficiaryCertificateWhereUniqueInput;
};

export type BeneficiaryCertificateWhereInput = {
  AND?: Maybe<Array<BeneficiaryCertificateWhereInput>>;
  AssessingOfficerDesignation?: Maybe<StringNullableFilter>;
  AssessingOfficerName?: Maybe<StringNullableFilter>;
  Benefeciary?: Maybe<BenefeciaryRelationFilter>;
  BenefeciaryId?: Maybe<IntFilter>;
  CerticateRateTax?: Maybe<StringNullableFilter>;
  CerticateSection?: Maybe<StringFilter>;
  CerticateValidTill?: Maybe<DateTimeNullableFilter>;
  CertificateNumber?: Maybe<StringNullableFilter>;
  CertificateOrderDate?: Maybe<DateTimeNullableFilter>;
  CertificateThreshold?: Maybe<StringNullableFilter>;
  CertificateValidFrom?: Maybe<DateTimeNullableFilter>;
  NOT?: Maybe<Array<BeneficiaryCertificateWhereInput>>;
  NatureOfIncome?: Maybe<StringNullableFilter>;
  OR?: Maybe<Array<BeneficiaryCertificateWhereInput>>;
  id?: Maybe<IntFilter>;
};

export type BeneficiaryCertificateWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedBoolNullableFilter>;
  _min?: Maybe<NestedBoolNullableFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type Branch = {
  __typename?: 'Branch';
  BankDetail: Array<BankDetail>;
  Benefeciary: Array<Benefeciary>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption: Scalars['String'];
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Company: Company;
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document: Array<Document>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific: Scalars['String'];
  ITPass: Scalars['String'];
  IorWe: Scalars['String'];
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  Request: Array<Request>;
  ResidentialStatus: Scalars['String'];
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess: Array<UserAccess>;
  VerifierDesignation: Scalars['String'];
  VerifierFatherName: Scalars['String'];
  VerifierName: Scalars['String'];
  VerifierPlace: Scalars['String'];
  _count?: Maybe<BranchCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};


export type BranchBankDetailArgs = {
  cursor?: Maybe<BankDetailWhereUniqueInput>;
  distinct?: Maybe<Array<BankDetailScalarFieldEnum>>;
  orderBy?: Maybe<Array<BankDetailOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BankDetailWhereInput>;
};


export type BranchBenefeciaryArgs = {
  cursor?: Maybe<BenefeciaryWhereUniqueInput>;
  distinct?: Maybe<Array<BenefeciaryScalarFieldEnum>>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type BranchDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type BranchRequestArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  distinct?: Maybe<Array<RequestScalarFieldEnum>>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type BranchUserAccessArgs = {
  cursor?: Maybe<UserAccessWhereUniqueInput>;
  distinct?: Maybe<Array<UserAccessScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserAccessOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};

export type BranchAvgAggregate = {
  __typename?: 'BranchAvgAggregate';
  CompanyId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type BranchAvgOrderByAggregateInput = {
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BranchCount = {
  __typename?: 'BranchCount';
  BankDetail: Scalars['Int'];
  Benefeciary: Scalars['Int'];
  Document: Scalars['Int'];
  Request: Scalars['Int'];
  UserAccess: Scalars['Int'];
};

export type BranchCountAggregate = {
  __typename?: 'BranchCountAggregate';
  BranchName: Scalars['Int'];
  Building: Scalars['Int'];
  BusinessPlace: Scalars['Int'];
  CertificateOption: Scalars['Int'];
  City: Scalars['Int'];
  ClientApproval: Scalars['Int'];
  CompanyId: Scalars['Int'];
  Country: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['Int'];
  Flat: Scalars['Int'];
  Honorific: Scalars['Int'];
  ITPass: Scalars['Int'];
  IorWe: Scalars['Int'];
  Locality: Scalars['Int'];
  Mobile: Scalars['Int'];
  PAN: Scalars['Int'];
  Pincode: Scalars['Int'];
  ResidentialStatus: Scalars['Int'];
  State: Scalars['Int'];
  Status: Scalars['Int'];
  Street: Scalars['Int'];
  TAN: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  VerifierDesignation: Scalars['Int'];
  VerifierFatherName: Scalars['Int'];
  VerifierName: Scalars['Int'];
  VerifierPlace: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type BranchCountOrderByAggregateInput = {
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BranchCreateInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutBranchInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutBranchInput>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Company: CompanyCreateNestedOneWithoutBranchInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBranchesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutBranchInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutBranchInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateManyCompanyInput = {
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateManyCompanyInputEnvelope = {
  data: Array<BranchCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type BranchCreateManyInput = {
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateNestedManyWithoutCompanyInput = {
  connect?: Maybe<Array<BranchWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BranchCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<BranchCreateWithoutCompanyInput>>;
  createMany?: Maybe<BranchCreateManyCompanyInputEnvelope>;
};

export type BranchCreateNestedOneWithoutBankDetailInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutBankDetailInput>;
  create?: Maybe<BranchCreateWithoutBankDetailInput>;
};

export type BranchCreateNestedOneWithoutBenefeciaryInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutBenefeciaryInput>;
  create?: Maybe<BranchCreateWithoutBenefeciaryInput>;
};

export type BranchCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<BranchCreateWithoutDocumentInput>;
};

export type BranchCreateNestedOneWithoutRequestInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutRequestInput>;
  create?: Maybe<BranchCreateWithoutRequestInput>;
};

export type BranchCreateNestedOneWithoutUserAccessInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<BranchCreateWithoutUserAccessInput>;
};

export type BranchCreateOrConnectWithoutBankDetailInput = {
  create: BranchCreateWithoutBankDetailInput;
  where: BranchWhereUniqueInput;
};

export type BranchCreateOrConnectWithoutBenefeciaryInput = {
  create: BranchCreateWithoutBenefeciaryInput;
  where: BranchWhereUniqueInput;
};

export type BranchCreateOrConnectWithoutCompanyInput = {
  create: BranchCreateWithoutCompanyInput;
  where: BranchWhereUniqueInput;
};

export type BranchCreateOrConnectWithoutDocumentInput = {
  create: BranchCreateWithoutDocumentInput;
  where: BranchWhereUniqueInput;
};

export type BranchCreateOrConnectWithoutRequestInput = {
  create: BranchCreateWithoutRequestInput;
  where: BranchWhereUniqueInput;
};

export type BranchCreateOrConnectWithoutUserAccessInput = {
  create: BranchCreateWithoutUserAccessInput;
  where: BranchWhereUniqueInput;
};

export type BranchCreateWithoutBankDetailInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutBranchInput>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Company: CompanyCreateNestedOneWithoutBranchInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBranchesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutBranchInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutBranchInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateWithoutBenefeciaryInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutBranchInput>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Company: CompanyCreateNestedOneWithoutBranchInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBranchesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutBranchInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutBranchInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateWithoutCompanyInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutBranchInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutBranchInput>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBranchesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutBranchInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutBranchInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateWithoutDocumentInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutBranchInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutBranchInput>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Company: CompanyCreateNestedOneWithoutBranchInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutBranchInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutBranchInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateWithoutRequestInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutBranchInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutBranchInput>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Company: CompanyCreateNestedOneWithoutBranchInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBranchesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutBranchInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchCreateWithoutUserAccessInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutBranchInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutBranchInput>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  Company: CompanyCreateNestedOneWithoutBranchInput;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutBranchesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutBranchInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchGroupBy = {
  __typename?: 'BranchGroupBy';
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption: Scalars['String'];
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyId: Scalars['Int'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific: Scalars['String'];
  ITPass: Scalars['String'];
  IorWe: Scalars['String'];
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN: Scalars['String'];
  Pincode: Scalars['String'];
  ResidentialStatus: Scalars['String'];
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TAN: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation: Scalars['String'];
  VerifierFatherName: Scalars['String'];
  VerifierName: Scalars['String'];
  VerifierPlace: Scalars['String'];
  _avg?: Maybe<BranchAvgAggregate>;
  _count?: Maybe<BranchCountAggregate>;
  _max?: Maybe<BranchMaxAggregate>;
  _min?: Maybe<BranchMinAggregate>;
  _sum?: Maybe<BranchSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type BranchListRelationFilter = {
  every?: Maybe<BranchWhereInput>;
  none?: Maybe<BranchWhereInput>;
  some?: Maybe<BranchWhereInput>;
};

export type BranchMaxAggregate = {
  __typename?: 'BranchMaxAggregate';
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  CertificateOption?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  ClientApproval?: Maybe<Scalars['Boolean']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  Email?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchMaxOrderByAggregateInput = {
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BranchMinAggregate = {
  __typename?: 'BranchMinAggregate';
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  CertificateOption?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  ClientApproval?: Maybe<Scalars['Boolean']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  Email?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BranchMinOrderByAggregateInput = {
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BranchOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type BranchOrderByWithAggregationInput = {
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  _avg?: Maybe<BranchAvgOrderByAggregateInput>;
  _count?: Maybe<BranchCountOrderByAggregateInput>;
  _max?: Maybe<BranchMaxOrderByAggregateInput>;
  _min?: Maybe<BranchMinOrderByAggregateInput>;
  _sum?: Maybe<BranchSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BranchOrderByWithRelationInput = {
  BankDetail?: Maybe<BankDetailOrderByRelationAggregateInput>;
  Benefeciary?: Maybe<BenefeciaryOrderByRelationAggregateInput>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  Company?: Maybe<CompanyOrderByWithRelationInput>;
  CompanyId?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  Request?: Maybe<RequestOrderByRelationAggregateInput>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  UserAccess?: Maybe<UserAccessOrderByRelationAggregateInput>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type BranchRelationFilter = {
  is?: Maybe<BranchWhereInput>;
  isNot?: Maybe<BranchWhereInput>;
};

export enum BranchScalarFieldEnum {
  BranchName = 'BranchName',
  Building = 'Building',
  BusinessPlace = 'BusinessPlace',
  CertificateOption = 'CertificateOption',
  City = 'City',
  ClientApproval = 'ClientApproval',
  CompanyId = 'CompanyId',
  Country = 'Country',
  CreatedBy = 'CreatedBy',
  Email = 'Email',
  Flat = 'Flat',
  Honorific = 'Honorific',
  ItPass = 'ITPass',
  IorWe = 'IorWe',
  Locality = 'Locality',
  Mobile = 'Mobile',
  Pan = 'PAN',
  Pincode = 'Pincode',
  ResidentialStatus = 'ResidentialStatus',
  State = 'State',
  Status = 'Status',
  Street = 'Street',
  Tan = 'TAN',
  UpdatedBy = 'UpdatedBy',
  VerifierDesignation = 'VerifierDesignation',
  VerifierFatherName = 'VerifierFatherName',
  VerifierName = 'VerifierName',
  VerifierPlace = 'VerifierPlace',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  UpdatedAt = 'updatedAt'
}

export type BranchScalarWhereInput = {
  AND?: Maybe<Array<BranchScalarWhereInput>>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  CertificateOption?: Maybe<StringFilter>;
  City?: Maybe<StringFilter>;
  ClientApproval?: Maybe<BoolFilter>;
  CompanyId?: Maybe<IntFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Email?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Honorific?: Maybe<StringFilter>;
  ITPass?: Maybe<StringFilter>;
  IorWe?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  Mobile?: Maybe<StringFilter>;
  NOT?: Maybe<Array<BranchScalarWhereInput>>;
  OR?: Maybe<Array<BranchScalarWhereInput>>;
  PAN?: Maybe<StringFilter>;
  Pincode?: Maybe<StringFilter>;
  ResidentialStatus?: Maybe<StringFilter>;
  State?: Maybe<StringFilter>;
  Status?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  TAN?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  VerifierDesignation?: Maybe<StringFilter>;
  VerifierFatherName?: Maybe<StringFilter>;
  VerifierName?: Maybe<StringFilter>;
  VerifierPlace?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BranchScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<BranchScalarWhereWithAggregatesInput>>;
  BranchName?: Maybe<StringWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  BusinessPlace?: Maybe<StringWithAggregatesFilter>;
  CertificateOption?: Maybe<StringWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  ClientApproval?: Maybe<BoolWithAggregatesFilter>;
  CompanyId?: Maybe<IntWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  Email?: Maybe<StringWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  Honorific?: Maybe<StringWithAggregatesFilter>;
  ITPass?: Maybe<StringWithAggregatesFilter>;
  IorWe?: Maybe<StringWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  Mobile?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<BranchScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<BranchScalarWhereWithAggregatesInput>>;
  PAN?: Maybe<StringWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  ResidentialStatus?: Maybe<StringWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Status?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  TAN?: Maybe<StringWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  VerifierDesignation?: Maybe<StringWithAggregatesFilter>;
  VerifierFatherName?: Maybe<StringWithAggregatesFilter>;
  VerifierName?: Maybe<StringWithAggregatesFilter>;
  VerifierPlace?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type BranchSumAggregate = {
  __typename?: 'BranchSumAggregate';
  CompanyId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type BranchSumOrderByAggregateInput = {
  CompanyId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type BranchUpdateInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutBranchNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutBranchNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBranchNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBranchesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBranchNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutBranchNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpdateManyMutationInput = {
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpdateManyWithWhereWithoutCompanyInput = {
  data: BranchUpdateManyMutationInput;
  where: BranchScalarWhereInput;
};

export type BranchUpdateManyWithoutCompanyNestedInput = {
  connect?: Maybe<Array<BranchWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<BranchCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<BranchCreateWithoutCompanyInput>>;
  createMany?: Maybe<BranchCreateManyCompanyInputEnvelope>;
  delete?: Maybe<Array<BranchWhereUniqueInput>>;
  deleteMany?: Maybe<Array<BranchScalarWhereInput>>;
  disconnect?: Maybe<Array<BranchWhereUniqueInput>>;
  set?: Maybe<Array<BranchWhereUniqueInput>>;
  update?: Maybe<Array<BranchUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<BranchUpdateManyWithWhereWithoutCompanyInput>>;
  upsert?: Maybe<Array<BranchUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type BranchUpdateOneWithoutBankDetailNestedInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutBankDetailInput>;
  create?: Maybe<BranchCreateWithoutBankDetailInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BranchUpdateWithoutBankDetailInput>;
  upsert?: Maybe<BranchUpsertWithoutBankDetailInput>;
};

export type BranchUpdateOneWithoutBenefeciaryNestedInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutBenefeciaryInput>;
  create?: Maybe<BranchCreateWithoutBenefeciaryInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BranchUpdateWithoutBenefeciaryInput>;
  upsert?: Maybe<BranchUpsertWithoutBenefeciaryInput>;
};

export type BranchUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<BranchCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BranchUpdateWithoutDocumentInput>;
  upsert?: Maybe<BranchUpsertWithoutDocumentInput>;
};

export type BranchUpdateOneWithoutRequestNestedInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutRequestInput>;
  create?: Maybe<BranchCreateWithoutRequestInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BranchUpdateWithoutRequestInput>;
  upsert?: Maybe<BranchUpsertWithoutRequestInput>;
};

export type BranchUpdateOneWithoutUserAccessNestedInput = {
  connect?: Maybe<BranchWhereUniqueInput>;
  connectOrCreate?: Maybe<BranchCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<BranchCreateWithoutUserAccessInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<BranchUpdateWithoutUserAccessInput>;
  upsert?: Maybe<BranchUpsertWithoutUserAccessInput>;
};

export type BranchUpdateWithWhereUniqueWithoutCompanyInput = {
  data: BranchUpdateWithoutCompanyInput;
  where: BranchWhereUniqueInput;
};

export type BranchUpdateWithoutBankDetailInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutBranchNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBranchNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBranchesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBranchNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutBranchNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpdateWithoutBenefeciaryInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutBranchNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBranchNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBranchesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBranchNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutBranchNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpdateWithoutCompanyInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutBranchNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutBranchNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBranchesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBranchNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutBranchNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpdateWithoutDocumentInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutBranchNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutBranchNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBranchNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBranchNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutBranchNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpdateWithoutRequestInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutBranchNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutBranchNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBranchNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBranchesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutBranchNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpdateWithoutUserAccessInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutBranchNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutBranchNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutBranchNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutBranchesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutBranchNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type BranchUpsertWithWhereUniqueWithoutCompanyInput = {
  create: BranchCreateWithoutCompanyInput;
  update: BranchUpdateWithoutCompanyInput;
  where: BranchWhereUniqueInput;
};

export type BranchUpsertWithoutBankDetailInput = {
  create: BranchCreateWithoutBankDetailInput;
  update: BranchUpdateWithoutBankDetailInput;
};

export type BranchUpsertWithoutBenefeciaryInput = {
  create: BranchCreateWithoutBenefeciaryInput;
  update: BranchUpdateWithoutBenefeciaryInput;
};

export type BranchUpsertWithoutDocumentInput = {
  create: BranchCreateWithoutDocumentInput;
  update: BranchUpdateWithoutDocumentInput;
};

export type BranchUpsertWithoutRequestInput = {
  create: BranchCreateWithoutRequestInput;
  update: BranchUpdateWithoutRequestInput;
};

export type BranchUpsertWithoutUserAccessInput = {
  create: BranchCreateWithoutUserAccessInput;
  update: BranchUpdateWithoutUserAccessInput;
};

export type BranchWhereInput = {
  AND?: Maybe<Array<BranchWhereInput>>;
  BankDetail?: Maybe<BankDetailListRelationFilter>;
  Benefeciary?: Maybe<BenefeciaryListRelationFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  CertificateOption?: Maybe<StringFilter>;
  City?: Maybe<StringFilter>;
  ClientApproval?: Maybe<BoolFilter>;
  Company?: Maybe<CompanyRelationFilter>;
  CompanyId?: Maybe<IntFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  Email?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Honorific?: Maybe<StringFilter>;
  ITPass?: Maybe<StringFilter>;
  IorWe?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  Mobile?: Maybe<StringFilter>;
  NOT?: Maybe<Array<BranchWhereInput>>;
  OR?: Maybe<Array<BranchWhereInput>>;
  PAN?: Maybe<StringFilter>;
  Pincode?: Maybe<StringFilter>;
  Request?: Maybe<RequestListRelationFilter>;
  ResidentialStatus?: Maybe<StringFilter>;
  State?: Maybe<StringFilter>;
  Status?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  TAN?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  UserAccess?: Maybe<UserAccessListRelationFilter>;
  VerifierDesignation?: Maybe<StringFilter>;
  VerifierFatherName?: Maybe<StringFilter>;
  VerifierName?: Maybe<StringFilter>;
  VerifierPlace?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type BranchWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type CaFirm = {
  __typename?: 'CAFirm';
  Admin?: Maybe<User>;
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  Group: Array<Group>;
  IorWe: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  Udin: Array<Udin>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  Users: Array<User>;
  _count?: Maybe<CaFirmCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type CaFirmGroupArgs = {
  cursor?: Maybe<GroupWhereUniqueInput>;
  distinct?: Maybe<Array<GroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<GroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GroupWhereInput>;
};


export type CaFirmUdinArgs = {
  cursor?: Maybe<UdinWhereUniqueInput>;
  distinct?: Maybe<Array<UdinScalarFieldEnum>>;
  orderBy?: Maybe<Array<UdinOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UdinWhereInput>;
};


export type CaFirmUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};

export type CaFirmAvgAggregate = {
  __typename?: 'CAFirmAvgAggregate';
  AdminId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type CaFirmAvgOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CaFirmCount = {
  __typename?: 'CAFirmCount';
  Group: Scalars['Int'];
  Udin: Scalars['Int'];
  Users: Scalars['Int'];
};

export type CaFirmCountAggregate = {
  __typename?: 'CAFirmCountAggregate';
  AdminId: Scalars['Int'];
  Building: Scalars['Int'];
  City: Scalars['Int'];
  Country: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['Int'];
  FirmRegisterNumber: Scalars['Int'];
  Flat: Scalars['Int'];
  IorWe: Scalars['Int'];
  Locality: Scalars['Int'];
  Pincode: Scalars['Int'];
  State: Scalars['Int'];
  Street: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CaFirmCountOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmName?: Maybe<SortOrder>;
  FirmRegisterNumber?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CaFirmCreateInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutCaFirmInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  Group?: Maybe<GroupCreateNestedManyWithoutFirmInput>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  Udin?: Maybe<UdinCreateNestedManyWithoutFirmInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  Users?: Maybe<UserCreateNestedManyWithoutFirmInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmCreateManyInput = {
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmCreateNestedOneWithoutAdminInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutAdminInput>;
  create?: Maybe<CaFirmCreateWithoutAdminInput>;
};

export type CaFirmCreateNestedOneWithoutGroupInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutGroupInput>;
  create?: Maybe<CaFirmCreateWithoutGroupInput>;
};

export type CaFirmCreateNestedOneWithoutUdinInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutUdinInput>;
  create?: Maybe<CaFirmCreateWithoutUdinInput>;
};

export type CaFirmCreateNestedOneWithoutUsersInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutUsersInput>;
  create?: Maybe<CaFirmCreateWithoutUsersInput>;
};

export type CaFirmCreateOrConnectWithoutAdminInput = {
  create: CaFirmCreateWithoutAdminInput;
  where: CaFirmWhereUniqueInput;
};

export type CaFirmCreateOrConnectWithoutGroupInput = {
  create: CaFirmCreateWithoutGroupInput;
  where: CaFirmWhereUniqueInput;
};

export type CaFirmCreateOrConnectWithoutUdinInput = {
  create: CaFirmCreateWithoutUdinInput;
  where: CaFirmWhereUniqueInput;
};

export type CaFirmCreateOrConnectWithoutUsersInput = {
  create: CaFirmCreateWithoutUsersInput;
  where: CaFirmWhereUniqueInput;
};

export type CaFirmCreateWithoutAdminInput = {
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  Group?: Maybe<GroupCreateNestedManyWithoutFirmInput>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  Udin?: Maybe<UdinCreateNestedManyWithoutFirmInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  Users?: Maybe<UserCreateNestedManyWithoutFirmInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmCreateWithoutGroupInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutCaFirmInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  Udin?: Maybe<UdinCreateNestedManyWithoutFirmInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  Users?: Maybe<UserCreateNestedManyWithoutFirmInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmCreateWithoutUdinInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutCaFirmInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  Group?: Maybe<GroupCreateNestedManyWithoutFirmInput>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  Users?: Maybe<UserCreateNestedManyWithoutFirmInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmCreateWithoutUsersInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutCaFirmInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  Group?: Maybe<GroupCreateNestedManyWithoutFirmInput>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  Udin?: Maybe<UdinCreateNestedManyWithoutFirmInput>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmGroupBy = {
  __typename?: 'CAFirmGroupBy';
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmName: Scalars['String'];
  FirmRegisterNumber: Scalars['String'];
  Flat: Scalars['String'];
  IorWe: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  _avg?: Maybe<CaFirmAvgAggregate>;
  _count?: Maybe<CaFirmCountAggregate>;
  _max?: Maybe<CaFirmMaxAggregate>;
  _min?: Maybe<CaFirmMinAggregate>;
  _sum?: Maybe<CaFirmSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CaFirmMaxAggregate = {
  __typename?: 'CAFirmMaxAggregate';
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  FirmName?: Maybe<Scalars['String']>;
  FirmRegisterNumber?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmMaxOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmName?: Maybe<SortOrder>;
  FirmRegisterNumber?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CaFirmMinAggregate = {
  __typename?: 'CAFirmMinAggregate';
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  FirmName?: Maybe<Scalars['String']>;
  FirmRegisterNumber?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CaFirmMinOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmName?: Maybe<SortOrder>;
  FirmRegisterNumber?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CaFirmOrderByWithAggregationInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmName?: Maybe<SortOrder>;
  FirmRegisterNumber?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  _avg?: Maybe<CaFirmAvgOrderByAggregateInput>;
  _count?: Maybe<CaFirmCountOrderByAggregateInput>;
  _max?: Maybe<CaFirmMaxOrderByAggregateInput>;
  _min?: Maybe<CaFirmMinOrderByAggregateInput>;
  _sum?: Maybe<CaFirmSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CaFirmOrderByWithRelationInput = {
  Admin?: Maybe<UserOrderByWithRelationInput>;
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmName?: Maybe<SortOrder>;
  FirmRegisterNumber?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Group?: Maybe<GroupOrderByRelationAggregateInput>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  Udin?: Maybe<UdinOrderByRelationAggregateInput>;
  UpdatedBy?: Maybe<SortOrder>;
  Users?: Maybe<UserOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CaFirmRelationFilter = {
  is?: Maybe<CaFirmWhereInput>;
  isNot?: Maybe<CaFirmWhereInput>;
};

export enum CaFirmScalarFieldEnum {
  AdminId = 'AdminId',
  Building = 'Building',
  City = 'City',
  Country = 'Country',
  CreatedBy = 'CreatedBy',
  FirmName = 'FirmName',
  FirmRegisterNumber = 'FirmRegisterNumber',
  Flat = 'Flat',
  IorWe = 'IorWe',
  Locality = 'Locality',
  Pincode = 'Pincode',
  State = 'State',
  Street = 'Street',
  UpdatedBy = 'UpdatedBy',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type CaFirmScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CaFirmScalarWhereWithAggregatesInput>>;
  AdminId?: Maybe<IntNullableWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  FirmName?: Maybe<StringWithAggregatesFilter>;
  FirmRegisterNumber?: Maybe<StringWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  IorWe?: Maybe<StringWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<CaFirmScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CaFirmScalarWhereWithAggregatesInput>>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CaFirmSumAggregate = {
  __typename?: 'CAFirmSumAggregate';
  AdminId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type CaFirmSumOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CaFirmUpdateInput = {
  Admin?: Maybe<UserUpdateOneWithoutCaFirmNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  FirmName?: Maybe<StringFieldUpdateOperationsInput>;
  FirmRegisterNumber?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateManyWithoutFirmNestedInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutFirmNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  Users?: Maybe<UserUpdateManyWithoutFirmNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CaFirmUpdateManyMutationInput = {
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  FirmName?: Maybe<StringFieldUpdateOperationsInput>;
  FirmRegisterNumber?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CaFirmUpdateOneRequiredWithoutGroupNestedInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutGroupInput>;
  create?: Maybe<CaFirmCreateWithoutGroupInput>;
  update?: Maybe<CaFirmUpdateWithoutGroupInput>;
  upsert?: Maybe<CaFirmUpsertWithoutGroupInput>;
};

export type CaFirmUpdateOneRequiredWithoutUdinNestedInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutUdinInput>;
  create?: Maybe<CaFirmCreateWithoutUdinInput>;
  update?: Maybe<CaFirmUpdateWithoutUdinInput>;
  upsert?: Maybe<CaFirmUpsertWithoutUdinInput>;
};

export type CaFirmUpdateOneWithoutAdminNestedInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutAdminInput>;
  create?: Maybe<CaFirmCreateWithoutAdminInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CaFirmUpdateWithoutAdminInput>;
  upsert?: Maybe<CaFirmUpsertWithoutAdminInput>;
};

export type CaFirmUpdateOneWithoutUsersNestedInput = {
  connect?: Maybe<CaFirmWhereUniqueInput>;
  connectOrCreate?: Maybe<CaFirmCreateOrConnectWithoutUsersInput>;
  create?: Maybe<CaFirmCreateWithoutUsersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CaFirmUpdateWithoutUsersInput>;
  upsert?: Maybe<CaFirmUpsertWithoutUsersInput>;
};

export type CaFirmUpdateWithoutAdminInput = {
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  FirmName?: Maybe<StringFieldUpdateOperationsInput>;
  FirmRegisterNumber?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateManyWithoutFirmNestedInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutFirmNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  Users?: Maybe<UserUpdateManyWithoutFirmNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CaFirmUpdateWithoutGroupInput = {
  Admin?: Maybe<UserUpdateOneWithoutCaFirmNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  FirmName?: Maybe<StringFieldUpdateOperationsInput>;
  FirmRegisterNumber?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutFirmNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  Users?: Maybe<UserUpdateManyWithoutFirmNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CaFirmUpdateWithoutUdinInput = {
  Admin?: Maybe<UserUpdateOneWithoutCaFirmNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  FirmName?: Maybe<StringFieldUpdateOperationsInput>;
  FirmRegisterNumber?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateManyWithoutFirmNestedInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  Users?: Maybe<UserUpdateManyWithoutFirmNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CaFirmUpdateWithoutUsersInput = {
  Admin?: Maybe<UserUpdateOneWithoutCaFirmNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  FirmName?: Maybe<StringFieldUpdateOperationsInput>;
  FirmRegisterNumber?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateManyWithoutFirmNestedInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutFirmNestedInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CaFirmUpsertWithoutAdminInput = {
  create: CaFirmCreateWithoutAdminInput;
  update: CaFirmUpdateWithoutAdminInput;
};

export type CaFirmUpsertWithoutGroupInput = {
  create: CaFirmCreateWithoutGroupInput;
  update: CaFirmUpdateWithoutGroupInput;
};

export type CaFirmUpsertWithoutUdinInput = {
  create: CaFirmCreateWithoutUdinInput;
  update: CaFirmUpdateWithoutUdinInput;
};

export type CaFirmUpsertWithoutUsersInput = {
  create: CaFirmCreateWithoutUsersInput;
  update: CaFirmUpdateWithoutUsersInput;
};

export type CaFirmWhereInput = {
  AND?: Maybe<Array<CaFirmWhereInput>>;
  Admin?: Maybe<UserRelationFilter>;
  AdminId?: Maybe<IntNullableFilter>;
  Building?: Maybe<StringNullableFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  FirmName?: Maybe<StringFilter>;
  FirmRegisterNumber?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Group?: Maybe<GroupListRelationFilter>;
  IorWe?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<CaFirmWhereInput>>;
  OR?: Maybe<Array<CaFirmWhereInput>>;
  Pincode?: Maybe<StringFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  Udin?: Maybe<UdinListRelationFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  Users?: Maybe<UserListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CaFirmWhereUniqueInput = {
  AdminId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Company = {
  __typename?: 'Company';
  BankDetail: Array<BankDetail>;
  Benefeciary: Array<Benefeciary>;
  Branch: Array<Branch>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption: Scalars['String'];
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document: Array<Document>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: Group;
  GroupId: Scalars['Int'];
  Honorific: Scalars['String'];
  ITPass: Scalars['String'];
  IorWe: Scalars['String'];
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request: Array<Request>;
  ResidentialStatus: Scalars['String'];
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess: Array<UserAccess>;
  VerifierDesignation: Scalars['String'];
  VerifierFatherName: Scalars['String'];
  VerifierName: Scalars['String'];
  VerifierPlace: Scalars['String'];
  _count?: Maybe<CompanyCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};


export type CompanyBankDetailArgs = {
  cursor?: Maybe<BankDetailWhereUniqueInput>;
  distinct?: Maybe<Array<BankDetailScalarFieldEnum>>;
  orderBy?: Maybe<Array<BankDetailOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BankDetailWhereInput>;
};


export type CompanyBenefeciaryArgs = {
  cursor?: Maybe<BenefeciaryWhereUniqueInput>;
  distinct?: Maybe<Array<BenefeciaryScalarFieldEnum>>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type CompanyBranchArgs = {
  cursor?: Maybe<BranchWhereUniqueInput>;
  distinct?: Maybe<Array<BranchScalarFieldEnum>>;
  orderBy?: Maybe<Array<BranchOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BranchWhereInput>;
};


export type CompanyDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type CompanyRequestArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  distinct?: Maybe<Array<RequestScalarFieldEnum>>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type CompanyUserAccessArgs = {
  cursor?: Maybe<UserAccessWhereUniqueInput>;
  distinct?: Maybe<Array<UserAccessScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserAccessOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};

export type CompanyAvgAggregate = {
  __typename?: 'CompanyAvgAggregate';
  CreatedBy?: Maybe<Scalars['Float']>;
  GroupId?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type CompanyAvgOrderByAggregateInput = {
  CreatedBy?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CompanyCount = {
  __typename?: 'CompanyCount';
  BankDetail: Scalars['Int'];
  Benefeciary: Scalars['Int'];
  Branch: Scalars['Int'];
  Document: Scalars['Int'];
  Request: Scalars['Int'];
  UserAccess: Scalars['Int'];
};

export type CompanyCountAggregate = {
  __typename?: 'CompanyCountAggregate';
  Building: Scalars['Int'];
  BusinessPlace: Scalars['Int'];
  CertificateOption: Scalars['Int'];
  City: Scalars['Int'];
  ClientApproval: Scalars['Int'];
  CompanyName: Scalars['Int'];
  Country: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['Int'];
  Flat: Scalars['Int'];
  GroupId: Scalars['Int'];
  Honorific: Scalars['Int'];
  ITPass: Scalars['Int'];
  IorWe: Scalars['Int'];
  Locality: Scalars['Int'];
  Mobile: Scalars['Int'];
  PAN: Scalars['Int'];
  Pincode: Scalars['Int'];
  ResidentialStatus: Scalars['Int'];
  State: Scalars['Int'];
  Status: Scalars['Int'];
  Street: Scalars['Int'];
  TAN: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  VerifierDesignation: Scalars['Int'];
  VerifierFatherName: Scalars['Int'];
  VerifierName: Scalars['Int'];
  VerifierPlace: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CompanyCountOrderByAggregateInput = {
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyName?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CompanyCreateInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutCompanyInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutCompanyInput>;
  Branch?: Maybe<BranchCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutCompaniesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: GroupCreateNestedOneWithoutCompanyInput;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutCompanyInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutCompanyInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateManyGroupInput = {
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateManyGroupInputEnvelope = {
  data: Array<CompanyCreateManyGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type CompanyCreateManyInput = {
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  GroupId: Scalars['Int'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateNestedManyWithoutGroupInput = {
  connect?: Maybe<Array<CompanyWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CompanyCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<CompanyCreateWithoutGroupInput>>;
  createMany?: Maybe<CompanyCreateManyGroupInputEnvelope>;
};

export type CompanyCreateNestedOneWithoutBankDetailInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutBankDetailInput>;
  create?: Maybe<CompanyCreateWithoutBankDetailInput>;
};

export type CompanyCreateNestedOneWithoutBenefeciaryInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutBenefeciaryInput>;
  create?: Maybe<CompanyCreateWithoutBenefeciaryInput>;
};

export type CompanyCreateNestedOneWithoutBranchInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutBranchInput>;
  create?: Maybe<CompanyCreateWithoutBranchInput>;
};

export type CompanyCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<CompanyCreateWithoutDocumentInput>;
};

export type CompanyCreateNestedOneWithoutRequestInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutRequestInput>;
  create?: Maybe<CompanyCreateWithoutRequestInput>;
};

export type CompanyCreateNestedOneWithoutUserAccessInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<CompanyCreateWithoutUserAccessInput>;
};

export type CompanyCreateOrConnectWithoutBankDetailInput = {
  create: CompanyCreateWithoutBankDetailInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateOrConnectWithoutBenefeciaryInput = {
  create: CompanyCreateWithoutBenefeciaryInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateOrConnectWithoutBranchInput = {
  create: CompanyCreateWithoutBranchInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateOrConnectWithoutDocumentInput = {
  create: CompanyCreateWithoutDocumentInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateOrConnectWithoutGroupInput = {
  create: CompanyCreateWithoutGroupInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateOrConnectWithoutRequestInput = {
  create: CompanyCreateWithoutRequestInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateOrConnectWithoutUserAccessInput = {
  create: CompanyCreateWithoutUserAccessInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateWithoutBankDetailInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutCompanyInput>;
  Branch?: Maybe<BranchCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutCompaniesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: GroupCreateNestedOneWithoutCompanyInput;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutCompanyInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutCompanyInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateWithoutBenefeciaryInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutCompanyInput>;
  Branch?: Maybe<BranchCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutCompaniesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: GroupCreateNestedOneWithoutCompanyInput;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutCompanyInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutCompanyInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateWithoutBranchInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutCompanyInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutCompaniesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: GroupCreateNestedOneWithoutCompanyInput;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutCompanyInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutCompanyInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateWithoutDocumentInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutCompanyInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutCompanyInput>;
  Branch?: Maybe<BranchCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: GroupCreateNestedOneWithoutCompanyInput;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutCompanyInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutCompanyInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateWithoutGroupInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutCompanyInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutCompanyInput>;
  Branch?: Maybe<BranchCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutCompaniesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutCompanyInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutCompanyInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateWithoutRequestInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutCompanyInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutCompanyInput>;
  Branch?: Maybe<BranchCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutCompaniesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: GroupCreateNestedOneWithoutCompanyInput;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutCompanyInput>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyCreateWithoutUserAccessInput = {
  BankDetail?: Maybe<BankDetailCreateNestedManyWithoutCompanyInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutCompanyInput>;
  Branch?: Maybe<BranchCreateNestedManyWithoutCompanyInput>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutCompaniesInput>;
  Email: Scalars['String'];
  Flat: Scalars['String'];
  Group: GroupCreateNestedOneWithoutCompanyInput;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutCompanyInput>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyGroupBy = {
  __typename?: 'CompanyGroupBy';
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  CertificateOption: Scalars['String'];
  City: Scalars['String'];
  ClientApproval: Scalars['Boolean'];
  CompanyName: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['String'];
  Flat: Scalars['String'];
  GroupId: Scalars['Int'];
  Honorific: Scalars['String'];
  ITPass: Scalars['String'];
  IorWe: Scalars['String'];
  Locality: Scalars['String'];
  Mobile: Scalars['String'];
  PAN?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ResidentialStatus: Scalars['String'];
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation: Scalars['String'];
  VerifierFatherName: Scalars['String'];
  VerifierName: Scalars['String'];
  VerifierPlace: Scalars['String'];
  _avg?: Maybe<CompanyAvgAggregate>;
  _count?: Maybe<CompanyCountAggregate>;
  _max?: Maybe<CompanyMaxAggregate>;
  _min?: Maybe<CompanyMinAggregate>;
  _sum?: Maybe<CompanySumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type CompanyListRelationFilter = {
  every?: Maybe<CompanyWhereInput>;
  none?: Maybe<CompanyWhereInput>;
  some?: Maybe<CompanyWhereInput>;
};

export type CompanyMaxAggregate = {
  __typename?: 'CompanyMaxAggregate';
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  CertificateOption?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  ClientApproval?: Maybe<Scalars['Boolean']>;
  CompanyName?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  Email?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  GroupId?: Maybe<Scalars['Int']>;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyMaxOrderByAggregateInput = {
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyName?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CompanyMinAggregate = {
  __typename?: 'CompanyMinAggregate';
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  CertificateOption?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  ClientApproval?: Maybe<Scalars['Boolean']>;
  CompanyName?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  Email?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  GroupId?: Maybe<Scalars['Int']>;
  Honorific?: Maybe<Scalars['String']>;
  ITPass?: Maybe<Scalars['String']>;
  IorWe?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Mobile?: Maybe<Scalars['String']>;
  PAN?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ResidentialStatus?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  TAN?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  VerifierDesignation?: Maybe<Scalars['String']>;
  VerifierFatherName?: Maybe<Scalars['String']>;
  VerifierName?: Maybe<Scalars['String']>;
  VerifierPlace?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyMinOrderByAggregateInput = {
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyName?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CompanyOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type CompanyOrderByWithAggregationInput = {
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyName?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  _avg?: Maybe<CompanyAvgOrderByAggregateInput>;
  _count?: Maybe<CompanyCountOrderByAggregateInput>;
  _max?: Maybe<CompanyMaxOrderByAggregateInput>;
  _min?: Maybe<CompanyMinOrderByAggregateInput>;
  _sum?: Maybe<CompanySumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CompanyOrderByWithRelationInput = {
  BankDetail?: Maybe<BankDetailOrderByRelationAggregateInput>;
  Benefeciary?: Maybe<BenefeciaryOrderByRelationAggregateInput>;
  Branch?: Maybe<BranchOrderByRelationAggregateInput>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  CertificateOption?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  ClientApproval?: Maybe<SortOrder>;
  CompanyName?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Group?: Maybe<GroupOrderByWithRelationInput>;
  GroupId?: Maybe<SortOrder>;
  Honorific?: Maybe<SortOrder>;
  ITPass?: Maybe<SortOrder>;
  IorWe?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Mobile?: Maybe<SortOrder>;
  PAN?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  Request?: Maybe<RequestOrderByRelationAggregateInput>;
  ResidentialStatus?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  TAN?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  UserAccess?: Maybe<UserAccessOrderByRelationAggregateInput>;
  VerifierDesignation?: Maybe<SortOrder>;
  VerifierFatherName?: Maybe<SortOrder>;
  VerifierName?: Maybe<SortOrder>;
  VerifierPlace?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type CompanyRelationFilter = {
  is?: Maybe<CompanyWhereInput>;
  isNot?: Maybe<CompanyWhereInput>;
};

export enum CompanyScalarFieldEnum {
  Building = 'Building',
  BusinessPlace = 'BusinessPlace',
  CertificateOption = 'CertificateOption',
  City = 'City',
  ClientApproval = 'ClientApproval',
  CompanyName = 'CompanyName',
  Country = 'Country',
  CreatedBy = 'CreatedBy',
  Email = 'Email',
  Flat = 'Flat',
  GroupId = 'GroupId',
  Honorific = 'Honorific',
  ItPass = 'ITPass',
  IorWe = 'IorWe',
  Locality = 'Locality',
  Mobile = 'Mobile',
  Pan = 'PAN',
  Pincode = 'Pincode',
  ResidentialStatus = 'ResidentialStatus',
  State = 'State',
  Status = 'Status',
  Street = 'Street',
  Tan = 'TAN',
  UpdatedBy = 'UpdatedBy',
  VerifierDesignation = 'VerifierDesignation',
  VerifierFatherName = 'VerifierFatherName',
  VerifierName = 'VerifierName',
  VerifierPlace = 'VerifierPlace',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  UpdatedAt = 'updatedAt'
}

export type CompanyScalarWhereInput = {
  AND?: Maybe<Array<CompanyScalarWhereInput>>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  CertificateOption?: Maybe<StringFilter>;
  City?: Maybe<StringFilter>;
  ClientApproval?: Maybe<BoolFilter>;
  CompanyName?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Email?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  GroupId?: Maybe<IntFilter>;
  Honorific?: Maybe<StringFilter>;
  ITPass?: Maybe<StringFilter>;
  IorWe?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  Mobile?: Maybe<StringFilter>;
  NOT?: Maybe<Array<CompanyScalarWhereInput>>;
  OR?: Maybe<Array<CompanyScalarWhereInput>>;
  PAN?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ResidentialStatus?: Maybe<StringFilter>;
  State?: Maybe<StringFilter>;
  Status?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  TAN?: Maybe<StringNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  VerifierDesignation?: Maybe<StringFilter>;
  VerifierFatherName?: Maybe<StringFilter>;
  VerifierName?: Maybe<StringFilter>;
  VerifierPlace?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CompanyScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<CompanyScalarWhereWithAggregatesInput>>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  BusinessPlace?: Maybe<StringWithAggregatesFilter>;
  CertificateOption?: Maybe<StringWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  ClientApproval?: Maybe<BoolWithAggregatesFilter>;
  CompanyName?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  Email?: Maybe<StringWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  GroupId?: Maybe<IntWithAggregatesFilter>;
  Honorific?: Maybe<StringWithAggregatesFilter>;
  ITPass?: Maybe<StringWithAggregatesFilter>;
  IorWe?: Maybe<StringWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  Mobile?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<CompanyScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<CompanyScalarWhereWithAggregatesInput>>;
  PAN?: Maybe<StringNullableWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  ResidentialStatus?: Maybe<StringWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Status?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  TAN?: Maybe<StringNullableWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  VerifierDesignation?: Maybe<StringWithAggregatesFilter>;
  VerifierFatherName?: Maybe<StringWithAggregatesFilter>;
  VerifierName?: Maybe<StringWithAggregatesFilter>;
  VerifierPlace?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type CompanySumAggregate = {
  __typename?: 'CompanySumAggregate';
  CreatedBy?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type CompanySumOrderByAggregateInput = {
  CreatedBy?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type CompanyUpdateInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutCompanyNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutCompanyNestedInput>;
  Branch?: Maybe<BranchUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutCompaniesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutCompanyNestedInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutCompanyNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutCompanyNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateManyMutationInput = {
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateManyWithWhereWithoutGroupInput = {
  data: CompanyUpdateManyMutationInput;
  where: CompanyScalarWhereInput;
};

export type CompanyUpdateManyWithoutGroupNestedInput = {
  connect?: Maybe<Array<CompanyWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<CompanyCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<CompanyCreateWithoutGroupInput>>;
  createMany?: Maybe<CompanyCreateManyGroupInputEnvelope>;
  delete?: Maybe<Array<CompanyWhereUniqueInput>>;
  deleteMany?: Maybe<Array<CompanyScalarWhereInput>>;
  disconnect?: Maybe<Array<CompanyWhereUniqueInput>>;
  set?: Maybe<Array<CompanyWhereUniqueInput>>;
  update?: Maybe<Array<CompanyUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: Maybe<Array<CompanyUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: Maybe<Array<CompanyUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type CompanyUpdateOneRequiredWithoutBenefeciaryNestedInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutBenefeciaryInput>;
  create?: Maybe<CompanyCreateWithoutBenefeciaryInput>;
  update?: Maybe<CompanyUpdateWithoutBenefeciaryInput>;
  upsert?: Maybe<CompanyUpsertWithoutBenefeciaryInput>;
};

export type CompanyUpdateOneRequiredWithoutBranchNestedInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutBranchInput>;
  create?: Maybe<CompanyCreateWithoutBranchInput>;
  update?: Maybe<CompanyUpdateWithoutBranchInput>;
  upsert?: Maybe<CompanyUpsertWithoutBranchInput>;
};

export type CompanyUpdateOneRequiredWithoutRequestNestedInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutRequestInput>;
  create?: Maybe<CompanyCreateWithoutRequestInput>;
  update?: Maybe<CompanyUpdateWithoutRequestInput>;
  upsert?: Maybe<CompanyUpsertWithoutRequestInput>;
};

export type CompanyUpdateOneRequiredWithoutUserAccessNestedInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<CompanyCreateWithoutUserAccessInput>;
  update?: Maybe<CompanyUpdateWithoutUserAccessInput>;
  upsert?: Maybe<CompanyUpsertWithoutUserAccessInput>;
};

export type CompanyUpdateOneWithoutBankDetailNestedInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutBankDetailInput>;
  create?: Maybe<CompanyCreateWithoutBankDetailInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CompanyUpdateWithoutBankDetailInput>;
  upsert?: Maybe<CompanyUpsertWithoutBankDetailInput>;
};

export type CompanyUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<CompanyWhereUniqueInput>;
  connectOrCreate?: Maybe<CompanyCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<CompanyCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<CompanyUpdateWithoutDocumentInput>;
  upsert?: Maybe<CompanyUpsertWithoutDocumentInput>;
};

export type CompanyUpdateWithWhereUniqueWithoutGroupInput = {
  data: CompanyUpdateWithoutGroupInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyUpdateWithoutBankDetailInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutCompanyNestedInput>;
  Branch?: Maybe<BranchUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutCompaniesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutCompanyNestedInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutCompanyNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutCompanyNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateWithoutBenefeciaryInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutCompanyNestedInput>;
  Branch?: Maybe<BranchUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutCompaniesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutCompanyNestedInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutCompanyNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutCompanyNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateWithoutBranchInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutCompanyNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutCompaniesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutCompanyNestedInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutCompanyNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutCompanyNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateWithoutDocumentInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutCompanyNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutCompanyNestedInput>;
  Branch?: Maybe<BranchUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutCompanyNestedInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutCompanyNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutCompanyNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateWithoutGroupInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutCompanyNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutCompanyNestedInput>;
  Branch?: Maybe<BranchUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutCompaniesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutCompanyNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutCompanyNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateWithoutRequestInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutCompanyNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutCompanyNestedInput>;
  Branch?: Maybe<BranchUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutCompaniesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutCompanyNestedInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutCompanyNestedInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateWithoutUserAccessInput = {
  BankDetail?: Maybe<BankDetailUpdateManyWithoutCompanyNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutCompanyNestedInput>;
  Branch?: Maybe<BranchUpdateManyWithoutCompanyNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateOption?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  ClientApproval?: Maybe<BoolFieldUpdateOperationsInput>;
  CompanyName?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutCompaniesNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutCompanyNestedInput>;
  Honorific?: Maybe<StringFieldUpdateOperationsInput>;
  ITPass?: Maybe<StringFieldUpdateOperationsInput>;
  IorWe?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Mobile?: Maybe<StringFieldUpdateOperationsInput>;
  PAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutCompanyNestedInput>;
  ResidentialStatus?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  TAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  VerifierDesignation?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierFatherName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierName?: Maybe<StringFieldUpdateOperationsInput>;
  VerifierPlace?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpsertWithWhereUniqueWithoutGroupInput = {
  create: CompanyCreateWithoutGroupInput;
  update: CompanyUpdateWithoutGroupInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyUpsertWithoutBankDetailInput = {
  create: CompanyCreateWithoutBankDetailInput;
  update: CompanyUpdateWithoutBankDetailInput;
};

export type CompanyUpsertWithoutBenefeciaryInput = {
  create: CompanyCreateWithoutBenefeciaryInput;
  update: CompanyUpdateWithoutBenefeciaryInput;
};

export type CompanyUpsertWithoutBranchInput = {
  create: CompanyCreateWithoutBranchInput;
  update: CompanyUpdateWithoutBranchInput;
};

export type CompanyUpsertWithoutDocumentInput = {
  create: CompanyCreateWithoutDocumentInput;
  update: CompanyUpdateWithoutDocumentInput;
};

export type CompanyUpsertWithoutRequestInput = {
  create: CompanyCreateWithoutRequestInput;
  update: CompanyUpdateWithoutRequestInput;
};

export type CompanyUpsertWithoutUserAccessInput = {
  create: CompanyCreateWithoutUserAccessInput;
  update: CompanyUpdateWithoutUserAccessInput;
};

export type CompanyWhereInput = {
  AND?: Maybe<Array<CompanyWhereInput>>;
  BankDetail?: Maybe<BankDetailListRelationFilter>;
  Benefeciary?: Maybe<BenefeciaryListRelationFilter>;
  Branch?: Maybe<BranchListRelationFilter>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  CertificateOption?: Maybe<StringFilter>;
  City?: Maybe<StringFilter>;
  ClientApproval?: Maybe<BoolFilter>;
  CompanyName?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  Email?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Group?: Maybe<GroupRelationFilter>;
  GroupId?: Maybe<IntFilter>;
  Honorific?: Maybe<StringFilter>;
  ITPass?: Maybe<StringFilter>;
  IorWe?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  Mobile?: Maybe<StringFilter>;
  NOT?: Maybe<Array<CompanyWhereInput>>;
  OR?: Maybe<Array<CompanyWhereInput>>;
  PAN?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  Request?: Maybe<RequestListRelationFilter>;
  ResidentialStatus?: Maybe<StringFilter>;
  State?: Maybe<StringFilter>;
  Status?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  TAN?: Maybe<StringNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  UserAccess?: Maybe<UserAccessListRelationFilter>;
  VerifierDesignation?: Maybe<StringFilter>;
  VerifierFatherName?: Maybe<StringFilter>;
  VerifierName?: Maybe<StringFilter>;
  VerifierPlace?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type CompanyWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type Document = {
  __typename?: 'Document';
  Benefeciary?: Maybe<Benefeciary>;
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Branches?: Maybe<Branch>;
  Companies?: Maybe<Company>;
  CompanyId?: Maybe<Scalars['Int']>;
  Events: Array<Events>;
  Form15CAA?: Maybe<Form15Caa>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CAB?: Maybe<Form15Cab>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CAD?: Maybe<Form15Cad>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CB?: Maybe<Form15Cb>;
  Form15CBId?: Maybe<Scalars['Int']>;
  Request?: Maybe<Request>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  _count?: Maybe<DocumentCount>;
  createdAt: Scalars['DateTime'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type DocumentEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};

export type DocumentAvgAggregate = {
  __typename?: 'DocumentAvgAggregate';
  BenefeciaryId?: Maybe<Scalars['Float']>;
  BranchId?: Maybe<Scalars['Float']>;
  CompanyId?: Maybe<Scalars['Float']>;
  Form15CAAId?: Maybe<Scalars['Float']>;
  Form15CABId?: Maybe<Scalars['Float']>;
  Form15CADId?: Maybe<Scalars['Float']>;
  Form15CBId?: Maybe<Scalars['Float']>;
  RequestId?: Maybe<Scalars['Float']>;
  fileId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type DocumentAvgOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Form15CAAId?: Maybe<SortOrder>;
  Form15CABId?: Maybe<SortOrder>;
  Form15CADId?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  fileId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentCount = {
  __typename?: 'DocumentCount';
  Events: Scalars['Int'];
};

export type DocumentCountAggregate = {
  __typename?: 'DocumentCountAggregate';
  BenefeciaryId: Scalars['Int'];
  BranchId: Scalars['Int'];
  CompanyId: Scalars['Int'];
  Form15CAAId: Scalars['Int'];
  Form15CABId: Scalars['Int'];
  Form15CADId: Scalars['Int'];
  Form15CBId: Scalars['Int'];
  RequestId: Scalars['Int'];
  SpecifyTag: Scalars['Int'];
  Tag: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type DocumentCountOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Form15CAAId?: Maybe<SortOrder>;
  Form15CABId?: Maybe<SortOrder>;
  Form15CADId?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  SpecifyTag?: Maybe<SortOrder>;
  Tag?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fileId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentCreateInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyBenefeciaryInput = {
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyBenefeciaryInputEnvelope = {
  data: Array<DocumentCreateManyBenefeciaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateManyBranchesInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyBranchesInputEnvelope = {
  data: Array<DocumentCreateManyBranchesInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateManyCompaniesInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyCompaniesInputEnvelope = {
  data: Array<DocumentCreateManyCompaniesInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateManyForm15CaaInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyForm15CaaInputEnvelope = {
  data: Array<DocumentCreateManyForm15CaaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateManyForm15CabInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyForm15CabInputEnvelope = {
  data: Array<DocumentCreateManyForm15CabInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateManyForm15CadInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyForm15CadInputEnvelope = {
  data: Array<DocumentCreateManyForm15CadInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateManyForm15CbInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyForm15CbInputEnvelope = {
  data: Array<DocumentCreateManyForm15CbInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateManyInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyRequestInput = {
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateManyRequestInputEnvelope = {
  data: Array<DocumentCreateManyRequestInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type DocumentCreateNestedManyWithoutBenefeciaryInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutBenefeciaryInput>>;
  create?: Maybe<Array<DocumentCreateWithoutBenefeciaryInput>>;
  createMany?: Maybe<DocumentCreateManyBenefeciaryInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutBranchesInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutBranchesInput>>;
  create?: Maybe<Array<DocumentCreateWithoutBranchesInput>>;
  createMany?: Maybe<DocumentCreateManyBranchesInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutCompaniesInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutCompaniesInput>>;
  create?: Maybe<Array<DocumentCreateWithoutCompaniesInput>>;
  createMany?: Maybe<DocumentCreateManyCompaniesInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutForm15CaaInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CaaInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CaaInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CaaInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutForm15CabInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CabInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CabInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CabInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutForm15CadInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CadInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CadInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CadInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutForm15CbInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CbInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CbInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CbInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutRequestInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutRequestInput>>;
  create?: Maybe<Array<DocumentCreateWithoutRequestInput>>;
  createMany?: Maybe<DocumentCreateManyRequestInputEnvelope>;
};

export type DocumentCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<DocumentWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCreateOrConnectWithoutEventsInput>;
  create?: Maybe<DocumentCreateWithoutEventsInput>;
};

export type DocumentCreateNestedOneWithoutFileInput = {
  connect?: Maybe<DocumentWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCreateOrConnectWithoutFileInput>;
  create?: Maybe<DocumentCreateWithoutFileInput>;
};

export type DocumentCreateOrConnectWithoutBenefeciaryInput = {
  create: DocumentCreateWithoutBenefeciaryInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutBranchesInput = {
  create: DocumentCreateWithoutBranchesInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutCompaniesInput = {
  create: DocumentCreateWithoutCompaniesInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutEventsInput = {
  create: DocumentCreateWithoutEventsInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutFileInput = {
  create: DocumentCreateWithoutFileInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutForm15CaaInput = {
  create: DocumentCreateWithoutForm15CaaInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutForm15CabInput = {
  create: DocumentCreateWithoutForm15CabInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutForm15CadInput = {
  create: DocumentCreateWithoutForm15CadInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutForm15CbInput = {
  create: DocumentCreateWithoutForm15CbInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutRequestInput = {
  create: DocumentCreateWithoutRequestInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateWithoutBenefeciaryInput = {
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutBranchesInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutCompaniesInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutEventsInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutFileInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutForm15CaaInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutForm15CabInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutForm15CadInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutForm15CbInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Request?: Maybe<RequestCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentCreateWithoutRequestInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedOneWithoutDocumentInput>;
  Branches?: Maybe<BranchCreateNestedOneWithoutDocumentInput>;
  Companies?: Maybe<CompanyCreateNestedOneWithoutDocumentInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutDocumentInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutDocumentInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutDocumentInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutDocumentInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutDocumentInput>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileCreateNestedOneWithoutDocumentInput>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentGroupBy = {
  __typename?: 'DocumentGroupBy';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  _avg?: Maybe<DocumentAvgAggregate>;
  _count?: Maybe<DocumentCountAggregate>;
  _max?: Maybe<DocumentMaxAggregate>;
  _min?: Maybe<DocumentMinAggregate>;
  _sum?: Maybe<DocumentSumAggregate>;
  createdAt: Scalars['DateTime'];
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DocumentListRelationFilter = {
  every?: Maybe<DocumentWhereInput>;
  none?: Maybe<DocumentWhereInput>;
  some?: Maybe<DocumentWhereInput>;
};

export type DocumentMaxAggregate = {
  __typename?: 'DocumentMaxAggregate';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentMaxOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Form15CAAId?: Maybe<SortOrder>;
  Form15CABId?: Maybe<SortOrder>;
  Form15CADId?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  SpecifyTag?: Maybe<SortOrder>;
  Tag?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fileId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentMinAggregate = {
  __typename?: 'DocumentMinAggregate';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  SpecifyTag?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentMinOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Form15CAAId?: Maybe<SortOrder>;
  Form15CABId?: Maybe<SortOrder>;
  Form15CADId?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  SpecifyTag?: Maybe<SortOrder>;
  Tag?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  fileId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type DocumentOrderByWithAggregationInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Form15CAAId?: Maybe<SortOrder>;
  Form15CABId?: Maybe<SortOrder>;
  Form15CADId?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  SpecifyTag?: Maybe<SortOrder>;
  Tag?: Maybe<SortOrder>;
  _avg?: Maybe<DocumentAvgOrderByAggregateInput>;
  _count?: Maybe<DocumentCountOrderByAggregateInput>;
  _max?: Maybe<DocumentMaxOrderByAggregateInput>;
  _min?: Maybe<DocumentMinOrderByAggregateInput>;
  _sum?: Maybe<DocumentSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  fileId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentOrderByWithRelationInput = {
  Benefeciary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BenefeciaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Branches?: Maybe<BranchOrderByWithRelationInput>;
  Companies?: Maybe<CompanyOrderByWithRelationInput>;
  CompanyId?: Maybe<SortOrder>;
  Events?: Maybe<EventsOrderByRelationAggregateInput>;
  Form15CAA?: Maybe<Form15CaaOrderByWithRelationInput>;
  Form15CAAId?: Maybe<SortOrder>;
  Form15CAB?: Maybe<Form15CabOrderByWithRelationInput>;
  Form15CABId?: Maybe<SortOrder>;
  Form15CAD?: Maybe<Form15CadOrderByWithRelationInput>;
  Form15CADId?: Maybe<SortOrder>;
  Form15CB?: Maybe<Form15CbOrderByWithRelationInput>;
  Form15CBId?: Maybe<SortOrder>;
  Request?: Maybe<RequestOrderByWithRelationInput>;
  RequestId?: Maybe<SortOrder>;
  SpecifyTag?: Maybe<SortOrder>;
  Tag?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  file?: Maybe<FileOrderByWithRelationInput>;
  fileId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  title?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type DocumentRelationFilter = {
  is?: Maybe<DocumentWhereInput>;
  isNot?: Maybe<DocumentWhereInput>;
};

export enum DocumentScalarFieldEnum {
  BenefeciaryId = 'BenefeciaryId',
  BranchId = 'BranchId',
  CompanyId = 'CompanyId',
  Form15CaaId = 'Form15CAAId',
  Form15CabId = 'Form15CABId',
  Form15CadId = 'Form15CADId',
  Form15CbId = 'Form15CBId',
  RequestId = 'RequestId',
  SpecifyTag = 'SpecifyTag',
  Tag = 'Tag',
  CreatedAt = 'createdAt',
  FileId = 'fileId',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type DocumentScalarWhereInput = {
  AND?: Maybe<Array<DocumentScalarWhereInput>>;
  BenefeciaryId?: Maybe<IntNullableFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  CompanyId?: Maybe<IntNullableFilter>;
  Form15CAAId?: Maybe<IntNullableFilter>;
  Form15CABId?: Maybe<IntNullableFilter>;
  Form15CADId?: Maybe<IntNullableFilter>;
  Form15CBId?: Maybe<IntNullableFilter>;
  NOT?: Maybe<Array<DocumentScalarWhereInput>>;
  OR?: Maybe<Array<DocumentScalarWhereInput>>;
  RequestId?: Maybe<IntNullableFilter>;
  SpecifyTag?: Maybe<StringNullableFilter>;
  Tag?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  fileId?: Maybe<IntNullableFilter>;
  id?: Maybe<IntFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DocumentScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<DocumentScalarWhereWithAggregatesInput>>;
  BenefeciaryId?: Maybe<IntNullableWithAggregatesFilter>;
  BranchId?: Maybe<IntNullableWithAggregatesFilter>;
  CompanyId?: Maybe<IntNullableWithAggregatesFilter>;
  Form15CAAId?: Maybe<IntNullableWithAggregatesFilter>;
  Form15CABId?: Maybe<IntNullableWithAggregatesFilter>;
  Form15CADId?: Maybe<IntNullableWithAggregatesFilter>;
  Form15CBId?: Maybe<IntNullableWithAggregatesFilter>;
  NOT?: Maybe<Array<DocumentScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<DocumentScalarWhereWithAggregatesInput>>;
  RequestId?: Maybe<IntNullableWithAggregatesFilter>;
  SpecifyTag?: Maybe<StringNullableWithAggregatesFilter>;
  Tag?: Maybe<StringNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  fileId?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  title?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type DocumentSumAggregate = {
  __typename?: 'DocumentSumAggregate';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  Form15CAAId?: Maybe<Scalars['Int']>;
  Form15CABId?: Maybe<Scalars['Int']>;
  Form15CADId?: Maybe<Scalars['Int']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  RequestId?: Maybe<Scalars['Int']>;
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type DocumentSumOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  Form15CAAId?: Maybe<SortOrder>;
  Form15CABId?: Maybe<SortOrder>;
  Form15CADId?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  fileId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type DocumentUpdateInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateManyMutationInput = {
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateManyWithWhereWithoutBenefeciaryInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutBranchesInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutCompaniesInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutForm15CaaInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutForm15CabInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutForm15CadInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutForm15CbInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutRequestInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithoutBenefeciaryNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutBenefeciaryInput>>;
  create?: Maybe<Array<DocumentCreateWithoutBenefeciaryInput>>;
  createMany?: Maybe<DocumentCreateManyBenefeciaryInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutBenefeciaryInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutBenefeciaryInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutBenefeciaryInput>>;
};

export type DocumentUpdateManyWithoutBranchesNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutBranchesInput>>;
  create?: Maybe<Array<DocumentCreateWithoutBranchesInput>>;
  createMany?: Maybe<DocumentCreateManyBranchesInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutBranchesInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutBranchesInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutBranchesInput>>;
};

export type DocumentUpdateManyWithoutCompaniesNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutCompaniesInput>>;
  create?: Maybe<Array<DocumentCreateWithoutCompaniesInput>>;
  createMany?: Maybe<DocumentCreateManyCompaniesInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutCompaniesInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutCompaniesInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutCompaniesInput>>;
};

export type DocumentUpdateManyWithoutForm15CaaNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CaaInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CaaInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CaaInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutForm15CaaInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutForm15CaaInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutForm15CaaInput>>;
};

export type DocumentUpdateManyWithoutForm15CabNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CabInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CabInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CabInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutForm15CabInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutForm15CabInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutForm15CabInput>>;
};

export type DocumentUpdateManyWithoutForm15CadNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CadInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CadInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CadInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutForm15CadInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutForm15CadInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutForm15CadInput>>;
};

export type DocumentUpdateManyWithoutForm15CbNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutForm15CbInput>>;
  create?: Maybe<Array<DocumentCreateWithoutForm15CbInput>>;
  createMany?: Maybe<DocumentCreateManyForm15CbInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutForm15CbInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutForm15CbInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutForm15CbInput>>;
};

export type DocumentUpdateManyWithoutRequestNestedInput = {
  connect?: Maybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<DocumentCreateOrConnectWithoutRequestInput>>;
  create?: Maybe<Array<DocumentCreateWithoutRequestInput>>;
  createMany?: Maybe<DocumentCreateManyRequestInputEnvelope>;
  delete?: Maybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: Maybe<Array<DocumentScalarWhereInput>>;
  disconnect?: Maybe<Array<DocumentWhereUniqueInput>>;
  set?: Maybe<Array<DocumentWhereUniqueInput>>;
  update?: Maybe<Array<DocumentUpdateWithWhereUniqueWithoutRequestInput>>;
  updateMany?: Maybe<Array<DocumentUpdateManyWithWhereWithoutRequestInput>>;
  upsert?: Maybe<Array<DocumentUpsertWithWhereUniqueWithoutRequestInput>>;
};

export type DocumentUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<DocumentWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCreateOrConnectWithoutEventsInput>;
  create?: Maybe<DocumentCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<DocumentUpdateWithoutEventsInput>;
  upsert?: Maybe<DocumentUpsertWithoutEventsInput>;
};

export type DocumentUpdateOneWithoutFileNestedInput = {
  connect?: Maybe<DocumentWhereUniqueInput>;
  connectOrCreate?: Maybe<DocumentCreateOrConnectWithoutFileInput>;
  create?: Maybe<DocumentCreateWithoutFileInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<DocumentUpdateWithoutFileInput>;
  upsert?: Maybe<DocumentUpsertWithoutFileInput>;
};

export type DocumentUpdateWithWhereUniqueWithoutBenefeciaryInput = {
  data: DocumentUpdateWithoutBenefeciaryInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutBranchesInput = {
  data: DocumentUpdateWithoutBranchesInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutCompaniesInput = {
  data: DocumentUpdateWithoutCompaniesInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutForm15CaaInput = {
  data: DocumentUpdateWithoutForm15CaaInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutForm15CabInput = {
  data: DocumentUpdateWithoutForm15CabInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutForm15CadInput = {
  data: DocumentUpdateWithoutForm15CadInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutForm15CbInput = {
  data: DocumentUpdateWithoutForm15CbInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutRequestInput = {
  data: DocumentUpdateWithoutRequestInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithoutBenefeciaryInput = {
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutBranchesInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutCompaniesInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutEventsInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutFileInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutForm15CaaInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutForm15CabInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutForm15CadInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutForm15CbInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Request?: Maybe<RequestUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpdateWithoutRequestInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneWithoutDocumentNestedInput>;
  Branches?: Maybe<BranchUpdateOneWithoutDocumentNestedInput>;
  Companies?: Maybe<CompanyUpdateOneWithoutDocumentNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutDocumentNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutDocumentNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutDocumentNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutDocumentNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutDocumentNestedInput>;
  SpecifyTag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Tag?: Maybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  file?: Maybe<FileUpdateOneWithoutDocumentNestedInput>;
  title?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentUpsertWithWhereUniqueWithoutBenefeciaryInput = {
  create: DocumentCreateWithoutBenefeciaryInput;
  update: DocumentUpdateWithoutBenefeciaryInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutBranchesInput = {
  create: DocumentCreateWithoutBranchesInput;
  update: DocumentUpdateWithoutBranchesInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutCompaniesInput = {
  create: DocumentCreateWithoutCompaniesInput;
  update: DocumentUpdateWithoutCompaniesInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutForm15CaaInput = {
  create: DocumentCreateWithoutForm15CaaInput;
  update: DocumentUpdateWithoutForm15CaaInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutForm15CabInput = {
  create: DocumentCreateWithoutForm15CabInput;
  update: DocumentUpdateWithoutForm15CabInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutForm15CadInput = {
  create: DocumentCreateWithoutForm15CadInput;
  update: DocumentUpdateWithoutForm15CadInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutForm15CbInput = {
  create: DocumentCreateWithoutForm15CbInput;
  update: DocumentUpdateWithoutForm15CbInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutRequestInput = {
  create: DocumentCreateWithoutRequestInput;
  update: DocumentUpdateWithoutRequestInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithoutEventsInput = {
  create: DocumentCreateWithoutEventsInput;
  update: DocumentUpdateWithoutEventsInput;
};

export type DocumentUpsertWithoutFileInput = {
  create: DocumentCreateWithoutFileInput;
  update: DocumentUpdateWithoutFileInput;
};

export type DocumentWhereInput = {
  AND?: Maybe<Array<DocumentWhereInput>>;
  Benefeciary?: Maybe<BenefeciaryRelationFilter>;
  BenefeciaryId?: Maybe<IntNullableFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  Branches?: Maybe<BranchRelationFilter>;
  Companies?: Maybe<CompanyRelationFilter>;
  CompanyId?: Maybe<IntNullableFilter>;
  Events?: Maybe<EventsListRelationFilter>;
  Form15CAA?: Maybe<Form15CaaRelationFilter>;
  Form15CAAId?: Maybe<IntNullableFilter>;
  Form15CAB?: Maybe<Form15CabRelationFilter>;
  Form15CABId?: Maybe<IntNullableFilter>;
  Form15CAD?: Maybe<Form15CadRelationFilter>;
  Form15CADId?: Maybe<IntNullableFilter>;
  Form15CB?: Maybe<Form15CbRelationFilter>;
  Form15CBId?: Maybe<IntNullableFilter>;
  NOT?: Maybe<Array<DocumentWhereInput>>;
  OR?: Maybe<Array<DocumentWhereInput>>;
  Request?: Maybe<RequestRelationFilter>;
  RequestId?: Maybe<IntNullableFilter>;
  SpecifyTag?: Maybe<StringNullableFilter>;
  Tag?: Maybe<StringNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  file?: Maybe<FileRelationFilter>;
  fileId?: Maybe<IntNullableFilter>;
  id?: Maybe<IntFilter>;
  title?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type DocumentWhereUniqueInput = {
  fileId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type EmailResponsePayload = {
  __typename?: 'EmailResponsePayload';
  message: Scalars['String'];
};

export type Events = {
  __typename?: 'Events';
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: User;
  CreatedById: Scalars['Int'];
  Document?: Maybe<Document>;
  Form15CAA?: Maybe<Form15Caa>;
  Form15CAB?: Maybe<Form15Cab>;
  Form15CAC?: Maybe<Form15Cac>;
  Form15CAD?: Maybe<Form15Cad>;
  Form15CB?: Maybe<Form15Cb>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt: Scalars['DateTime'];
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsAvgAggregate = {
  __typename?: 'EventsAvgAggregate';
  CreatedById?: Maybe<Scalars['Float']>;
  documentId?: Maybe<Scalars['Float']>;
  form15CAAId?: Maybe<Scalars['Float']>;
  form15CABId?: Maybe<Scalars['Float']>;
  form15CACId?: Maybe<Scalars['Float']>;
  form15CADId?: Maybe<Scalars['Float']>;
  form15CBId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type EventsAvgOrderByAggregateInput = {
  CreatedById?: Maybe<SortOrder>;
  documentId?: Maybe<SortOrder>;
  form15CAAId?: Maybe<SortOrder>;
  form15CABId?: Maybe<SortOrder>;
  form15CACId?: Maybe<SortOrder>;
  form15CADId?: Maybe<SortOrder>;
  form15CBId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type EventsCountAggregate = {
  __typename?: 'EventsCountAggregate';
  AckNumber: Scalars['Int'];
  CertificateDate: Scalars['Int'];
  CreatedById: Scalars['Int'];
  UDIN: Scalars['Int'];
  _all: Scalars['Int'];
  comments: Scalars['Int'];
  createdAt: Scalars['Int'];
  documentId: Scalars['Int'];
  form15CAAId: Scalars['Int'];
  form15CABId: Scalars['Int'];
  form15CACId: Scalars['Int'];
  form15CADId: Scalars['Int'];
  form15CBId: Scalars['Int'];
  id: Scalars['Int'];
  isLatest: Scalars['Int'];
  status: Scalars['Int'];
};

export type EventsCountOrderByAggregateInput = {
  AckNumber?: Maybe<SortOrder>;
  CertificateDate?: Maybe<SortOrder>;
  CreatedById?: Maybe<SortOrder>;
  UDIN?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentId?: Maybe<SortOrder>;
  form15CAAId?: Maybe<SortOrder>;
  form15CABId?: Maybe<SortOrder>;
  form15CACId?: Maybe<SortOrder>;
  form15CADId?: Maybe<SortOrder>;
  form15CBId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isLatest?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type EventsCreateInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: UserCreateNestedOneWithoutEventsInput;
  Document?: Maybe<DocumentCreateNestedOneWithoutEventsInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutEventsInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutEventsInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutEventsInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutEventsInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyCreatedByInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyCreatedByInputEnvelope = {
  data: Array<EventsCreateManyCreatedByInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EventsCreateManyDocumentInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyDocumentInputEnvelope = {
  data: Array<EventsCreateManyDocumentInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EventsCreateManyForm15CaaInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyForm15CaaInputEnvelope = {
  data: Array<EventsCreateManyForm15CaaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EventsCreateManyForm15CabInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyForm15CabInputEnvelope = {
  data: Array<EventsCreateManyForm15CabInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EventsCreateManyForm15CacInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyForm15CacInputEnvelope = {
  data: Array<EventsCreateManyForm15CacInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EventsCreateManyForm15CadInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyForm15CadInputEnvelope = {
  data: Array<EventsCreateManyForm15CadInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EventsCreateManyForm15CbInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateManyForm15CbInputEnvelope = {
  data: Array<EventsCreateManyForm15CbInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type EventsCreateManyInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateNestedManyWithoutCreatedByInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutCreatedByInput>>;
  create?: Maybe<Array<EventsCreateWithoutCreatedByInput>>;
  createMany?: Maybe<EventsCreateManyCreatedByInputEnvelope>;
};

export type EventsCreateNestedManyWithoutDocumentInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutDocumentInput>>;
  create?: Maybe<Array<EventsCreateWithoutDocumentInput>>;
  createMany?: Maybe<EventsCreateManyDocumentInputEnvelope>;
};

export type EventsCreateNestedManyWithoutForm15CaaInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CaaInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CaaInput>>;
  createMany?: Maybe<EventsCreateManyForm15CaaInputEnvelope>;
};

export type EventsCreateNestedManyWithoutForm15CabInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CabInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CabInput>>;
  createMany?: Maybe<EventsCreateManyForm15CabInputEnvelope>;
};

export type EventsCreateNestedManyWithoutForm15CacInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CacInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CacInput>>;
  createMany?: Maybe<EventsCreateManyForm15CacInputEnvelope>;
};

export type EventsCreateNestedManyWithoutForm15CadInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CadInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CadInput>>;
  createMany?: Maybe<EventsCreateManyForm15CadInputEnvelope>;
};

export type EventsCreateNestedManyWithoutForm15CbInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CbInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CbInput>>;
  createMany?: Maybe<EventsCreateManyForm15CbInputEnvelope>;
};

export type EventsCreateOrConnectWithoutCreatedByInput = {
  create: EventsCreateWithoutCreatedByInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutDocumentInput = {
  create: EventsCreateWithoutDocumentInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutForm15CaaInput = {
  create: EventsCreateWithoutForm15CaaInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutForm15CabInput = {
  create: EventsCreateWithoutForm15CabInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutForm15CacInput = {
  create: EventsCreateWithoutForm15CacInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutForm15CadInput = {
  create: EventsCreateWithoutForm15CadInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateOrConnectWithoutForm15CbInput = {
  create: EventsCreateWithoutForm15CbInput;
  where: EventsWhereUniqueInput;
};

export type EventsCreateWithoutCreatedByInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedOneWithoutEventsInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutEventsInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutEventsInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutEventsInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutEventsInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateWithoutDocumentInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: UserCreateNestedOneWithoutEventsInput;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutEventsInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutEventsInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutEventsInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutEventsInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateWithoutForm15CaaInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: UserCreateNestedOneWithoutEventsInput;
  Document?: Maybe<DocumentCreateNestedOneWithoutEventsInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutEventsInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutEventsInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutEventsInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateWithoutForm15CabInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: UserCreateNestedOneWithoutEventsInput;
  Document?: Maybe<DocumentCreateNestedOneWithoutEventsInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutEventsInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutEventsInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutEventsInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateWithoutForm15CacInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: UserCreateNestedOneWithoutEventsInput;
  Document?: Maybe<DocumentCreateNestedOneWithoutEventsInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutEventsInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutEventsInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutEventsInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateWithoutForm15CadInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: UserCreateNestedOneWithoutEventsInput;
  Document?: Maybe<DocumentCreateNestedOneWithoutEventsInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutEventsInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutEventsInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutEventsInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsCreateWithoutForm15CbInput = {
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedBy: UserCreateNestedOneWithoutEventsInput;
  Document?: Maybe<DocumentCreateNestedOneWithoutEventsInput>;
  Form15CAA?: Maybe<Form15CaaCreateNestedOneWithoutEventsInput>;
  Form15CAB?: Maybe<Form15CabCreateNestedOneWithoutEventsInput>;
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutEventsInput>;
  Form15CAD?: Maybe<Form15CadCreateNestedOneWithoutEventsInput>;
  UDIN?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsGroupBy = {
  __typename?: 'EventsGroupBy';
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById: Scalars['Int'];
  UDIN?: Maybe<Scalars['String']>;
  _avg?: Maybe<EventsAvgAggregate>;
  _count?: Maybe<EventsCountAggregate>;
  _max?: Maybe<EventsMaxAggregate>;
  _min?: Maybe<EventsMinAggregate>;
  _sum?: Maybe<EventsSumAggregate>;
  comments: Scalars['String'];
  createdAt: Scalars['DateTime'];
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isLatest: Scalars['Boolean'];
  status: Scalars['String'];
};

export type EventsListRelationFilter = {
  every?: Maybe<EventsWhereInput>;
  none?: Maybe<EventsWhereInput>;
  some?: Maybe<EventsWhereInput>;
};

export type EventsMaxAggregate = {
  __typename?: 'EventsMaxAggregate';
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById?: Maybe<Scalars['Int']>;
  UDIN?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type EventsMaxOrderByAggregateInput = {
  AckNumber?: Maybe<SortOrder>;
  CertificateDate?: Maybe<SortOrder>;
  CreatedById?: Maybe<SortOrder>;
  UDIN?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentId?: Maybe<SortOrder>;
  form15CAAId?: Maybe<SortOrder>;
  form15CABId?: Maybe<SortOrder>;
  form15CACId?: Maybe<SortOrder>;
  form15CADId?: Maybe<SortOrder>;
  form15CBId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isLatest?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type EventsMinAggregate = {
  __typename?: 'EventsMinAggregate';
  AckNumber?: Maybe<Scalars['String']>;
  CertificateDate?: Maybe<Scalars['DateTime']>;
  CreatedById?: Maybe<Scalars['Int']>;
  UDIN?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isLatest?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type EventsMinOrderByAggregateInput = {
  AckNumber?: Maybe<SortOrder>;
  CertificateDate?: Maybe<SortOrder>;
  CreatedById?: Maybe<SortOrder>;
  UDIN?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentId?: Maybe<SortOrder>;
  form15CAAId?: Maybe<SortOrder>;
  form15CABId?: Maybe<SortOrder>;
  form15CACId?: Maybe<SortOrder>;
  form15CADId?: Maybe<SortOrder>;
  form15CBId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isLatest?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type EventsOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type EventsOrderByWithAggregationInput = {
  AckNumber?: Maybe<SortOrder>;
  CertificateDate?: Maybe<SortOrder>;
  CreatedById?: Maybe<SortOrder>;
  UDIN?: Maybe<SortOrder>;
  _avg?: Maybe<EventsAvgOrderByAggregateInput>;
  _count?: Maybe<EventsCountOrderByAggregateInput>;
  _max?: Maybe<EventsMaxOrderByAggregateInput>;
  _min?: Maybe<EventsMinOrderByAggregateInput>;
  _sum?: Maybe<EventsSumOrderByAggregateInput>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentId?: Maybe<SortOrder>;
  form15CAAId?: Maybe<SortOrder>;
  form15CABId?: Maybe<SortOrder>;
  form15CACId?: Maybe<SortOrder>;
  form15CADId?: Maybe<SortOrder>;
  form15CBId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isLatest?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export type EventsOrderByWithRelationInput = {
  AckNumber?: Maybe<SortOrder>;
  CertificateDate?: Maybe<SortOrder>;
  CreatedBy?: Maybe<UserOrderByWithRelationInput>;
  CreatedById?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByWithRelationInput>;
  Form15CAA?: Maybe<Form15CaaOrderByWithRelationInput>;
  Form15CAB?: Maybe<Form15CabOrderByWithRelationInput>;
  Form15CAC?: Maybe<Form15CacOrderByWithRelationInput>;
  Form15CAD?: Maybe<Form15CadOrderByWithRelationInput>;
  Form15CB?: Maybe<Form15CbOrderByWithRelationInput>;
  UDIN?: Maybe<SortOrder>;
  comments?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  documentId?: Maybe<SortOrder>;
  form15CAAId?: Maybe<SortOrder>;
  form15CABId?: Maybe<SortOrder>;
  form15CACId?: Maybe<SortOrder>;
  form15CADId?: Maybe<SortOrder>;
  form15CBId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isLatest?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
};

export enum EventsScalarFieldEnum {
  AckNumber = 'AckNumber',
  CertificateDate = 'CertificateDate',
  CreatedById = 'CreatedById',
  Udin = 'UDIN',
  Comments = 'comments',
  CreatedAt = 'createdAt',
  DocumentId = 'documentId',
  Form15CaaId = 'form15CAAId',
  Form15CabId = 'form15CABId',
  Form15CacId = 'form15CACId',
  Form15CadId = 'form15CADId',
  Form15CbId = 'form15CBId',
  Id = 'id',
  IsLatest = 'isLatest',
  Status = 'status'
}

export type EventsScalarWhereInput = {
  AND?: Maybe<Array<EventsScalarWhereInput>>;
  AckNumber?: Maybe<StringNullableFilter>;
  CertificateDate?: Maybe<DateTimeNullableFilter>;
  CreatedById?: Maybe<IntFilter>;
  NOT?: Maybe<Array<EventsScalarWhereInput>>;
  OR?: Maybe<Array<EventsScalarWhereInput>>;
  UDIN?: Maybe<StringNullableFilter>;
  comments?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  documentId?: Maybe<IntNullableFilter>;
  form15CAAId?: Maybe<IntNullableFilter>;
  form15CABId?: Maybe<IntNullableFilter>;
  form15CACId?: Maybe<IntNullableFilter>;
  form15CADId?: Maybe<IntNullableFilter>;
  form15CBId?: Maybe<IntNullableFilter>;
  id?: Maybe<IntFilter>;
  isLatest?: Maybe<BoolFilter>;
  status?: Maybe<StringFilter>;
};

export type EventsScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<EventsScalarWhereWithAggregatesInput>>;
  AckNumber?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  CreatedById?: Maybe<IntWithAggregatesFilter>;
  NOT?: Maybe<Array<EventsScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<EventsScalarWhereWithAggregatesInput>>;
  UDIN?: Maybe<StringNullableWithAggregatesFilter>;
  comments?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  documentId?: Maybe<IntNullableWithAggregatesFilter>;
  form15CAAId?: Maybe<IntNullableWithAggregatesFilter>;
  form15CABId?: Maybe<IntNullableWithAggregatesFilter>;
  form15CACId?: Maybe<IntNullableWithAggregatesFilter>;
  form15CADId?: Maybe<IntNullableWithAggregatesFilter>;
  form15CBId?: Maybe<IntNullableWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  isLatest?: Maybe<BoolWithAggregatesFilter>;
  status?: Maybe<StringWithAggregatesFilter>;
};

export type EventsSumAggregate = {
  __typename?: 'EventsSumAggregate';
  CreatedById?: Maybe<Scalars['Int']>;
  documentId?: Maybe<Scalars['Int']>;
  form15CAAId?: Maybe<Scalars['Int']>;
  form15CABId?: Maybe<Scalars['Int']>;
  form15CACId?: Maybe<Scalars['Int']>;
  form15CADId?: Maybe<Scalars['Int']>;
  form15CBId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type EventsSumOrderByAggregateInput = {
  CreatedById?: Maybe<SortOrder>;
  documentId?: Maybe<SortOrder>;
  form15CAAId?: Maybe<SortOrder>;
  form15CABId?: Maybe<SortOrder>;
  form15CACId?: Maybe<SortOrder>;
  form15CADId?: Maybe<SortOrder>;
  form15CBId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type EventsUpdateInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<UserUpdateOneRequiredWithoutEventsNestedInput>;
  Document?: Maybe<DocumentUpdateOneWithoutEventsNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutEventsNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutEventsNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutEventsNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutEventsNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateManyMutationInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateManyWithWhereWithoutCreatedByInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutDocumentInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutForm15CaaInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutForm15CabInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutForm15CacInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutForm15CadInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithWhereWithoutForm15CbInput = {
  data: EventsUpdateManyMutationInput;
  where: EventsScalarWhereInput;
};

export type EventsUpdateManyWithoutCreatedByNestedInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutCreatedByInput>>;
  create?: Maybe<Array<EventsCreateWithoutCreatedByInput>>;
  createMany?: Maybe<EventsCreateManyCreatedByInputEnvelope>;
  delete?: Maybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EventsScalarWhereInput>>;
  disconnect?: Maybe<Array<EventsWhereUniqueInput>>;
  set?: Maybe<Array<EventsWhereUniqueInput>>;
  update?: Maybe<Array<EventsUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: Maybe<Array<EventsUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: Maybe<Array<EventsUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type EventsUpdateManyWithoutDocumentNestedInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutDocumentInput>>;
  create?: Maybe<Array<EventsCreateWithoutDocumentInput>>;
  createMany?: Maybe<EventsCreateManyDocumentInputEnvelope>;
  delete?: Maybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EventsScalarWhereInput>>;
  disconnect?: Maybe<Array<EventsWhereUniqueInput>>;
  set?: Maybe<Array<EventsWhereUniqueInput>>;
  update?: Maybe<Array<EventsUpdateWithWhereUniqueWithoutDocumentInput>>;
  updateMany?: Maybe<Array<EventsUpdateManyWithWhereWithoutDocumentInput>>;
  upsert?: Maybe<Array<EventsUpsertWithWhereUniqueWithoutDocumentInput>>;
};

export type EventsUpdateManyWithoutForm15CaaNestedInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CaaInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CaaInput>>;
  createMany?: Maybe<EventsCreateManyForm15CaaInputEnvelope>;
  delete?: Maybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EventsScalarWhereInput>>;
  disconnect?: Maybe<Array<EventsWhereUniqueInput>>;
  set?: Maybe<Array<EventsWhereUniqueInput>>;
  update?: Maybe<Array<EventsUpdateWithWhereUniqueWithoutForm15CaaInput>>;
  updateMany?: Maybe<Array<EventsUpdateManyWithWhereWithoutForm15CaaInput>>;
  upsert?: Maybe<Array<EventsUpsertWithWhereUniqueWithoutForm15CaaInput>>;
};

export type EventsUpdateManyWithoutForm15CabNestedInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CabInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CabInput>>;
  createMany?: Maybe<EventsCreateManyForm15CabInputEnvelope>;
  delete?: Maybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EventsScalarWhereInput>>;
  disconnect?: Maybe<Array<EventsWhereUniqueInput>>;
  set?: Maybe<Array<EventsWhereUniqueInput>>;
  update?: Maybe<Array<EventsUpdateWithWhereUniqueWithoutForm15CabInput>>;
  updateMany?: Maybe<Array<EventsUpdateManyWithWhereWithoutForm15CabInput>>;
  upsert?: Maybe<Array<EventsUpsertWithWhereUniqueWithoutForm15CabInput>>;
};

export type EventsUpdateManyWithoutForm15CacNestedInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CacInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CacInput>>;
  createMany?: Maybe<EventsCreateManyForm15CacInputEnvelope>;
  delete?: Maybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EventsScalarWhereInput>>;
  disconnect?: Maybe<Array<EventsWhereUniqueInput>>;
  set?: Maybe<Array<EventsWhereUniqueInput>>;
  update?: Maybe<Array<EventsUpdateWithWhereUniqueWithoutForm15CacInput>>;
  updateMany?: Maybe<Array<EventsUpdateManyWithWhereWithoutForm15CacInput>>;
  upsert?: Maybe<Array<EventsUpsertWithWhereUniqueWithoutForm15CacInput>>;
};

export type EventsUpdateManyWithoutForm15CadNestedInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CadInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CadInput>>;
  createMany?: Maybe<EventsCreateManyForm15CadInputEnvelope>;
  delete?: Maybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EventsScalarWhereInput>>;
  disconnect?: Maybe<Array<EventsWhereUniqueInput>>;
  set?: Maybe<Array<EventsWhereUniqueInput>>;
  update?: Maybe<Array<EventsUpdateWithWhereUniqueWithoutForm15CadInput>>;
  updateMany?: Maybe<Array<EventsUpdateManyWithWhereWithoutForm15CadInput>>;
  upsert?: Maybe<Array<EventsUpsertWithWhereUniqueWithoutForm15CadInput>>;
};

export type EventsUpdateManyWithoutForm15CbNestedInput = {
  connect?: Maybe<Array<EventsWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<EventsCreateOrConnectWithoutForm15CbInput>>;
  create?: Maybe<Array<EventsCreateWithoutForm15CbInput>>;
  createMany?: Maybe<EventsCreateManyForm15CbInputEnvelope>;
  delete?: Maybe<Array<EventsWhereUniqueInput>>;
  deleteMany?: Maybe<Array<EventsScalarWhereInput>>;
  disconnect?: Maybe<Array<EventsWhereUniqueInput>>;
  set?: Maybe<Array<EventsWhereUniqueInput>>;
  update?: Maybe<Array<EventsUpdateWithWhereUniqueWithoutForm15CbInput>>;
  updateMany?: Maybe<Array<EventsUpdateManyWithWhereWithoutForm15CbInput>>;
  upsert?: Maybe<Array<EventsUpsertWithWhereUniqueWithoutForm15CbInput>>;
};

export type EventsUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: EventsUpdateWithoutCreatedByInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutDocumentInput = {
  data: EventsUpdateWithoutDocumentInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutForm15CaaInput = {
  data: EventsUpdateWithoutForm15CaaInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutForm15CabInput = {
  data: EventsUpdateWithoutForm15CabInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutForm15CacInput = {
  data: EventsUpdateWithoutForm15CacInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutForm15CadInput = {
  data: EventsUpdateWithoutForm15CadInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithWhereUniqueWithoutForm15CbInput = {
  data: EventsUpdateWithoutForm15CbInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpdateWithoutCreatedByInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateOneWithoutEventsNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutEventsNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutEventsNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutEventsNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutEventsNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutDocumentInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<UserUpdateOneRequiredWithoutEventsNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutEventsNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutEventsNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutEventsNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutEventsNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutForm15CaaInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<UserUpdateOneRequiredWithoutEventsNestedInput>;
  Document?: Maybe<DocumentUpdateOneWithoutEventsNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutEventsNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutEventsNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutEventsNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutForm15CabInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<UserUpdateOneRequiredWithoutEventsNestedInput>;
  Document?: Maybe<DocumentUpdateOneWithoutEventsNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutEventsNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutEventsNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutEventsNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutForm15CacInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<UserUpdateOneRequiredWithoutEventsNestedInput>;
  Document?: Maybe<DocumentUpdateOneWithoutEventsNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutEventsNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutEventsNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutEventsNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutForm15CadInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<UserUpdateOneRequiredWithoutEventsNestedInput>;
  Document?: Maybe<DocumentUpdateOneWithoutEventsNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutEventsNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutEventsNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutEventsNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpdateWithoutForm15CbInput = {
  AckNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<UserUpdateOneRequiredWithoutEventsNestedInput>;
  Document?: Maybe<DocumentUpdateOneWithoutEventsNestedInput>;
  Form15CAA?: Maybe<Form15CaaUpdateOneWithoutEventsNestedInput>;
  Form15CAB?: Maybe<Form15CabUpdateOneWithoutEventsNestedInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutEventsNestedInput>;
  Form15CAD?: Maybe<Form15CadUpdateOneWithoutEventsNestedInput>;
  UDIN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  comments?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isLatest?: Maybe<BoolFieldUpdateOperationsInput>;
  status?: Maybe<StringFieldUpdateOperationsInput>;
};

export type EventsUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: EventsCreateWithoutCreatedByInput;
  update: EventsUpdateWithoutCreatedByInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutDocumentInput = {
  create: EventsCreateWithoutDocumentInput;
  update: EventsUpdateWithoutDocumentInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutForm15CaaInput = {
  create: EventsCreateWithoutForm15CaaInput;
  update: EventsUpdateWithoutForm15CaaInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutForm15CabInput = {
  create: EventsCreateWithoutForm15CabInput;
  update: EventsUpdateWithoutForm15CabInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutForm15CacInput = {
  create: EventsCreateWithoutForm15CacInput;
  update: EventsUpdateWithoutForm15CacInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutForm15CadInput = {
  create: EventsCreateWithoutForm15CadInput;
  update: EventsUpdateWithoutForm15CadInput;
  where: EventsWhereUniqueInput;
};

export type EventsUpsertWithWhereUniqueWithoutForm15CbInput = {
  create: EventsCreateWithoutForm15CbInput;
  update: EventsUpdateWithoutForm15CbInput;
  where: EventsWhereUniqueInput;
};

export type EventsWhereInput = {
  AND?: Maybe<Array<EventsWhereInput>>;
  AckNumber?: Maybe<StringNullableFilter>;
  CertificateDate?: Maybe<DateTimeNullableFilter>;
  CreatedBy?: Maybe<UserRelationFilter>;
  CreatedById?: Maybe<IntFilter>;
  Document?: Maybe<DocumentRelationFilter>;
  Form15CAA?: Maybe<Form15CaaRelationFilter>;
  Form15CAB?: Maybe<Form15CabRelationFilter>;
  Form15CAC?: Maybe<Form15CacRelationFilter>;
  Form15CAD?: Maybe<Form15CadRelationFilter>;
  Form15CB?: Maybe<Form15CbRelationFilter>;
  NOT?: Maybe<Array<EventsWhereInput>>;
  OR?: Maybe<Array<EventsWhereInput>>;
  UDIN?: Maybe<StringNullableFilter>;
  comments?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  documentId?: Maybe<IntNullableFilter>;
  form15CAAId?: Maybe<IntNullableFilter>;
  form15CABId?: Maybe<IntNullableFilter>;
  form15CACId?: Maybe<IntNullableFilter>;
  form15CADId?: Maybe<IntNullableFilter>;
  form15CBId?: Maybe<IntNullableFilter>;
  id?: Maybe<IntFilter>;
  isLatest?: Maybe<BoolFilter>;
  status?: Maybe<StringFilter>;
};

export type EventsWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type File = {
  __typename?: 'File';
  Document?: Maybe<Document>;
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  path: Scalars['String'];
};

export type FileAvgAggregate = {
  __typename?: 'FileAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type FileAvgOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type FileCountAggregate = {
  __typename?: 'FileCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  filename: Scalars['Int'];
  id: Scalars['Int'];
  path: Scalars['Int'];
};

export type FileCountOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
};

export type FileCreateInput = {
  Document?: Maybe<DocumentCreateNestedOneWithoutFileInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  filename: Scalars['String'];
  path: Scalars['String'];
};

export type FileCreateManyInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filename: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
};

export type FileCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<FileWhereUniqueInput>;
  connectOrCreate?: Maybe<FileCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<FileCreateWithoutDocumentInput>;
};

export type FileCreateOrConnectWithoutDocumentInput = {
  create: FileCreateWithoutDocumentInput;
  where: FileWhereUniqueInput;
};

export type FileCreateWithoutDocumentInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  filename: Scalars['String'];
  path: Scalars['String'];
};

export type FileGroupBy = {
  __typename?: 'FileGroupBy';
  _avg?: Maybe<FileAvgAggregate>;
  _count?: Maybe<FileCountAggregate>;
  _max?: Maybe<FileMaxAggregate>;
  _min?: Maybe<FileMinAggregate>;
  _sum?: Maybe<FileSumAggregate>;
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  path: Scalars['String'];
};

export type FileMaxAggregate = {
  __typename?: 'FileMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

export type FileMaxOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
};

export type FileMinAggregate = {
  __typename?: 'FileMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
};

export type FileMinOrderByAggregateInput = {
  createdAt?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
};

export type FileOrderByWithAggregationInput = {
  _avg?: Maybe<FileAvgOrderByAggregateInput>;
  _count?: Maybe<FileCountOrderByAggregateInput>;
  _max?: Maybe<FileMaxOrderByAggregateInput>;
  _min?: Maybe<FileMinOrderByAggregateInput>;
  _sum?: Maybe<FileSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
};

export type FileOrderByWithRelationInput = {
  Document?: Maybe<DocumentOrderByWithRelationInput>;
  createdAt?: Maybe<SortOrder>;
  filename?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  path?: Maybe<SortOrder>;
};

export type FileRelationFilter = {
  is?: Maybe<FileWhereInput>;
  isNot?: Maybe<FileWhereInput>;
};

export enum FileScalarFieldEnum {
  CreatedAt = 'createdAt',
  Filename = 'filename',
  Id = 'id',
  Path = 'path'
}

export type FileScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FileScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<FileScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FileScalarWhereWithAggregatesInput>>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  filename?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  path?: Maybe<StringWithAggregatesFilter>;
};

export type FileSumAggregate = {
  __typename?: 'FileSumAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type FileSumOrderByAggregateInput = {
  id?: Maybe<SortOrder>;
};

export type FileUpdateInput = {
  Document?: Maybe<DocumentUpdateOneWithoutFileNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  filename?: Maybe<StringFieldUpdateOperationsInput>;
  path?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateManyMutationInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  filename?: Maybe<StringFieldUpdateOperationsInput>;
  path?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<FileWhereUniqueInput>;
  connectOrCreate?: Maybe<FileCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<FileCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<FileUpdateWithoutDocumentInput>;
  upsert?: Maybe<FileUpsertWithoutDocumentInput>;
};

export type FileUpdateWithoutDocumentInput = {
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  filename?: Maybe<StringFieldUpdateOperationsInput>;
  path?: Maybe<StringFieldUpdateOperationsInput>;
};

export type FileUpsertWithoutDocumentInput = {
  create: FileCreateWithoutDocumentInput;
  update: FileUpdateWithoutDocumentInput;
};

export type FileWhereInput = {
  AND?: Maybe<Array<FileWhereInput>>;
  Document?: Maybe<DocumentRelationFilter>;
  NOT?: Maybe<Array<FileWhereInput>>;
  OR?: Maybe<Array<FileWhereInput>>;
  createdAt?: Maybe<DateTimeFilter>;
  filename?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  path?: Maybe<StringFilter>;
};

export type FileWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Float']>;
  divide?: Maybe<Scalars['Float']>;
  increment?: Maybe<Scalars['Float']>;
  multiply?: Maybe<Scalars['Float']>;
  set?: Maybe<Scalars['Float']>;
};

export type FloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedFloatNullableFilter>;
  _min?: Maybe<NestedFloatNullableFilter>;
  _sum?: Maybe<NestedFloatNullableFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FolioNumber = {
  __typename?: 'FolioNumber';
  Benefeciary: Benefeciary;
  BenefeciaryId: Scalars['Int'];
  FolioNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type FolioNumberAvgAggregate = {
  __typename?: 'FolioNumberAvgAggregate';
  BenefeciaryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type FolioNumberAvgOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type FolioNumberCountAggregate = {
  __typename?: 'FolioNumberCountAggregate';
  BenefeciaryId: Scalars['Int'];
  FolioNumber: Scalars['Int'];
  _all: Scalars['Int'];
  id: Scalars['Int'];
};

export type FolioNumberCountOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  FolioNumber?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type FolioNumberCreateInput = {
  Benefeciary: BenefeciaryCreateNestedOneWithoutFolioNumbersInput;
  FolioNumber?: Maybe<Scalars['String']>;
};

export type FolioNumberCreateManyBenefeciaryInput = {
  FolioNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type FolioNumberCreateManyBenefeciaryInputEnvelope = {
  data: Array<FolioNumberCreateManyBenefeciaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type FolioNumberCreateManyInput = {
  BenefeciaryId: Scalars['Int'];
  FolioNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type FolioNumberCreateNestedManyWithoutBenefeciaryInput = {
  connect?: Maybe<Array<FolioNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FolioNumberCreateOrConnectWithoutBenefeciaryInput>>;
  create?: Maybe<Array<FolioNumberCreateWithoutBenefeciaryInput>>;
  createMany?: Maybe<FolioNumberCreateManyBenefeciaryInputEnvelope>;
};

export type FolioNumberCreateOrConnectWithoutBenefeciaryInput = {
  create: FolioNumberCreateWithoutBenefeciaryInput;
  where: FolioNumberWhereUniqueInput;
};

export type FolioNumberCreateWithoutBenefeciaryInput = {
  FolioNumber?: Maybe<Scalars['String']>;
};

export type FolioNumberGroupBy = {
  __typename?: 'FolioNumberGroupBy';
  BenefeciaryId: Scalars['Int'];
  FolioNumber?: Maybe<Scalars['String']>;
  _avg?: Maybe<FolioNumberAvgAggregate>;
  _count?: Maybe<FolioNumberCountAggregate>;
  _max?: Maybe<FolioNumberMaxAggregate>;
  _min?: Maybe<FolioNumberMinAggregate>;
  _sum?: Maybe<FolioNumberSumAggregate>;
  id: Scalars['Int'];
};

export type FolioNumberListRelationFilter = {
  every?: Maybe<FolioNumberWhereInput>;
  none?: Maybe<FolioNumberWhereInput>;
  some?: Maybe<FolioNumberWhereInput>;
};

export type FolioNumberMaxAggregate = {
  __typename?: 'FolioNumberMaxAggregate';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  FolioNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type FolioNumberMaxOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  FolioNumber?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type FolioNumberMinAggregate = {
  __typename?: 'FolioNumberMinAggregate';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  FolioNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type FolioNumberMinOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  FolioNumber?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type FolioNumberOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type FolioNumberOrderByWithAggregationInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  FolioNumber?: Maybe<SortOrder>;
  _avg?: Maybe<FolioNumberAvgOrderByAggregateInput>;
  _count?: Maybe<FolioNumberCountOrderByAggregateInput>;
  _max?: Maybe<FolioNumberMaxOrderByAggregateInput>;
  _min?: Maybe<FolioNumberMinOrderByAggregateInput>;
  _sum?: Maybe<FolioNumberSumOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
};

export type FolioNumberOrderByWithRelationInput = {
  Benefeciary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BenefeciaryId?: Maybe<SortOrder>;
  FolioNumber?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export enum FolioNumberScalarFieldEnum {
  BenefeciaryId = 'BenefeciaryId',
  FolioNumber = 'FolioNumber',
  Id = 'id'
}

export type FolioNumberScalarWhereInput = {
  AND?: Maybe<Array<FolioNumberScalarWhereInput>>;
  BenefeciaryId?: Maybe<IntFilter>;
  FolioNumber?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<FolioNumberScalarWhereInput>>;
  OR?: Maybe<Array<FolioNumberScalarWhereInput>>;
  id?: Maybe<IntFilter>;
};

export type FolioNumberScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<FolioNumberScalarWhereWithAggregatesInput>>;
  BenefeciaryId?: Maybe<IntWithAggregatesFilter>;
  FolioNumber?: Maybe<StringNullableWithAggregatesFilter>;
  NOT?: Maybe<Array<FolioNumberScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<FolioNumberScalarWhereWithAggregatesInput>>;
  id?: Maybe<IntWithAggregatesFilter>;
};

export type FolioNumberSumAggregate = {
  __typename?: 'FolioNumberSumAggregate';
  BenefeciaryId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type FolioNumberSumOrderByAggregateInput = {
  BenefeciaryId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type FolioNumberUpdateInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateOneRequiredWithoutFolioNumbersNestedInput>;
  FolioNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FolioNumberUpdateManyMutationInput = {
  FolioNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FolioNumberUpdateManyWithWhereWithoutBenefeciaryInput = {
  data: FolioNumberUpdateManyMutationInput;
  where: FolioNumberScalarWhereInput;
};

export type FolioNumberUpdateManyWithoutBenefeciaryNestedInput = {
  connect?: Maybe<Array<FolioNumberWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<FolioNumberCreateOrConnectWithoutBenefeciaryInput>>;
  create?: Maybe<Array<FolioNumberCreateWithoutBenefeciaryInput>>;
  createMany?: Maybe<FolioNumberCreateManyBenefeciaryInputEnvelope>;
  delete?: Maybe<Array<FolioNumberWhereUniqueInput>>;
  deleteMany?: Maybe<Array<FolioNumberScalarWhereInput>>;
  disconnect?: Maybe<Array<FolioNumberWhereUniqueInput>>;
  set?: Maybe<Array<FolioNumberWhereUniqueInput>>;
  update?: Maybe<Array<FolioNumberUpdateWithWhereUniqueWithoutBenefeciaryInput>>;
  updateMany?: Maybe<Array<FolioNumberUpdateManyWithWhereWithoutBenefeciaryInput>>;
  upsert?: Maybe<Array<FolioNumberUpsertWithWhereUniqueWithoutBenefeciaryInput>>;
};

export type FolioNumberUpdateWithWhereUniqueWithoutBenefeciaryInput = {
  data: FolioNumberUpdateWithoutBenefeciaryInput;
  where: FolioNumberWhereUniqueInput;
};

export type FolioNumberUpdateWithoutBenefeciaryInput = {
  FolioNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type FolioNumberUpsertWithWhereUniqueWithoutBenefeciaryInput = {
  create: FolioNumberCreateWithoutBenefeciaryInput;
  update: FolioNumberUpdateWithoutBenefeciaryInput;
  where: FolioNumberWhereUniqueInput;
};

export type FolioNumberWhereInput = {
  AND?: Maybe<Array<FolioNumberWhereInput>>;
  Benefeciary?: Maybe<BenefeciaryRelationFilter>;
  BenefeciaryId?: Maybe<IntFilter>;
  FolioNumber?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<FolioNumberWhereInput>>;
  OR?: Maybe<Array<FolioNumberWhereInput>>;
  id?: Maybe<IntFilter>;
};

export type FolioNumberWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type Form15Caa = {
  __typename?: 'Form15CAA';
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  /** Remittance */
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer: Scalars['String'];
  BankDetail: BankDetail;
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  Beneficiary: Benefeciary;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document: Array<Document>;
  Email?: Maybe<Scalars['String']>;
  Events: Array<Events>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  /** TDS */
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15Caa>;
  RevokedToForm?: Maybe<Form15Caa>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  _count?: Maybe<Form15CaaCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type Form15CaaDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type Form15CaaEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};

export type Form15CaaAvgAggregate = {
  __typename?: 'Form15CAAAvgAggregate';
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayableBeforeINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Float']>;
  BeneficiaryId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  RevokedToId?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Form15CaaAvgOrderByAggregateInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableBeforeINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CaaCount = {
  __typename?: 'Form15CAACount';
  Document: Scalars['Int'];
  Events: Scalars['Int'];
};

export type Form15CaaCountAggregate = {
  __typename?: 'Form15CAACountAggregate';
  AggregateAmount: Scalars['Int'];
  AmountOfTDSInINR: Scalars['Int'];
  AmountPayableBeforeINR: Scalars['Int'];
  AuthDealer: Scalars['Int'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['Int'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['Int'];
  Building: Scalars['Int'];
  City: Scalars['Int'];
  Country: Scalars['Int'];
  CountryOfRemittance: Scalars['Int'];
  CountryOfRemittanceOther: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  DateOfDeduction: Scalars['Int'];
  Email: Scalars['Int'];
  Flat: Scalars['Int'];
  IsTaxPayableGrossedUp: Scalars['Int'];
  Locality: Scalars['Int'];
  PhoneNumber: Scalars['Int'];
  Pincode: Scalars['Int'];
  ProposedDate: Scalars['Int'];
  PurposeCode: Scalars['Int'];
  RateOfTDS: Scalars['Int'];
  RecipientName: Scalars['Int'];
  RecipientPAN: Scalars['Int'];
  RemittanceNameOnDocument: Scalars['Int'];
  RemittanceNameOnDocumentOther: Scalars['Int'];
  RevokedToId: Scalars['Int'];
  State: Scalars['Int'];
  Street: Scalars['Int'];
  SubCategory: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ifsc: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type Form15CaaCountOrderByAggregateInput = {
  AggregateAmount?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableBeforeINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CaaCreateInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetail: BankDetailCreateNestedOneWithoutForm15CaaInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CaaInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CaaInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CaaInput>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaCreateManyBankDetailInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaCreateManyBankDetailInputEnvelope = {
  data: Array<Form15CaaCreateManyBankDetailInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CaaCreateManyBeneficiaryInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaCreateManyBeneficiaryInputEnvelope = {
  data: Array<Form15CaaCreateManyBeneficiaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CaaCreateManyInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaCreateNestedManyWithoutBankDetailInput = {
  connect?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CaaCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CaaCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CaaCreateManyBankDetailInputEnvelope>;
};

export type Form15CaaCreateNestedManyWithoutBeneficiaryInput = {
  connect?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CaaCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CaaCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CaaCreateManyBeneficiaryInputEnvelope>;
};

export type Form15CaaCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<Form15CaaWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CaaCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CaaCreateWithoutDocumentInput>;
};

export type Form15CaaCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<Form15CaaWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CaaCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CaaCreateWithoutEventsInput>;
};

export type Form15CaaCreateOrConnectWithoutBankDetailInput = {
  create: Form15CaaCreateWithoutBankDetailInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaCreateOrConnectWithoutBeneficiaryInput = {
  create: Form15CaaCreateWithoutBeneficiaryInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaCreateOrConnectWithoutDocumentInput = {
  create: Form15CaaCreateWithoutDocumentInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaCreateOrConnectWithoutEventsInput = {
  create: Form15CaaCreateWithoutEventsInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaCreateWithoutBankDetailInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CaaInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CaaInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CaaInput>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaCreateWithoutBeneficiaryInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetail: BankDetailCreateNestedOneWithoutForm15CaaInput;
  BankName: Scalars['String'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CaaInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CaaInput>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaCreateWithoutDocumentInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetail: BankDetailCreateNestedOneWithoutForm15CaaInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CaaInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CaaInput>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaCreateWithoutEventsInput = {
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetail: BankDetailCreateNestedOneWithoutForm15CaaInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CaaInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CaaInput>;
  Email?: Maybe<Scalars['String']>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaGroupBy = {
  __typename?: 'Form15CAAGroupBy';
  AggregateAmount: Scalars['String'];
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayableBeforeINR: Scalars['Float'];
  AuthDealer: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  Locality: Scalars['String'];
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  _avg?: Maybe<Form15CaaAvgAggregate>;
  _count?: Maybe<Form15CaaCountAggregate>;
  _max?: Maybe<Form15CaaMaxAggregate>;
  _min?: Maybe<Form15CaaMinAggregate>;
  _sum?: Maybe<Form15CaaSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Form15CaaListRelationFilter = {
  every?: Maybe<Form15CaaWhereInput>;
  none?: Maybe<Form15CaaWhereInput>;
  some?: Maybe<Form15CaaWhereInput>;
};

export type Form15CaaMaxAggregate = {
  __typename?: 'Form15CAAMaxAggregate';
  AggregateAmount?: Maybe<Scalars['String']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayableBeforeINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CountryOfRemittance?: Maybe<Scalars['String']>;
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  PurposeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaMaxOrderByAggregateInput = {
  AggregateAmount?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableBeforeINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CaaMinAggregate = {
  __typename?: 'Form15CAAMinAggregate';
  AggregateAmount?: Maybe<Scalars['String']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayableBeforeINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CountryOfRemittance?: Maybe<Scalars['String']>;
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  PurposeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CaaMinOrderByAggregateInput = {
  AggregateAmount?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableBeforeINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CaaOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type Form15CaaOrderByWithAggregationInput = {
  AggregateAmount?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableBeforeINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  _avg?: Maybe<Form15CaaAvgOrderByAggregateInput>;
  _count?: Maybe<Form15CaaCountOrderByAggregateInput>;
  _max?: Maybe<Form15CaaMaxOrderByAggregateInput>;
  _min?: Maybe<Form15CaaMinOrderByAggregateInput>;
  _sum?: Maybe<Form15CaaSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CaaOrderByWithRelationInput = {
  AggregateAmount?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableBeforeINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BankDetail?: Maybe<BankDetailOrderByWithRelationInput>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  Beneficiary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  Email?: Maybe<SortOrder>;
  Events?: Maybe<EventsOrderByRelationAggregateInput>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedFrom?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToForm?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CaaRelationFilter = {
  is?: Maybe<Form15CaaWhereInput>;
  isNot?: Maybe<Form15CaaWhereInput>;
};

export enum Form15CaaScalarFieldEnum {
  AggregateAmount = 'AggregateAmount',
  AmountOfTdsInInr = 'AmountOfTDSInINR',
  AmountPayableBeforeInr = 'AmountPayableBeforeINR',
  AuthDealer = 'AuthDealer',
  BankDetailId = 'BankDetailId',
  BankName = 'BankName',
  BeneficiaryId = 'BeneficiaryId',
  BranchName = 'BranchName',
  Building = 'Building',
  City = 'City',
  Country = 'Country',
  CountryOfRemittance = 'CountryOfRemittance',
  CountryOfRemittanceOther = 'CountryOfRemittanceOther',
  CreatedBy = 'CreatedBy',
  DateOfDeduction = 'DateOfDeduction',
  Email = 'Email',
  Flat = 'Flat',
  IsTaxPayableGrossedUp = 'IsTaxPayableGrossedUp',
  Locality = 'Locality',
  PhoneNumber = 'PhoneNumber',
  Pincode = 'Pincode',
  ProposedDate = 'ProposedDate',
  PurposeCode = 'PurposeCode',
  RateOfTds = 'RateOfTDS',
  RecipientName = 'RecipientName',
  RecipientPan = 'RecipientPAN',
  RemittanceNameOnDocument = 'RemittanceNameOnDocument',
  RemittanceNameOnDocumentOther = 'RemittanceNameOnDocumentOther',
  RevokedToId = 'RevokedToId',
  State = 'State',
  Street = 'Street',
  SubCategory = 'SubCategory',
  UpdatedBy = 'UpdatedBy',
  CreatedAt = 'createdAt',
  Id = 'id',
  Ifsc = 'ifsc',
  UpdatedAt = 'updatedAt'
}

export type Form15CaaScalarWhereInput = {
  AND?: Maybe<Array<Form15CaaScalarWhereInput>>;
  AggregateAmount?: Maybe<StringFilter>;
  AmountOfTDSInINR?: Maybe<FloatFilter>;
  AmountPayableBeforeINR?: Maybe<FloatFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CountryOfRemittance?: Maybe<StringFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  Email?: Maybe<StringNullableFilter>;
  Flat?: Maybe<StringFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CaaScalarWhereInput>>;
  OR?: Maybe<Array<Form15CaaScalarWhereInput>>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  PurposeCode?: Maybe<StringFilter>;
  RateOfTDS?: Maybe<StringFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CaaScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<Form15CaaScalarWhereWithAggregatesInput>>;
  AggregateAmount?: Maybe<StringWithAggregatesFilter>;
  AmountOfTDSInINR?: Maybe<FloatWithAggregatesFilter>;
  AmountPayableBeforeINR?: Maybe<FloatWithAggregatesFilter>;
  AuthDealer?: Maybe<StringWithAggregatesFilter>;
  BankDetailId?: Maybe<IntWithAggregatesFilter>;
  BankName?: Maybe<StringWithAggregatesFilter>;
  BeneficiaryId?: Maybe<IntWithAggregatesFilter>;
  BranchName?: Maybe<StringWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CountryOfRemittance?: Maybe<StringWithAggregatesFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableWithAggregatesFilter>;
  Email?: Maybe<StringNullableWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<Form15CaaScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<Form15CaaScalarWhereWithAggregatesInput>>;
  PhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  ProposedDate?: Maybe<DateTimeWithAggregatesFilter>;
  PurposeCode?: Maybe<StringWithAggregatesFilter>;
  RateOfTDS?: Maybe<StringWithAggregatesFilter>;
  RecipientName?: Maybe<StringWithAggregatesFilter>;
  RecipientPAN?: Maybe<StringNullableWithAggregatesFilter>;
  RemittanceNameOnDocument?: Maybe<StringWithAggregatesFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableWithAggregatesFilter>;
  RevokedToId?: Maybe<IntNullableWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  SubCategory?: Maybe<StringWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  ifsc?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type Form15CaaSumAggregate = {
  __typename?: 'Form15CAASumAggregate';
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayableBeforeINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15CaaSumOrderByAggregateInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableBeforeINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CaaUpdateInput = {
  AggregateAmount?: Maybe<StringFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayableBeforeINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CaaNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CaaNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CaaUpdateManyMutationInput = {
  AggregateAmount?: Maybe<StringFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayableBeforeINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CaaUpdateManyWithWhereWithoutBankDetailInput = {
  data: Form15CaaUpdateManyMutationInput;
  where: Form15CaaScalarWhereInput;
};

export type Form15CaaUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: Form15CaaUpdateManyMutationInput;
  where: Form15CaaScalarWhereInput;
};

export type Form15CaaUpdateManyWithoutBankDetailNestedInput = {
  connect?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CaaCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CaaCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CaaCreateManyBankDetailInputEnvelope>;
  delete?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CaaScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  set?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  update?: Maybe<Array<Form15CaaUpdateWithWhereUniqueWithoutBankDetailInput>>;
  updateMany?: Maybe<Array<Form15CaaUpdateManyWithWhereWithoutBankDetailInput>>;
  upsert?: Maybe<Array<Form15CaaUpsertWithWhereUniqueWithoutBankDetailInput>>;
};

export type Form15CaaUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CaaCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CaaCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CaaCreateManyBeneficiaryInputEnvelope>;
  delete?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CaaScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  set?: Maybe<Array<Form15CaaWhereUniqueInput>>;
  update?: Maybe<Array<Form15CaaUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: Maybe<Array<Form15CaaUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: Maybe<Array<Form15CaaUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type Form15CaaUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<Form15CaaWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CaaCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CaaCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CaaUpdateWithoutDocumentInput>;
  upsert?: Maybe<Form15CaaUpsertWithoutDocumentInput>;
};

export type Form15CaaUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<Form15CaaWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CaaCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CaaCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CaaUpdateWithoutEventsInput>;
  upsert?: Maybe<Form15CaaUpsertWithoutEventsInput>;
};

export type Form15CaaUpdateWithWhereUniqueWithoutBankDetailInput = {
  data: Form15CaaUpdateWithoutBankDetailInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: Form15CaaUpdateWithoutBeneficiaryInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaUpdateWithoutBankDetailInput = {
  AggregateAmount?: Maybe<StringFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayableBeforeINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CaaNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CaaNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CaaUpdateWithoutBeneficiaryInput = {
  AggregateAmount?: Maybe<StringFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayableBeforeINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CaaNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CaaNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CaaUpdateWithoutDocumentInput = {
  AggregateAmount?: Maybe<StringFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayableBeforeINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CaaNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CaaUpdateWithoutEventsInput = {
  AggregateAmount?: Maybe<StringFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayableBeforeINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CaaNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CaaNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CaaUpsertWithWhereUniqueWithoutBankDetailInput = {
  create: Form15CaaCreateWithoutBankDetailInput;
  update: Form15CaaUpdateWithoutBankDetailInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: Form15CaaCreateWithoutBeneficiaryInput;
  update: Form15CaaUpdateWithoutBeneficiaryInput;
  where: Form15CaaWhereUniqueInput;
};

export type Form15CaaUpsertWithoutDocumentInput = {
  create: Form15CaaCreateWithoutDocumentInput;
  update: Form15CaaUpdateWithoutDocumentInput;
};

export type Form15CaaUpsertWithoutEventsInput = {
  create: Form15CaaCreateWithoutEventsInput;
  update: Form15CaaUpdateWithoutEventsInput;
};

export type Form15CaaWhereInput = {
  AND?: Maybe<Array<Form15CaaWhereInput>>;
  AggregateAmount?: Maybe<StringFilter>;
  AmountOfTDSInINR?: Maybe<FloatFilter>;
  AmountPayableBeforeINR?: Maybe<FloatFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BankDetail?: Maybe<BankDetailRelationFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  Beneficiary?: Maybe<BenefeciaryRelationFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CountryOfRemittance?: Maybe<StringFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  Email?: Maybe<StringNullableFilter>;
  Events?: Maybe<EventsListRelationFilter>;
  Flat?: Maybe<StringFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CaaWhereInput>>;
  OR?: Maybe<Array<Form15CaaWhereInput>>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  PurposeCode?: Maybe<StringFilter>;
  RateOfTDS?: Maybe<StringFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableFilter>;
  RevokedFrom?: Maybe<Form15CbRelationFilter>;
  RevokedToForm?: Maybe<Form15CbRelationFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CaaWhereUniqueInput = {
  RevokedToId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15Cab = {
  __typename?: 'Form15CAB';
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetail: BankDetail;
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  Beneficiary: Benefeciary;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  /** AO.Order */
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  /** Remittance */
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document: Array<Document>;
  Email?: Maybe<Scalars['String']>;
  Events: Array<Events>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  /** TDS */
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15Cab>;
  RevokedToForm?: Maybe<Form15Cab>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  _count?: Maybe<Form15CabCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type Form15CabDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type Form15CabEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};

export type Form15CabAvgAggregate = {
  __typename?: 'Form15CABAvgAggregate';
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayableINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Float']>;
  BeneficiaryId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  RevokedToId?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Form15CabAvgOrderByAggregateInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CabCount = {
  __typename?: 'Form15CABCount';
  Document: Scalars['Int'];
  Events: Scalars['Int'];
};

export type Form15CabCountAggregate = {
  __typename?: 'Form15CABCountAggregate';
  AmountOfTDSInINR: Scalars['Int'];
  AmountPayable: Scalars['Int'];
  AmountPayableINR: Scalars['Int'];
  AuthDealer: Scalars['Int'];
  BSRCode: Scalars['Int'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['Int'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['Int'];
  Building: Scalars['Int'];
  CertificateDateAO: Scalars['Int'];
  CertificateNumberAO: Scalars['Int'];
  CertificateSection: Scalars['Int'];
  City: Scalars['Int'];
  Country: Scalars['Int'];
  CountryOfRemittance: Scalars['Int'];
  CountryOfRemittanceOther: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  DateOfDeduction: Scalars['Int'];
  Email: Scalars['Int'];
  ExchangeRate: Scalars['Int'];
  Flat: Scalars['Int'];
  IsTaxPayableGrossedUp: Scalars['Int'];
  Locality: Scalars['Int'];
  OfficerDesignationAO: Scalars['Int'];
  OfficerNameAO: Scalars['Int'];
  OtherRemittanceCurrency: Scalars['Int'];
  PhoneNumber: Scalars['Int'];
  Pincode: Scalars['Int'];
  ProposedDate: Scalars['Int'];
  PurposeCode: Scalars['Int'];
  RateOfTDS: Scalars['Int'];
  RecipientName: Scalars['Int'];
  RecipientPAN: Scalars['Int'];
  RemittanceCurrency: Scalars['Int'];
  RemittanceNameOnDocument: Scalars['Int'];
  RemittanceNameOnDocumentOther: Scalars['Int'];
  RevokedToId: Scalars['Int'];
  State: Scalars['Int'];
  Street: Scalars['Int'];
  SubCategory: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ifsc: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type Form15CabCountOrderByAggregateInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CabCreateInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CabInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CabInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CabInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CabInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabCreateManyBankDetailInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabCreateManyBankDetailInputEnvelope = {
  data: Array<Form15CabCreateManyBankDetailInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CabCreateManyBeneficiaryInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabCreateManyBeneficiaryInputEnvelope = {
  data: Array<Form15CabCreateManyBeneficiaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CabCreateManyInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabCreateNestedManyWithoutBankDetailInput = {
  connect?: Maybe<Array<Form15CabWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CabCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CabCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CabCreateManyBankDetailInputEnvelope>;
};

export type Form15CabCreateNestedManyWithoutBeneficiaryInput = {
  connect?: Maybe<Array<Form15CabWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CabCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CabCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CabCreateManyBeneficiaryInputEnvelope>;
};

export type Form15CabCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<Form15CabWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CabCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CabCreateWithoutDocumentInput>;
};

export type Form15CabCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<Form15CabWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CabCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CabCreateWithoutEventsInput>;
};

export type Form15CabCreateOrConnectWithoutBankDetailInput = {
  create: Form15CabCreateWithoutBankDetailInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabCreateOrConnectWithoutBeneficiaryInput = {
  create: Form15CabCreateWithoutBeneficiaryInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabCreateOrConnectWithoutDocumentInput = {
  create: Form15CabCreateWithoutDocumentInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabCreateOrConnectWithoutEventsInput = {
  create: Form15CabCreateWithoutEventsInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabCreateWithoutBankDetailInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CabInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CabInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CabInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabCreateWithoutBeneficiaryInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CabInput;
  BankName: Scalars['String'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CabInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CabInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabCreateWithoutDocumentInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CabInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CabInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CabInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabCreateWithoutEventsInput = {
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CabInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CabInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CabInput>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabGroupBy = {
  __typename?: 'Form15CABGroupBy';
  AmountOfTDSInINR: Scalars['Float'];
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO: Scalars['DateTime'];
  CertificateNumberAO: Scalars['String'];
  CertificateSection: Scalars['String'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  Locality: Scalars['String'];
  OfficerDesignationAO: Scalars['String'];
  OfficerNameAO: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RateOfTDS: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  _avg?: Maybe<Form15CabAvgAggregate>;
  _count?: Maybe<Form15CabCountAggregate>;
  _max?: Maybe<Form15CabMaxAggregate>;
  _min?: Maybe<Form15CabMinAggregate>;
  _sum?: Maybe<Form15CabSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Form15CabListRelationFilter = {
  every?: Maybe<Form15CabWhereInput>;
  none?: Maybe<Form15CabWhereInput>;
  some?: Maybe<Form15CabWhereInput>;
};

export type Form15CabMaxAggregate = {
  __typename?: 'Form15CABMaxAggregate';
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayable?: Maybe<Scalars['String']>;
  AmountPayableINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CountryOfRemittance?: Maybe<Scalars['String']>;
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  PurposeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabMaxOrderByAggregateInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CabMinAggregate = {
  __typename?: 'Form15CABMinAggregate';
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayable?: Maybe<Scalars['String']>;
  AmountPayableINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CountryOfRemittance?: Maybe<Scalars['String']>;
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  PurposeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CabMinOrderByAggregateInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CabOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type Form15CabOrderByWithAggregationInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  _avg?: Maybe<Form15CabAvgOrderByAggregateInput>;
  _count?: Maybe<Form15CabCountOrderByAggregateInput>;
  _max?: Maybe<Form15CabMaxOrderByAggregateInput>;
  _min?: Maybe<Form15CabMinOrderByAggregateInput>;
  _sum?: Maybe<Form15CabSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CabOrderByWithRelationInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetail?: Maybe<BankDetailOrderByWithRelationInput>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  Beneficiary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  Email?: Maybe<SortOrder>;
  Events?: Maybe<EventsOrderByRelationAggregateInput>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  RevokedFrom?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToForm?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CabRelationFilter = {
  is?: Maybe<Form15CabWhereInput>;
  isNot?: Maybe<Form15CabWhereInput>;
};

export enum Form15CabScalarFieldEnum {
  AmountOfTdsInInr = 'AmountOfTDSInINR',
  AmountPayable = 'AmountPayable',
  AmountPayableInr = 'AmountPayableINR',
  AuthDealer = 'AuthDealer',
  BsrCode = 'BSRCode',
  BankDetailId = 'BankDetailId',
  BankName = 'BankName',
  BeneficiaryId = 'BeneficiaryId',
  BranchName = 'BranchName',
  Building = 'Building',
  CertificateDateAo = 'CertificateDateAO',
  CertificateNumberAo = 'CertificateNumberAO',
  CertificateSection = 'CertificateSection',
  City = 'City',
  Country = 'Country',
  CountryOfRemittance = 'CountryOfRemittance',
  CountryOfRemittanceOther = 'CountryOfRemittanceOther',
  CreatedBy = 'CreatedBy',
  DateOfDeduction = 'DateOfDeduction',
  Email = 'Email',
  ExchangeRate = 'ExchangeRate',
  Flat = 'Flat',
  IsTaxPayableGrossedUp = 'IsTaxPayableGrossedUp',
  Locality = 'Locality',
  OfficerDesignationAo = 'OfficerDesignationAO',
  OfficerNameAo = 'OfficerNameAO',
  OtherRemittanceCurrency = 'OtherRemittanceCurrency',
  PhoneNumber = 'PhoneNumber',
  Pincode = 'Pincode',
  ProposedDate = 'ProposedDate',
  PurposeCode = 'PurposeCode',
  RateOfTds = 'RateOfTDS',
  RecipientName = 'RecipientName',
  RecipientPan = 'RecipientPAN',
  RemittanceCurrency = 'RemittanceCurrency',
  RemittanceNameOnDocument = 'RemittanceNameOnDocument',
  RemittanceNameOnDocumentOther = 'RemittanceNameOnDocumentOther',
  RevokedToId = 'RevokedToId',
  State = 'State',
  Street = 'Street',
  SubCategory = 'SubCategory',
  UpdatedBy = 'UpdatedBy',
  CreatedAt = 'createdAt',
  Id = 'id',
  Ifsc = 'ifsc',
  UpdatedAt = 'updatedAt'
}

export type Form15CabScalarWhereInput = {
  AND?: Maybe<Array<Form15CabScalarWhereInput>>;
  AmountOfTDSInINR?: Maybe<FloatFilter>;
  AmountPayable?: Maybe<StringFilter>;
  AmountPayableINR?: Maybe<FloatFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  CertificateDateAO?: Maybe<DateTimeFilter>;
  CertificateNumberAO?: Maybe<StringFilter>;
  CertificateSection?: Maybe<StringFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CountryOfRemittance?: Maybe<StringFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  Email?: Maybe<StringNullableFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CabScalarWhereInput>>;
  OR?: Maybe<Array<Form15CabScalarWhereInput>>;
  OfficerDesignationAO?: Maybe<StringFilter>;
  OfficerNameAO?: Maybe<StringFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  PurposeCode?: Maybe<StringFilter>;
  RateOfTDS?: Maybe<StringFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CabScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<Form15CabScalarWhereWithAggregatesInput>>;
  AmountOfTDSInINR?: Maybe<FloatWithAggregatesFilter>;
  AmountPayable?: Maybe<StringWithAggregatesFilter>;
  AmountPayableINR?: Maybe<FloatWithAggregatesFilter>;
  AuthDealer?: Maybe<StringWithAggregatesFilter>;
  BSRCode?: Maybe<StringWithAggregatesFilter>;
  BankDetailId?: Maybe<IntWithAggregatesFilter>;
  BankName?: Maybe<StringWithAggregatesFilter>;
  BeneficiaryId?: Maybe<IntWithAggregatesFilter>;
  BranchName?: Maybe<StringWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateDateAO?: Maybe<DateTimeWithAggregatesFilter>;
  CertificateNumberAO?: Maybe<StringWithAggregatesFilter>;
  CertificateSection?: Maybe<StringWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CountryOfRemittance?: Maybe<StringWithAggregatesFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableWithAggregatesFilter>;
  Email?: Maybe<StringNullableWithAggregatesFilter>;
  ExchangeRate?: Maybe<StringWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<Form15CabScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<Form15CabScalarWhereWithAggregatesInput>>;
  OfficerDesignationAO?: Maybe<StringWithAggregatesFilter>;
  OfficerNameAO?: Maybe<StringWithAggregatesFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableWithAggregatesFilter>;
  PhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  ProposedDate?: Maybe<DateTimeWithAggregatesFilter>;
  PurposeCode?: Maybe<StringWithAggregatesFilter>;
  RateOfTDS?: Maybe<StringWithAggregatesFilter>;
  RecipientName?: Maybe<StringWithAggregatesFilter>;
  RecipientPAN?: Maybe<StringNullableWithAggregatesFilter>;
  RemittanceCurrency?: Maybe<StringWithAggregatesFilter>;
  RemittanceNameOnDocument?: Maybe<StringWithAggregatesFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableWithAggregatesFilter>;
  RevokedToId?: Maybe<IntNullableWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  SubCategory?: Maybe<StringWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  ifsc?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type Form15CabSumAggregate = {
  __typename?: 'Form15CABSumAggregate';
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AmountPayableINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15CabSumOrderByAggregateInput = {
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CabUpdateInput = {
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CabNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CabNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<DateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CabNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CabNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CabUpdateManyMutationInput = {
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<DateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CabUpdateManyWithWhereWithoutBankDetailInput = {
  data: Form15CabUpdateManyMutationInput;
  where: Form15CabScalarWhereInput;
};

export type Form15CabUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: Form15CabUpdateManyMutationInput;
  where: Form15CabScalarWhereInput;
};

export type Form15CabUpdateManyWithoutBankDetailNestedInput = {
  connect?: Maybe<Array<Form15CabWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CabCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CabCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CabCreateManyBankDetailInputEnvelope>;
  delete?: Maybe<Array<Form15CabWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CabScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CabWhereUniqueInput>>;
  set?: Maybe<Array<Form15CabWhereUniqueInput>>;
  update?: Maybe<Array<Form15CabUpdateWithWhereUniqueWithoutBankDetailInput>>;
  updateMany?: Maybe<Array<Form15CabUpdateManyWithWhereWithoutBankDetailInput>>;
  upsert?: Maybe<Array<Form15CabUpsertWithWhereUniqueWithoutBankDetailInput>>;
};

export type Form15CabUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: Maybe<Array<Form15CabWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CabCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CabCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CabCreateManyBeneficiaryInputEnvelope>;
  delete?: Maybe<Array<Form15CabWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CabScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CabWhereUniqueInput>>;
  set?: Maybe<Array<Form15CabWhereUniqueInput>>;
  update?: Maybe<Array<Form15CabUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: Maybe<Array<Form15CabUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: Maybe<Array<Form15CabUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type Form15CabUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<Form15CabWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CabCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CabCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CabUpdateWithoutDocumentInput>;
  upsert?: Maybe<Form15CabUpsertWithoutDocumentInput>;
};

export type Form15CabUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<Form15CabWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CabCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CabCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CabUpdateWithoutEventsInput>;
  upsert?: Maybe<Form15CabUpsertWithoutEventsInput>;
};

export type Form15CabUpdateWithWhereUniqueWithoutBankDetailInput = {
  data: Form15CabUpdateWithoutBankDetailInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: Form15CabUpdateWithoutBeneficiaryInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabUpdateWithoutBankDetailInput = {
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CabNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<DateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CabNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CabNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CabUpdateWithoutBeneficiaryInput = {
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CabNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<DateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CabNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CabNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CabUpdateWithoutDocumentInput = {
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CabNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CabNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<DateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CabNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CabUpdateWithoutEventsInput = {
  AmountOfTDSInINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CabNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CabNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<DateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<StringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<StringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CabNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<StringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CabUpsertWithWhereUniqueWithoutBankDetailInput = {
  create: Form15CabCreateWithoutBankDetailInput;
  update: Form15CabUpdateWithoutBankDetailInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: Form15CabCreateWithoutBeneficiaryInput;
  update: Form15CabUpdateWithoutBeneficiaryInput;
  where: Form15CabWhereUniqueInput;
};

export type Form15CabUpsertWithoutDocumentInput = {
  create: Form15CabCreateWithoutDocumentInput;
  update: Form15CabUpdateWithoutDocumentInput;
};

export type Form15CabUpsertWithoutEventsInput = {
  create: Form15CabCreateWithoutEventsInput;
  update: Form15CabUpdateWithoutEventsInput;
};

export type Form15CabWhereInput = {
  AND?: Maybe<Array<Form15CabWhereInput>>;
  AmountOfTDSInINR?: Maybe<FloatFilter>;
  AmountPayable?: Maybe<StringFilter>;
  AmountPayableINR?: Maybe<FloatFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetail?: Maybe<BankDetailRelationFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  Beneficiary?: Maybe<BenefeciaryRelationFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  CertificateDateAO?: Maybe<DateTimeFilter>;
  CertificateNumberAO?: Maybe<StringFilter>;
  CertificateSection?: Maybe<StringFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CountryOfRemittance?: Maybe<StringFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  Email?: Maybe<StringNullableFilter>;
  Events?: Maybe<EventsListRelationFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CabWhereInput>>;
  OR?: Maybe<Array<Form15CabWhereInput>>;
  OfficerDesignationAO?: Maybe<StringFilter>;
  OfficerNameAO?: Maybe<StringFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  PurposeCode?: Maybe<StringFilter>;
  RateOfTDS?: Maybe<StringFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableFilter>;
  RevokedFrom?: Maybe<Form15CbRelationFilter>;
  RevokedToForm?: Maybe<Form15CbRelationFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CabWhereUniqueInput = {
  RevokedToId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15Cac = {
  __typename?: 'Form15CAC';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  /** Accountant */
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetail: BankDetail;
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: Benefeciary;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Events: Array<Events>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CB: Form15Cb;
  Form15CBId: Scalars['Int'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  /** AO.Order */
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15Cac>;
  RevokedToForm?: Maybe<Form15Cac>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  _count?: Maybe<Form15CacCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type Form15CacEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};

export type Form15CacAvgAggregate = {
  __typename?: 'Form15CACAvgAggregate';
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Float']>;
  BeneficiaryId?: Maybe<Scalars['Float']>;
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  Form15CBId?: Maybe<Scalars['Float']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  RevokedToId?: Maybe<Scalars['Float']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Form15CacAvgOrderByAggregateInput = {
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BusinessRateOfTax?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CacCount = {
  __typename?: 'Form15CACCount';
  Events: Scalars['Int'];
};

export type Form15CacCountAggregate = {
  __typename?: 'Form15CACCountAggregate';
  AccountantBuilding: Scalars['Int'];
  AccountantCertificateDate: Scalars['Int'];
  AccountantCertificateNumber: Scalars['Int'];
  AccountantCity: Scalars['Int'];
  AccountantCountry: Scalars['Int'];
  AccountantFirm: Scalars['Int'];
  AccountantFlat: Scalars['Int'];
  AccountantLocality: Scalars['Int'];
  AccountantMembershipNumber: Scalars['Int'];
  AccountantName: Scalars['Int'];
  AccountantPincode: Scalars['Int'];
  AccountantRegistrationNumber: Scalars['Int'];
  AccountantState: Scalars['Int'];
  AccountantStreet: Scalars['Int'];
  AmountAfterTDS: Scalars['Int'];
  AmountOfCapitalGains: Scalars['Int'];
  AmountOfShortCapitalGains: Scalars['Int'];
  AmountOfTDSInForeign: Scalars['Int'];
  AmountOfTDSInINR: Scalars['Int'];
  AoNumber: Scalars['Int'];
  AoType: Scalars['Int'];
  AreaCode: Scalars['Int'];
  AuthDealer: Scalars['Int'];
  BSRCode: Scalars['Int'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['Int'];
  BasisOfTaxableIncome: Scalars['Int'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['Int'];
  Building: Scalars['Int'];
  BusinessPlace: Scalars['Int'];
  BusinessRateOfTax: Scalars['Int'];
  CapitalGainsRateOfTDS: Scalars['Int'];
  CertificateArticleOfDTAA: Scalars['Int'];
  CertificateDTAA: Scalars['Int'];
  CertificateDateAO: Scalars['Int'];
  CertificateNumberAO: Scalars['Int'];
  CertificateSection: Scalars['Int'];
  ChargeableAndReliefDTAA: Scalars['Int'];
  City: Scalars['Int'];
  Country: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability: Scalars['Int'];
  DTAATaxableIncome: Scalars['Int'];
  DateOfDeduction: Scalars['Int'];
  DeterminingTaxAndLiability: Scalars['Int'];
  Email: Scalars['Int'];
  ExchangeRate: Scalars['Int'];
  Flat: Scalars['Int'];
  Form15CBId: Scalars['Int'];
  IfBasisOfTheRateOfDeduction: Scalars['Int'];
  IncomeChargeableToTax: Scalars['Int'];
  IsAccountOfBusinessIncome: Scalars['Int'];
  IsCertificateObtained: Scalars['Int'];
  IsRelatedParty: Scalars['Int'];
  IsRemittanceCapitalGains: Scalars['Int'];
  IsRemittanceChargeableIndia: Scalars['Int'];
  IsRemittanceCovered: Scalars['Int'];
  IsTaxPayableGrossedUp: Scalars['Int'];
  IsWithPermanentEstablishment: Scalars['Int'];
  Locality: Scalars['Int'];
  NatureOfRemittance: Scalars['Int'];
  NoReasonRelevantArticleDTAA: Scalars['Int'];
  NoTaxableInIndiaDTAA: Scalars['Int'];
  OfficerDesignationAO: Scalars['Int'];
  OfficerNameAO: Scalars['Int'];
  OtherRemittanceCountry: Scalars['Int'];
  OtherRemittanceCurrency: Scalars['Int'];
  OtherRemittanceNameOnDocument: Scalars['Int'];
  PayableAmountINR: Scalars['Int'];
  PayableAmountInForeign: Scalars['Int'];
  PermanentEstablishmentArticle: Scalars['Int'];
  PermanentEstablishmentRateOfTDS: Scalars['Int'];
  PhoneNumber: Scalars['Int'];
  Pincode: Scalars['Int'];
  ProposedDate: Scalars['Int'];
  RBIPurposeCode: Scalars['Int'];
  RangeCode: Scalars['Int'];
  RateOfTDS: Scalars['Int'];
  RateOfTDSIncomeTaxAct: Scalars['Int'];
  ReasonRemittanceNotChargeable: Scalars['Int'];
  RecipientName: Scalars['Int'];
  RecipientPAN: Scalars['Int'];
  RemittanceCountry: Scalars['Int'];
  RemittanceCurrency: Scalars['Int'];
  RemittanceNameOnDocument: Scalars['Int'];
  ResidentCountry: Scalars['Int'];
  RevokedToId: Scalars['Int'];
  SectionOfActRemittanceCovered: Scalars['Int'];
  State: Scalars['Int'];
  Status: Scalars['Int'];
  Street: Scalars['Int'];
  SubCategory: Scalars['Int'];
  SuchIncomeLiableToTaxIN: Scalars['Int'];
  TaxLiability: Scalars['Int'];
  TaxResidencyCertificateMade: Scalars['Int'];
  TaxResidencyCertificateObtained: Scalars['Int'];
  TaxableInIndiaDTAA: Scalars['Int'];
  TransactionLengthPrice: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  YesTaxableInIndiaDTAA: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ifsc: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type Form15CacCountOrderByAggregateInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCertificateDate?: Maybe<SortOrder>;
  AccountantCertificateNumber?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirm?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AoNumber?: Maybe<SortOrder>;
  AoType?: Maybe<SortOrder>;
  AreaCode?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  BusinessRateOfTax?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsCertificateObtained?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RangeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CacCreateInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CacInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CacInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CacInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CB: Form15CbCreateNestedOneWithoutForm15CacInput;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacCreateManyBankDetailInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CBId: Scalars['Int'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacCreateManyBankDetailInputEnvelope = {
  data: Array<Form15CacCreateManyBankDetailInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CacCreateManyBeneficiaryInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CBId: Scalars['Int'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacCreateManyBeneficiaryInputEnvelope = {
  data: Array<Form15CacCreateManyBeneficiaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CacCreateManyInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CBId: Scalars['Int'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacCreateNestedManyWithoutBankDetailInput = {
  connect?: Maybe<Array<Form15CacWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CacCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CacCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CacCreateManyBankDetailInputEnvelope>;
};

export type Form15CacCreateNestedManyWithoutBeneficiaryInput = {
  connect?: Maybe<Array<Form15CacWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CacCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CacCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CacCreateManyBeneficiaryInputEnvelope>;
};

export type Form15CacCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<Form15CacWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CacCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CacCreateWithoutEventsInput>;
};

export type Form15CacCreateNestedOneWithoutForm15CbInput = {
  connect?: Maybe<Form15CacWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CacCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<Form15CacCreateWithoutForm15CbInput>;
};

export type Form15CacCreateOrConnectWithoutBankDetailInput = {
  create: Form15CacCreateWithoutBankDetailInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacCreateOrConnectWithoutBeneficiaryInput = {
  create: Form15CacCreateWithoutBeneficiaryInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacCreateOrConnectWithoutEventsInput = {
  create: Form15CacCreateWithoutEventsInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacCreateOrConnectWithoutForm15CbInput = {
  create: Form15CacCreateWithoutForm15CbInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacCreateWithoutBankDetailInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CacInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CacInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CB: Form15CbCreateNestedOneWithoutForm15CacInput;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacCreateWithoutBeneficiaryInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CacInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CacInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CB: Form15CbCreateNestedOneWithoutForm15CacInput;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacCreateWithoutEventsInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CacInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CacInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CB: Form15CbCreateNestedOneWithoutForm15CacInput;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacCreateWithoutForm15CbInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CacInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CacInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CacInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacGroupBy = {
  __typename?: 'Form15CACGroupBy';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate: Scalars['DateTime'];
  AccountantCertificateNumber: Scalars['String'];
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirm: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  BusinessPlace: Scalars['String'];
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CBId: Scalars['Int'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained: Scalars['Boolean'];
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Status: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  _avg?: Maybe<Form15CacAvgAggregate>;
  _count?: Maybe<Form15CacCountAggregate>;
  _max?: Maybe<Form15CacMaxAggregate>;
  _min?: Maybe<Form15CacMinAggregate>;
  _sum?: Maybe<Form15CacSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Form15CacListRelationFilter = {
  every?: Maybe<Form15CacWhereInput>;
  none?: Maybe<Form15CacWhereInput>;
  some?: Maybe<Form15CacWhereInput>;
};

export type Form15CacMaxAggregate = {
  __typename?: 'Form15CACMaxAggregate';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate?: Maybe<Scalars['DateTime']>;
  AccountantCertificateNumber?: Maybe<Scalars['String']>;
  AccountantCity?: Maybe<Scalars['String']>;
  AccountantCountry?: Maybe<Scalars['String']>;
  AccountantFirm?: Maybe<Scalars['String']>;
  AccountantFlat?: Maybe<Scalars['String']>;
  AccountantLocality?: Maybe<Scalars['String']>;
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName?: Maybe<Scalars['String']>;
  AccountantPincode?: Maybe<Scalars['String']>;
  AccountantRegistrationNumber?: Maybe<Scalars['String']>;
  AccountantState?: Maybe<Scalars['String']>;
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA?: Maybe<Scalars['Boolean']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia?: Maybe<Scalars['Boolean']>;
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  RBIPurposeCode?: Maybe<Scalars['String']>;
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  ResidentCountry?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacMaxOrderByAggregateInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCertificateDate?: Maybe<SortOrder>;
  AccountantCertificateNumber?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirm?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AoNumber?: Maybe<SortOrder>;
  AoType?: Maybe<SortOrder>;
  AreaCode?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  BusinessRateOfTax?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsCertificateObtained?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RangeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CacMinAggregate = {
  __typename?: 'Form15CACMinAggregate';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCertificateDate?: Maybe<Scalars['DateTime']>;
  AccountantCertificateNumber?: Maybe<Scalars['String']>;
  AccountantCity?: Maybe<Scalars['String']>;
  AccountantCountry?: Maybe<Scalars['String']>;
  AccountantFirm?: Maybe<Scalars['String']>;
  AccountantFlat?: Maybe<Scalars['String']>;
  AccountantLocality?: Maybe<Scalars['String']>;
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName?: Maybe<Scalars['String']>;
  AccountantPincode?: Maybe<Scalars['String']>;
  AccountantRegistrationNumber?: Maybe<Scalars['String']>;
  AccountantState?: Maybe<Scalars['String']>;
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AoNumber?: Maybe<Scalars['String']>;
  AoType?: Maybe<Scalars['String']>;
  AreaCode?: Maybe<Scalars['String']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  BusinessPlace?: Maybe<Scalars['String']>;
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  CertificateDateAO?: Maybe<Scalars['DateTime']>;
  CertificateNumberAO?: Maybe<Scalars['String']>;
  CertificateSection?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA?: Maybe<Scalars['Boolean']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsCertificateObtained?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia?: Maybe<Scalars['Boolean']>;
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OfficerDesignationAO?: Maybe<Scalars['String']>;
  OfficerNameAO?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  RBIPurposeCode?: Maybe<Scalars['String']>;
  RangeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCountry?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  ResidentCountry?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CacMinOrderByAggregateInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCertificateDate?: Maybe<SortOrder>;
  AccountantCertificateNumber?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirm?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AoNumber?: Maybe<SortOrder>;
  AoType?: Maybe<SortOrder>;
  AreaCode?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  BusinessRateOfTax?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsCertificateObtained?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RangeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CacOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type Form15CacOrderByWithAggregationInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCertificateDate?: Maybe<SortOrder>;
  AccountantCertificateNumber?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirm?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AoNumber?: Maybe<SortOrder>;
  AoType?: Maybe<SortOrder>;
  AreaCode?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  BusinessRateOfTax?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsCertificateObtained?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RangeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  _avg?: Maybe<Form15CacAvgOrderByAggregateInput>;
  _count?: Maybe<Form15CacCountOrderByAggregateInput>;
  _max?: Maybe<Form15CacMaxOrderByAggregateInput>;
  _min?: Maybe<Form15CacMinOrderByAggregateInput>;
  _sum?: Maybe<Form15CacSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CacOrderByWithRelationInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCertificateDate?: Maybe<SortOrder>;
  AccountantCertificateNumber?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirm?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AoNumber?: Maybe<SortOrder>;
  AoType?: Maybe<SortOrder>;
  AreaCode?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetail?: Maybe<BankDetailOrderByWithRelationInput>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  Beneficiary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  BusinessPlace?: Maybe<SortOrder>;
  BusinessRateOfTax?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  CertificateDateAO?: Maybe<SortOrder>;
  CertificateNumberAO?: Maybe<SortOrder>;
  CertificateSection?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  Events?: Maybe<EventsOrderByRelationAggregateInput>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Form15CB?: Maybe<Form15CbOrderByWithRelationInput>;
  Form15CBId?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsCertificateObtained?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OfficerDesignationAO?: Maybe<SortOrder>;
  OfficerNameAO?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RangeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedFrom?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToForm?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CacRelationFilter = {
  is?: Maybe<Form15CacWhereInput>;
  isNot?: Maybe<Form15CacWhereInput>;
};

export enum Form15CacScalarFieldEnum {
  AccountantBuilding = 'AccountantBuilding',
  AccountantCertificateDate = 'AccountantCertificateDate',
  AccountantCertificateNumber = 'AccountantCertificateNumber',
  AccountantCity = 'AccountantCity',
  AccountantCountry = 'AccountantCountry',
  AccountantFirm = 'AccountantFirm',
  AccountantFlat = 'AccountantFlat',
  AccountantLocality = 'AccountantLocality',
  AccountantMembershipNumber = 'AccountantMembershipNumber',
  AccountantName = 'AccountantName',
  AccountantPincode = 'AccountantPincode',
  AccountantRegistrationNumber = 'AccountantRegistrationNumber',
  AccountantState = 'AccountantState',
  AccountantStreet = 'AccountantStreet',
  AmountAfterTds = 'AmountAfterTDS',
  AmountOfCapitalGains = 'AmountOfCapitalGains',
  AmountOfShortCapitalGains = 'AmountOfShortCapitalGains',
  AmountOfTdsInForeign = 'AmountOfTDSInForeign',
  AmountOfTdsInInr = 'AmountOfTDSInINR',
  AoNumber = 'AoNumber',
  AoType = 'AoType',
  AreaCode = 'AreaCode',
  AuthDealer = 'AuthDealer',
  BsrCode = 'BSRCode',
  BankDetailId = 'BankDetailId',
  BankName = 'BankName',
  BasisOfTaxableIncome = 'BasisOfTaxableIncome',
  BeneficiaryId = 'BeneficiaryId',
  BranchName = 'BranchName',
  Building = 'Building',
  BusinessPlace = 'BusinessPlace',
  BusinessRateOfTax = 'BusinessRateOfTax',
  CapitalGainsRateOfTds = 'CapitalGainsRateOfTDS',
  CertificateArticleOfDtaa = 'CertificateArticleOfDTAA',
  CertificateDtaa = 'CertificateDTAA',
  CertificateDateAo = 'CertificateDateAO',
  CertificateNumberAo = 'CertificateNumberAO',
  CertificateSection = 'CertificateSection',
  ChargeableAndReliefDtaa = 'ChargeableAndReliefDTAA',
  City = 'City',
  Country = 'Country',
  CreatedBy = 'CreatedBy',
  DtaaTaxLiability = 'DTAATaxLiability',
  DtaaTaxableIncome = 'DTAATaxableIncome',
  DateOfDeduction = 'DateOfDeduction',
  DeterminingTaxAndLiability = 'DeterminingTaxAndLiability',
  Email = 'Email',
  ExchangeRate = 'ExchangeRate',
  Flat = 'Flat',
  Form15CbId = 'Form15CBId',
  IfBasisOfTheRateOfDeduction = 'IfBasisOfTheRateOfDeduction',
  IncomeChargeableToTax = 'IncomeChargeableToTax',
  IsAccountOfBusinessIncome = 'IsAccountOfBusinessIncome',
  IsCertificateObtained = 'IsCertificateObtained',
  IsRelatedParty = 'IsRelatedParty',
  IsRemittanceCapitalGains = 'IsRemittanceCapitalGains',
  IsRemittanceChargeableIndia = 'IsRemittanceChargeableIndia',
  IsRemittanceCovered = 'IsRemittanceCovered',
  IsTaxPayableGrossedUp = 'IsTaxPayableGrossedUp',
  IsWithPermanentEstablishment = 'IsWithPermanentEstablishment',
  Locality = 'Locality',
  NatureOfRemittance = 'NatureOfRemittance',
  NoReasonRelevantArticleDtaa = 'NoReasonRelevantArticleDTAA',
  NoTaxableInIndiaDtaa = 'NoTaxableInIndiaDTAA',
  OfficerDesignationAo = 'OfficerDesignationAO',
  OfficerNameAo = 'OfficerNameAO',
  OtherRemittanceCountry = 'OtherRemittanceCountry',
  OtherRemittanceCurrency = 'OtherRemittanceCurrency',
  OtherRemittanceNameOnDocument = 'OtherRemittanceNameOnDocument',
  PayableAmountInr = 'PayableAmountINR',
  PayableAmountInForeign = 'PayableAmountInForeign',
  PermanentEstablishmentArticle = 'PermanentEstablishmentArticle',
  PermanentEstablishmentRateOfTds = 'PermanentEstablishmentRateOfTDS',
  PhoneNumber = 'PhoneNumber',
  Pincode = 'Pincode',
  ProposedDate = 'ProposedDate',
  RbiPurposeCode = 'RBIPurposeCode',
  RangeCode = 'RangeCode',
  RateOfTds = 'RateOfTDS',
  RateOfTdsIncomeTaxAct = 'RateOfTDSIncomeTaxAct',
  ReasonRemittanceNotChargeable = 'ReasonRemittanceNotChargeable',
  RecipientName = 'RecipientName',
  RecipientPan = 'RecipientPAN',
  RemittanceCountry = 'RemittanceCountry',
  RemittanceCurrency = 'RemittanceCurrency',
  RemittanceNameOnDocument = 'RemittanceNameOnDocument',
  ResidentCountry = 'ResidentCountry',
  RevokedToId = 'RevokedToId',
  SectionOfActRemittanceCovered = 'SectionOfActRemittanceCovered',
  State = 'State',
  Status = 'Status',
  Street = 'Street',
  SubCategory = 'SubCategory',
  SuchIncomeLiableToTaxIn = 'SuchIncomeLiableToTaxIN',
  TaxLiability = 'TaxLiability',
  TaxResidencyCertificateMade = 'TaxResidencyCertificateMade',
  TaxResidencyCertificateObtained = 'TaxResidencyCertificateObtained',
  TaxableInIndiaDtaa = 'TaxableInIndiaDTAA',
  TransactionLengthPrice = 'TransactionLengthPrice',
  UpdatedBy = 'UpdatedBy',
  YesTaxableInIndiaDtaa = 'YesTaxableInIndiaDTAA',
  CreatedAt = 'createdAt',
  Id = 'id',
  Ifsc = 'ifsc',
  UpdatedAt = 'updatedAt'
}

export type Form15CacScalarWhereInput = {
  AND?: Maybe<Array<Form15CacScalarWhereInput>>;
  AccountantBuilding?: Maybe<StringNullableFilter>;
  AccountantCertificateDate?: Maybe<DateTimeFilter>;
  AccountantCertificateNumber?: Maybe<StringFilter>;
  AccountantCity?: Maybe<StringFilter>;
  AccountantCountry?: Maybe<StringFilter>;
  AccountantFirm?: Maybe<StringFilter>;
  AccountantFlat?: Maybe<StringFilter>;
  AccountantLocality?: Maybe<StringFilter>;
  AccountantMembershipNumber?: Maybe<StringFilter>;
  AccountantName?: Maybe<StringFilter>;
  AccountantPincode?: Maybe<StringFilter>;
  AccountantRegistrationNumber?: Maybe<StringFilter>;
  AccountantState?: Maybe<StringFilter>;
  AccountantStreet?: Maybe<StringNullableFilter>;
  AmountAfterTDS?: Maybe<FloatNullableFilter>;
  AmountOfCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfShortCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfTDSInForeign?: Maybe<FloatNullableFilter>;
  AmountOfTDSInINR?: Maybe<FloatNullableFilter>;
  AoNumber?: Maybe<StringNullableFilter>;
  AoType?: Maybe<StringNullableFilter>;
  AreaCode?: Maybe<StringNullableFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  BasisOfTaxableIncome?: Maybe<StringNullableFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  BusinessRateOfTax?: Maybe<FloatNullableFilter>;
  CapitalGainsRateOfTDS?: Maybe<FloatNullableFilter>;
  CertificateArticleOfDTAA?: Maybe<StringNullableFilter>;
  CertificateDTAA?: Maybe<StringNullableFilter>;
  CertificateDateAO?: Maybe<DateTimeNullableFilter>;
  CertificateNumberAO?: Maybe<StringNullableFilter>;
  CertificateSection?: Maybe<StringNullableFilter>;
  ChargeableAndReliefDTAA?: Maybe<BoolFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DTAATaxLiability?: Maybe<FloatNullableFilter>;
  DTAATaxableIncome?: Maybe<FloatNullableFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  DeterminingTaxAndLiability?: Maybe<StringNullableFilter>;
  Email?: Maybe<StringNullableFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Form15CBId?: Maybe<IntFilter>;
  IfBasisOfTheRateOfDeduction?: Maybe<StringNullableFilter>;
  IncomeChargeableToTax?: Maybe<FloatNullableFilter>;
  IsAccountOfBusinessIncome?: Maybe<BoolNullableFilter>;
  IsCertificateObtained?: Maybe<BoolFilter>;
  IsRelatedParty?: Maybe<BoolNullableFilter>;
  IsRemittanceCapitalGains?: Maybe<BoolNullableFilter>;
  IsRemittanceChargeableIndia?: Maybe<BoolFilter>;
  IsRemittanceCovered?: Maybe<BoolNullableFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  IsWithPermanentEstablishment?: Maybe<BoolNullableFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CacScalarWhereInput>>;
  NatureOfRemittance?: Maybe<StringNullableFilter>;
  NoReasonRelevantArticleDTAA?: Maybe<StringNullableFilter>;
  NoTaxableInIndiaDTAA?: Maybe<StringNullableFilter>;
  OR?: Maybe<Array<Form15CacScalarWhereInput>>;
  OfficerDesignationAO?: Maybe<StringNullableFilter>;
  OfficerNameAO?: Maybe<StringNullableFilter>;
  OtherRemittanceCountry?: Maybe<StringNullableFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  OtherRemittanceNameOnDocument?: Maybe<StringNullableFilter>;
  PayableAmountINR?: Maybe<FloatFilter>;
  PayableAmountInForeign?: Maybe<FloatFilter>;
  PermanentEstablishmentArticle?: Maybe<StringNullableFilter>;
  PermanentEstablishmentRateOfTDS?: Maybe<FloatNullableFilter>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  RBIPurposeCode?: Maybe<StringFilter>;
  RangeCode?: Maybe<StringNullableFilter>;
  RateOfTDS?: Maybe<StringNullableFilter>;
  RateOfTDSIncomeTaxAct?: Maybe<StringNullableFilter>;
  ReasonRemittanceNotChargeable?: Maybe<StringNullableFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceCountry?: Maybe<StringFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  ResidentCountry?: Maybe<StringFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  SectionOfActRemittanceCovered?: Maybe<StringNullableFilter>;
  State?: Maybe<StringFilter>;
  Status?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  SuchIncomeLiableToTaxIN?: Maybe<BoolNullableFilter>;
  TaxLiability?: Maybe<FloatNullableFilter>;
  TaxResidencyCertificateMade?: Maybe<BoolNullableFilter>;
  TaxResidencyCertificateObtained?: Maybe<BoolNullableFilter>;
  TaxableInIndiaDTAA?: Maybe<BoolNullableFilter>;
  TransactionLengthPrice?: Maybe<BoolNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  YesTaxableInIndiaDTAA?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CacScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<Form15CacScalarWhereWithAggregatesInput>>;
  AccountantBuilding?: Maybe<StringNullableWithAggregatesFilter>;
  AccountantCertificateDate?: Maybe<DateTimeWithAggregatesFilter>;
  AccountantCertificateNumber?: Maybe<StringWithAggregatesFilter>;
  AccountantCity?: Maybe<StringWithAggregatesFilter>;
  AccountantCountry?: Maybe<StringWithAggregatesFilter>;
  AccountantFirm?: Maybe<StringWithAggregatesFilter>;
  AccountantFlat?: Maybe<StringWithAggregatesFilter>;
  AccountantLocality?: Maybe<StringWithAggregatesFilter>;
  AccountantMembershipNumber?: Maybe<StringWithAggregatesFilter>;
  AccountantName?: Maybe<StringWithAggregatesFilter>;
  AccountantPincode?: Maybe<StringWithAggregatesFilter>;
  AccountantRegistrationNumber?: Maybe<StringWithAggregatesFilter>;
  AccountantState?: Maybe<StringWithAggregatesFilter>;
  AccountantStreet?: Maybe<StringNullableWithAggregatesFilter>;
  AmountAfterTDS?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfCapitalGains?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfShortCapitalGains?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfTDSInForeign?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfTDSInINR?: Maybe<FloatNullableWithAggregatesFilter>;
  AoNumber?: Maybe<StringNullableWithAggregatesFilter>;
  AoType?: Maybe<StringNullableWithAggregatesFilter>;
  AreaCode?: Maybe<StringNullableWithAggregatesFilter>;
  AuthDealer?: Maybe<StringWithAggregatesFilter>;
  BSRCode?: Maybe<StringWithAggregatesFilter>;
  BankDetailId?: Maybe<IntWithAggregatesFilter>;
  BankName?: Maybe<StringWithAggregatesFilter>;
  BasisOfTaxableIncome?: Maybe<StringNullableWithAggregatesFilter>;
  BeneficiaryId?: Maybe<IntWithAggregatesFilter>;
  BranchName?: Maybe<StringWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  BusinessPlace?: Maybe<StringWithAggregatesFilter>;
  BusinessRateOfTax?: Maybe<FloatNullableWithAggregatesFilter>;
  CapitalGainsRateOfTDS?: Maybe<FloatNullableWithAggregatesFilter>;
  CertificateArticleOfDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateDateAO?: Maybe<DateTimeNullableWithAggregatesFilter>;
  CertificateNumberAO?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateSection?: Maybe<StringNullableWithAggregatesFilter>;
  ChargeableAndReliefDTAA?: Maybe<BoolWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  DTAATaxLiability?: Maybe<FloatNullableWithAggregatesFilter>;
  DTAATaxableIncome?: Maybe<FloatNullableWithAggregatesFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableWithAggregatesFilter>;
  DeterminingTaxAndLiability?: Maybe<StringNullableWithAggregatesFilter>;
  Email?: Maybe<StringNullableWithAggregatesFilter>;
  ExchangeRate?: Maybe<StringWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  Form15CBId?: Maybe<IntWithAggregatesFilter>;
  IfBasisOfTheRateOfDeduction?: Maybe<StringNullableWithAggregatesFilter>;
  IncomeChargeableToTax?: Maybe<FloatNullableWithAggregatesFilter>;
  IsAccountOfBusinessIncome?: Maybe<BoolNullableWithAggregatesFilter>;
  IsCertificateObtained?: Maybe<BoolWithAggregatesFilter>;
  IsRelatedParty?: Maybe<BoolNullableWithAggregatesFilter>;
  IsRemittanceCapitalGains?: Maybe<BoolNullableWithAggregatesFilter>;
  IsRemittanceChargeableIndia?: Maybe<BoolWithAggregatesFilter>;
  IsRemittanceCovered?: Maybe<BoolNullableWithAggregatesFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolWithAggregatesFilter>;
  IsWithPermanentEstablishment?: Maybe<BoolNullableWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<Form15CacScalarWhereWithAggregatesInput>>;
  NatureOfRemittance?: Maybe<StringNullableWithAggregatesFilter>;
  NoReasonRelevantArticleDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  NoTaxableInIndiaDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  OR?: Maybe<Array<Form15CacScalarWhereWithAggregatesInput>>;
  OfficerDesignationAO?: Maybe<StringNullableWithAggregatesFilter>;
  OfficerNameAO?: Maybe<StringNullableWithAggregatesFilter>;
  OtherRemittanceCountry?: Maybe<StringNullableWithAggregatesFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableWithAggregatesFilter>;
  OtherRemittanceNameOnDocument?: Maybe<StringNullableWithAggregatesFilter>;
  PayableAmountINR?: Maybe<FloatWithAggregatesFilter>;
  PayableAmountInForeign?: Maybe<FloatWithAggregatesFilter>;
  PermanentEstablishmentArticle?: Maybe<StringNullableWithAggregatesFilter>;
  PermanentEstablishmentRateOfTDS?: Maybe<FloatNullableWithAggregatesFilter>;
  PhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  ProposedDate?: Maybe<DateTimeWithAggregatesFilter>;
  RBIPurposeCode?: Maybe<StringWithAggregatesFilter>;
  RangeCode?: Maybe<StringNullableWithAggregatesFilter>;
  RateOfTDS?: Maybe<StringNullableWithAggregatesFilter>;
  RateOfTDSIncomeTaxAct?: Maybe<StringNullableWithAggregatesFilter>;
  ReasonRemittanceNotChargeable?: Maybe<StringNullableWithAggregatesFilter>;
  RecipientName?: Maybe<StringWithAggregatesFilter>;
  RecipientPAN?: Maybe<StringNullableWithAggregatesFilter>;
  RemittanceCountry?: Maybe<StringWithAggregatesFilter>;
  RemittanceCurrency?: Maybe<StringWithAggregatesFilter>;
  RemittanceNameOnDocument?: Maybe<StringWithAggregatesFilter>;
  ResidentCountry?: Maybe<StringWithAggregatesFilter>;
  RevokedToId?: Maybe<IntNullableWithAggregatesFilter>;
  SectionOfActRemittanceCovered?: Maybe<StringNullableWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Status?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  SubCategory?: Maybe<StringWithAggregatesFilter>;
  SuchIncomeLiableToTaxIN?: Maybe<BoolNullableWithAggregatesFilter>;
  TaxLiability?: Maybe<FloatNullableWithAggregatesFilter>;
  TaxResidencyCertificateMade?: Maybe<BoolNullableWithAggregatesFilter>;
  TaxResidencyCertificateObtained?: Maybe<BoolNullableWithAggregatesFilter>;
  TaxableInIndiaDTAA?: Maybe<BoolNullableWithAggregatesFilter>;
  TransactionLengthPrice?: Maybe<BoolNullableWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  YesTaxableInIndiaDTAA?: Maybe<FloatNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  ifsc?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type Form15CacSumAggregate = {
  __typename?: 'Form15CACSumAggregate';
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BusinessRateOfTax?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  Form15CBId?: Maybe<Scalars['Int']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15CacSumOrderByAggregateInput = {
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BusinessRateOfTax?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  Form15CBId?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CacUpdateInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCertificateDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  AccountantCertificateNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirm?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AoNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AoType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AreaCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CacNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CacNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  BusinessRateOfTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CacNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateOneRequiredWithoutForm15CacNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RangeCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CacUpdateManyMutationInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCertificateDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  AccountantCertificateNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirm?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AoNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AoType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AreaCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  BusinessRateOfTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RangeCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CacUpdateManyWithWhereWithoutBankDetailInput = {
  data: Form15CacUpdateManyMutationInput;
  where: Form15CacScalarWhereInput;
};

export type Form15CacUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: Form15CacUpdateManyMutationInput;
  where: Form15CacScalarWhereInput;
};

export type Form15CacUpdateManyWithoutBankDetailNestedInput = {
  connect?: Maybe<Array<Form15CacWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CacCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CacCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CacCreateManyBankDetailInputEnvelope>;
  delete?: Maybe<Array<Form15CacWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CacScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CacWhereUniqueInput>>;
  set?: Maybe<Array<Form15CacWhereUniqueInput>>;
  update?: Maybe<Array<Form15CacUpdateWithWhereUniqueWithoutBankDetailInput>>;
  updateMany?: Maybe<Array<Form15CacUpdateManyWithWhereWithoutBankDetailInput>>;
  upsert?: Maybe<Array<Form15CacUpsertWithWhereUniqueWithoutBankDetailInput>>;
};

export type Form15CacUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: Maybe<Array<Form15CacWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CacCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CacCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CacCreateManyBeneficiaryInputEnvelope>;
  delete?: Maybe<Array<Form15CacWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CacScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CacWhereUniqueInput>>;
  set?: Maybe<Array<Form15CacWhereUniqueInput>>;
  update?: Maybe<Array<Form15CacUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: Maybe<Array<Form15CacUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: Maybe<Array<Form15CacUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type Form15CacUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<Form15CacWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CacCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CacCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CacUpdateWithoutEventsInput>;
  upsert?: Maybe<Form15CacUpsertWithoutEventsInput>;
};

export type Form15CacUpdateOneWithoutForm15CbNestedInput = {
  connect?: Maybe<Form15CacWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CacCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<Form15CacCreateWithoutForm15CbInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CacUpdateWithoutForm15CbInput>;
  upsert?: Maybe<Form15CacUpsertWithoutForm15CbInput>;
};

export type Form15CacUpdateWithWhereUniqueWithoutBankDetailInput = {
  data: Form15CacUpdateWithoutBankDetailInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: Form15CacUpdateWithoutBeneficiaryInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacUpdateWithoutBankDetailInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCertificateDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  AccountantCertificateNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirm?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AoNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AoType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AreaCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CacNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  BusinessRateOfTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CacNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateOneRequiredWithoutForm15CacNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RangeCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CacUpdateWithoutBeneficiaryInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCertificateDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  AccountantCertificateNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirm?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AoNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AoType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AreaCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CacNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  BusinessRateOfTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CacNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateOneRequiredWithoutForm15CacNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RangeCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CacUpdateWithoutEventsInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCertificateDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  AccountantCertificateNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirm?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AoNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AoType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AreaCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CacNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CacNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  BusinessRateOfTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateOneRequiredWithoutForm15CacNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RangeCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CacUpdateWithoutForm15CbInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCertificateDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  AccountantCertificateNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirm?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AoNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AoType?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AreaCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CacNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CacNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BusinessPlace?: Maybe<StringFieldUpdateOperationsInput>;
  BusinessRateOfTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDateAO?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  CertificateNumberAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateSection?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CacNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerDesignationAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OfficerNameAO?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RangeCode?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CacUpsertWithWhereUniqueWithoutBankDetailInput = {
  create: Form15CacCreateWithoutBankDetailInput;
  update: Form15CacUpdateWithoutBankDetailInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: Form15CacCreateWithoutBeneficiaryInput;
  update: Form15CacUpdateWithoutBeneficiaryInput;
  where: Form15CacWhereUniqueInput;
};

export type Form15CacUpsertWithoutEventsInput = {
  create: Form15CacCreateWithoutEventsInput;
  update: Form15CacUpdateWithoutEventsInput;
};

export type Form15CacUpsertWithoutForm15CbInput = {
  create: Form15CacCreateWithoutForm15CbInput;
  update: Form15CacUpdateWithoutForm15CbInput;
};

export type Form15CacWhereInput = {
  AND?: Maybe<Array<Form15CacWhereInput>>;
  AccountantBuilding?: Maybe<StringNullableFilter>;
  AccountantCertificateDate?: Maybe<DateTimeFilter>;
  AccountantCertificateNumber?: Maybe<StringFilter>;
  AccountantCity?: Maybe<StringFilter>;
  AccountantCountry?: Maybe<StringFilter>;
  AccountantFirm?: Maybe<StringFilter>;
  AccountantFlat?: Maybe<StringFilter>;
  AccountantLocality?: Maybe<StringFilter>;
  AccountantMembershipNumber?: Maybe<StringFilter>;
  AccountantName?: Maybe<StringFilter>;
  AccountantPincode?: Maybe<StringFilter>;
  AccountantRegistrationNumber?: Maybe<StringFilter>;
  AccountantState?: Maybe<StringFilter>;
  AccountantStreet?: Maybe<StringNullableFilter>;
  AmountAfterTDS?: Maybe<FloatNullableFilter>;
  AmountOfCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfShortCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfTDSInForeign?: Maybe<FloatNullableFilter>;
  AmountOfTDSInINR?: Maybe<FloatNullableFilter>;
  AoNumber?: Maybe<StringNullableFilter>;
  AoType?: Maybe<StringNullableFilter>;
  AreaCode?: Maybe<StringNullableFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetail?: Maybe<BankDetailRelationFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  BasisOfTaxableIncome?: Maybe<StringNullableFilter>;
  Beneficiary?: Maybe<BenefeciaryRelationFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  BusinessPlace?: Maybe<StringFilter>;
  BusinessRateOfTax?: Maybe<FloatNullableFilter>;
  CapitalGainsRateOfTDS?: Maybe<FloatNullableFilter>;
  CertificateArticleOfDTAA?: Maybe<StringNullableFilter>;
  CertificateDTAA?: Maybe<StringNullableFilter>;
  CertificateDateAO?: Maybe<DateTimeNullableFilter>;
  CertificateNumberAO?: Maybe<StringNullableFilter>;
  CertificateSection?: Maybe<StringNullableFilter>;
  ChargeableAndReliefDTAA?: Maybe<BoolFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DTAATaxLiability?: Maybe<FloatNullableFilter>;
  DTAATaxableIncome?: Maybe<FloatNullableFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  DeterminingTaxAndLiability?: Maybe<StringNullableFilter>;
  Email?: Maybe<StringNullableFilter>;
  Events?: Maybe<EventsListRelationFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Form15CB?: Maybe<Form15CbRelationFilter>;
  Form15CBId?: Maybe<IntFilter>;
  IfBasisOfTheRateOfDeduction?: Maybe<StringNullableFilter>;
  IncomeChargeableToTax?: Maybe<FloatNullableFilter>;
  IsAccountOfBusinessIncome?: Maybe<BoolNullableFilter>;
  IsCertificateObtained?: Maybe<BoolFilter>;
  IsRelatedParty?: Maybe<BoolNullableFilter>;
  IsRemittanceCapitalGains?: Maybe<BoolNullableFilter>;
  IsRemittanceChargeableIndia?: Maybe<BoolFilter>;
  IsRemittanceCovered?: Maybe<BoolNullableFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  IsWithPermanentEstablishment?: Maybe<BoolNullableFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CacWhereInput>>;
  NatureOfRemittance?: Maybe<StringNullableFilter>;
  NoReasonRelevantArticleDTAA?: Maybe<StringNullableFilter>;
  NoTaxableInIndiaDTAA?: Maybe<StringNullableFilter>;
  OR?: Maybe<Array<Form15CacWhereInput>>;
  OfficerDesignationAO?: Maybe<StringNullableFilter>;
  OfficerNameAO?: Maybe<StringNullableFilter>;
  OtherRemittanceCountry?: Maybe<StringNullableFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  OtherRemittanceNameOnDocument?: Maybe<StringNullableFilter>;
  PayableAmountINR?: Maybe<FloatFilter>;
  PayableAmountInForeign?: Maybe<FloatFilter>;
  PermanentEstablishmentArticle?: Maybe<StringNullableFilter>;
  PermanentEstablishmentRateOfTDS?: Maybe<FloatNullableFilter>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  RBIPurposeCode?: Maybe<StringFilter>;
  RangeCode?: Maybe<StringNullableFilter>;
  RateOfTDS?: Maybe<StringNullableFilter>;
  RateOfTDSIncomeTaxAct?: Maybe<StringNullableFilter>;
  ReasonRemittanceNotChargeable?: Maybe<StringNullableFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceCountry?: Maybe<StringFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  ResidentCountry?: Maybe<StringFilter>;
  RevokedFrom?: Maybe<Form15CbRelationFilter>;
  RevokedToForm?: Maybe<Form15CbRelationFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  SectionOfActRemittanceCovered?: Maybe<StringNullableFilter>;
  State?: Maybe<StringFilter>;
  Status?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  SuchIncomeLiableToTaxIN?: Maybe<BoolNullableFilter>;
  TaxLiability?: Maybe<FloatNullableFilter>;
  TaxResidencyCertificateMade?: Maybe<BoolNullableFilter>;
  TaxResidencyCertificateObtained?: Maybe<BoolNullableFilter>;
  TaxableInIndiaDTAA?: Maybe<BoolNullableFilter>;
  TransactionLengthPrice?: Maybe<BoolNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  YesTaxableInIndiaDTAA?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CacWhereUniqueInput = {
  Form15CBId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15Cad = {
  __typename?: 'Form15CAD';
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetail: BankDetail;
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  Beneficiary: Benefeciary;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  /** Remittance */
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Document: Array<Document>;
  Email?: Maybe<Scalars['String']>;
  Events: Array<Events>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15Cad>;
  RevokedToForm?: Maybe<Form15Cad>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  _count?: Maybe<Form15CadCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type Form15CadDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type Form15CadEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};

export type Form15CadAvgAggregate = {
  __typename?: 'Form15CADAvgAggregate';
  AmountPayableINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Float']>;
  BeneficiaryId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  RevokedToId?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Form15CadAvgOrderByAggregateInput = {
  AmountPayableINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CadCount = {
  __typename?: 'Form15CADCount';
  Document: Scalars['Int'];
  Events: Scalars['Int'];
};

export type Form15CadCountAggregate = {
  __typename?: 'Form15CADCountAggregate';
  AmountPayable: Scalars['Int'];
  AmountPayableINR: Scalars['Int'];
  AuthDealer: Scalars['Int'];
  BSRCode: Scalars['Int'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['Int'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['Int'];
  Building: Scalars['Int'];
  City: Scalars['Int'];
  Country: Scalars['Int'];
  CountryOfRemittance: Scalars['Int'];
  CountryOfRemittanceOther: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  Email: Scalars['Int'];
  ExchangeRate: Scalars['Int'];
  Flat: Scalars['Int'];
  Locality: Scalars['Int'];
  OtherRemittanceCurrency: Scalars['Int'];
  PhoneNumber: Scalars['Int'];
  Pincode: Scalars['Int'];
  ProposedDate: Scalars['Int'];
  PurposeCode: Scalars['Int'];
  RecipientName: Scalars['Int'];
  RecipientPAN: Scalars['Int'];
  RemittanceCurrency: Scalars['Int'];
  RemittanceNameOnDocument: Scalars['Int'];
  RemittanceNameOnDocumentOther: Scalars['Int'];
  ResidentCountry: Scalars['Int'];
  RevokedToId: Scalars['Int'];
  State: Scalars['Int'];
  Street: Scalars['Int'];
  SubCategory: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ifsc: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type Form15CadCountOrderByAggregateInput = {
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CadCreateInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CadInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CadInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CadInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CadInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadCreateManyBankDetailInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadCreateManyBankDetailInputEnvelope = {
  data: Array<Form15CadCreateManyBankDetailInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CadCreateManyBeneficiaryInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadCreateManyBeneficiaryInputEnvelope = {
  data: Array<Form15CadCreateManyBeneficiaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CadCreateManyInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadCreateNestedManyWithoutBankDetailInput = {
  connect?: Maybe<Array<Form15CadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CadCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CadCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CadCreateManyBankDetailInputEnvelope>;
};

export type Form15CadCreateNestedManyWithoutBeneficiaryInput = {
  connect?: Maybe<Array<Form15CadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CadCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CadCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CadCreateManyBeneficiaryInputEnvelope>;
};

export type Form15CadCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<Form15CadWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CadCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CadCreateWithoutDocumentInput>;
};

export type Form15CadCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<Form15CadWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CadCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CadCreateWithoutEventsInput>;
};

export type Form15CadCreateOrConnectWithoutBankDetailInput = {
  create: Form15CadCreateWithoutBankDetailInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadCreateOrConnectWithoutBeneficiaryInput = {
  create: Form15CadCreateWithoutBeneficiaryInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadCreateOrConnectWithoutDocumentInput = {
  create: Form15CadCreateWithoutDocumentInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadCreateOrConnectWithoutEventsInput = {
  create: Form15CadCreateWithoutEventsInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadCreateWithoutBankDetailInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CadInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CadInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CadInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadCreateWithoutBeneficiaryInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CadInput;
  BankName: Scalars['String'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CadInput>;
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CadInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadCreateWithoutDocumentInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CadInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CadInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Email?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CadInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadCreateWithoutEventsInput = {
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CadInput;
  BankName: Scalars['String'];
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CadInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CadInput>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadGroupBy = {
  __typename?: 'Form15CADGroupBy';
  AmountPayable: Scalars['String'];
  AmountPayableINR: Scalars['Float'];
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CountryOfRemittance: Scalars['String'];
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy: Scalars['Int'];
  Email?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Locality: Scalars['String'];
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  PurposeCode: Scalars['String'];
  RecipientName: Scalars['String'];
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry: Scalars['String'];
  RevokedToId?: Maybe<Scalars['Int']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  UpdatedBy?: Maybe<Scalars['Int']>;
  _avg?: Maybe<Form15CadAvgAggregate>;
  _count?: Maybe<Form15CadCountAggregate>;
  _max?: Maybe<Form15CadMaxAggregate>;
  _min?: Maybe<Form15CadMinAggregate>;
  _sum?: Maybe<Form15CadSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Form15CadListRelationFilter = {
  every?: Maybe<Form15CadWhereInput>;
  none?: Maybe<Form15CadWhereInput>;
  some?: Maybe<Form15CadWhereInput>;
};

export type Form15CadMaxAggregate = {
  __typename?: 'Form15CADMaxAggregate';
  AmountPayable?: Maybe<Scalars['String']>;
  AmountPayableINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CountryOfRemittance?: Maybe<Scalars['String']>;
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  PurposeCode?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadMaxOrderByAggregateInput = {
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CadMinAggregate = {
  __typename?: 'Form15CADMinAggregate';
  AmountPayable?: Maybe<Scalars['String']>;
  AmountPayableINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CountryOfRemittance?: Maybe<Scalars['String']>;
  CountryOfRemittanceOther?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  Email?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  PurposeCode?: Maybe<Scalars['String']>;
  RecipientName?: Maybe<Scalars['String']>;
  RecipientPAN?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RemittanceNameOnDocumentOther?: Maybe<Scalars['String']>;
  ResidentCountry?: Maybe<Scalars['String']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CadMinOrderByAggregateInput = {
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CadOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type Form15CadOrderByWithAggregationInput = {
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Email?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  _avg?: Maybe<Form15CadAvgOrderByAggregateInput>;
  _count?: Maybe<Form15CadCountOrderByAggregateInput>;
  _max?: Maybe<Form15CadMaxOrderByAggregateInput>;
  _min?: Maybe<Form15CadMinOrderByAggregateInput>;
  _sum?: Maybe<Form15CadSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CadOrderByWithRelationInput = {
  AmountPayable?: Maybe<SortOrder>;
  AmountPayableINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetail?: Maybe<BankDetailOrderByWithRelationInput>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  Beneficiary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CountryOfRemittance?: Maybe<SortOrder>;
  CountryOfRemittanceOther?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  Email?: Maybe<SortOrder>;
  Events?: Maybe<EventsOrderByRelationAggregateInput>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  PhoneNumber?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  PurposeCode?: Maybe<SortOrder>;
  RecipientName?: Maybe<SortOrder>;
  RecipientPAN?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RemittanceNameOnDocumentOther?: Maybe<SortOrder>;
  ResidentCountry?: Maybe<SortOrder>;
  RevokedFrom?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToForm?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToId?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CadRelationFilter = {
  is?: Maybe<Form15CadWhereInput>;
  isNot?: Maybe<Form15CadWhereInput>;
};

export enum Form15CadScalarFieldEnum {
  AmountPayable = 'AmountPayable',
  AmountPayableInr = 'AmountPayableINR',
  AuthDealer = 'AuthDealer',
  BsrCode = 'BSRCode',
  BankDetailId = 'BankDetailId',
  BankName = 'BankName',
  BeneficiaryId = 'BeneficiaryId',
  BranchName = 'BranchName',
  Building = 'Building',
  City = 'City',
  Country = 'Country',
  CountryOfRemittance = 'CountryOfRemittance',
  CountryOfRemittanceOther = 'CountryOfRemittanceOther',
  CreatedBy = 'CreatedBy',
  Email = 'Email',
  ExchangeRate = 'ExchangeRate',
  Flat = 'Flat',
  Locality = 'Locality',
  OtherRemittanceCurrency = 'OtherRemittanceCurrency',
  PhoneNumber = 'PhoneNumber',
  Pincode = 'Pincode',
  ProposedDate = 'ProposedDate',
  PurposeCode = 'PurposeCode',
  RecipientName = 'RecipientName',
  RecipientPan = 'RecipientPAN',
  RemittanceCurrency = 'RemittanceCurrency',
  RemittanceNameOnDocument = 'RemittanceNameOnDocument',
  RemittanceNameOnDocumentOther = 'RemittanceNameOnDocumentOther',
  ResidentCountry = 'ResidentCountry',
  RevokedToId = 'RevokedToId',
  State = 'State',
  Street = 'Street',
  SubCategory = 'SubCategory',
  UpdatedBy = 'UpdatedBy',
  CreatedAt = 'createdAt',
  Id = 'id',
  Ifsc = 'ifsc',
  UpdatedAt = 'updatedAt'
}

export type Form15CadScalarWhereInput = {
  AND?: Maybe<Array<Form15CadScalarWhereInput>>;
  AmountPayable?: Maybe<StringFilter>;
  AmountPayableINR?: Maybe<FloatFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CountryOfRemittance?: Maybe<StringFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Email?: Maybe<StringNullableFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CadScalarWhereInput>>;
  OR?: Maybe<Array<Form15CadScalarWhereInput>>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  PurposeCode?: Maybe<StringFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableFilter>;
  ResidentCountry?: Maybe<StringFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CadScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<Form15CadScalarWhereWithAggregatesInput>>;
  AmountPayable?: Maybe<StringWithAggregatesFilter>;
  AmountPayableINR?: Maybe<FloatWithAggregatesFilter>;
  AuthDealer?: Maybe<StringWithAggregatesFilter>;
  BSRCode?: Maybe<StringWithAggregatesFilter>;
  BankDetailId?: Maybe<IntWithAggregatesFilter>;
  BankName?: Maybe<StringWithAggregatesFilter>;
  BeneficiaryId?: Maybe<IntWithAggregatesFilter>;
  BranchName?: Maybe<StringWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CountryOfRemittance?: Maybe<StringWithAggregatesFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  Email?: Maybe<StringNullableWithAggregatesFilter>;
  ExchangeRate?: Maybe<StringWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<Form15CadScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<Form15CadScalarWhereWithAggregatesInput>>;
  OtherRemittanceCurrency?: Maybe<StringNullableWithAggregatesFilter>;
  PhoneNumber?: Maybe<StringNullableWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  ProposedDate?: Maybe<DateTimeWithAggregatesFilter>;
  PurposeCode?: Maybe<StringWithAggregatesFilter>;
  RecipientName?: Maybe<StringWithAggregatesFilter>;
  RecipientPAN?: Maybe<StringNullableWithAggregatesFilter>;
  RemittanceCurrency?: Maybe<StringWithAggregatesFilter>;
  RemittanceNameOnDocument?: Maybe<StringWithAggregatesFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableWithAggregatesFilter>;
  ResidentCountry?: Maybe<StringWithAggregatesFilter>;
  RevokedToId?: Maybe<IntNullableWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  SubCategory?: Maybe<StringWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  ifsc?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type Form15CadSumAggregate = {
  __typename?: 'Form15CADSumAggregate';
  AmountPayableINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15CadSumOrderByAggregateInput = {
  AmountPayableINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CadUpdateInput = {
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CadNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CadNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CadNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CadNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CadUpdateManyMutationInput = {
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CadUpdateManyWithWhereWithoutBankDetailInput = {
  data: Form15CadUpdateManyMutationInput;
  where: Form15CadScalarWhereInput;
};

export type Form15CadUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: Form15CadUpdateManyMutationInput;
  where: Form15CadScalarWhereInput;
};

export type Form15CadUpdateManyWithoutBankDetailNestedInput = {
  connect?: Maybe<Array<Form15CadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CadCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CadCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CadCreateManyBankDetailInputEnvelope>;
  delete?: Maybe<Array<Form15CadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CadScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CadWhereUniqueInput>>;
  set?: Maybe<Array<Form15CadWhereUniqueInput>>;
  update?: Maybe<Array<Form15CadUpdateWithWhereUniqueWithoutBankDetailInput>>;
  updateMany?: Maybe<Array<Form15CadUpdateManyWithWhereWithoutBankDetailInput>>;
  upsert?: Maybe<Array<Form15CadUpsertWithWhereUniqueWithoutBankDetailInput>>;
};

export type Form15CadUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: Maybe<Array<Form15CadWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CadCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CadCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CadCreateManyBeneficiaryInputEnvelope>;
  delete?: Maybe<Array<Form15CadWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CadScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CadWhereUniqueInput>>;
  set?: Maybe<Array<Form15CadWhereUniqueInput>>;
  update?: Maybe<Array<Form15CadUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: Maybe<Array<Form15CadUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: Maybe<Array<Form15CadUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type Form15CadUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<Form15CadWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CadCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CadCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CadUpdateWithoutDocumentInput>;
  upsert?: Maybe<Form15CadUpsertWithoutDocumentInput>;
};

export type Form15CadUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<Form15CadWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CadCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CadCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CadUpdateWithoutEventsInput>;
  upsert?: Maybe<Form15CadUpsertWithoutEventsInput>;
};

export type Form15CadUpdateWithWhereUniqueWithoutBankDetailInput = {
  data: Form15CadUpdateWithoutBankDetailInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: Form15CadUpdateWithoutBeneficiaryInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadUpdateWithoutBankDetailInput = {
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CadNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CadNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CadNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CadUpdateWithoutBeneficiaryInput = {
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CadNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CadNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CadNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CadUpdateWithoutDocumentInput = {
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CadNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CadNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CadNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CadUpdateWithoutEventsInput = {
  AmountPayable?: Maybe<StringFieldUpdateOperationsInput>;
  AmountPayableINR?: Maybe<FloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CadNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CadNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittance?: Maybe<StringFieldUpdateOperationsInput>;
  CountryOfRemittanceOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CadNestedInput>;
  Email?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PhoneNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  PurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientName?: Maybe<StringFieldUpdateOperationsInput>;
  RecipientPAN?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocumentOther?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ResidentCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CadUpsertWithWhereUniqueWithoutBankDetailInput = {
  create: Form15CadCreateWithoutBankDetailInput;
  update: Form15CadUpdateWithoutBankDetailInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: Form15CadCreateWithoutBeneficiaryInput;
  update: Form15CadUpdateWithoutBeneficiaryInput;
  where: Form15CadWhereUniqueInput;
};

export type Form15CadUpsertWithoutDocumentInput = {
  create: Form15CadCreateWithoutDocumentInput;
  update: Form15CadUpdateWithoutDocumentInput;
};

export type Form15CadUpsertWithoutEventsInput = {
  create: Form15CadCreateWithoutEventsInput;
  update: Form15CadUpdateWithoutEventsInput;
};

export type Form15CadWhereInput = {
  AND?: Maybe<Array<Form15CadWhereInput>>;
  AmountPayable?: Maybe<StringFilter>;
  AmountPayableINR?: Maybe<FloatFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetail?: Maybe<BankDetailRelationFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  Beneficiary?: Maybe<BenefeciaryRelationFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CountryOfRemittance?: Maybe<StringFilter>;
  CountryOfRemittanceOther?: Maybe<StringNullableFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  Email?: Maybe<StringNullableFilter>;
  Events?: Maybe<EventsListRelationFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CadWhereInput>>;
  OR?: Maybe<Array<Form15CadWhereInput>>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  PhoneNumber?: Maybe<StringNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  PurposeCode?: Maybe<StringFilter>;
  RecipientName?: Maybe<StringFilter>;
  RecipientPAN?: Maybe<StringNullableFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  RemittanceNameOnDocumentOther?: Maybe<StringNullableFilter>;
  ResidentCountry?: Maybe<StringFilter>;
  RevokedFrom?: Maybe<Form15CbRelationFilter>;
  RevokedToForm?: Maybe<Form15CbRelationFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CadWhereUniqueInput = {
  RevokedToId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15Cb = {
  __typename?: 'Form15CB';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetail: BankDetail;
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: Benefeciary;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<User>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document: Array<Document>;
  Events: Array<Events>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15Cac>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<Request>;
  RequestId?: Maybe<Scalars['Int']>;
  RevokedFrom?: Maybe<Form15Cb>;
  RevokedToForm?: Maybe<Form15Cb>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  _count?: Maybe<Form15CbCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type Form15CbDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type Form15CbEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};

export type Form15CbAvgAggregate = {
  __typename?: 'Form15CBAvgAggregate';
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Float']>;
  BeneficiaryId?: Maybe<Scalars['Float']>;
  CaId?: Maybe<Scalars['Float']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  RequestId?: Maybe<Scalars['Float']>;
  RevokedToId?: Maybe<Scalars['Float']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Form15CbAvgOrderByAggregateInput = {
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CaId?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IncomeTaxRateOfTDS?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CbCount = {
  __typename?: 'Form15CBCount';
  Document: Scalars['Int'];
  Events: Scalars['Int'];
};

export type Form15CbCountAggregate = {
  __typename?: 'Form15CBCountAggregate';
  AccountantBuilding: Scalars['Int'];
  AccountantCity: Scalars['Int'];
  AccountantCountry: Scalars['Int'];
  AccountantFirmName: Scalars['Int'];
  AccountantFlat: Scalars['Int'];
  AccountantLocality: Scalars['Int'];
  AccountantMembershipNumber: Scalars['Int'];
  AccountantName: Scalars['Int'];
  AccountantPincode: Scalars['Int'];
  AccountantRegistrationNumber: Scalars['Int'];
  AccountantState: Scalars['Int'];
  AccountantStreet: Scalars['Int'];
  AmountAfterTDS: Scalars['Int'];
  AmountOfCapitalGains: Scalars['Int'];
  AmountOfShortCapitalGains: Scalars['Int'];
  AmountOfTDSInForeign: Scalars['Int'];
  AmountOfTDSInINR: Scalars['Int'];
  AuthDealer: Scalars['Int'];
  BSRCode: Scalars['Int'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['Int'];
  BasisOfTaxableIncome: Scalars['Int'];
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['Int'];
  Building: Scalars['Int'];
  CaId: Scalars['Int'];
  CapitalGainsRateOfTDS: Scalars['Int'];
  CertificateArticleOfDTAA: Scalars['Int'];
  CertificateDTAA: Scalars['Int'];
  ChargeableAndReliefDTAA: Scalars['Int'];
  City: Scalars['Int'];
  Country: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability: Scalars['Int'];
  DTAATaxableIncome: Scalars['Int'];
  DateOfDeduction: Scalars['Int'];
  DeterminingTaxAndLiability: Scalars['Int'];
  ExchangeRate: Scalars['Int'];
  Flat: Scalars['Int'];
  IfBasisOfTheRateOfDeduction: Scalars['Int'];
  IncomeChargeableToTax: Scalars['Int'];
  IncomeTaxRateOfTDS: Scalars['Int'];
  IsAccountOfBusinessIncome: Scalars['Int'];
  IsRelatedParty: Scalars['Int'];
  IsRemittanceCapitalGains: Scalars['Int'];
  IsRemittanceChargeableIndia: Scalars['Int'];
  IsRemittanceCovered: Scalars['Int'];
  IsTaxPayableGrossedUp: Scalars['Int'];
  IsWithPermanentEstablishment: Scalars['Int'];
  Locality: Scalars['Int'];
  NatureOfRemittance: Scalars['Int'];
  NoReasonRelevantArticleDTAA: Scalars['Int'];
  NoTaxableInIndiaDTAA: Scalars['Int'];
  OtherRemittanceCountry: Scalars['Int'];
  OtherRemittanceCurrency: Scalars['Int'];
  OtherRemittanceNameOnDocument: Scalars['Int'];
  PayableAmountINR: Scalars['Int'];
  PayableAmountInForeign: Scalars['Int'];
  PermanentEstablishmentArticle: Scalars['Int'];
  PermanentEstablishmentRateOfTDS: Scalars['Int'];
  Pincode: Scalars['Int'];
  ProposedDate: Scalars['Int'];
  RBIPurposeCode: Scalars['Int'];
  RateOfTDS: Scalars['Int'];
  RateOfTDSIncomeTaxAct: Scalars['Int'];
  ReasonRemittanceNotChargeable: Scalars['Int'];
  RemittanceCountry: Scalars['Int'];
  RemittanceCurrency: Scalars['Int'];
  RemittanceNameOnDocument: Scalars['Int'];
  RequestId: Scalars['Int'];
  RevokedToId: Scalars['Int'];
  SectionOfActRemittanceCovered: Scalars['Int'];
  State: Scalars['Int'];
  Street: Scalars['Int'];
  SubCategory: Scalars['Int'];
  SuchIncomeLiableToTaxIN: Scalars['Int'];
  TaxLiability: Scalars['Int'];
  TaxResidencyCertificateMade: Scalars['Int'];
  TaxResidencyCertificateObtained: Scalars['Int'];
  TaxableInIndiaDTAA: Scalars['Int'];
  TransactionLengthPrice: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  YesTaxableInIndiaDTAA: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  ifsc: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type Form15CbCountOrderByAggregateInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirmName?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CaId?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IncomeTaxRateOfTDS?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CbCreateInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateManyBankDetailInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateManyBankDetailInputEnvelope = {
  data: Array<Form15CbCreateManyBankDetailInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CbCreateManyBeneficiaryInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateManyBeneficiaryInputEnvelope = {
  data: Array<Form15CbCreateManyBeneficiaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CbCreateManyCaInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateManyCaInputEnvelope = {
  data: Array<Form15CbCreateManyCaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type Form15CbCreateManyInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateNestedManyWithoutBankDetailInput = {
  connect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CbCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CbCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CbCreateManyBankDetailInputEnvelope>;
};

export type Form15CbCreateNestedManyWithoutBeneficiaryInput = {
  connect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CbCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CbCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CbCreateManyBeneficiaryInputEnvelope>;
};

export type Form15CbCreateNestedManyWithoutCaInput = {
  connect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CbCreateOrConnectWithoutCaInput>>;
  create?: Maybe<Array<Form15CbCreateWithoutCaInput>>;
  createMany?: Maybe<Form15CbCreateManyCaInputEnvelope>;
};

export type Form15CbCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CbCreateWithoutDocumentInput>;
};

export type Form15CbCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CbCreateWithoutEventsInput>;
};

export type Form15CbCreateNestedOneWithoutForm15CacInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutForm15CacInput>;
  create?: Maybe<Form15CbCreateWithoutForm15CacInput>;
};

export type Form15CbCreateNestedOneWithoutRequestInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutRequestInput>;
  create?: Maybe<Form15CbCreateWithoutRequestInput>;
};

export type Form15CbCreateNestedOneWithoutRevokedFromInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutRevokedFromInput>;
  create?: Maybe<Form15CbCreateWithoutRevokedFromInput>;
};

export type Form15CbCreateNestedOneWithoutRevokedToFormInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutRevokedToFormInput>;
  create?: Maybe<Form15CbCreateWithoutRevokedToFormInput>;
};

export type Form15CbCreateOrConnectWithoutBankDetailInput = {
  create: Form15CbCreateWithoutBankDetailInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutBeneficiaryInput = {
  create: Form15CbCreateWithoutBeneficiaryInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutCaInput = {
  create: Form15CbCreateWithoutCaInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutDocumentInput = {
  create: Form15CbCreateWithoutDocumentInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutEventsInput = {
  create: Form15CbCreateWithoutEventsInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutForm15CacInput = {
  create: Form15CbCreateWithoutForm15CacInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutRequestInput = {
  create: Form15CbCreateWithoutRequestInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutRevokedFromInput = {
  create: Form15CbCreateWithoutRevokedFromInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateOrConnectWithoutRevokedToFormInput = {
  create: Form15CbCreateWithoutRevokedToFormInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbCreateWithoutBankDetailInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutBeneficiaryInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutCaInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutDocumentInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutEventsInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutForm15CacInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutRequestInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutRevokedFromInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedToForm?: Maybe<Form15CbCreateNestedOneWithoutRevokedFromInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbCreateWithoutRevokedToFormInput = {
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode: Scalars['String'];
  BankDetail: BankDetailCreateNestedOneWithoutForm15CbInput;
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  Beneficiary: BenefeciaryCreateNestedOneWithoutForm15CbInput;
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CA?: Maybe<UserCreateNestedOneWithoutForm15CbInput>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutForm15CbInput>;
  Events?: Maybe<EventsCreateNestedManyWithoutForm15CbInput>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  Form15CAC?: Maybe<Form15CacCreateNestedOneWithoutForm15CbInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  Request?: Maybe<RequestCreateNestedOneWithoutForm15CbInput>;
  RevokedFrom?: Maybe<Form15CbCreateNestedOneWithoutRevokedToFormInput>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbGroupBy = {
  __typename?: 'Form15CBGroupBy';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity: Scalars['String'];
  AccountantCountry: Scalars['String'];
  AccountantFirmName: Scalars['String'];
  AccountantFlat: Scalars['String'];
  AccountantLocality: Scalars['String'];
  AccountantMembershipNumber: Scalars['String'];
  AccountantName: Scalars['String'];
  AccountantPincode: Scalars['String'];
  AccountantRegistrationNumber: Scalars['String'];
  AccountantState: Scalars['String'];
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer: Scalars['String'];
  BSRCode: Scalars['String'];
  BankDetailId: Scalars['Int'];
  BankName: Scalars['String'];
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId: Scalars['Int'];
  BranchName: Scalars['String'];
  Building?: Maybe<Scalars['String']>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA: Scalars['Boolean'];
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  ExchangeRate: Scalars['String'];
  Flat: Scalars['String'];
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia: Scalars['Boolean'];
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp: Scalars['Boolean'];
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality: Scalars['String'];
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR: Scalars['Float'];
  PayableAmountInForeign: Scalars['Float'];
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode: Scalars['String'];
  ProposedDate: Scalars['DateTime'];
  RBIPurposeCode: Scalars['String'];
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry: Scalars['String'];
  RemittanceCurrency: Scalars['String'];
  RemittanceNameOnDocument: Scalars['String'];
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  SubCategory: Scalars['String'];
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained: Scalars['Boolean'];
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  _avg?: Maybe<Form15CbAvgAggregate>;
  _count?: Maybe<Form15CbCountAggregate>;
  _max?: Maybe<Form15CbMaxAggregate>;
  _min?: Maybe<Form15CbMinAggregate>;
  _sum?: Maybe<Form15CbSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  ifsc: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Form15CbListRelationFilter = {
  every?: Maybe<Form15CbWhereInput>;
  none?: Maybe<Form15CbWhereInput>;
  some?: Maybe<Form15CbWhereInput>;
};

export type Form15CbMaxAggregate = {
  __typename?: 'Form15CBMaxAggregate';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity?: Maybe<Scalars['String']>;
  AccountantCountry?: Maybe<Scalars['String']>;
  AccountantFirmName?: Maybe<Scalars['String']>;
  AccountantFlat?: Maybe<Scalars['String']>;
  AccountantLocality?: Maybe<Scalars['String']>;
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName?: Maybe<Scalars['String']>;
  AccountantPincode?: Maybe<Scalars['String']>;
  AccountantRegistrationNumber?: Maybe<Scalars['String']>;
  AccountantState?: Maybe<Scalars['String']>;
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA?: Maybe<Scalars['Boolean']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia?: Maybe<Scalars['Boolean']>;
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  RBIPurposeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbMaxOrderByAggregateInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirmName?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CaId?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IncomeTaxRateOfTDS?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CbMinAggregate = {
  __typename?: 'Form15CBMinAggregate';
  AccountantBuilding?: Maybe<Scalars['String']>;
  AccountantCity?: Maybe<Scalars['String']>;
  AccountantCountry?: Maybe<Scalars['String']>;
  AccountantFirmName?: Maybe<Scalars['String']>;
  AccountantFlat?: Maybe<Scalars['String']>;
  AccountantLocality?: Maybe<Scalars['String']>;
  AccountantMembershipNumber?: Maybe<Scalars['String']>;
  AccountantName?: Maybe<Scalars['String']>;
  AccountantPincode?: Maybe<Scalars['String']>;
  AccountantRegistrationNumber?: Maybe<Scalars['String']>;
  AccountantState?: Maybe<Scalars['String']>;
  AccountantStreet?: Maybe<Scalars['String']>;
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  AuthDealer?: Maybe<Scalars['String']>;
  BSRCode?: Maybe<Scalars['String']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BankName?: Maybe<Scalars['String']>;
  BasisOfTaxableIncome?: Maybe<Scalars['String']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchName?: Maybe<Scalars['String']>;
  Building?: Maybe<Scalars['String']>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CertificateArticleOfDTAA?: Maybe<Scalars['String']>;
  CertificateDTAA?: Maybe<Scalars['String']>;
  ChargeableAndReliefDTAA?: Maybe<Scalars['Boolean']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  DateOfDeduction?: Maybe<Scalars['DateTime']>;
  DeterminingTaxAndLiability?: Maybe<Scalars['String']>;
  ExchangeRate?: Maybe<Scalars['String']>;
  Flat?: Maybe<Scalars['String']>;
  IfBasisOfTheRateOfDeduction?: Maybe<Scalars['String']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  IsAccountOfBusinessIncome?: Maybe<Scalars['Boolean']>;
  IsRelatedParty?: Maybe<Scalars['Boolean']>;
  IsRemittanceCapitalGains?: Maybe<Scalars['Boolean']>;
  IsRemittanceChargeableIndia?: Maybe<Scalars['Boolean']>;
  IsRemittanceCovered?: Maybe<Scalars['Boolean']>;
  IsTaxPayableGrossedUp?: Maybe<Scalars['Boolean']>;
  IsWithPermanentEstablishment?: Maybe<Scalars['Boolean']>;
  Locality?: Maybe<Scalars['String']>;
  NatureOfRemittance?: Maybe<Scalars['String']>;
  NoReasonRelevantArticleDTAA?: Maybe<Scalars['String']>;
  NoTaxableInIndiaDTAA?: Maybe<Scalars['String']>;
  OtherRemittanceCountry?: Maybe<Scalars['String']>;
  OtherRemittanceCurrency?: Maybe<Scalars['String']>;
  OtherRemittanceNameOnDocument?: Maybe<Scalars['String']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentArticle?: Maybe<Scalars['String']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  Pincode?: Maybe<Scalars['String']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  RBIPurposeCode?: Maybe<Scalars['String']>;
  RateOfTDS?: Maybe<Scalars['String']>;
  RateOfTDSIncomeTaxAct?: Maybe<Scalars['String']>;
  ReasonRemittanceNotChargeable?: Maybe<Scalars['String']>;
  RemittanceCountry?: Maybe<Scalars['String']>;
  RemittanceCurrency?: Maybe<Scalars['String']>;
  RemittanceNameOnDocument?: Maybe<Scalars['String']>;
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  SectionOfActRemittanceCovered?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubCategory?: Maybe<Scalars['String']>;
  SuchIncomeLiableToTaxIN?: Maybe<Scalars['Boolean']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  TaxResidencyCertificateMade?: Maybe<Scalars['Boolean']>;
  TaxResidencyCertificateObtained?: Maybe<Scalars['Boolean']>;
  TaxableInIndiaDTAA?: Maybe<Scalars['Boolean']>;
  TransactionLengthPrice?: Maybe<Scalars['Boolean']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Form15CbMinOrderByAggregateInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirmName?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CaId?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IncomeTaxRateOfTDS?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CbOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type Form15CbOrderByWithAggregationInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirmName?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CaId?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IncomeTaxRateOfTDS?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  _avg?: Maybe<Form15CbAvgOrderByAggregateInput>;
  _count?: Maybe<Form15CbCountOrderByAggregateInput>;
  _max?: Maybe<Form15CbMaxOrderByAggregateInput>;
  _min?: Maybe<Form15CbMinOrderByAggregateInput>;
  _sum?: Maybe<Form15CbSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CbOrderByWithRelationInput = {
  AccountantBuilding?: Maybe<SortOrder>;
  AccountantCity?: Maybe<SortOrder>;
  AccountantCountry?: Maybe<SortOrder>;
  AccountantFirmName?: Maybe<SortOrder>;
  AccountantFlat?: Maybe<SortOrder>;
  AccountantLocality?: Maybe<SortOrder>;
  AccountantMembershipNumber?: Maybe<SortOrder>;
  AccountantName?: Maybe<SortOrder>;
  AccountantPincode?: Maybe<SortOrder>;
  AccountantRegistrationNumber?: Maybe<SortOrder>;
  AccountantState?: Maybe<SortOrder>;
  AccountantStreet?: Maybe<SortOrder>;
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  AuthDealer?: Maybe<SortOrder>;
  BSRCode?: Maybe<SortOrder>;
  BankDetail?: Maybe<BankDetailOrderByWithRelationInput>;
  BankDetailId?: Maybe<SortOrder>;
  BankName?: Maybe<SortOrder>;
  BasisOfTaxableIncome?: Maybe<SortOrder>;
  Beneficiary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BeneficiaryId?: Maybe<SortOrder>;
  BranchName?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  CA?: Maybe<UserOrderByWithRelationInput>;
  CaId?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CertificateArticleOfDTAA?: Maybe<SortOrder>;
  CertificateDTAA?: Maybe<SortOrder>;
  ChargeableAndReliefDTAA?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  DateOfDeduction?: Maybe<SortOrder>;
  DeterminingTaxAndLiability?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  Events?: Maybe<EventsOrderByRelationAggregateInput>;
  ExchangeRate?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  Form15CAC?: Maybe<Form15CacOrderByWithRelationInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IncomeTaxRateOfTDS?: Maybe<SortOrder>;
  IsAccountOfBusinessIncome?: Maybe<SortOrder>;
  IsRelatedParty?: Maybe<SortOrder>;
  IsRemittanceCapitalGains?: Maybe<SortOrder>;
  IsRemittanceChargeableIndia?: Maybe<SortOrder>;
  IsRemittanceCovered?: Maybe<SortOrder>;
  IsTaxPayableGrossedUp?: Maybe<SortOrder>;
  IsWithPermanentEstablishment?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  NatureOfRemittance?: Maybe<SortOrder>;
  NoReasonRelevantArticleDTAA?: Maybe<SortOrder>;
  NoTaxableInIndiaDTAA?: Maybe<SortOrder>;
  OtherRemittanceCountry?: Maybe<SortOrder>;
  OtherRemittanceCurrency?: Maybe<SortOrder>;
  OtherRemittanceNameOnDocument?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentArticle?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  RBIPurposeCode?: Maybe<SortOrder>;
  RateOfTDS?: Maybe<SortOrder>;
  RateOfTDSIncomeTaxAct?: Maybe<SortOrder>;
  ReasonRemittanceNotChargeable?: Maybe<SortOrder>;
  RemittanceCountry?: Maybe<SortOrder>;
  RemittanceCurrency?: Maybe<SortOrder>;
  RemittanceNameOnDocument?: Maybe<SortOrder>;
  Request?: Maybe<RequestOrderByWithRelationInput>;
  RequestId?: Maybe<SortOrder>;
  RevokedFrom?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToForm?: Maybe<Form15CbOrderByWithRelationInput>;
  RevokedToId?: Maybe<SortOrder>;
  SectionOfActRemittanceCovered?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  SubCategory?: Maybe<SortOrder>;
  SuchIncomeLiableToTaxIN?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  TaxResidencyCertificateMade?: Maybe<SortOrder>;
  TaxResidencyCertificateObtained?: Maybe<SortOrder>;
  TaxableInIndiaDTAA?: Maybe<SortOrder>;
  TransactionLengthPrice?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  ifsc?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type Form15CbRelationFilter = {
  is?: Maybe<Form15CbWhereInput>;
  isNot?: Maybe<Form15CbWhereInput>;
};

export enum Form15CbScalarFieldEnum {
  AccountantBuilding = 'AccountantBuilding',
  AccountantCity = 'AccountantCity',
  AccountantCountry = 'AccountantCountry',
  AccountantFirmName = 'AccountantFirmName',
  AccountantFlat = 'AccountantFlat',
  AccountantLocality = 'AccountantLocality',
  AccountantMembershipNumber = 'AccountantMembershipNumber',
  AccountantName = 'AccountantName',
  AccountantPincode = 'AccountantPincode',
  AccountantRegistrationNumber = 'AccountantRegistrationNumber',
  AccountantState = 'AccountantState',
  AccountantStreet = 'AccountantStreet',
  AmountAfterTds = 'AmountAfterTDS',
  AmountOfCapitalGains = 'AmountOfCapitalGains',
  AmountOfShortCapitalGains = 'AmountOfShortCapitalGains',
  AmountOfTdsInForeign = 'AmountOfTDSInForeign',
  AmountOfTdsInInr = 'AmountOfTDSInINR',
  AuthDealer = 'AuthDealer',
  BsrCode = 'BSRCode',
  BankDetailId = 'BankDetailId',
  BankName = 'BankName',
  BasisOfTaxableIncome = 'BasisOfTaxableIncome',
  BeneficiaryId = 'BeneficiaryId',
  BranchName = 'BranchName',
  Building = 'Building',
  CaId = 'CaId',
  CapitalGainsRateOfTds = 'CapitalGainsRateOfTDS',
  CertificateArticleOfDtaa = 'CertificateArticleOfDTAA',
  CertificateDtaa = 'CertificateDTAA',
  ChargeableAndReliefDtaa = 'ChargeableAndReliefDTAA',
  City = 'City',
  Country = 'Country',
  CreatedBy = 'CreatedBy',
  DtaaTaxLiability = 'DTAATaxLiability',
  DtaaTaxableIncome = 'DTAATaxableIncome',
  DateOfDeduction = 'DateOfDeduction',
  DeterminingTaxAndLiability = 'DeterminingTaxAndLiability',
  ExchangeRate = 'ExchangeRate',
  Flat = 'Flat',
  IfBasisOfTheRateOfDeduction = 'IfBasisOfTheRateOfDeduction',
  IncomeChargeableToTax = 'IncomeChargeableToTax',
  IncomeTaxRateOfTds = 'IncomeTaxRateOfTDS',
  IsAccountOfBusinessIncome = 'IsAccountOfBusinessIncome',
  IsRelatedParty = 'IsRelatedParty',
  IsRemittanceCapitalGains = 'IsRemittanceCapitalGains',
  IsRemittanceChargeableIndia = 'IsRemittanceChargeableIndia',
  IsRemittanceCovered = 'IsRemittanceCovered',
  IsTaxPayableGrossedUp = 'IsTaxPayableGrossedUp',
  IsWithPermanentEstablishment = 'IsWithPermanentEstablishment',
  Locality = 'Locality',
  NatureOfRemittance = 'NatureOfRemittance',
  NoReasonRelevantArticleDtaa = 'NoReasonRelevantArticleDTAA',
  NoTaxableInIndiaDtaa = 'NoTaxableInIndiaDTAA',
  OtherRemittanceCountry = 'OtherRemittanceCountry',
  OtherRemittanceCurrency = 'OtherRemittanceCurrency',
  OtherRemittanceNameOnDocument = 'OtherRemittanceNameOnDocument',
  PayableAmountInr = 'PayableAmountINR',
  PayableAmountInForeign = 'PayableAmountInForeign',
  PermanentEstablishmentArticle = 'PermanentEstablishmentArticle',
  PermanentEstablishmentRateOfTds = 'PermanentEstablishmentRateOfTDS',
  Pincode = 'Pincode',
  ProposedDate = 'ProposedDate',
  RbiPurposeCode = 'RBIPurposeCode',
  RateOfTds = 'RateOfTDS',
  RateOfTdsIncomeTaxAct = 'RateOfTDSIncomeTaxAct',
  ReasonRemittanceNotChargeable = 'ReasonRemittanceNotChargeable',
  RemittanceCountry = 'RemittanceCountry',
  RemittanceCurrency = 'RemittanceCurrency',
  RemittanceNameOnDocument = 'RemittanceNameOnDocument',
  RequestId = 'RequestId',
  RevokedToId = 'RevokedToId',
  SectionOfActRemittanceCovered = 'SectionOfActRemittanceCovered',
  State = 'State',
  Street = 'Street',
  SubCategory = 'SubCategory',
  SuchIncomeLiableToTaxIn = 'SuchIncomeLiableToTaxIN',
  TaxLiability = 'TaxLiability',
  TaxResidencyCertificateMade = 'TaxResidencyCertificateMade',
  TaxResidencyCertificateObtained = 'TaxResidencyCertificateObtained',
  TaxableInIndiaDtaa = 'TaxableInIndiaDTAA',
  TransactionLengthPrice = 'TransactionLengthPrice',
  UpdatedBy = 'UpdatedBy',
  YesTaxableInIndiaDtaa = 'YesTaxableInIndiaDTAA',
  CreatedAt = 'createdAt',
  Id = 'id',
  Ifsc = 'ifsc',
  UpdatedAt = 'updatedAt'
}

export type Form15CbScalarWhereInput = {
  AND?: Maybe<Array<Form15CbScalarWhereInput>>;
  AccountantBuilding?: Maybe<StringNullableFilter>;
  AccountantCity?: Maybe<StringFilter>;
  AccountantCountry?: Maybe<StringFilter>;
  AccountantFirmName?: Maybe<StringFilter>;
  AccountantFlat?: Maybe<StringFilter>;
  AccountantLocality?: Maybe<StringFilter>;
  AccountantMembershipNumber?: Maybe<StringFilter>;
  AccountantName?: Maybe<StringFilter>;
  AccountantPincode?: Maybe<StringFilter>;
  AccountantRegistrationNumber?: Maybe<StringFilter>;
  AccountantState?: Maybe<StringFilter>;
  AccountantStreet?: Maybe<StringNullableFilter>;
  AmountAfterTDS?: Maybe<FloatNullableFilter>;
  AmountOfCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfShortCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfTDSInForeign?: Maybe<FloatNullableFilter>;
  AmountOfTDSInINR?: Maybe<FloatNullableFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  BasisOfTaxableIncome?: Maybe<StringNullableFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  CaId?: Maybe<IntNullableFilter>;
  CapitalGainsRateOfTDS?: Maybe<FloatNullableFilter>;
  CertificateArticleOfDTAA?: Maybe<StringNullableFilter>;
  CertificateDTAA?: Maybe<StringNullableFilter>;
  ChargeableAndReliefDTAA?: Maybe<BoolFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DTAATaxLiability?: Maybe<FloatNullableFilter>;
  DTAATaxableIncome?: Maybe<FloatNullableFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  DeterminingTaxAndLiability?: Maybe<StringNullableFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  IfBasisOfTheRateOfDeduction?: Maybe<StringNullableFilter>;
  IncomeChargeableToTax?: Maybe<FloatNullableFilter>;
  IncomeTaxRateOfTDS?: Maybe<FloatNullableFilter>;
  IsAccountOfBusinessIncome?: Maybe<BoolNullableFilter>;
  IsRelatedParty?: Maybe<BoolNullableFilter>;
  IsRemittanceCapitalGains?: Maybe<BoolNullableFilter>;
  IsRemittanceChargeableIndia?: Maybe<BoolFilter>;
  IsRemittanceCovered?: Maybe<BoolNullableFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  IsWithPermanentEstablishment?: Maybe<BoolNullableFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CbScalarWhereInput>>;
  NatureOfRemittance?: Maybe<StringNullableFilter>;
  NoReasonRelevantArticleDTAA?: Maybe<StringNullableFilter>;
  NoTaxableInIndiaDTAA?: Maybe<StringNullableFilter>;
  OR?: Maybe<Array<Form15CbScalarWhereInput>>;
  OtherRemittanceCountry?: Maybe<StringNullableFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  OtherRemittanceNameOnDocument?: Maybe<StringNullableFilter>;
  PayableAmountINR?: Maybe<FloatFilter>;
  PayableAmountInForeign?: Maybe<FloatFilter>;
  PermanentEstablishmentArticle?: Maybe<StringNullableFilter>;
  PermanentEstablishmentRateOfTDS?: Maybe<FloatNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  RBIPurposeCode?: Maybe<StringFilter>;
  RateOfTDS?: Maybe<StringNullableFilter>;
  RateOfTDSIncomeTaxAct?: Maybe<StringNullableFilter>;
  ReasonRemittanceNotChargeable?: Maybe<StringNullableFilter>;
  RemittanceCountry?: Maybe<StringFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  RequestId?: Maybe<IntNullableFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  SectionOfActRemittanceCovered?: Maybe<StringNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  SuchIncomeLiableToTaxIN?: Maybe<BoolNullableFilter>;
  TaxLiability?: Maybe<FloatNullableFilter>;
  TaxResidencyCertificateMade?: Maybe<BoolNullableFilter>;
  TaxResidencyCertificateObtained?: Maybe<BoolFilter>;
  TaxableInIndiaDTAA?: Maybe<BoolNullableFilter>;
  TransactionLengthPrice?: Maybe<BoolNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  YesTaxableInIndiaDTAA?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CbScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<Form15CbScalarWhereWithAggregatesInput>>;
  AccountantBuilding?: Maybe<StringNullableWithAggregatesFilter>;
  AccountantCity?: Maybe<StringWithAggregatesFilter>;
  AccountantCountry?: Maybe<StringWithAggregatesFilter>;
  AccountantFirmName?: Maybe<StringWithAggregatesFilter>;
  AccountantFlat?: Maybe<StringWithAggregatesFilter>;
  AccountantLocality?: Maybe<StringWithAggregatesFilter>;
  AccountantMembershipNumber?: Maybe<StringWithAggregatesFilter>;
  AccountantName?: Maybe<StringWithAggregatesFilter>;
  AccountantPincode?: Maybe<StringWithAggregatesFilter>;
  AccountantRegistrationNumber?: Maybe<StringWithAggregatesFilter>;
  AccountantState?: Maybe<StringWithAggregatesFilter>;
  AccountantStreet?: Maybe<StringNullableWithAggregatesFilter>;
  AmountAfterTDS?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfCapitalGains?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfShortCapitalGains?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfTDSInForeign?: Maybe<FloatNullableWithAggregatesFilter>;
  AmountOfTDSInINR?: Maybe<FloatNullableWithAggregatesFilter>;
  AuthDealer?: Maybe<StringWithAggregatesFilter>;
  BSRCode?: Maybe<StringWithAggregatesFilter>;
  BankDetailId?: Maybe<IntWithAggregatesFilter>;
  BankName?: Maybe<StringWithAggregatesFilter>;
  BasisOfTaxableIncome?: Maybe<StringNullableWithAggregatesFilter>;
  BeneficiaryId?: Maybe<IntWithAggregatesFilter>;
  BranchName?: Maybe<StringWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  CaId?: Maybe<IntNullableWithAggregatesFilter>;
  CapitalGainsRateOfTDS?: Maybe<FloatNullableWithAggregatesFilter>;
  CertificateArticleOfDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  CertificateDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  ChargeableAndReliefDTAA?: Maybe<BoolWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  DTAATaxLiability?: Maybe<FloatNullableWithAggregatesFilter>;
  DTAATaxableIncome?: Maybe<FloatNullableWithAggregatesFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableWithAggregatesFilter>;
  DeterminingTaxAndLiability?: Maybe<StringNullableWithAggregatesFilter>;
  ExchangeRate?: Maybe<StringWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  IfBasisOfTheRateOfDeduction?: Maybe<StringNullableWithAggregatesFilter>;
  IncomeChargeableToTax?: Maybe<FloatNullableWithAggregatesFilter>;
  IncomeTaxRateOfTDS?: Maybe<FloatNullableWithAggregatesFilter>;
  IsAccountOfBusinessIncome?: Maybe<BoolNullableWithAggregatesFilter>;
  IsRelatedParty?: Maybe<BoolNullableWithAggregatesFilter>;
  IsRemittanceCapitalGains?: Maybe<BoolNullableWithAggregatesFilter>;
  IsRemittanceChargeableIndia?: Maybe<BoolWithAggregatesFilter>;
  IsRemittanceCovered?: Maybe<BoolNullableWithAggregatesFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolWithAggregatesFilter>;
  IsWithPermanentEstablishment?: Maybe<BoolNullableWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<Form15CbScalarWhereWithAggregatesInput>>;
  NatureOfRemittance?: Maybe<StringNullableWithAggregatesFilter>;
  NoReasonRelevantArticleDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  NoTaxableInIndiaDTAA?: Maybe<StringNullableWithAggregatesFilter>;
  OR?: Maybe<Array<Form15CbScalarWhereWithAggregatesInput>>;
  OtherRemittanceCountry?: Maybe<StringNullableWithAggregatesFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableWithAggregatesFilter>;
  OtherRemittanceNameOnDocument?: Maybe<StringNullableWithAggregatesFilter>;
  PayableAmountINR?: Maybe<FloatWithAggregatesFilter>;
  PayableAmountInForeign?: Maybe<FloatWithAggregatesFilter>;
  PermanentEstablishmentArticle?: Maybe<StringNullableWithAggregatesFilter>;
  PermanentEstablishmentRateOfTDS?: Maybe<FloatNullableWithAggregatesFilter>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  ProposedDate?: Maybe<DateTimeWithAggregatesFilter>;
  RBIPurposeCode?: Maybe<StringWithAggregatesFilter>;
  RateOfTDS?: Maybe<StringNullableWithAggregatesFilter>;
  RateOfTDSIncomeTaxAct?: Maybe<StringNullableWithAggregatesFilter>;
  ReasonRemittanceNotChargeable?: Maybe<StringNullableWithAggregatesFilter>;
  RemittanceCountry?: Maybe<StringWithAggregatesFilter>;
  RemittanceCurrency?: Maybe<StringWithAggregatesFilter>;
  RemittanceNameOnDocument?: Maybe<StringWithAggregatesFilter>;
  RequestId?: Maybe<IntNullableWithAggregatesFilter>;
  RevokedToId?: Maybe<IntNullableWithAggregatesFilter>;
  SectionOfActRemittanceCovered?: Maybe<StringNullableWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  SubCategory?: Maybe<StringWithAggregatesFilter>;
  SuchIncomeLiableToTaxIN?: Maybe<BoolNullableWithAggregatesFilter>;
  TaxLiability?: Maybe<FloatNullableWithAggregatesFilter>;
  TaxResidencyCertificateMade?: Maybe<BoolNullableWithAggregatesFilter>;
  TaxResidencyCertificateObtained?: Maybe<BoolWithAggregatesFilter>;
  TaxableInIndiaDTAA?: Maybe<BoolNullableWithAggregatesFilter>;
  TransactionLengthPrice?: Maybe<BoolNullableWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  YesTaxableInIndiaDTAA?: Maybe<FloatNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  ifsc?: Maybe<StringWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type Form15CbSumAggregate = {
  __typename?: 'Form15CBSumAggregate';
  AmountAfterTDS?: Maybe<Scalars['Float']>;
  AmountOfCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfShortCapitalGains?: Maybe<Scalars['Float']>;
  AmountOfTDSInForeign?: Maybe<Scalars['Float']>;
  AmountOfTDSInINR?: Maybe<Scalars['Float']>;
  BankDetailId?: Maybe<Scalars['Int']>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  CaId?: Maybe<Scalars['Int']>;
  CapitalGainsRateOfTDS?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  DTAATaxLiability?: Maybe<Scalars['Float']>;
  DTAATaxableIncome?: Maybe<Scalars['Float']>;
  IncomeChargeableToTax?: Maybe<Scalars['Float']>;
  IncomeTaxRateOfTDS?: Maybe<Scalars['Float']>;
  PayableAmountINR?: Maybe<Scalars['Float']>;
  PayableAmountInForeign?: Maybe<Scalars['Float']>;
  PermanentEstablishmentRateOfTDS?: Maybe<Scalars['Float']>;
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  TaxLiability?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  YesTaxableInIndiaDTAA?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
};

export type Form15CbSumOrderByAggregateInput = {
  AmountAfterTDS?: Maybe<SortOrder>;
  AmountOfCapitalGains?: Maybe<SortOrder>;
  AmountOfShortCapitalGains?: Maybe<SortOrder>;
  AmountOfTDSInForeign?: Maybe<SortOrder>;
  AmountOfTDSInINR?: Maybe<SortOrder>;
  BankDetailId?: Maybe<SortOrder>;
  BeneficiaryId?: Maybe<SortOrder>;
  CaId?: Maybe<SortOrder>;
  CapitalGainsRateOfTDS?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  DTAATaxLiability?: Maybe<SortOrder>;
  DTAATaxableIncome?: Maybe<SortOrder>;
  IncomeChargeableToTax?: Maybe<SortOrder>;
  IncomeTaxRateOfTDS?: Maybe<SortOrder>;
  PayableAmountINR?: Maybe<SortOrder>;
  PayableAmountInForeign?: Maybe<SortOrder>;
  PermanentEstablishmentRateOfTDS?: Maybe<SortOrder>;
  RequestId?: Maybe<SortOrder>;
  RevokedToId?: Maybe<SortOrder>;
  TaxLiability?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  YesTaxableInIndiaDTAA?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type Form15CbUpdateInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateManyMutationInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateManyWithWhereWithoutBankDetailInput = {
  data: Form15CbUpdateManyMutationInput;
  where: Form15CbScalarWhereInput;
};

export type Form15CbUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: Form15CbUpdateManyMutationInput;
  where: Form15CbScalarWhereInput;
};

export type Form15CbUpdateManyWithWhereWithoutCaInput = {
  data: Form15CbUpdateManyMutationInput;
  where: Form15CbScalarWhereInput;
};

export type Form15CbUpdateManyWithoutBankDetailNestedInput = {
  connect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CbCreateOrConnectWithoutBankDetailInput>>;
  create?: Maybe<Array<Form15CbCreateWithoutBankDetailInput>>;
  createMany?: Maybe<Form15CbCreateManyBankDetailInputEnvelope>;
  delete?: Maybe<Array<Form15CbWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CbScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  set?: Maybe<Array<Form15CbWhereUniqueInput>>;
  update?: Maybe<Array<Form15CbUpdateWithWhereUniqueWithoutBankDetailInput>>;
  updateMany?: Maybe<Array<Form15CbUpdateManyWithWhereWithoutBankDetailInput>>;
  upsert?: Maybe<Array<Form15CbUpsertWithWhereUniqueWithoutBankDetailInput>>;
};

export type Form15CbUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CbCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<Form15CbCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<Form15CbCreateManyBeneficiaryInputEnvelope>;
  delete?: Maybe<Array<Form15CbWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CbScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  set?: Maybe<Array<Form15CbWhereUniqueInput>>;
  update?: Maybe<Array<Form15CbUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: Maybe<Array<Form15CbUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: Maybe<Array<Form15CbUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type Form15CbUpdateManyWithoutCaNestedInput = {
  connect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<Form15CbCreateOrConnectWithoutCaInput>>;
  create?: Maybe<Array<Form15CbCreateWithoutCaInput>>;
  createMany?: Maybe<Form15CbCreateManyCaInputEnvelope>;
  delete?: Maybe<Array<Form15CbWhereUniqueInput>>;
  deleteMany?: Maybe<Array<Form15CbScalarWhereInput>>;
  disconnect?: Maybe<Array<Form15CbWhereUniqueInput>>;
  set?: Maybe<Array<Form15CbWhereUniqueInput>>;
  update?: Maybe<Array<Form15CbUpdateWithWhereUniqueWithoutCaInput>>;
  updateMany?: Maybe<Array<Form15CbUpdateManyWithWhereWithoutCaInput>>;
  upsert?: Maybe<Array<Form15CbUpsertWithWhereUniqueWithoutCaInput>>;
};

export type Form15CbUpdateOneRequiredWithoutForm15CacNestedInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutForm15CacInput>;
  create?: Maybe<Form15CbCreateWithoutForm15CacInput>;
  update?: Maybe<Form15CbUpdateWithoutForm15CacInput>;
  upsert?: Maybe<Form15CbUpsertWithoutForm15CacInput>;
};

export type Form15CbUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<Form15CbCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CbUpdateWithoutDocumentInput>;
  upsert?: Maybe<Form15CbUpsertWithoutDocumentInput>;
};

export type Form15CbUpdateOneWithoutEventsNestedInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutEventsInput>;
  create?: Maybe<Form15CbCreateWithoutEventsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CbUpdateWithoutEventsInput>;
  upsert?: Maybe<Form15CbUpsertWithoutEventsInput>;
};

export type Form15CbUpdateOneWithoutRequestNestedInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutRequestInput>;
  create?: Maybe<Form15CbCreateWithoutRequestInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CbUpdateWithoutRequestInput>;
  upsert?: Maybe<Form15CbUpsertWithoutRequestInput>;
};

export type Form15CbUpdateOneWithoutRevokedFromNestedInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutRevokedFromInput>;
  create?: Maybe<Form15CbCreateWithoutRevokedFromInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CbUpdateWithoutRevokedFromInput>;
  upsert?: Maybe<Form15CbUpsertWithoutRevokedFromInput>;
};

export type Form15CbUpdateOneWithoutRevokedToFormNestedInput = {
  connect?: Maybe<Form15CbWhereUniqueInput>;
  connectOrCreate?: Maybe<Form15CbCreateOrConnectWithoutRevokedToFormInput>;
  create?: Maybe<Form15CbCreateWithoutRevokedToFormInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<Form15CbUpdateWithoutRevokedToFormInput>;
  upsert?: Maybe<Form15CbUpsertWithoutRevokedToFormInput>;
};

export type Form15CbUpdateWithWhereUniqueWithoutBankDetailInput = {
  data: Form15CbUpdateWithoutBankDetailInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: Form15CbUpdateWithoutBeneficiaryInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbUpdateWithWhereUniqueWithoutCaInput = {
  data: Form15CbUpdateWithoutCaInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbUpdateWithoutBankDetailInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutBeneficiaryInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutCaInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutDocumentInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutEventsInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutForm15CacInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutRequestInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutRevokedFromInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedToForm?: Maybe<Form15CbUpdateOneWithoutRevokedFromNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpdateWithoutRevokedToFormInput = {
  AccountantBuilding?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AccountantCity?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantCountry?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFirmName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantFlat?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantLocality?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantMembershipNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantName?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantPincode?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantRegistrationNumber?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantState?: Maybe<StringFieldUpdateOperationsInput>;
  AccountantStreet?: Maybe<NullableStringFieldUpdateOperationsInput>;
  AmountAfterTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfShortCapitalGains?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInForeign?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AmountOfTDSInINR?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  AuthDealer?: Maybe<StringFieldUpdateOperationsInput>;
  BSRCode?: Maybe<StringFieldUpdateOperationsInput>;
  BankDetail?: Maybe<BankDetailUpdateOneRequiredWithoutForm15CbNestedInput>;
  BankName?: Maybe<StringFieldUpdateOperationsInput>;
  BasisOfTaxableIncome?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Beneficiary?: Maybe<BenefeciaryUpdateOneRequiredWithoutForm15CbNestedInput>;
  BranchName?: Maybe<StringFieldUpdateOperationsInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CA?: Maybe<UserUpdateOneWithoutForm15CbNestedInput>;
  CapitalGainsRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  CertificateArticleOfDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  CertificateDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ChargeableAndReliefDTAA?: Maybe<BoolFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  DTAATaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DTAATaxableIncome?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  DateOfDeduction?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  DeterminingTaxAndLiability?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutForm15CbNestedInput>;
  Events?: Maybe<EventsUpdateManyWithoutForm15CbNestedInput>;
  ExchangeRate?: Maybe<StringFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CAC?: Maybe<Form15CacUpdateOneWithoutForm15CbNestedInput>;
  IfBasisOfTheRateOfDeduction?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IncomeChargeableToTax?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IncomeTaxRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  IsAccountOfBusinessIncome?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRelatedParty?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceCapitalGains?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsRemittanceChargeableIndia?: Maybe<BoolFieldUpdateOperationsInput>;
  IsRemittanceCovered?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  IsTaxPayableGrossedUp?: Maybe<BoolFieldUpdateOperationsInput>;
  IsWithPermanentEstablishment?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  NatureOfRemittance?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoReasonRelevantArticleDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  NoTaxableInIndiaDTAA?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCountry?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceCurrency?: Maybe<NullableStringFieldUpdateOperationsInput>;
  OtherRemittanceNameOnDocument?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PayableAmountINR?: Maybe<FloatFieldUpdateOperationsInput>;
  PayableAmountInForeign?: Maybe<FloatFieldUpdateOperationsInput>;
  PermanentEstablishmentArticle?: Maybe<NullableStringFieldUpdateOperationsInput>;
  PermanentEstablishmentRateOfTDS?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<DateTimeFieldUpdateOperationsInput>;
  RBIPurposeCode?: Maybe<StringFieldUpdateOperationsInput>;
  RateOfTDS?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RateOfTDSIncomeTaxAct?: Maybe<NullableStringFieldUpdateOperationsInput>;
  ReasonRemittanceNotChargeable?: Maybe<NullableStringFieldUpdateOperationsInput>;
  RemittanceCountry?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceCurrency?: Maybe<StringFieldUpdateOperationsInput>;
  RemittanceNameOnDocument?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateOneWithoutForm15CbNestedInput>;
  RevokedFrom?: Maybe<Form15CbUpdateOneWithoutRevokedToFormNestedInput>;
  SectionOfActRemittanceCovered?: Maybe<NullableStringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  SubCategory?: Maybe<StringFieldUpdateOperationsInput>;
  SuchIncomeLiableToTaxIN?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxLiability?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  TaxResidencyCertificateMade?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TaxResidencyCertificateObtained?: Maybe<BoolFieldUpdateOperationsInput>;
  TaxableInIndiaDTAA?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  TransactionLengthPrice?: Maybe<NullableBoolFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  YesTaxableInIndiaDTAA?: Maybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  ifsc?: Maybe<StringFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type Form15CbUpsertWithWhereUniqueWithoutBankDetailInput = {
  create: Form15CbCreateWithoutBankDetailInput;
  update: Form15CbUpdateWithoutBankDetailInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: Form15CbCreateWithoutBeneficiaryInput;
  update: Form15CbUpdateWithoutBeneficiaryInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbUpsertWithWhereUniqueWithoutCaInput = {
  create: Form15CbCreateWithoutCaInput;
  update: Form15CbUpdateWithoutCaInput;
  where: Form15CbWhereUniqueInput;
};

export type Form15CbUpsertWithoutDocumentInput = {
  create: Form15CbCreateWithoutDocumentInput;
  update: Form15CbUpdateWithoutDocumentInput;
};

export type Form15CbUpsertWithoutEventsInput = {
  create: Form15CbCreateWithoutEventsInput;
  update: Form15CbUpdateWithoutEventsInput;
};

export type Form15CbUpsertWithoutForm15CacInput = {
  create: Form15CbCreateWithoutForm15CacInput;
  update: Form15CbUpdateWithoutForm15CacInput;
};

export type Form15CbUpsertWithoutRequestInput = {
  create: Form15CbCreateWithoutRequestInput;
  update: Form15CbUpdateWithoutRequestInput;
};

export type Form15CbUpsertWithoutRevokedFromInput = {
  create: Form15CbCreateWithoutRevokedFromInput;
  update: Form15CbUpdateWithoutRevokedFromInput;
};

export type Form15CbUpsertWithoutRevokedToFormInput = {
  create: Form15CbCreateWithoutRevokedToFormInput;
  update: Form15CbUpdateWithoutRevokedToFormInput;
};

export type Form15CbWhereInput = {
  AND?: Maybe<Array<Form15CbWhereInput>>;
  AccountantBuilding?: Maybe<StringNullableFilter>;
  AccountantCity?: Maybe<StringFilter>;
  AccountantCountry?: Maybe<StringFilter>;
  AccountantFirmName?: Maybe<StringFilter>;
  AccountantFlat?: Maybe<StringFilter>;
  AccountantLocality?: Maybe<StringFilter>;
  AccountantMembershipNumber?: Maybe<StringFilter>;
  AccountantName?: Maybe<StringFilter>;
  AccountantPincode?: Maybe<StringFilter>;
  AccountantRegistrationNumber?: Maybe<StringFilter>;
  AccountantState?: Maybe<StringFilter>;
  AccountantStreet?: Maybe<StringNullableFilter>;
  AmountAfterTDS?: Maybe<FloatNullableFilter>;
  AmountOfCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfShortCapitalGains?: Maybe<FloatNullableFilter>;
  AmountOfTDSInForeign?: Maybe<FloatNullableFilter>;
  AmountOfTDSInINR?: Maybe<FloatNullableFilter>;
  AuthDealer?: Maybe<StringFilter>;
  BSRCode?: Maybe<StringFilter>;
  BankDetail?: Maybe<BankDetailRelationFilter>;
  BankDetailId?: Maybe<IntFilter>;
  BankName?: Maybe<StringFilter>;
  BasisOfTaxableIncome?: Maybe<StringNullableFilter>;
  Beneficiary?: Maybe<BenefeciaryRelationFilter>;
  BeneficiaryId?: Maybe<IntFilter>;
  BranchName?: Maybe<StringFilter>;
  Building?: Maybe<StringNullableFilter>;
  CA?: Maybe<UserRelationFilter>;
  CaId?: Maybe<IntNullableFilter>;
  CapitalGainsRateOfTDS?: Maybe<FloatNullableFilter>;
  CertificateArticleOfDTAA?: Maybe<StringNullableFilter>;
  CertificateDTAA?: Maybe<StringNullableFilter>;
  ChargeableAndReliefDTAA?: Maybe<BoolFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  DTAATaxLiability?: Maybe<FloatNullableFilter>;
  DTAATaxableIncome?: Maybe<FloatNullableFilter>;
  DateOfDeduction?: Maybe<DateTimeNullableFilter>;
  DeterminingTaxAndLiability?: Maybe<StringNullableFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  Events?: Maybe<EventsListRelationFilter>;
  ExchangeRate?: Maybe<StringFilter>;
  Flat?: Maybe<StringFilter>;
  Form15CAC?: Maybe<Form15CacRelationFilter>;
  IfBasisOfTheRateOfDeduction?: Maybe<StringNullableFilter>;
  IncomeChargeableToTax?: Maybe<FloatNullableFilter>;
  IncomeTaxRateOfTDS?: Maybe<FloatNullableFilter>;
  IsAccountOfBusinessIncome?: Maybe<BoolNullableFilter>;
  IsRelatedParty?: Maybe<BoolNullableFilter>;
  IsRemittanceCapitalGains?: Maybe<BoolNullableFilter>;
  IsRemittanceChargeableIndia?: Maybe<BoolFilter>;
  IsRemittanceCovered?: Maybe<BoolNullableFilter>;
  IsTaxPayableGrossedUp?: Maybe<BoolFilter>;
  IsWithPermanentEstablishment?: Maybe<BoolNullableFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<Form15CbWhereInput>>;
  NatureOfRemittance?: Maybe<StringNullableFilter>;
  NoReasonRelevantArticleDTAA?: Maybe<StringNullableFilter>;
  NoTaxableInIndiaDTAA?: Maybe<StringNullableFilter>;
  OR?: Maybe<Array<Form15CbWhereInput>>;
  OtherRemittanceCountry?: Maybe<StringNullableFilter>;
  OtherRemittanceCurrency?: Maybe<StringNullableFilter>;
  OtherRemittanceNameOnDocument?: Maybe<StringNullableFilter>;
  PayableAmountINR?: Maybe<FloatFilter>;
  PayableAmountInForeign?: Maybe<FloatFilter>;
  PermanentEstablishmentArticle?: Maybe<StringNullableFilter>;
  PermanentEstablishmentRateOfTDS?: Maybe<FloatNullableFilter>;
  Pincode?: Maybe<StringFilter>;
  ProposedDate?: Maybe<DateTimeFilter>;
  RBIPurposeCode?: Maybe<StringFilter>;
  RateOfTDS?: Maybe<StringNullableFilter>;
  RateOfTDSIncomeTaxAct?: Maybe<StringNullableFilter>;
  ReasonRemittanceNotChargeable?: Maybe<StringNullableFilter>;
  RemittanceCountry?: Maybe<StringFilter>;
  RemittanceCurrency?: Maybe<StringFilter>;
  RemittanceNameOnDocument?: Maybe<StringFilter>;
  Request?: Maybe<RequestRelationFilter>;
  RequestId?: Maybe<IntNullableFilter>;
  RevokedFrom?: Maybe<Form15CbRelationFilter>;
  RevokedToForm?: Maybe<Form15CbRelationFilter>;
  RevokedToId?: Maybe<IntNullableFilter>;
  SectionOfActRemittanceCovered?: Maybe<StringNullableFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  SubCategory?: Maybe<StringFilter>;
  SuchIncomeLiableToTaxIN?: Maybe<BoolNullableFilter>;
  TaxLiability?: Maybe<FloatNullableFilter>;
  TaxResidencyCertificateMade?: Maybe<BoolNullableFilter>;
  TaxResidencyCertificateObtained?: Maybe<BoolFilter>;
  TaxableInIndiaDTAA?: Maybe<BoolNullableFilter>;
  TransactionLengthPrice?: Maybe<BoolNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  YesTaxableInIndiaDTAA?: Maybe<FloatNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  ifsc?: Maybe<StringFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type Form15CbWhereUniqueInput = {
  RequestId?: Maybe<Scalars['Int']>;
  RevokedToId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type Group = {
  __typename?: 'Group';
  Admin?: Maybe<User>;
  AdminId?: Maybe<Scalars['Int']>;
  Benefeciary: Array<Benefeciary>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company: Array<Company>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirm;
  FirmId: Scalars['Int'];
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request: Array<Request>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess: Array<UserAccess>;
  Users: Array<User>;
  _count?: Maybe<GroupCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type GroupBenefeciaryArgs = {
  cursor?: Maybe<BenefeciaryWhereUniqueInput>;
  distinct?: Maybe<Array<BenefeciaryScalarFieldEnum>>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type GroupCompanyArgs = {
  cursor?: Maybe<CompanyWhereUniqueInput>;
  distinct?: Maybe<Array<CompanyScalarFieldEnum>>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CompanyWhereInput>;
};


export type GroupRequestArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  distinct?: Maybe<Array<RequestScalarFieldEnum>>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type GroupUserAccessArgs = {
  cursor?: Maybe<UserAccessWhereUniqueInput>;
  distinct?: Maybe<Array<UserAccessScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserAccessOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};


export type GroupUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};

export type GroupAvgAggregate = {
  __typename?: 'GroupAvgAggregate';
  AdminId?: Maybe<Scalars['Float']>;
  CreatedBy?: Maybe<Scalars['Float']>;
  FirmId?: Maybe<Scalars['Float']>;
  UpdatedBy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type GroupAvgOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type GroupCount = {
  __typename?: 'GroupCount';
  Benefeciary: Scalars['Int'];
  Company: Scalars['Int'];
  Request: Scalars['Int'];
  UserAccess: Scalars['Int'];
  Users: Scalars['Int'];
};

export type GroupCountAggregate = {
  __typename?: 'GroupCountAggregate';
  AdminId: Scalars['Int'];
  Building: Scalars['Int'];
  City: Scalars['Int'];
  Country: Scalars['Int'];
  CreatedBy: Scalars['Int'];
  FirmId: Scalars['Int'];
  Flat: Scalars['Int'];
  GroupName: Scalars['Int'];
  Locality: Scalars['Int'];
  Pincode: Scalars['Int'];
  State: Scalars['Int'];
  Street: Scalars['Int'];
  UpdatedBy: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type GroupCountOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupName?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GroupCreateInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutGroupsInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutGroupInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedManyWithoutGroupInput>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirmCreateNestedOneWithoutGroupInput;
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutGroupInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutGroupInput>;
  Users?: Maybe<UserCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateManyFirmInput = {
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateManyFirmInputEnvelope = {
  data: Array<GroupCreateManyFirmInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type GroupCreateManyInput = {
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmId: Scalars['Int'];
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateNestedManyWithoutFirmInput = {
  connect?: Maybe<Array<GroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<GroupCreateOrConnectWithoutFirmInput>>;
  create?: Maybe<Array<GroupCreateWithoutFirmInput>>;
  createMany?: Maybe<GroupCreateManyFirmInputEnvelope>;
};

export type GroupCreateNestedOneWithoutAdminInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutAdminInput>;
  create?: Maybe<GroupCreateWithoutAdminInput>;
};

export type GroupCreateNestedOneWithoutBenefeciaryInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutBenefeciaryInput>;
  create?: Maybe<GroupCreateWithoutBenefeciaryInput>;
};

export type GroupCreateNestedOneWithoutCompanyInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutCompanyInput>;
  create?: Maybe<GroupCreateWithoutCompanyInput>;
};

export type GroupCreateNestedOneWithoutRequestInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutRequestInput>;
  create?: Maybe<GroupCreateWithoutRequestInput>;
};

export type GroupCreateNestedOneWithoutUserAccessInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<GroupCreateWithoutUserAccessInput>;
};

export type GroupCreateNestedOneWithoutUsersInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutUsersInput>;
  create?: Maybe<GroupCreateWithoutUsersInput>;
};

export type GroupCreateOrConnectWithoutAdminInput = {
  create: GroupCreateWithoutAdminInput;
  where: GroupWhereUniqueInput;
};

export type GroupCreateOrConnectWithoutBenefeciaryInput = {
  create: GroupCreateWithoutBenefeciaryInput;
  where: GroupWhereUniqueInput;
};

export type GroupCreateOrConnectWithoutCompanyInput = {
  create: GroupCreateWithoutCompanyInput;
  where: GroupWhereUniqueInput;
};

export type GroupCreateOrConnectWithoutFirmInput = {
  create: GroupCreateWithoutFirmInput;
  where: GroupWhereUniqueInput;
};

export type GroupCreateOrConnectWithoutRequestInput = {
  create: GroupCreateWithoutRequestInput;
  where: GroupWhereUniqueInput;
};

export type GroupCreateOrConnectWithoutUserAccessInput = {
  create: GroupCreateWithoutUserAccessInput;
  where: GroupWhereUniqueInput;
};

export type GroupCreateOrConnectWithoutUsersInput = {
  create: GroupCreateWithoutUsersInput;
  where: GroupWhereUniqueInput;
};

export type GroupCreateWithoutAdminInput = {
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutGroupInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedManyWithoutGroupInput>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirmCreateNestedOneWithoutGroupInput;
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutGroupInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutGroupInput>;
  Users?: Maybe<UserCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateWithoutBenefeciaryInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutGroupsInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedManyWithoutGroupInput>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirmCreateNestedOneWithoutGroupInput;
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutGroupInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutGroupInput>;
  Users?: Maybe<UserCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateWithoutCompanyInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutGroupsInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutGroupInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirmCreateNestedOneWithoutGroupInput;
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutGroupInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutGroupInput>;
  Users?: Maybe<UserCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateWithoutFirmInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutGroupsInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutGroupInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedManyWithoutGroupInput>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutGroupInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutGroupInput>;
  Users?: Maybe<UserCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateWithoutRequestInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutGroupsInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutGroupInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedManyWithoutGroupInput>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirmCreateNestedOneWithoutGroupInput;
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutGroupInput>;
  Users?: Maybe<UserCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateWithoutUserAccessInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutGroupsInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutGroupInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedManyWithoutGroupInput>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirmCreateNestedOneWithoutGroupInput;
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutGroupInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  Users?: Maybe<UserCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupCreateWithoutUsersInput = {
  Admin?: Maybe<UserCreateNestedOneWithoutGroupsInput>;
  Benefeciary?: Maybe<BenefeciaryCreateNestedManyWithoutGroupInput>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Company?: Maybe<CompanyCreateNestedManyWithoutGroupInput>;
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  Firm: CaFirmCreateNestedOneWithoutGroupInput;
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutGroupInput>;
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutGroupInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupGroupBy = {
  __typename?: 'GroupGroupBy';
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City: Scalars['String'];
  Country: Scalars['String'];
  CreatedBy: Scalars['Int'];
  FirmId: Scalars['Int'];
  Flat: Scalars['String'];
  GroupName: Scalars['String'];
  Locality: Scalars['String'];
  Pincode: Scalars['String'];
  State: Scalars['String'];
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  _avg?: Maybe<GroupAvgAggregate>;
  _count?: Maybe<GroupCountAggregate>;
  _max?: Maybe<GroupMaxAggregate>;
  _min?: Maybe<GroupMinAggregate>;
  _sum?: Maybe<GroupSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type GroupListRelationFilter = {
  every?: Maybe<GroupWhereInput>;
  none?: Maybe<GroupWhereInput>;
  some?: Maybe<GroupWhereInput>;
};

export type GroupMaxAggregate = {
  __typename?: 'GroupMaxAggregate';
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  FirmId?: Maybe<Scalars['Int']>;
  Flat?: Maybe<Scalars['String']>;
  GroupName?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupMaxOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupName?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GroupMinAggregate = {
  __typename?: 'GroupMinAggregate';
  AdminId?: Maybe<Scalars['Int']>;
  Building?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  FirmId?: Maybe<Scalars['Int']>;
  Flat?: Maybe<Scalars['String']>;
  GroupName?: Maybe<Scalars['String']>;
  Locality?: Maybe<Scalars['String']>;
  Pincode?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupMinOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupName?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GroupOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type GroupOrderByWithAggregationInput = {
  AdminId?: Maybe<SortOrder>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupName?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  _avg?: Maybe<GroupAvgOrderByAggregateInput>;
  _count?: Maybe<GroupCountOrderByAggregateInput>;
  _max?: Maybe<GroupMaxOrderByAggregateInput>;
  _min?: Maybe<GroupMinOrderByAggregateInput>;
  _sum?: Maybe<GroupSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GroupOrderByWithRelationInput = {
  Admin?: Maybe<UserOrderByWithRelationInput>;
  AdminId?: Maybe<SortOrder>;
  Benefeciary?: Maybe<BenefeciaryOrderByRelationAggregateInput>;
  Building?: Maybe<SortOrder>;
  City?: Maybe<SortOrder>;
  Company?: Maybe<CompanyOrderByRelationAggregateInput>;
  Country?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  Firm?: Maybe<CaFirmOrderByWithRelationInput>;
  FirmId?: Maybe<SortOrder>;
  Flat?: Maybe<SortOrder>;
  GroupName?: Maybe<SortOrder>;
  Locality?: Maybe<SortOrder>;
  Pincode?: Maybe<SortOrder>;
  Request?: Maybe<RequestOrderByRelationAggregateInput>;
  State?: Maybe<SortOrder>;
  Street?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  UserAccess?: Maybe<UserAccessOrderByRelationAggregateInput>;
  Users?: Maybe<UserOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type GroupRelationFilter = {
  is?: Maybe<GroupWhereInput>;
  isNot?: Maybe<GroupWhereInput>;
};

export enum GroupScalarFieldEnum {
  AdminId = 'AdminId',
  Building = 'Building',
  City = 'City',
  Country = 'Country',
  CreatedBy = 'CreatedBy',
  FirmId = 'FirmId',
  Flat = 'Flat',
  GroupName = 'GroupName',
  Locality = 'Locality',
  Pincode = 'Pincode',
  State = 'State',
  Street = 'Street',
  UpdatedBy = 'UpdatedBy',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type GroupScalarWhereInput = {
  AND?: Maybe<Array<GroupScalarWhereInput>>;
  AdminId?: Maybe<IntNullableFilter>;
  Building?: Maybe<StringNullableFilter>;
  City?: Maybe<StringFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  FirmId?: Maybe<IntFilter>;
  Flat?: Maybe<StringFilter>;
  GroupName?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<GroupScalarWhereInput>>;
  OR?: Maybe<Array<GroupScalarWhereInput>>;
  Pincode?: Maybe<StringFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type GroupScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<GroupScalarWhereWithAggregatesInput>>;
  AdminId?: Maybe<IntNullableWithAggregatesFilter>;
  Building?: Maybe<StringNullableWithAggregatesFilter>;
  City?: Maybe<StringWithAggregatesFilter>;
  Country?: Maybe<StringWithAggregatesFilter>;
  CreatedBy?: Maybe<IntWithAggregatesFilter>;
  FirmId?: Maybe<IntWithAggregatesFilter>;
  Flat?: Maybe<StringWithAggregatesFilter>;
  GroupName?: Maybe<StringWithAggregatesFilter>;
  Locality?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<GroupScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<GroupScalarWhereWithAggregatesInput>>;
  Pincode?: Maybe<StringWithAggregatesFilter>;
  State?: Maybe<StringWithAggregatesFilter>;
  Street?: Maybe<StringNullableWithAggregatesFilter>;
  UpdatedBy?: Maybe<IntNullableWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type GroupSumAggregate = {
  __typename?: 'GroupSumAggregate';
  AdminId?: Maybe<Scalars['Int']>;
  CreatedBy?: Maybe<Scalars['Int']>;
  FirmId?: Maybe<Scalars['Int']>;
  UpdatedBy?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type GroupSumOrderByAggregateInput = {
  AdminId?: Maybe<SortOrder>;
  CreatedBy?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  UpdatedBy?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type GroupUpdateInput = {
  Admin?: Maybe<UserUpdateOneWithoutGroupsNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutGroupNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateManyWithoutGroupNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneRequiredWithoutGroupNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutGroupNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutGroupNestedInput>;
  Users?: Maybe<UserUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateManyMutationInput = {
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateManyWithWhereWithoutFirmInput = {
  data: GroupUpdateManyMutationInput;
  where: GroupScalarWhereInput;
};

export type GroupUpdateManyWithoutFirmNestedInput = {
  connect?: Maybe<Array<GroupWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<GroupCreateOrConnectWithoutFirmInput>>;
  create?: Maybe<Array<GroupCreateWithoutFirmInput>>;
  createMany?: Maybe<GroupCreateManyFirmInputEnvelope>;
  delete?: Maybe<Array<GroupWhereUniqueInput>>;
  deleteMany?: Maybe<Array<GroupScalarWhereInput>>;
  disconnect?: Maybe<Array<GroupWhereUniqueInput>>;
  set?: Maybe<Array<GroupWhereUniqueInput>>;
  update?: Maybe<Array<GroupUpdateWithWhereUniqueWithoutFirmInput>>;
  updateMany?: Maybe<Array<GroupUpdateManyWithWhereWithoutFirmInput>>;
  upsert?: Maybe<Array<GroupUpsertWithWhereUniqueWithoutFirmInput>>;
};

export type GroupUpdateOneRequiredWithoutBenefeciaryNestedInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutBenefeciaryInput>;
  create?: Maybe<GroupCreateWithoutBenefeciaryInput>;
  update?: Maybe<GroupUpdateWithoutBenefeciaryInput>;
  upsert?: Maybe<GroupUpsertWithoutBenefeciaryInput>;
};

export type GroupUpdateOneRequiredWithoutCompanyNestedInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutCompanyInput>;
  create?: Maybe<GroupCreateWithoutCompanyInput>;
  update?: Maybe<GroupUpdateWithoutCompanyInput>;
  upsert?: Maybe<GroupUpsertWithoutCompanyInput>;
};

export type GroupUpdateOneRequiredWithoutRequestNestedInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutRequestInput>;
  create?: Maybe<GroupCreateWithoutRequestInput>;
  update?: Maybe<GroupUpdateWithoutRequestInput>;
  upsert?: Maybe<GroupUpsertWithoutRequestInput>;
};

export type GroupUpdateOneRequiredWithoutUserAccessNestedInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<GroupCreateWithoutUserAccessInput>;
  update?: Maybe<GroupUpdateWithoutUserAccessInput>;
  upsert?: Maybe<GroupUpsertWithoutUserAccessInput>;
};

export type GroupUpdateOneWithoutAdminNestedInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutAdminInput>;
  create?: Maybe<GroupCreateWithoutAdminInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<GroupUpdateWithoutAdminInput>;
  upsert?: Maybe<GroupUpsertWithoutAdminInput>;
};

export type GroupUpdateOneWithoutUsersNestedInput = {
  connect?: Maybe<GroupWhereUniqueInput>;
  connectOrCreate?: Maybe<GroupCreateOrConnectWithoutUsersInput>;
  create?: Maybe<GroupCreateWithoutUsersInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<GroupUpdateWithoutUsersInput>;
  upsert?: Maybe<GroupUpsertWithoutUsersInput>;
};

export type GroupUpdateWithWhereUniqueWithoutFirmInput = {
  data: GroupUpdateWithoutFirmInput;
  where: GroupWhereUniqueInput;
};

export type GroupUpdateWithoutAdminInput = {
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutGroupNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateManyWithoutGroupNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneRequiredWithoutGroupNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutGroupNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutGroupNestedInput>;
  Users?: Maybe<UserUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateWithoutBenefeciaryInput = {
  Admin?: Maybe<UserUpdateOneWithoutGroupsNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateManyWithoutGroupNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneRequiredWithoutGroupNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutGroupNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutGroupNestedInput>;
  Users?: Maybe<UserUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateWithoutCompanyInput = {
  Admin?: Maybe<UserUpdateOneWithoutGroupsNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutGroupNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneRequiredWithoutGroupNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutGroupNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutGroupNestedInput>;
  Users?: Maybe<UserUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateWithoutFirmInput = {
  Admin?: Maybe<UserUpdateOneWithoutGroupsNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutGroupNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateManyWithoutGroupNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutGroupNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutGroupNestedInput>;
  Users?: Maybe<UserUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateWithoutRequestInput = {
  Admin?: Maybe<UserUpdateOneWithoutGroupsNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutGroupNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateManyWithoutGroupNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneRequiredWithoutGroupNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutGroupNestedInput>;
  Users?: Maybe<UserUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateWithoutUserAccessInput = {
  Admin?: Maybe<UserUpdateOneWithoutGroupsNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutGroupNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateManyWithoutGroupNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneRequiredWithoutGroupNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutGroupNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  Users?: Maybe<UserUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateWithoutUsersInput = {
  Admin?: Maybe<UserUpdateOneWithoutGroupsNestedInput>;
  Benefeciary?: Maybe<BenefeciaryUpdateManyWithoutGroupNestedInput>;
  Building?: Maybe<NullableStringFieldUpdateOperationsInput>;
  City?: Maybe<StringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateManyWithoutGroupNestedInput>;
  Country?: Maybe<StringFieldUpdateOperationsInput>;
  CreatedBy?: Maybe<IntFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneRequiredWithoutGroupNestedInput>;
  Flat?: Maybe<StringFieldUpdateOperationsInput>;
  GroupName?: Maybe<StringFieldUpdateOperationsInput>;
  Locality?: Maybe<StringFieldUpdateOperationsInput>;
  Pincode?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutGroupNestedInput>;
  State?: Maybe<StringFieldUpdateOperationsInput>;
  Street?: Maybe<NullableStringFieldUpdateOperationsInput>;
  UpdatedBy?: Maybe<NullableIntFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutGroupNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpsertWithWhereUniqueWithoutFirmInput = {
  create: GroupCreateWithoutFirmInput;
  update: GroupUpdateWithoutFirmInput;
  where: GroupWhereUniqueInput;
};

export type GroupUpsertWithoutAdminInput = {
  create: GroupCreateWithoutAdminInput;
  update: GroupUpdateWithoutAdminInput;
};

export type GroupUpsertWithoutBenefeciaryInput = {
  create: GroupCreateWithoutBenefeciaryInput;
  update: GroupUpdateWithoutBenefeciaryInput;
};

export type GroupUpsertWithoutCompanyInput = {
  create: GroupCreateWithoutCompanyInput;
  update: GroupUpdateWithoutCompanyInput;
};

export type GroupUpsertWithoutRequestInput = {
  create: GroupCreateWithoutRequestInput;
  update: GroupUpdateWithoutRequestInput;
};

export type GroupUpsertWithoutUserAccessInput = {
  create: GroupCreateWithoutUserAccessInput;
  update: GroupUpdateWithoutUserAccessInput;
};

export type GroupUpsertWithoutUsersInput = {
  create: GroupCreateWithoutUsersInput;
  update: GroupUpdateWithoutUsersInput;
};

export type GroupWhereInput = {
  AND?: Maybe<Array<GroupWhereInput>>;
  Admin?: Maybe<UserRelationFilter>;
  AdminId?: Maybe<IntNullableFilter>;
  Benefeciary?: Maybe<BenefeciaryListRelationFilter>;
  Building?: Maybe<StringNullableFilter>;
  City?: Maybe<StringFilter>;
  Company?: Maybe<CompanyListRelationFilter>;
  Country?: Maybe<StringFilter>;
  CreatedBy?: Maybe<IntFilter>;
  Firm?: Maybe<CaFirmRelationFilter>;
  FirmId?: Maybe<IntFilter>;
  Flat?: Maybe<StringFilter>;
  GroupName?: Maybe<StringFilter>;
  Locality?: Maybe<StringFilter>;
  NOT?: Maybe<Array<GroupWhereInput>>;
  OR?: Maybe<Array<GroupWhereInput>>;
  Pincode?: Maybe<StringFilter>;
  Request?: Maybe<RequestListRelationFilter>;
  State?: Maybe<StringFilter>;
  Street?: Maybe<StringNullableFilter>;
  UpdatedBy?: Maybe<IntNullableFilter>;
  UserAccess?: Maybe<UserAccessListRelationFilter>;
  Users?: Maybe<UserListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type GroupWhereUniqueInput = {
  AdminId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Int']>;
  divide?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  multiply?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedIntNullableFilter>;
  _sum?: Maybe<NestedIntNullableFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createManyBankDetail: AffectedRowsOutput;
  createManyBenefeciary: AffectedRowsOutput;
  createManyBeneficiaryCertificate: AffectedRowsOutput;
  createManyBranch: AffectedRowsOutput;
  createManyCAFirm: AffectedRowsOutput;
  createManyCompany: AffectedRowsOutput;
  createManyDocument: AffectedRowsOutput;
  createManyEvents: AffectedRowsOutput;
  createManyFile: AffectedRowsOutput;
  createManyFolioNumber: AffectedRowsOutput;
  createManyForm15CAA: AffectedRowsOutput;
  createManyForm15CAB: AffectedRowsOutput;
  createManyForm15CAC: AffectedRowsOutput;
  createManyForm15CAD: AffectedRowsOutput;
  createManyForm15CB: AffectedRowsOutput;
  createManyGroup: AffectedRowsOutput;
  createManyRequest: AffectedRowsOutput;
  createManyUdin: AffectedRowsOutput;
  createManyUser: AffectedRowsOutput;
  createManyUserAccess: AffectedRowsOutput;
  createOneBankDetail: BankDetail;
  createOneBenefeciary: Benefeciary;
  createOneBeneficiaryCertificate: BeneficiaryCertificate;
  createOneBranch: Branch;
  createOneCAFirm: CaFirm;
  createOneCompany: Company;
  createOneDocument: Document;
  createOneEvents: Events;
  createOneFile: File;
  createOneFolioNumber: FolioNumber;
  createOneForm15CAA: Form15Caa;
  createOneForm15CAB: Form15Cab;
  createOneForm15CAC: Form15Cac;
  createOneForm15CAD: Form15Cad;
  createOneForm15CB: Form15Cb;
  createOneGroup: Group;
  createOneRequest: Request;
  createOneUdin: Udin;
  createOneUser: User;
  createOneUserAccess: UserAccess;
  deleteManyBankDetail: AffectedRowsOutput;
  deleteManyBenefeciary: AffectedRowsOutput;
  deleteManyBeneficiaryCertificate: AffectedRowsOutput;
  deleteManyBranch: AffectedRowsOutput;
  deleteManyCAFirm: AffectedRowsOutput;
  deleteManyCompany: AffectedRowsOutput;
  deleteManyDocument: AffectedRowsOutput;
  deleteManyEvents: AffectedRowsOutput;
  deleteManyFile: AffectedRowsOutput;
  deleteManyFolioNumber: AffectedRowsOutput;
  deleteManyForm15CAA: AffectedRowsOutput;
  deleteManyForm15CAB: AffectedRowsOutput;
  deleteManyForm15CAC: AffectedRowsOutput;
  deleteManyForm15CAD: AffectedRowsOutput;
  deleteManyForm15CB: AffectedRowsOutput;
  deleteManyGroup: AffectedRowsOutput;
  deleteManyRequest: AffectedRowsOutput;
  deleteManyUdin: AffectedRowsOutput;
  deleteManyUser: AffectedRowsOutput;
  deleteManyUserAccess: AffectedRowsOutput;
  deleteOneBankDetail?: Maybe<BankDetail>;
  deleteOneBenefeciary?: Maybe<Benefeciary>;
  deleteOneBeneficiaryCertificate?: Maybe<BeneficiaryCertificate>;
  deleteOneBranch?: Maybe<Branch>;
  deleteOneCAFirm?: Maybe<CaFirm>;
  deleteOneCompany?: Maybe<Company>;
  deleteOneDocument?: Maybe<Document>;
  deleteOneEvents?: Maybe<Events>;
  deleteOneFile?: Maybe<File>;
  deleteOneFolioNumber?: Maybe<FolioNumber>;
  deleteOneForm15CAA?: Maybe<Form15Caa>;
  deleteOneForm15CAB?: Maybe<Form15Cab>;
  deleteOneForm15CAC?: Maybe<Form15Cac>;
  deleteOneForm15CAD?: Maybe<Form15Cad>;
  deleteOneForm15CB?: Maybe<Form15Cb>;
  deleteOneGroup?: Maybe<Group>;
  deleteOneRequest?: Maybe<Request>;
  deleteOneUdin?: Maybe<Udin>;
  deleteOneUser?: Maybe<User>;
  deleteOneUserAccess?: Maybe<UserAccess>;
  forgotPassword: ForgotPasswordPayload;
  login?: Maybe<AuthPayload>;
  sendApprovedEmail?: Maybe<EmailResponsePayload>;
  sendRejectionEmail?: Maybe<EmailResponsePayload>;
  setPassword: ChangePasswordPayload;
  updateManyBankDetail: AffectedRowsOutput;
  updateManyBenefeciary: AffectedRowsOutput;
  updateManyBeneficiaryCertificate: AffectedRowsOutput;
  updateManyBranch: AffectedRowsOutput;
  updateManyCAFirm: AffectedRowsOutput;
  updateManyCompany: AffectedRowsOutput;
  updateManyDocument: AffectedRowsOutput;
  updateManyEvents: AffectedRowsOutput;
  updateManyFile: AffectedRowsOutput;
  updateManyFolioNumber: AffectedRowsOutput;
  updateManyForm15CAA: AffectedRowsOutput;
  updateManyForm15CAB: AffectedRowsOutput;
  updateManyForm15CAC: AffectedRowsOutput;
  updateManyForm15CAD: AffectedRowsOutput;
  updateManyForm15CB: AffectedRowsOutput;
  updateManyGroup: AffectedRowsOutput;
  updateManyRequest: AffectedRowsOutput;
  updateManyUdin: AffectedRowsOutput;
  updateManyUser: AffectedRowsOutput;
  updateManyUserAccess: AffectedRowsOutput;
  updateOneBankDetail?: Maybe<BankDetail>;
  updateOneBenefeciary?: Maybe<Benefeciary>;
  updateOneBeneficiaryCertificate?: Maybe<BeneficiaryCertificate>;
  updateOneBranch?: Maybe<Branch>;
  updateOneCAFirm?: Maybe<CaFirm>;
  updateOneCompany?: Maybe<Company>;
  updateOneDocument?: Maybe<Document>;
  updateOneEvents?: Maybe<Events>;
  updateOneFile?: Maybe<File>;
  updateOneFolioNumber?: Maybe<FolioNumber>;
  updateOneForm15CAA?: Maybe<Form15Caa>;
  updateOneForm15CAB?: Maybe<Form15Cab>;
  updateOneForm15CAC?: Maybe<Form15Cac>;
  updateOneForm15CAD?: Maybe<Form15Cad>;
  updateOneForm15CB?: Maybe<Form15Cb>;
  updateOneGroup?: Maybe<Group>;
  updateOneRequest?: Maybe<Request>;
  updateOneUdin?: Maybe<Udin>;
  updateOneUser?: Maybe<User>;
  updateOneUserAccess?: Maybe<UserAccess>;
  upsertOneBankDetail: BankDetail;
  upsertOneBenefeciary: Benefeciary;
  upsertOneBeneficiaryCertificate: BeneficiaryCertificate;
  upsertOneBranch: Branch;
  upsertOneCAFirm: CaFirm;
  upsertOneCompany: Company;
  upsertOneDocument: Document;
  upsertOneEvents: Events;
  upsertOneFile: File;
  upsertOneFolioNumber: FolioNumber;
  upsertOneForm15CAA: Form15Caa;
  upsertOneForm15CAB: Form15Cab;
  upsertOneForm15CAC: Form15Cac;
  upsertOneForm15CAD: Form15Cad;
  upsertOneForm15CB: Form15Cb;
  upsertOneGroup: Group;
  upsertOneRequest: Request;
  upsertOneUdin: Udin;
  upsertOneUser: User;
  upsertOneUserAccess: UserAccess;
  validateConfirmToken: ValidConfirmationTokenPayload;
};


export type MutationCreateManyBankDetailArgs = {
  data: Array<BankDetailCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyBenefeciaryArgs = {
  data: Array<BenefeciaryCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyBeneficiaryCertificateArgs = {
  data: Array<BeneficiaryCertificateCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyBranchArgs = {
  data: Array<BranchCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyCaFirmArgs = {
  data: Array<CaFirmCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyCompanyArgs = {
  data: Array<CompanyCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyDocumentArgs = {
  data: Array<DocumentCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyEventsArgs = {
  data: Array<EventsCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyFileArgs = {
  data: Array<FileCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyFolioNumberArgs = {
  data: Array<FolioNumberCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyForm15CaaArgs = {
  data: Array<Form15CaaCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyForm15CabArgs = {
  data: Array<Form15CabCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyForm15CacArgs = {
  data: Array<Form15CacCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyForm15CadArgs = {
  data: Array<Form15CadCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyForm15CbArgs = {
  data: Array<Form15CbCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyGroupArgs = {
  data: Array<GroupCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyRequestArgs = {
  data: Array<RequestCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyUdinArgs = {
  data: Array<UdinCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyUserArgs = {
  data: Array<UserCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateManyUserAccessArgs = {
  data: Array<UserAccessCreateManyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateOneBankDetailArgs = {
  data: BankDetailCreateInput;
};


export type MutationCreateOneBenefeciaryArgs = {
  data: BenefeciaryCreateInput;
};


export type MutationCreateOneBeneficiaryCertificateArgs = {
  data: BeneficiaryCertificateCreateInput;
};


export type MutationCreateOneBranchArgs = {
  data: BranchCreateInput;
};


export type MutationCreateOneCaFirmArgs = {
  data: CaFirmCreateInput;
};


export type MutationCreateOneCompanyArgs = {
  data: CompanyCreateInput;
};


export type MutationCreateOneDocumentArgs = {
  data: DocumentCreateInput;
};


export type MutationCreateOneEventsArgs = {
  data: EventsCreateInput;
};


export type MutationCreateOneFileArgs = {
  data: FileCreateInput;
};


export type MutationCreateOneFolioNumberArgs = {
  data: FolioNumberCreateInput;
};


export type MutationCreateOneForm15CaaArgs = {
  data: Form15CaaCreateInput;
};


export type MutationCreateOneForm15CabArgs = {
  data: Form15CabCreateInput;
};


export type MutationCreateOneForm15CacArgs = {
  data: Form15CacCreateInput;
};


export type MutationCreateOneForm15CadArgs = {
  data: Form15CadCreateInput;
};


export type MutationCreateOneForm15CbArgs = {
  data: Form15CbCreateInput;
};


export type MutationCreateOneGroupArgs = {
  data: GroupCreateInput;
};


export type MutationCreateOneRequestArgs = {
  data: RequestCreateInput;
};


export type MutationCreateOneUdinArgs = {
  data: UdinCreateInput;
};


export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateOneUserAccessArgs = {
  data: UserAccessCreateInput;
};


export type MutationDeleteManyBankDetailArgs = {
  where?: Maybe<BankDetailWhereInput>;
};


export type MutationDeleteManyBenefeciaryArgs = {
  where?: Maybe<BenefeciaryWhereInput>;
};


export type MutationDeleteManyBeneficiaryCertificateArgs = {
  where?: Maybe<BeneficiaryCertificateWhereInput>;
};


export type MutationDeleteManyBranchArgs = {
  where?: Maybe<BranchWhereInput>;
};


export type MutationDeleteManyCaFirmArgs = {
  where?: Maybe<CaFirmWhereInput>;
};


export type MutationDeleteManyCompanyArgs = {
  where?: Maybe<CompanyWhereInput>;
};


export type MutationDeleteManyDocumentArgs = {
  where?: Maybe<DocumentWhereInput>;
};


export type MutationDeleteManyEventsArgs = {
  where?: Maybe<EventsWhereInput>;
};


export type MutationDeleteManyFileArgs = {
  where?: Maybe<FileWhereInput>;
};


export type MutationDeleteManyFolioNumberArgs = {
  where?: Maybe<FolioNumberWhereInput>;
};


export type MutationDeleteManyForm15CaaArgs = {
  where?: Maybe<Form15CaaWhereInput>;
};


export type MutationDeleteManyForm15CabArgs = {
  where?: Maybe<Form15CabWhereInput>;
};


export type MutationDeleteManyForm15CacArgs = {
  where?: Maybe<Form15CacWhereInput>;
};


export type MutationDeleteManyForm15CadArgs = {
  where?: Maybe<Form15CadWhereInput>;
};


export type MutationDeleteManyForm15CbArgs = {
  where?: Maybe<Form15CbWhereInput>;
};


export type MutationDeleteManyGroupArgs = {
  where?: Maybe<GroupWhereInput>;
};


export type MutationDeleteManyRequestArgs = {
  where?: Maybe<RequestWhereInput>;
};


export type MutationDeleteManyUdinArgs = {
  where?: Maybe<UdinWhereInput>;
};


export type MutationDeleteManyUserArgs = {
  where?: Maybe<UserWhereInput>;
};


export type MutationDeleteManyUserAccessArgs = {
  where?: Maybe<UserAccessWhereInput>;
};


export type MutationDeleteOneBankDetailArgs = {
  where: BankDetailWhereUniqueInput;
};


export type MutationDeleteOneBenefeciaryArgs = {
  where: BenefeciaryWhereUniqueInput;
};


export type MutationDeleteOneBeneficiaryCertificateArgs = {
  where: BeneficiaryCertificateWhereUniqueInput;
};


export type MutationDeleteOneBranchArgs = {
  where: BranchWhereUniqueInput;
};


export type MutationDeleteOneCaFirmArgs = {
  where: CaFirmWhereUniqueInput;
};


export type MutationDeleteOneCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationDeleteOneDocumentArgs = {
  where: DocumentWhereUniqueInput;
};


export type MutationDeleteOneEventsArgs = {
  where: EventsWhereUniqueInput;
};


export type MutationDeleteOneFileArgs = {
  where: FileWhereUniqueInput;
};


export type MutationDeleteOneFolioNumberArgs = {
  where: FolioNumberWhereUniqueInput;
};


export type MutationDeleteOneForm15CaaArgs = {
  where: Form15CaaWhereUniqueInput;
};


export type MutationDeleteOneForm15CabArgs = {
  where: Form15CabWhereUniqueInput;
};


export type MutationDeleteOneForm15CacArgs = {
  where: Form15CacWhereUniqueInput;
};


export type MutationDeleteOneForm15CadArgs = {
  where: Form15CadWhereUniqueInput;
};


export type MutationDeleteOneForm15CbArgs = {
  where: Form15CbWhereUniqueInput;
};


export type MutationDeleteOneGroupArgs = {
  where: GroupWhereUniqueInput;
};


export type MutationDeleteOneRequestArgs = {
  where: RequestWhereUniqueInput;
};


export type MutationDeleteOneUdinArgs = {
  where: UdinWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneUserAccessArgs = {
  where: UserAccessWhereUniqueInput;
};


export type MutationForgotPasswordArgs = {
  Email: Scalars['String'];
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationSendApprovedEmailArgs = {
  formId: Scalars['Float'];
  formType: Scalars['String'];
};


export type MutationSendRejectionEmailArgs = {
  formId: Scalars['Float'];
  formType: Scalars['String'];
};


export type MutationSetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationUpdateManyBankDetailArgs = {
  data: BankDetailUpdateManyMutationInput;
  where?: Maybe<BankDetailWhereInput>;
};


export type MutationUpdateManyBenefeciaryArgs = {
  data: BenefeciaryUpdateManyMutationInput;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type MutationUpdateManyBeneficiaryCertificateArgs = {
  data: BeneficiaryCertificateUpdateManyMutationInput;
  where?: Maybe<BeneficiaryCertificateWhereInput>;
};


export type MutationUpdateManyBranchArgs = {
  data: BranchUpdateManyMutationInput;
  where?: Maybe<BranchWhereInput>;
};


export type MutationUpdateManyCaFirmArgs = {
  data: CaFirmUpdateManyMutationInput;
  where?: Maybe<CaFirmWhereInput>;
};


export type MutationUpdateManyCompanyArgs = {
  data: CompanyUpdateManyMutationInput;
  where?: Maybe<CompanyWhereInput>;
};


export type MutationUpdateManyDocumentArgs = {
  data: DocumentUpdateManyMutationInput;
  where?: Maybe<DocumentWhereInput>;
};


export type MutationUpdateManyEventsArgs = {
  data: EventsUpdateManyMutationInput;
  where?: Maybe<EventsWhereInput>;
};


export type MutationUpdateManyFileArgs = {
  data: FileUpdateManyMutationInput;
  where?: Maybe<FileWhereInput>;
};


export type MutationUpdateManyFolioNumberArgs = {
  data: FolioNumberUpdateManyMutationInput;
  where?: Maybe<FolioNumberWhereInput>;
};


export type MutationUpdateManyForm15CaaArgs = {
  data: Form15CaaUpdateManyMutationInput;
  where?: Maybe<Form15CaaWhereInput>;
};


export type MutationUpdateManyForm15CabArgs = {
  data: Form15CabUpdateManyMutationInput;
  where?: Maybe<Form15CabWhereInput>;
};


export type MutationUpdateManyForm15CacArgs = {
  data: Form15CacUpdateManyMutationInput;
  where?: Maybe<Form15CacWhereInput>;
};


export type MutationUpdateManyForm15CadArgs = {
  data: Form15CadUpdateManyMutationInput;
  where?: Maybe<Form15CadWhereInput>;
};


export type MutationUpdateManyForm15CbArgs = {
  data: Form15CbUpdateManyMutationInput;
  where?: Maybe<Form15CbWhereInput>;
};


export type MutationUpdateManyGroupArgs = {
  data: GroupUpdateManyMutationInput;
  where?: Maybe<GroupWhereInput>;
};


export type MutationUpdateManyRequestArgs = {
  data: RequestUpdateManyMutationInput;
  where?: Maybe<RequestWhereInput>;
};


export type MutationUpdateManyUdinArgs = {
  data: UdinUpdateManyMutationInput;
  where?: Maybe<UdinWhereInput>;
};


export type MutationUpdateManyUserArgs = {
  data: UserUpdateManyMutationInput;
  where?: Maybe<UserWhereInput>;
};


export type MutationUpdateManyUserAccessArgs = {
  data: UserAccessUpdateManyMutationInput;
  where?: Maybe<UserAccessWhereInput>;
};


export type MutationUpdateOneBankDetailArgs = {
  data: BankDetailUpdateInput;
  where: BankDetailWhereUniqueInput;
};


export type MutationUpdateOneBenefeciaryArgs = {
  data: BenefeciaryUpdateInput;
  where: BenefeciaryWhereUniqueInput;
};


export type MutationUpdateOneBeneficiaryCertificateArgs = {
  data: BeneficiaryCertificateUpdateInput;
  where: BeneficiaryCertificateWhereUniqueInput;
};


export type MutationUpdateOneBranchArgs = {
  data: BranchUpdateInput;
  where: BranchWhereUniqueInput;
};


export type MutationUpdateOneCaFirmArgs = {
  data: CaFirmUpdateInput;
  where: CaFirmWhereUniqueInput;
};


export type MutationUpdateOneCompanyArgs = {
  data: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};


export type MutationUpdateOneDocumentArgs = {
  data: DocumentUpdateInput;
  where: DocumentWhereUniqueInput;
};


export type MutationUpdateOneEventsArgs = {
  data: EventsUpdateInput;
  where: EventsWhereUniqueInput;
};


export type MutationUpdateOneFileArgs = {
  data: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpdateOneFolioNumberArgs = {
  data: FolioNumberUpdateInput;
  where: FolioNumberWhereUniqueInput;
};


export type MutationUpdateOneForm15CaaArgs = {
  data: Form15CaaUpdateInput;
  where: Form15CaaWhereUniqueInput;
};


export type MutationUpdateOneForm15CabArgs = {
  data: Form15CabUpdateInput;
  where: Form15CabWhereUniqueInput;
};


export type MutationUpdateOneForm15CacArgs = {
  data: Form15CacUpdateInput;
  where: Form15CacWhereUniqueInput;
};


export type MutationUpdateOneForm15CadArgs = {
  data: Form15CadUpdateInput;
  where: Form15CadWhereUniqueInput;
};


export type MutationUpdateOneForm15CbArgs = {
  data: Form15CbUpdateInput;
  where: Form15CbWhereUniqueInput;
};


export type MutationUpdateOneGroupArgs = {
  data: GroupUpdateInput;
  where: GroupWhereUniqueInput;
};


export type MutationUpdateOneRequestArgs = {
  data: RequestUpdateInput;
  where: RequestWhereUniqueInput;
};


export type MutationUpdateOneUdinArgs = {
  data: UdinUpdateInput;
  where: UdinWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneUserAccessArgs = {
  data: UserAccessUpdateInput;
  where: UserAccessWhereUniqueInput;
};


export type MutationUpsertOneBankDetailArgs = {
  create: BankDetailCreateInput;
  update: BankDetailUpdateInput;
  where: BankDetailWhereUniqueInput;
};


export type MutationUpsertOneBenefeciaryArgs = {
  create: BenefeciaryCreateInput;
  update: BenefeciaryUpdateInput;
  where: BenefeciaryWhereUniqueInput;
};


export type MutationUpsertOneBeneficiaryCertificateArgs = {
  create: BeneficiaryCertificateCreateInput;
  update: BeneficiaryCertificateUpdateInput;
  where: BeneficiaryCertificateWhereUniqueInput;
};


export type MutationUpsertOneBranchArgs = {
  create: BranchCreateInput;
  update: BranchUpdateInput;
  where: BranchWhereUniqueInput;
};


export type MutationUpsertOneCaFirmArgs = {
  create: CaFirmCreateInput;
  update: CaFirmUpdateInput;
  where: CaFirmWhereUniqueInput;
};


export type MutationUpsertOneCompanyArgs = {
  create: CompanyCreateInput;
  update: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};


export type MutationUpsertOneDocumentArgs = {
  create: DocumentCreateInput;
  update: DocumentUpdateInput;
  where: DocumentWhereUniqueInput;
};


export type MutationUpsertOneEventsArgs = {
  create: EventsCreateInput;
  update: EventsUpdateInput;
  where: EventsWhereUniqueInput;
};


export type MutationUpsertOneFileArgs = {
  create: FileCreateInput;
  update: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpsertOneFolioNumberArgs = {
  create: FolioNumberCreateInput;
  update: FolioNumberUpdateInput;
  where: FolioNumberWhereUniqueInput;
};


export type MutationUpsertOneForm15CaaArgs = {
  create: Form15CaaCreateInput;
  update: Form15CaaUpdateInput;
  where: Form15CaaWhereUniqueInput;
};


export type MutationUpsertOneForm15CabArgs = {
  create: Form15CabCreateInput;
  update: Form15CabUpdateInput;
  where: Form15CabWhereUniqueInput;
};


export type MutationUpsertOneForm15CacArgs = {
  create: Form15CacCreateInput;
  update: Form15CacUpdateInput;
  where: Form15CacWhereUniqueInput;
};


export type MutationUpsertOneForm15CadArgs = {
  create: Form15CadCreateInput;
  update: Form15CadUpdateInput;
  where: Form15CadWhereUniqueInput;
};


export type MutationUpsertOneForm15CbArgs = {
  create: Form15CbCreateInput;
  update: Form15CbUpdateInput;
  where: Form15CbWhereUniqueInput;
};


export type MutationUpsertOneGroupArgs = {
  create: GroupCreateInput;
  update: GroupUpdateInput;
  where: GroupWhereUniqueInput;
};


export type MutationUpsertOneRequestArgs = {
  create: RequestCreateInput;
  update: RequestUpdateInput;
  where: RequestWhereUniqueInput;
};


export type MutationUpsertOneUdinArgs = {
  create: UdinCreateInput;
  update: UdinUpdateInput;
  where: UdinWhereUniqueInput;
};


export type MutationUpsertOneUserArgs = {
  create: UserCreateInput;
  update: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpsertOneUserAccessArgs = {
  create: UserAccessCreateInput;
  update: UserAccessUpdateInput;
  where: UserAccessWhereUniqueInput;
};


export type MutationValidateConfirmTokenArgs = {
  token: Scalars['String'];
};

export type NestedBoolFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedBoolNullableFilter>;
  _min?: Maybe<NestedBoolNullableFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedBoolFilter>;
  _min?: Maybe<NestedBoolFilter>;
  equals?: Maybe<Scalars['Boolean']>;
  not?: Maybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedDateTimeNullableFilter>;
  _min?: Maybe<NestedDateTimeNullableFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedDateTimeFilter>;
  _min?: Maybe<NestedDateTimeFilter>;
  equals?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  not?: Maybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedFloatFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedFloatNullableFilter>;
  _min?: Maybe<NestedFloatNullableFilter>;
  _sum?: Maybe<NestedFloatNullableFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedFloatFilter>;
  _min?: Maybe<NestedFloatFilter>;
  _sum?: Maybe<NestedFloatFilter>;
  equals?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  not?: Maybe<NestedFloatWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatNullableFilter>;
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedIntNullableFilter>;
  _min?: Maybe<NestedIntNullableFilter>;
  _sum?: Maybe<NestedIntNullableFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: Maybe<NestedFloatFilter>;
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedIntFilter>;
  _min?: Maybe<NestedIntFilter>;
  _sum?: Maybe<NestedIntFilter>;
  equals?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<NestedIntWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['DateTime']>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Float']>;
  divide?: Maybe<Scalars['Float']>;
  increment?: Maybe<Scalars['Float']>;
  multiply?: Maybe<Scalars['Float']>;
  set?: Maybe<Scalars['Float']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: Maybe<Scalars['Int']>;
  divide?: Maybe<Scalars['Int']>;
  increment?: Maybe<Scalars['Int']>;
  multiply?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  aggregateBankDetail: AggregateBankDetail;
  aggregateBenefeciary: AggregateBenefeciary;
  aggregateBeneficiaryCertificate: AggregateBeneficiaryCertificate;
  aggregateBranch: AggregateBranch;
  aggregateCAFirm: AggregateCaFirm;
  aggregateCompany: AggregateCompany;
  aggregateDocument: AggregateDocument;
  aggregateEvents: AggregateEvents;
  aggregateFile: AggregateFile;
  aggregateFolioNumber: AggregateFolioNumber;
  aggregateForm15CAA: AggregateForm15Caa;
  aggregateForm15CAB: AggregateForm15Cab;
  aggregateForm15CAC: AggregateForm15Cac;
  aggregateForm15CAD: AggregateForm15Cad;
  aggregateForm15CB: AggregateForm15Cb;
  aggregateGroup: AggregateGroup;
  aggregateRequest: AggregateRequest;
  aggregateUdin: AggregateUdin;
  aggregateUser: AggregateUser;
  aggregateUserAccess: AggregateUserAccess;
  bankDetail?: Maybe<BankDetail>;
  bankDetails: Array<BankDetail>;
  benefeciaries: Array<Benefeciary>;
  benefeciary?: Maybe<Benefeciary>;
  beneficiaryCertificate?: Maybe<BeneficiaryCertificate>;
  beneficiaryCertificates: Array<BeneficiaryCertificate>;
  branch?: Maybe<Branch>;
  branches: Array<Branch>;
  cAFirm?: Maybe<CaFirm>;
  cAFirms: Array<CaFirm>;
  companies: Array<Company>;
  company?: Maybe<Company>;
  document?: Maybe<Document>;
  documents: Array<Document>;
  file?: Maybe<File>;
  files: Array<File>;
  findFirstBankDetail?: Maybe<BankDetail>;
  findFirstBenefeciary?: Maybe<Benefeciary>;
  findFirstBeneficiaryCertificate?: Maybe<BeneficiaryCertificate>;
  findFirstBranch?: Maybe<Branch>;
  findFirstCAFirm?: Maybe<CaFirm>;
  findFirstCompany?: Maybe<Company>;
  findFirstDocument?: Maybe<Document>;
  findFirstEvents?: Maybe<Events>;
  findFirstFile?: Maybe<File>;
  findFirstFolioNumber?: Maybe<FolioNumber>;
  findFirstForm15CAA?: Maybe<Form15Caa>;
  findFirstForm15CAB?: Maybe<Form15Cab>;
  findFirstForm15CAC?: Maybe<Form15Cac>;
  findFirstForm15CAD?: Maybe<Form15Cad>;
  findFirstForm15CB?: Maybe<Form15Cb>;
  findFirstGroup?: Maybe<Group>;
  findFirstRequest?: Maybe<Request>;
  findFirstUdin?: Maybe<Udin>;
  findFirstUser?: Maybe<User>;
  findFirstUserAccess?: Maybe<UserAccess>;
  findManyEvents: Array<Events>;
  findUniqueEvents?: Maybe<Events>;
  folioNumber?: Maybe<FolioNumber>;
  folioNumbers: Array<FolioNumber>;
  form15CAA?: Maybe<Form15Caa>;
  form15CAAS: Array<Form15Caa>;
  form15CAB?: Maybe<Form15Cab>;
  form15CABS: Array<Form15Cab>;
  form15CAC?: Maybe<Form15Cac>;
  form15CACS: Array<Form15Cac>;
  form15CAD?: Maybe<Form15Cad>;
  form15CADS: Array<Form15Cad>;
  form15CB?: Maybe<Form15Cb>;
  form15CBS: Array<Form15Cb>;
  group?: Maybe<Group>;
  groupByBankDetail: Array<BankDetailGroupBy>;
  groupByBenefeciary: Array<BenefeciaryGroupBy>;
  groupByBeneficiaryCertificate: Array<BeneficiaryCertificateGroupBy>;
  groupByBranch: Array<BranchGroupBy>;
  groupByCAFirm: Array<CaFirmGroupBy>;
  groupByCompany: Array<CompanyGroupBy>;
  groupByDocument: Array<DocumentGroupBy>;
  groupByEvents: Array<EventsGroupBy>;
  groupByFile: Array<FileGroupBy>;
  groupByFolioNumber: Array<FolioNumberGroupBy>;
  groupByForm15CAA: Array<Form15CaaGroupBy>;
  groupByForm15CAB: Array<Form15CabGroupBy>;
  groupByForm15CAC: Array<Form15CacGroupBy>;
  groupByForm15CAD: Array<Form15CadGroupBy>;
  groupByForm15CB: Array<Form15CbGroupBy>;
  groupByGroup: Array<GroupGroupBy>;
  groupByRequest: Array<RequestGroupBy>;
  groupByUdin: Array<UdinGroupBy>;
  groupByUser: Array<UserGroupBy>;
  groupByUserAccess: Array<UserAccessGroupBy>;
  groups: Array<Group>;
  request?: Maybe<Request>;
  requests: Array<Request>;
  udin?: Maybe<Udin>;
  udins: Array<Udin>;
  user?: Maybe<User>;
  userAccess?: Maybe<UserAccess>;
  userAccesses: Array<UserAccess>;
  users: Array<User>;
};


export type QueryAggregateBankDetailArgs = {
  cursor?: Maybe<BankDetailWhereUniqueInput>;
  orderBy?: Maybe<Array<BankDetailOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BankDetailWhereInput>;
};


export type QueryAggregateBenefeciaryArgs = {
  cursor?: Maybe<BenefeciaryWhereUniqueInput>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type QueryAggregateBeneficiaryCertificateArgs = {
  cursor?: Maybe<BeneficiaryCertificateWhereUniqueInput>;
  orderBy?: Maybe<Array<BeneficiaryCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BeneficiaryCertificateWhereInput>;
};


export type QueryAggregateBranchArgs = {
  cursor?: Maybe<BranchWhereUniqueInput>;
  orderBy?: Maybe<Array<BranchOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BranchWhereInput>;
};


export type QueryAggregateCaFirmArgs = {
  cursor?: Maybe<CaFirmWhereUniqueInput>;
  orderBy?: Maybe<Array<CaFirmOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CaFirmWhereInput>;
};


export type QueryAggregateCompanyArgs = {
  cursor?: Maybe<CompanyWhereUniqueInput>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CompanyWhereInput>;
};


export type QueryAggregateDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type QueryAggregateEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};


export type QueryAggregateFileArgs = {
  cursor?: Maybe<FileWhereUniqueInput>;
  orderBy?: Maybe<Array<FileOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FileWhereInput>;
};


export type QueryAggregateFolioNumberArgs = {
  cursor?: Maybe<FolioNumberWhereUniqueInput>;
  orderBy?: Maybe<Array<FolioNumberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FolioNumberWhereInput>;
};


export type QueryAggregateForm15CaaArgs = {
  cursor?: Maybe<Form15CaaWhereUniqueInput>;
  orderBy?: Maybe<Array<Form15CaaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CaaWhereInput>;
};


export type QueryAggregateForm15CabArgs = {
  cursor?: Maybe<Form15CabWhereUniqueInput>;
  orderBy?: Maybe<Array<Form15CabOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CabWhereInput>;
};


export type QueryAggregateForm15CacArgs = {
  cursor?: Maybe<Form15CacWhereUniqueInput>;
  orderBy?: Maybe<Array<Form15CacOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CacWhereInput>;
};


export type QueryAggregateForm15CadArgs = {
  cursor?: Maybe<Form15CadWhereUniqueInput>;
  orderBy?: Maybe<Array<Form15CadOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CadWhereInput>;
};


export type QueryAggregateForm15CbArgs = {
  cursor?: Maybe<Form15CbWhereUniqueInput>;
  orderBy?: Maybe<Array<Form15CbOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CbWhereInput>;
};


export type QueryAggregateGroupArgs = {
  cursor?: Maybe<GroupWhereUniqueInput>;
  orderBy?: Maybe<Array<GroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GroupWhereInput>;
};


export type QueryAggregateRequestArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type QueryAggregateUdinArgs = {
  cursor?: Maybe<UdinWhereUniqueInput>;
  orderBy?: Maybe<Array<UdinOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UdinWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type QueryAggregateUserAccessArgs = {
  cursor?: Maybe<UserAccessWhereUniqueInput>;
  orderBy?: Maybe<Array<UserAccessOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};


export type QueryBankDetailArgs = {
  where: BankDetailWhereUniqueInput;
};


export type QueryBankDetailsArgs = {
  cursor?: Maybe<BankDetailWhereUniqueInput>;
  distinct?: Maybe<Array<BankDetailScalarFieldEnum>>;
  orderBy?: Maybe<Array<BankDetailOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BankDetailWhereInput>;
};


export type QueryBenefeciariesArgs = {
  cursor?: Maybe<BenefeciaryWhereUniqueInput>;
  distinct?: Maybe<Array<BenefeciaryScalarFieldEnum>>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type QueryBenefeciaryArgs = {
  where: BenefeciaryWhereUniqueInput;
};


export type QueryBeneficiaryCertificateArgs = {
  where: BeneficiaryCertificateWhereUniqueInput;
};


export type QueryBeneficiaryCertificatesArgs = {
  cursor?: Maybe<BeneficiaryCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<BeneficiaryCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<BeneficiaryCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BeneficiaryCertificateWhereInput>;
};


export type QueryBranchArgs = {
  where: BranchWhereUniqueInput;
};


export type QueryBranchesArgs = {
  cursor?: Maybe<BranchWhereUniqueInput>;
  distinct?: Maybe<Array<BranchScalarFieldEnum>>;
  orderBy?: Maybe<Array<BranchOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BranchWhereInput>;
};


export type QueryCaFirmArgs = {
  where: CaFirmWhereUniqueInput;
};


export type QueryCaFirmsArgs = {
  cursor?: Maybe<CaFirmWhereUniqueInput>;
  distinct?: Maybe<Array<CaFirmScalarFieldEnum>>;
  orderBy?: Maybe<Array<CaFirmOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CaFirmWhereInput>;
};


export type QueryCompaniesArgs = {
  cursor?: Maybe<CompanyWhereUniqueInput>;
  distinct?: Maybe<Array<CompanyScalarFieldEnum>>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CompanyWhereInput>;
};


export type QueryCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type QueryDocumentArgs = {
  where: DocumentWhereUniqueInput;
};


export type QueryDocumentsArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type QueryFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryFilesArgs = {
  cursor?: Maybe<FileWhereUniqueInput>;
  distinct?: Maybe<Array<FileScalarFieldEnum>>;
  orderBy?: Maybe<Array<FileOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FileWhereInput>;
};


export type QueryFindFirstBankDetailArgs = {
  cursor?: Maybe<BankDetailWhereUniqueInput>;
  distinct?: Maybe<Array<BankDetailScalarFieldEnum>>;
  orderBy?: Maybe<Array<BankDetailOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BankDetailWhereInput>;
};


export type QueryFindFirstBenefeciaryArgs = {
  cursor?: Maybe<BenefeciaryWhereUniqueInput>;
  distinct?: Maybe<Array<BenefeciaryScalarFieldEnum>>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type QueryFindFirstBeneficiaryCertificateArgs = {
  cursor?: Maybe<BeneficiaryCertificateWhereUniqueInput>;
  distinct?: Maybe<Array<BeneficiaryCertificateScalarFieldEnum>>;
  orderBy?: Maybe<Array<BeneficiaryCertificateOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BeneficiaryCertificateWhereInput>;
};


export type QueryFindFirstBranchArgs = {
  cursor?: Maybe<BranchWhereUniqueInput>;
  distinct?: Maybe<Array<BranchScalarFieldEnum>>;
  orderBy?: Maybe<Array<BranchOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BranchWhereInput>;
};


export type QueryFindFirstCaFirmArgs = {
  cursor?: Maybe<CaFirmWhereUniqueInput>;
  distinct?: Maybe<Array<CaFirmScalarFieldEnum>>;
  orderBy?: Maybe<Array<CaFirmOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CaFirmWhereInput>;
};


export type QueryFindFirstCompanyArgs = {
  cursor?: Maybe<CompanyWhereUniqueInput>;
  distinct?: Maybe<Array<CompanyScalarFieldEnum>>;
  orderBy?: Maybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CompanyWhereInput>;
};


export type QueryFindFirstDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type QueryFindFirstEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};


export type QueryFindFirstFileArgs = {
  cursor?: Maybe<FileWhereUniqueInput>;
  distinct?: Maybe<Array<FileScalarFieldEnum>>;
  orderBy?: Maybe<Array<FileOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FileWhereInput>;
};


export type QueryFindFirstFolioNumberArgs = {
  cursor?: Maybe<FolioNumberWhereUniqueInput>;
  distinct?: Maybe<Array<FolioNumberScalarFieldEnum>>;
  orderBy?: Maybe<Array<FolioNumberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FolioNumberWhereInput>;
};


export type QueryFindFirstForm15CaaArgs = {
  cursor?: Maybe<Form15CaaWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CaaScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CaaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CaaWhereInput>;
};


export type QueryFindFirstForm15CabArgs = {
  cursor?: Maybe<Form15CabWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CabScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CabOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CabWhereInput>;
};


export type QueryFindFirstForm15CacArgs = {
  cursor?: Maybe<Form15CacWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CacScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CacOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CacWhereInput>;
};


export type QueryFindFirstForm15CadArgs = {
  cursor?: Maybe<Form15CadWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CadScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CadOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CadWhereInput>;
};


export type QueryFindFirstForm15CbArgs = {
  cursor?: Maybe<Form15CbWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CbScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CbOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CbWhereInput>;
};


export type QueryFindFirstGroupArgs = {
  cursor?: Maybe<GroupWhereUniqueInput>;
  distinct?: Maybe<Array<GroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<GroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GroupWhereInput>;
};


export type QueryFindFirstRequestArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  distinct?: Maybe<Array<RequestScalarFieldEnum>>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type QueryFindFirstUdinArgs = {
  cursor?: Maybe<UdinWhereUniqueInput>;
  distinct?: Maybe<Array<UdinScalarFieldEnum>>;
  orderBy?: Maybe<Array<UdinOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UdinWhereInput>;
};


export type QueryFindFirstUserArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type QueryFindFirstUserAccessArgs = {
  cursor?: Maybe<UserAccessWhereUniqueInput>;
  distinct?: Maybe<Array<UserAccessScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserAccessOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};


export type QueryFindManyEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};


export type QueryFindUniqueEventsArgs = {
  where: EventsWhereUniqueInput;
};


export type QueryFolioNumberArgs = {
  where: FolioNumberWhereUniqueInput;
};


export type QueryFolioNumbersArgs = {
  cursor?: Maybe<FolioNumberWhereUniqueInput>;
  distinct?: Maybe<Array<FolioNumberScalarFieldEnum>>;
  orderBy?: Maybe<Array<FolioNumberOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FolioNumberWhereInput>;
};


export type QueryForm15CaaArgs = {
  where: Form15CaaWhereUniqueInput;
};


export type QueryForm15CaasArgs = {
  cursor?: Maybe<Form15CaaWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CaaScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CaaOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CaaWhereInput>;
};


export type QueryForm15CabArgs = {
  where: Form15CabWhereUniqueInput;
};


export type QueryForm15CabsArgs = {
  cursor?: Maybe<Form15CabWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CabScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CabOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CabWhereInput>;
};


export type QueryForm15CacArgs = {
  where: Form15CacWhereUniqueInput;
};


export type QueryForm15CacsArgs = {
  cursor?: Maybe<Form15CacWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CacScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CacOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CacWhereInput>;
};


export type QueryForm15CadArgs = {
  where: Form15CadWhereUniqueInput;
};


export type QueryForm15CadsArgs = {
  cursor?: Maybe<Form15CadWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CadScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CadOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CadWhereInput>;
};


export type QueryForm15CbArgs = {
  where: Form15CbWhereUniqueInput;
};


export type QueryForm15CbsArgs = {
  cursor?: Maybe<Form15CbWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CbScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CbOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CbWhereInput>;
};


export type QueryGroupArgs = {
  where: GroupWhereUniqueInput;
};


export type QueryGroupByBankDetailArgs = {
  by: Array<BankDetailScalarFieldEnum>;
  having?: Maybe<BankDetailScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<BankDetailOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BankDetailWhereInput>;
};


export type QueryGroupByBenefeciaryArgs = {
  by: Array<BenefeciaryScalarFieldEnum>;
  having?: Maybe<BenefeciaryScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BenefeciaryWhereInput>;
};


export type QueryGroupByBeneficiaryCertificateArgs = {
  by: Array<BeneficiaryCertificateScalarFieldEnum>;
  having?: Maybe<BeneficiaryCertificateScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<BeneficiaryCertificateOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BeneficiaryCertificateWhereInput>;
};


export type QueryGroupByBranchArgs = {
  by: Array<BranchScalarFieldEnum>;
  having?: Maybe<BranchScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<BranchOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<BranchWhereInput>;
};


export type QueryGroupByCaFirmArgs = {
  by: Array<CaFirmScalarFieldEnum>;
  having?: Maybe<CaFirmScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<CaFirmOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CaFirmWhereInput>;
};


export type QueryGroupByCompanyArgs = {
  by: Array<CompanyScalarFieldEnum>;
  having?: Maybe<CompanyScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<CompanyOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<CompanyWhereInput>;
};


export type QueryGroupByDocumentArgs = {
  by: Array<DocumentScalarFieldEnum>;
  having?: Maybe<DocumentScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<DocumentOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};


export type QueryGroupByEventsArgs = {
  by: Array<EventsScalarFieldEnum>;
  having?: Maybe<EventsScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<EventsOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};


export type QueryGroupByFileArgs = {
  by: Array<FileScalarFieldEnum>;
  having?: Maybe<FileScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<FileOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FileWhereInput>;
};


export type QueryGroupByFolioNumberArgs = {
  by: Array<FolioNumberScalarFieldEnum>;
  having?: Maybe<FolioNumberScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<FolioNumberOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<FolioNumberWhereInput>;
};


export type QueryGroupByForm15CaaArgs = {
  by: Array<Form15CaaScalarFieldEnum>;
  having?: Maybe<Form15CaaScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<Form15CaaOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CaaWhereInput>;
};


export type QueryGroupByForm15CabArgs = {
  by: Array<Form15CabScalarFieldEnum>;
  having?: Maybe<Form15CabScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<Form15CabOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CabWhereInput>;
};


export type QueryGroupByForm15CacArgs = {
  by: Array<Form15CacScalarFieldEnum>;
  having?: Maybe<Form15CacScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<Form15CacOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CacWhereInput>;
};


export type QueryGroupByForm15CadArgs = {
  by: Array<Form15CadScalarFieldEnum>;
  having?: Maybe<Form15CadScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<Form15CadOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CadWhereInput>;
};


export type QueryGroupByForm15CbArgs = {
  by: Array<Form15CbScalarFieldEnum>;
  having?: Maybe<Form15CbScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<Form15CbOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CbWhereInput>;
};


export type QueryGroupByGroupArgs = {
  by: Array<GroupScalarFieldEnum>;
  having?: Maybe<GroupScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<GroupOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GroupWhereInput>;
};


export type QueryGroupByRequestArgs = {
  by: Array<RequestScalarFieldEnum>;
  having?: Maybe<RequestScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<RequestOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type QueryGroupByUdinArgs = {
  by: Array<UdinScalarFieldEnum>;
  having?: Maybe<UdinScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<UdinOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UdinWhereInput>;
};


export type QueryGroupByUserArgs = {
  by: Array<UserScalarFieldEnum>;
  having?: Maybe<UserScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<UserOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};


export type QueryGroupByUserAccessArgs = {
  by: Array<UserAccessScalarFieldEnum>;
  having?: Maybe<UserAccessScalarWhereWithAggregatesInput>;
  orderBy?: Maybe<Array<UserAccessOrderByWithAggregationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};


export type QueryGroupsArgs = {
  cursor?: Maybe<GroupWhereUniqueInput>;
  distinct?: Maybe<Array<GroupScalarFieldEnum>>;
  orderBy?: Maybe<Array<GroupOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<GroupWhereInput>;
};


export type QueryRequestArgs = {
  where: RequestWhereUniqueInput;
};


export type QueryRequestsArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  distinct?: Maybe<Array<RequestScalarFieldEnum>>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type QueryUdinArgs = {
  where: UdinWhereUniqueInput;
};


export type QueryUdinsArgs = {
  cursor?: Maybe<UdinWhereUniqueInput>;
  distinct?: Maybe<Array<UdinScalarFieldEnum>>;
  orderBy?: Maybe<Array<UdinOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UdinWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserAccessArgs = {
  where: UserAccessWhereUniqueInput;
};


export type QueryUserAccessesArgs = {
  cursor?: Maybe<UserAccessWhereUniqueInput>;
  distinct?: Maybe<Array<UserAccessScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserAccessOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};


export type QueryUsersArgs = {
  cursor?: Maybe<UserWhereUniqueInput>;
  distinct?: Maybe<Array<UserScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserWhereInput>;
};

export type Request = {
  __typename?: 'Request';
  Beneficiary?: Maybe<Benefeciary>;
  BeneficiaryId?: Maybe<Scalars['Int']>;
  Branch?: Maybe<Branch>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  Company: Company;
  CompanyId: Scalars['Int'];
  Document: Array<Document>;
  Form15CB?: Maybe<Form15Cb>;
  Group: Group;
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: User;
  UserId: Scalars['Int'];
  _count?: Maybe<RequestCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};


export type RequestDocumentArgs = {
  cursor?: Maybe<DocumentWhereUniqueInput>;
  distinct?: Maybe<Array<DocumentScalarFieldEnum>>;
  orderBy?: Maybe<Array<DocumentOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<DocumentWhereInput>;
};

export type RequestAvgAggregate = {
  __typename?: 'RequestAvgAggregate';
  BeneficiaryId?: Maybe<Scalars['Float']>;
  BranchId?: Maybe<Scalars['Float']>;
  CompanyId?: Maybe<Scalars['Float']>;
  GroupId?: Maybe<Scalars['Float']>;
  UserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type RequestAvgOrderByAggregateInput = {
  BeneficiaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type RequestCount = {
  __typename?: 'RequestCount';
  Document: Scalars['Int'];
};

export type RequestCountAggregate = {
  __typename?: 'RequestCountAggregate';
  BeneficiaryId: Scalars['Int'];
  BranchId: Scalars['Int'];
  Comment: Scalars['Int'];
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Int'];
  ProposedDate: Scalars['Int'];
  Remarks: Scalars['Int'];
  Status: Scalars['Int'];
  UserId: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type RequestCountOrderByAggregateInput = {
  BeneficiaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Comment?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsNewBeneficiary?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  Remarks?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RequestCreateInput = {
  Beneficiary?: Maybe<BenefeciaryCreateNestedOneWithoutRequestInput>;
  Branch?: Maybe<BranchCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Company: CompanyCreateNestedOneWithoutRequestInput;
  Document?: Maybe<DocumentCreateNestedManyWithoutRequestInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutRequestInput>;
  Group: GroupCreateNestedOneWithoutRequestInput;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: UserCreateNestedOneWithoutRequestInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateManyBeneficiaryInput = {
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  UserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateManyBeneficiaryInputEnvelope = {
  data: Array<RequestCreateManyBeneficiaryInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RequestCreateManyBranchInput = {
  BeneficiaryId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  UserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateManyBranchInputEnvelope = {
  data: Array<RequestCreateManyBranchInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RequestCreateManyCompanyInput = {
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  UserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateManyCompanyInputEnvelope = {
  data: Array<RequestCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RequestCreateManyGroupInput = {
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  UserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateManyGroupInputEnvelope = {
  data: Array<RequestCreateManyGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RequestCreateManyInput = {
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  UserId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateManyUserInput = {
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateManyUserInputEnvelope = {
  data: Array<RequestCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type RequestCreateNestedManyWithoutBeneficiaryInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<RequestCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<RequestCreateManyBeneficiaryInputEnvelope>;
};

export type RequestCreateNestedManyWithoutBranchInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<RequestCreateWithoutBranchInput>>;
  createMany?: Maybe<RequestCreateManyBranchInputEnvelope>;
};

export type RequestCreateNestedManyWithoutCompanyInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<RequestCreateWithoutCompanyInput>>;
  createMany?: Maybe<RequestCreateManyCompanyInputEnvelope>;
};

export type RequestCreateNestedManyWithoutGroupInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<RequestCreateWithoutGroupInput>>;
  createMany?: Maybe<RequestCreateManyGroupInputEnvelope>;
};

export type RequestCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<RequestCreateWithoutUserInput>>;
  createMany?: Maybe<RequestCreateManyUserInputEnvelope>;
};

export type RequestCreateNestedOneWithoutDocumentInput = {
  connect?: Maybe<RequestWhereUniqueInput>;
  connectOrCreate?: Maybe<RequestCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<RequestCreateWithoutDocumentInput>;
};

export type RequestCreateNestedOneWithoutForm15CbInput = {
  connect?: Maybe<RequestWhereUniqueInput>;
  connectOrCreate?: Maybe<RequestCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<RequestCreateWithoutForm15CbInput>;
};

export type RequestCreateOrConnectWithoutBeneficiaryInput = {
  create: RequestCreateWithoutBeneficiaryInput;
  where: RequestWhereUniqueInput;
};

export type RequestCreateOrConnectWithoutBranchInput = {
  create: RequestCreateWithoutBranchInput;
  where: RequestWhereUniqueInput;
};

export type RequestCreateOrConnectWithoutCompanyInput = {
  create: RequestCreateWithoutCompanyInput;
  where: RequestWhereUniqueInput;
};

export type RequestCreateOrConnectWithoutDocumentInput = {
  create: RequestCreateWithoutDocumentInput;
  where: RequestWhereUniqueInput;
};

export type RequestCreateOrConnectWithoutForm15CbInput = {
  create: RequestCreateWithoutForm15CbInput;
  where: RequestWhereUniqueInput;
};

export type RequestCreateOrConnectWithoutGroupInput = {
  create: RequestCreateWithoutGroupInput;
  where: RequestWhereUniqueInput;
};

export type RequestCreateOrConnectWithoutUserInput = {
  create: RequestCreateWithoutUserInput;
  where: RequestWhereUniqueInput;
};

export type RequestCreateWithoutBeneficiaryInput = {
  Branch?: Maybe<BranchCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Company: CompanyCreateNestedOneWithoutRequestInput;
  Document?: Maybe<DocumentCreateNestedManyWithoutRequestInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutRequestInput>;
  Group: GroupCreateNestedOneWithoutRequestInput;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: UserCreateNestedOneWithoutRequestInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateWithoutBranchInput = {
  Beneficiary?: Maybe<BenefeciaryCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Company: CompanyCreateNestedOneWithoutRequestInput;
  Document?: Maybe<DocumentCreateNestedManyWithoutRequestInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutRequestInput>;
  Group: GroupCreateNestedOneWithoutRequestInput;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: UserCreateNestedOneWithoutRequestInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateWithoutCompanyInput = {
  Beneficiary?: Maybe<BenefeciaryCreateNestedOneWithoutRequestInput>;
  Branch?: Maybe<BranchCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Document?: Maybe<DocumentCreateNestedManyWithoutRequestInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutRequestInput>;
  Group: GroupCreateNestedOneWithoutRequestInput;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: UserCreateNestedOneWithoutRequestInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateWithoutDocumentInput = {
  Beneficiary?: Maybe<BenefeciaryCreateNestedOneWithoutRequestInput>;
  Branch?: Maybe<BranchCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Company: CompanyCreateNestedOneWithoutRequestInput;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutRequestInput>;
  Group: GroupCreateNestedOneWithoutRequestInput;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: UserCreateNestedOneWithoutRequestInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateWithoutForm15CbInput = {
  Beneficiary?: Maybe<BenefeciaryCreateNestedOneWithoutRequestInput>;
  Branch?: Maybe<BranchCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Company: CompanyCreateNestedOneWithoutRequestInput;
  Document?: Maybe<DocumentCreateNestedManyWithoutRequestInput>;
  Group: GroupCreateNestedOneWithoutRequestInput;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: UserCreateNestedOneWithoutRequestInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateWithoutGroupInput = {
  Beneficiary?: Maybe<BenefeciaryCreateNestedOneWithoutRequestInput>;
  Branch?: Maybe<BranchCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Company: CompanyCreateNestedOneWithoutRequestInput;
  Document?: Maybe<DocumentCreateNestedManyWithoutRequestInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutRequestInput>;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  User: UserCreateNestedOneWithoutRequestInput;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCreateWithoutUserInput = {
  Beneficiary?: Maybe<BenefeciaryCreateNestedOneWithoutRequestInput>;
  Branch?: Maybe<BranchCreateNestedOneWithoutRequestInput>;
  Comment?: Maybe<Scalars['String']>;
  Company: CompanyCreateNestedOneWithoutRequestInput;
  Document?: Maybe<DocumentCreateNestedManyWithoutRequestInput>;
  Form15CB?: Maybe<Form15CbCreateNestedOneWithoutRequestInput>;
  Group: GroupCreateNestedOneWithoutRequestInput;
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestGroupBy = {
  __typename?: 'RequestGroupBy';
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  IsNewBeneficiary: Scalars['Boolean'];
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  UserId: Scalars['Int'];
  _avg?: Maybe<RequestAvgAggregate>;
  _count?: Maybe<RequestCountAggregate>;
  _max?: Maybe<RequestMaxAggregate>;
  _min?: Maybe<RequestMinAggregate>;
  _sum?: Maybe<RequestSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type RequestListRelationFilter = {
  every?: Maybe<RequestWhereInput>;
  none?: Maybe<RequestWhereInput>;
  some?: Maybe<RequestWhereInput>;
};

export type RequestMaxAggregate = {
  __typename?: 'RequestMaxAggregate';
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  IsNewBeneficiary?: Maybe<Scalars['Boolean']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  UserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestMaxOrderByAggregateInput = {
  BeneficiaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Comment?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsNewBeneficiary?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  Remarks?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RequestMinAggregate = {
  __typename?: 'RequestMinAggregate';
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  Comment?: Maybe<Scalars['String']>;
  CompanyId?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  IsNewBeneficiary?: Maybe<Scalars['Boolean']>;
  ProposedDate?: Maybe<Scalars['DateTime']>;
  Remarks?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  UserId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestMinOrderByAggregateInput = {
  BeneficiaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Comment?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsNewBeneficiary?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  Remarks?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RequestOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type RequestOrderByWithAggregationInput = {
  BeneficiaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  Comment?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsNewBeneficiary?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  Remarks?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  _avg?: Maybe<RequestAvgOrderByAggregateInput>;
  _count?: Maybe<RequestCountOrderByAggregateInput>;
  _max?: Maybe<RequestMaxOrderByAggregateInput>;
  _min?: Maybe<RequestMinOrderByAggregateInput>;
  _sum?: Maybe<RequestSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RequestOrderByWithRelationInput = {
  Beneficiary?: Maybe<BenefeciaryOrderByWithRelationInput>;
  BeneficiaryId?: Maybe<SortOrder>;
  Branch?: Maybe<BranchOrderByWithRelationInput>;
  BranchId?: Maybe<SortOrder>;
  Comment?: Maybe<SortOrder>;
  Company?: Maybe<CompanyOrderByWithRelationInput>;
  CompanyId?: Maybe<SortOrder>;
  Document?: Maybe<DocumentOrderByRelationAggregateInput>;
  Form15CB?: Maybe<Form15CbOrderByWithRelationInput>;
  Group?: Maybe<GroupOrderByWithRelationInput>;
  GroupId?: Maybe<SortOrder>;
  IsNewBeneficiary?: Maybe<SortOrder>;
  ProposedDate?: Maybe<SortOrder>;
  Remarks?: Maybe<SortOrder>;
  Status?: Maybe<SortOrder>;
  User?: Maybe<UserOrderByWithRelationInput>;
  UserId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type RequestRelationFilter = {
  is?: Maybe<RequestWhereInput>;
  isNot?: Maybe<RequestWhereInput>;
};

export enum RequestScalarFieldEnum {
  BeneficiaryId = 'BeneficiaryId',
  BranchId = 'BranchId',
  Comment = 'Comment',
  CompanyId = 'CompanyId',
  GroupId = 'GroupId',
  IsNewBeneficiary = 'IsNewBeneficiary',
  ProposedDate = 'ProposedDate',
  Remarks = 'Remarks',
  Status = 'Status',
  UserId = 'UserId',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type RequestScalarWhereInput = {
  AND?: Maybe<Array<RequestScalarWhereInput>>;
  BeneficiaryId?: Maybe<IntNullableFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  Comment?: Maybe<StringNullableFilter>;
  CompanyId?: Maybe<IntFilter>;
  GroupId?: Maybe<IntFilter>;
  IsNewBeneficiary?: Maybe<BoolFilter>;
  NOT?: Maybe<Array<RequestScalarWhereInput>>;
  OR?: Maybe<Array<RequestScalarWhereInput>>;
  ProposedDate?: Maybe<DateTimeNullableFilter>;
  Remarks?: Maybe<StringNullableFilter>;
  Status?: Maybe<StringFilter>;
  UserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type RequestScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<RequestScalarWhereWithAggregatesInput>>;
  BeneficiaryId?: Maybe<IntNullableWithAggregatesFilter>;
  BranchId?: Maybe<IntNullableWithAggregatesFilter>;
  Comment?: Maybe<StringNullableWithAggregatesFilter>;
  CompanyId?: Maybe<IntWithAggregatesFilter>;
  GroupId?: Maybe<IntWithAggregatesFilter>;
  IsNewBeneficiary?: Maybe<BoolWithAggregatesFilter>;
  NOT?: Maybe<Array<RequestScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<RequestScalarWhereWithAggregatesInput>>;
  ProposedDate?: Maybe<DateTimeNullableWithAggregatesFilter>;
  Remarks?: Maybe<StringNullableWithAggregatesFilter>;
  Status?: Maybe<StringWithAggregatesFilter>;
  UserId?: Maybe<IntWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type RequestSumAggregate = {
  __typename?: 'RequestSumAggregate';
  BeneficiaryId?: Maybe<Scalars['Int']>;
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  UserId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type RequestSumOrderByAggregateInput = {
  BeneficiaryId?: Maybe<SortOrder>;
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type RequestUpdateInput = {
  Beneficiary?: Maybe<BenefeciaryUpdateOneWithoutRequestNestedInput>;
  Branch?: Maybe<BranchUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutRequestNestedInput>;
  Document?: Maybe<DocumentUpdateManyWithoutRequestNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutRequestNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutRequestNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateManyMutationInput = {
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateManyWithWhereWithoutBeneficiaryInput = {
  data: RequestUpdateManyMutationInput;
  where: RequestScalarWhereInput;
};

export type RequestUpdateManyWithWhereWithoutBranchInput = {
  data: RequestUpdateManyMutationInput;
  where: RequestScalarWhereInput;
};

export type RequestUpdateManyWithWhereWithoutCompanyInput = {
  data: RequestUpdateManyMutationInput;
  where: RequestScalarWhereInput;
};

export type RequestUpdateManyWithWhereWithoutGroupInput = {
  data: RequestUpdateManyMutationInput;
  where: RequestScalarWhereInput;
};

export type RequestUpdateManyWithWhereWithoutUserInput = {
  data: RequestUpdateManyMutationInput;
  where: RequestScalarWhereInput;
};

export type RequestUpdateManyWithoutBeneficiaryNestedInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutBeneficiaryInput>>;
  create?: Maybe<Array<RequestCreateWithoutBeneficiaryInput>>;
  createMany?: Maybe<RequestCreateManyBeneficiaryInputEnvelope>;
  delete?: Maybe<Array<RequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RequestScalarWhereInput>>;
  disconnect?: Maybe<Array<RequestWhereUniqueInput>>;
  set?: Maybe<Array<RequestWhereUniqueInput>>;
  update?: Maybe<Array<RequestUpdateWithWhereUniqueWithoutBeneficiaryInput>>;
  updateMany?: Maybe<Array<RequestUpdateManyWithWhereWithoutBeneficiaryInput>>;
  upsert?: Maybe<Array<RequestUpsertWithWhereUniqueWithoutBeneficiaryInput>>;
};

export type RequestUpdateManyWithoutBranchNestedInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<RequestCreateWithoutBranchInput>>;
  createMany?: Maybe<RequestCreateManyBranchInputEnvelope>;
  delete?: Maybe<Array<RequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RequestScalarWhereInput>>;
  disconnect?: Maybe<Array<RequestWhereUniqueInput>>;
  set?: Maybe<Array<RequestWhereUniqueInput>>;
  update?: Maybe<Array<RequestUpdateWithWhereUniqueWithoutBranchInput>>;
  updateMany?: Maybe<Array<RequestUpdateManyWithWhereWithoutBranchInput>>;
  upsert?: Maybe<Array<RequestUpsertWithWhereUniqueWithoutBranchInput>>;
};

export type RequestUpdateManyWithoutCompanyNestedInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<RequestCreateWithoutCompanyInput>>;
  createMany?: Maybe<RequestCreateManyCompanyInputEnvelope>;
  delete?: Maybe<Array<RequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RequestScalarWhereInput>>;
  disconnect?: Maybe<Array<RequestWhereUniqueInput>>;
  set?: Maybe<Array<RequestWhereUniqueInput>>;
  update?: Maybe<Array<RequestUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<RequestUpdateManyWithWhereWithoutCompanyInput>>;
  upsert?: Maybe<Array<RequestUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type RequestUpdateManyWithoutGroupNestedInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<RequestCreateWithoutGroupInput>>;
  createMany?: Maybe<RequestCreateManyGroupInputEnvelope>;
  delete?: Maybe<Array<RequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RequestScalarWhereInput>>;
  disconnect?: Maybe<Array<RequestWhereUniqueInput>>;
  set?: Maybe<Array<RequestWhereUniqueInput>>;
  update?: Maybe<Array<RequestUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: Maybe<Array<RequestUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: Maybe<Array<RequestUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type RequestUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<RequestWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<RequestCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<RequestCreateWithoutUserInput>>;
  createMany?: Maybe<RequestCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<RequestWhereUniqueInput>>;
  deleteMany?: Maybe<Array<RequestScalarWhereInput>>;
  disconnect?: Maybe<Array<RequestWhereUniqueInput>>;
  set?: Maybe<Array<RequestWhereUniqueInput>>;
  update?: Maybe<Array<RequestUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<RequestUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<RequestUpsertWithWhereUniqueWithoutUserInput>>;
};

export type RequestUpdateOneWithoutDocumentNestedInput = {
  connect?: Maybe<RequestWhereUniqueInput>;
  connectOrCreate?: Maybe<RequestCreateOrConnectWithoutDocumentInput>;
  create?: Maybe<RequestCreateWithoutDocumentInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<RequestUpdateWithoutDocumentInput>;
  upsert?: Maybe<RequestUpsertWithoutDocumentInput>;
};

export type RequestUpdateOneWithoutForm15CbNestedInput = {
  connect?: Maybe<RequestWhereUniqueInput>;
  connectOrCreate?: Maybe<RequestCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<RequestCreateWithoutForm15CbInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<RequestUpdateWithoutForm15CbInput>;
  upsert?: Maybe<RequestUpsertWithoutForm15CbInput>;
};

export type RequestUpdateWithWhereUniqueWithoutBeneficiaryInput = {
  data: RequestUpdateWithoutBeneficiaryInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpdateWithWhereUniqueWithoutBranchInput = {
  data: RequestUpdateWithoutBranchInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpdateWithWhereUniqueWithoutCompanyInput = {
  data: RequestUpdateWithoutCompanyInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpdateWithWhereUniqueWithoutGroupInput = {
  data: RequestUpdateWithoutGroupInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpdateWithWhereUniqueWithoutUserInput = {
  data: RequestUpdateWithoutUserInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpdateWithoutBeneficiaryInput = {
  Branch?: Maybe<BranchUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutRequestNestedInput>;
  Document?: Maybe<DocumentUpdateManyWithoutRequestNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutRequestNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutRequestNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateWithoutBranchInput = {
  Beneficiary?: Maybe<BenefeciaryUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutRequestNestedInput>;
  Document?: Maybe<DocumentUpdateManyWithoutRequestNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutRequestNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutRequestNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateWithoutCompanyInput = {
  Beneficiary?: Maybe<BenefeciaryUpdateOneWithoutRequestNestedInput>;
  Branch?: Maybe<BranchUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Document?: Maybe<DocumentUpdateManyWithoutRequestNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutRequestNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutRequestNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateWithoutDocumentInput = {
  Beneficiary?: Maybe<BenefeciaryUpdateOneWithoutRequestNestedInput>;
  Branch?: Maybe<BranchUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutRequestNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutRequestNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutRequestNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateWithoutForm15CbInput = {
  Beneficiary?: Maybe<BenefeciaryUpdateOneWithoutRequestNestedInput>;
  Branch?: Maybe<BranchUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutRequestNestedInput>;
  Document?: Maybe<DocumentUpdateManyWithoutRequestNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutRequestNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateWithoutGroupInput = {
  Beneficiary?: Maybe<BenefeciaryUpdateOneWithoutRequestNestedInput>;
  Branch?: Maybe<BranchUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutRequestNestedInput>;
  Document?: Maybe<DocumentUpdateManyWithoutRequestNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutRequestNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpdateWithoutUserInput = {
  Beneficiary?: Maybe<BenefeciaryUpdateOneWithoutRequestNestedInput>;
  Branch?: Maybe<BranchUpdateOneWithoutRequestNestedInput>;
  Comment?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutRequestNestedInput>;
  Document?: Maybe<DocumentUpdateManyWithoutRequestNestedInput>;
  Form15CB?: Maybe<Form15CbUpdateOneWithoutRequestNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutRequestNestedInput>;
  IsNewBeneficiary?: Maybe<BoolFieldUpdateOperationsInput>;
  ProposedDate?: Maybe<NullableDateTimeFieldUpdateOperationsInput>;
  Remarks?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Status?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestUpsertWithWhereUniqueWithoutBeneficiaryInput = {
  create: RequestCreateWithoutBeneficiaryInput;
  update: RequestUpdateWithoutBeneficiaryInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpsertWithWhereUniqueWithoutBranchInput = {
  create: RequestCreateWithoutBranchInput;
  update: RequestUpdateWithoutBranchInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpsertWithWhereUniqueWithoutCompanyInput = {
  create: RequestCreateWithoutCompanyInput;
  update: RequestUpdateWithoutCompanyInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpsertWithWhereUniqueWithoutGroupInput = {
  create: RequestCreateWithoutGroupInput;
  update: RequestUpdateWithoutGroupInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpsertWithWhereUniqueWithoutUserInput = {
  create: RequestCreateWithoutUserInput;
  update: RequestUpdateWithoutUserInput;
  where: RequestWhereUniqueInput;
};

export type RequestUpsertWithoutDocumentInput = {
  create: RequestCreateWithoutDocumentInput;
  update: RequestUpdateWithoutDocumentInput;
};

export type RequestUpsertWithoutForm15CbInput = {
  create: RequestCreateWithoutForm15CbInput;
  update: RequestUpdateWithoutForm15CbInput;
};

export type RequestWhereInput = {
  AND?: Maybe<Array<RequestWhereInput>>;
  Beneficiary?: Maybe<BenefeciaryRelationFilter>;
  BeneficiaryId?: Maybe<IntNullableFilter>;
  Branch?: Maybe<BranchRelationFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  Comment?: Maybe<StringNullableFilter>;
  Company?: Maybe<CompanyRelationFilter>;
  CompanyId?: Maybe<IntFilter>;
  Document?: Maybe<DocumentListRelationFilter>;
  Form15CB?: Maybe<Form15CbRelationFilter>;
  Group?: Maybe<GroupRelationFilter>;
  GroupId?: Maybe<IntFilter>;
  IsNewBeneficiary?: Maybe<BoolFilter>;
  NOT?: Maybe<Array<RequestWhereInput>>;
  OR?: Maybe<Array<RequestWhereInput>>;
  ProposedDate?: Maybe<DateTimeNullableFilter>;
  Remarks?: Maybe<StringNullableFilter>;
  Status?: Maybe<StringFilter>;
  User?: Maybe<UserRelationFilter>;
  UserId?: Maybe<IntFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type RequestWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFieldUpdateOperationsInput = {
  set?: Maybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: Maybe<NestedIntNullableFilter>;
  _max?: Maybe<NestedStringNullableFilter>;
  _min?: Maybe<NestedStringNullableFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: Maybe<NestedIntFilter>;
  _max?: Maybe<NestedStringFilter>;
  _min?: Maybe<NestedStringFilter>;
  contains?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  equals?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringWithAggregatesFilter>;
  notIn?: Maybe<Array<Scalars['String']>>;
  startsWith?: Maybe<Scalars['String']>;
};

export type Udin = {
  __typename?: 'Udin';
  cAFirmId: Scalars['Int'];
  ca: User;
  firm: CaFirm;
  firstField: Scalars['String'];
  id: Scalars['Int'];
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
  userId: Scalars['Int'];
};

export type UdinAvgAggregate = {
  __typename?: 'UdinAvgAggregate';
  cAFirmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type UdinAvgOrderByAggregateInput = {
  cAFirmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UdinCountAggregate = {
  __typename?: 'UdinCountAggregate';
  _all: Scalars['Int'];
  cAFirmId: Scalars['Int'];
  firstField: Scalars['Int'];
  id: Scalars['Int'];
  itLogin: Scalars['Int'];
  itPass: Scalars['Int'];
  pan: Scalars['Int'];
  secondField: Scalars['Int'];
  stdDescription: Scalars['Int'];
  stdRemark: Scalars['Int'];
  thirdField: Scalars['Int'];
  udinLogin: Scalars['Int'];
  udinPass: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UdinCountOrderByAggregateInput = {
  cAFirmId?: Maybe<SortOrder>;
  firstField?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  itLogin?: Maybe<SortOrder>;
  itPass?: Maybe<SortOrder>;
  pan?: Maybe<SortOrder>;
  secondField?: Maybe<SortOrder>;
  stdDescription?: Maybe<SortOrder>;
  stdRemark?: Maybe<SortOrder>;
  thirdField?: Maybe<SortOrder>;
  udinLogin?: Maybe<SortOrder>;
  udinPass?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UdinCreateInput = {
  ca: UserCreateNestedOneWithoutUdinInput;
  firm: CaFirmCreateNestedOneWithoutUdinInput;
  firstField: Scalars['String'];
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
};

export type UdinCreateManyCaInput = {
  cAFirmId: Scalars['Int'];
  firstField: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
};

export type UdinCreateManyCaInputEnvelope = {
  data: Array<UdinCreateManyCaInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UdinCreateManyFirmInput = {
  firstField: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
  userId: Scalars['Int'];
};

export type UdinCreateManyFirmInputEnvelope = {
  data: Array<UdinCreateManyFirmInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UdinCreateManyInput = {
  cAFirmId: Scalars['Int'];
  firstField: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
  userId: Scalars['Int'];
};

export type UdinCreateNestedManyWithoutCaInput = {
  connect?: Maybe<Array<UdinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UdinCreateOrConnectWithoutCaInput>>;
  create?: Maybe<Array<UdinCreateWithoutCaInput>>;
  createMany?: Maybe<UdinCreateManyCaInputEnvelope>;
};

export type UdinCreateNestedManyWithoutFirmInput = {
  connect?: Maybe<Array<UdinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UdinCreateOrConnectWithoutFirmInput>>;
  create?: Maybe<Array<UdinCreateWithoutFirmInput>>;
  createMany?: Maybe<UdinCreateManyFirmInputEnvelope>;
};

export type UdinCreateOrConnectWithoutCaInput = {
  create: UdinCreateWithoutCaInput;
  where: UdinWhereUniqueInput;
};

export type UdinCreateOrConnectWithoutFirmInput = {
  create: UdinCreateWithoutFirmInput;
  where: UdinWhereUniqueInput;
};

export type UdinCreateWithoutCaInput = {
  firm: CaFirmCreateNestedOneWithoutUdinInput;
  firstField: Scalars['String'];
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
};

export type UdinCreateWithoutFirmInput = {
  ca: UserCreateNestedOneWithoutUdinInput;
  firstField: Scalars['String'];
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
};

export type UdinGroupBy = {
  __typename?: 'UdinGroupBy';
  _avg?: Maybe<UdinAvgAggregate>;
  _count?: Maybe<UdinCountAggregate>;
  _max?: Maybe<UdinMaxAggregate>;
  _min?: Maybe<UdinMinAggregate>;
  _sum?: Maybe<UdinSumAggregate>;
  cAFirmId: Scalars['Int'];
  firstField: Scalars['String'];
  id: Scalars['Int'];
  itLogin: Scalars['String'];
  itPass: Scalars['String'];
  pan: Scalars['String'];
  secondField: Scalars['String'];
  stdDescription: Scalars['String'];
  stdRemark: Scalars['String'];
  thirdField: Scalars['String'];
  udinLogin: Scalars['String'];
  udinPass: Scalars['String'];
  userId: Scalars['Int'];
};

export type UdinListRelationFilter = {
  every?: Maybe<UdinWhereInput>;
  none?: Maybe<UdinWhereInput>;
  some?: Maybe<UdinWhereInput>;
};

export type UdinMaxAggregate = {
  __typename?: 'UdinMaxAggregate';
  cAFirmId?: Maybe<Scalars['Int']>;
  firstField?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  itLogin?: Maybe<Scalars['String']>;
  itPass?: Maybe<Scalars['String']>;
  pan?: Maybe<Scalars['String']>;
  secondField?: Maybe<Scalars['String']>;
  stdDescription?: Maybe<Scalars['String']>;
  stdRemark?: Maybe<Scalars['String']>;
  thirdField?: Maybe<Scalars['String']>;
  udinLogin?: Maybe<Scalars['String']>;
  udinPass?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type UdinMaxOrderByAggregateInput = {
  cAFirmId?: Maybe<SortOrder>;
  firstField?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  itLogin?: Maybe<SortOrder>;
  itPass?: Maybe<SortOrder>;
  pan?: Maybe<SortOrder>;
  secondField?: Maybe<SortOrder>;
  stdDescription?: Maybe<SortOrder>;
  stdRemark?: Maybe<SortOrder>;
  thirdField?: Maybe<SortOrder>;
  udinLogin?: Maybe<SortOrder>;
  udinPass?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UdinMinAggregate = {
  __typename?: 'UdinMinAggregate';
  cAFirmId?: Maybe<Scalars['Int']>;
  firstField?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  itLogin?: Maybe<Scalars['String']>;
  itPass?: Maybe<Scalars['String']>;
  pan?: Maybe<Scalars['String']>;
  secondField?: Maybe<Scalars['String']>;
  stdDescription?: Maybe<Scalars['String']>;
  stdRemark?: Maybe<Scalars['String']>;
  thirdField?: Maybe<Scalars['String']>;
  udinLogin?: Maybe<Scalars['String']>;
  udinPass?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type UdinMinOrderByAggregateInput = {
  cAFirmId?: Maybe<SortOrder>;
  firstField?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  itLogin?: Maybe<SortOrder>;
  itPass?: Maybe<SortOrder>;
  pan?: Maybe<SortOrder>;
  secondField?: Maybe<SortOrder>;
  stdDescription?: Maybe<SortOrder>;
  stdRemark?: Maybe<SortOrder>;
  thirdField?: Maybe<SortOrder>;
  udinLogin?: Maybe<SortOrder>;
  udinPass?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UdinOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UdinOrderByWithAggregationInput = {
  _avg?: Maybe<UdinAvgOrderByAggregateInput>;
  _count?: Maybe<UdinCountOrderByAggregateInput>;
  _max?: Maybe<UdinMaxOrderByAggregateInput>;
  _min?: Maybe<UdinMinOrderByAggregateInput>;
  _sum?: Maybe<UdinSumOrderByAggregateInput>;
  cAFirmId?: Maybe<SortOrder>;
  firstField?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  itLogin?: Maybe<SortOrder>;
  itPass?: Maybe<SortOrder>;
  pan?: Maybe<SortOrder>;
  secondField?: Maybe<SortOrder>;
  stdDescription?: Maybe<SortOrder>;
  stdRemark?: Maybe<SortOrder>;
  thirdField?: Maybe<SortOrder>;
  udinLogin?: Maybe<SortOrder>;
  udinPass?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UdinOrderByWithRelationInput = {
  cAFirmId?: Maybe<SortOrder>;
  ca?: Maybe<UserOrderByWithRelationInput>;
  firm?: Maybe<CaFirmOrderByWithRelationInput>;
  firstField?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  itLogin?: Maybe<SortOrder>;
  itPass?: Maybe<SortOrder>;
  pan?: Maybe<SortOrder>;
  secondField?: Maybe<SortOrder>;
  stdDescription?: Maybe<SortOrder>;
  stdRemark?: Maybe<SortOrder>;
  thirdField?: Maybe<SortOrder>;
  udinLogin?: Maybe<SortOrder>;
  udinPass?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export enum UdinScalarFieldEnum {
  CAFirmId = 'cAFirmId',
  FirstField = 'firstField',
  Id = 'id',
  ItLogin = 'itLogin',
  ItPass = 'itPass',
  Pan = 'pan',
  SecondField = 'secondField',
  StdDescription = 'stdDescription',
  StdRemark = 'stdRemark',
  ThirdField = 'thirdField',
  UdinLogin = 'udinLogin',
  UdinPass = 'udinPass',
  UserId = 'userId'
}

export type UdinScalarWhereInput = {
  AND?: Maybe<Array<UdinScalarWhereInput>>;
  NOT?: Maybe<Array<UdinScalarWhereInput>>;
  OR?: Maybe<Array<UdinScalarWhereInput>>;
  cAFirmId?: Maybe<IntFilter>;
  firstField?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  itLogin?: Maybe<StringFilter>;
  itPass?: Maybe<StringFilter>;
  pan?: Maybe<StringFilter>;
  secondField?: Maybe<StringFilter>;
  stdDescription?: Maybe<StringFilter>;
  stdRemark?: Maybe<StringFilter>;
  thirdField?: Maybe<StringFilter>;
  udinLogin?: Maybe<StringFilter>;
  udinPass?: Maybe<StringFilter>;
  userId?: Maybe<IntFilter>;
};

export type UdinScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UdinScalarWhereWithAggregatesInput>>;
  NOT?: Maybe<Array<UdinScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UdinScalarWhereWithAggregatesInput>>;
  cAFirmId?: Maybe<IntWithAggregatesFilter>;
  firstField?: Maybe<StringWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  itLogin?: Maybe<StringWithAggregatesFilter>;
  itPass?: Maybe<StringWithAggregatesFilter>;
  pan?: Maybe<StringWithAggregatesFilter>;
  secondField?: Maybe<StringWithAggregatesFilter>;
  stdDescription?: Maybe<StringWithAggregatesFilter>;
  stdRemark?: Maybe<StringWithAggregatesFilter>;
  thirdField?: Maybe<StringWithAggregatesFilter>;
  udinLogin?: Maybe<StringWithAggregatesFilter>;
  udinPass?: Maybe<StringWithAggregatesFilter>;
  userId?: Maybe<IntWithAggregatesFilter>;
};

export type UdinSumAggregate = {
  __typename?: 'UdinSumAggregate';
  cAFirmId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type UdinSumOrderByAggregateInput = {
  cAFirmId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
};

export type UdinUpdateInput = {
  ca?: Maybe<UserUpdateOneRequiredWithoutUdinNestedInput>;
  firm?: Maybe<CaFirmUpdateOneRequiredWithoutUdinNestedInput>;
  firstField?: Maybe<StringFieldUpdateOperationsInput>;
  itLogin?: Maybe<StringFieldUpdateOperationsInput>;
  itPass?: Maybe<StringFieldUpdateOperationsInput>;
  pan?: Maybe<StringFieldUpdateOperationsInput>;
  secondField?: Maybe<StringFieldUpdateOperationsInput>;
  stdDescription?: Maybe<StringFieldUpdateOperationsInput>;
  stdRemark?: Maybe<StringFieldUpdateOperationsInput>;
  thirdField?: Maybe<StringFieldUpdateOperationsInput>;
  udinLogin?: Maybe<StringFieldUpdateOperationsInput>;
  udinPass?: Maybe<StringFieldUpdateOperationsInput>;
};

export type UdinUpdateManyMutationInput = {
  firstField?: Maybe<StringFieldUpdateOperationsInput>;
  itLogin?: Maybe<StringFieldUpdateOperationsInput>;
  itPass?: Maybe<StringFieldUpdateOperationsInput>;
  pan?: Maybe<StringFieldUpdateOperationsInput>;
  secondField?: Maybe<StringFieldUpdateOperationsInput>;
  stdDescription?: Maybe<StringFieldUpdateOperationsInput>;
  stdRemark?: Maybe<StringFieldUpdateOperationsInput>;
  thirdField?: Maybe<StringFieldUpdateOperationsInput>;
  udinLogin?: Maybe<StringFieldUpdateOperationsInput>;
  udinPass?: Maybe<StringFieldUpdateOperationsInput>;
};

export type UdinUpdateManyWithWhereWithoutCaInput = {
  data: UdinUpdateManyMutationInput;
  where: UdinScalarWhereInput;
};

export type UdinUpdateManyWithWhereWithoutFirmInput = {
  data: UdinUpdateManyMutationInput;
  where: UdinScalarWhereInput;
};

export type UdinUpdateManyWithoutCaNestedInput = {
  connect?: Maybe<Array<UdinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UdinCreateOrConnectWithoutCaInput>>;
  create?: Maybe<Array<UdinCreateWithoutCaInput>>;
  createMany?: Maybe<UdinCreateManyCaInputEnvelope>;
  delete?: Maybe<Array<UdinWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UdinScalarWhereInput>>;
  disconnect?: Maybe<Array<UdinWhereUniqueInput>>;
  set?: Maybe<Array<UdinWhereUniqueInput>>;
  update?: Maybe<Array<UdinUpdateWithWhereUniqueWithoutCaInput>>;
  updateMany?: Maybe<Array<UdinUpdateManyWithWhereWithoutCaInput>>;
  upsert?: Maybe<Array<UdinUpsertWithWhereUniqueWithoutCaInput>>;
};

export type UdinUpdateManyWithoutFirmNestedInput = {
  connect?: Maybe<Array<UdinWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UdinCreateOrConnectWithoutFirmInput>>;
  create?: Maybe<Array<UdinCreateWithoutFirmInput>>;
  createMany?: Maybe<UdinCreateManyFirmInputEnvelope>;
  delete?: Maybe<Array<UdinWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UdinScalarWhereInput>>;
  disconnect?: Maybe<Array<UdinWhereUniqueInput>>;
  set?: Maybe<Array<UdinWhereUniqueInput>>;
  update?: Maybe<Array<UdinUpdateWithWhereUniqueWithoutFirmInput>>;
  updateMany?: Maybe<Array<UdinUpdateManyWithWhereWithoutFirmInput>>;
  upsert?: Maybe<Array<UdinUpsertWithWhereUniqueWithoutFirmInput>>;
};

export type UdinUpdateWithWhereUniqueWithoutCaInput = {
  data: UdinUpdateWithoutCaInput;
  where: UdinWhereUniqueInput;
};

export type UdinUpdateWithWhereUniqueWithoutFirmInput = {
  data: UdinUpdateWithoutFirmInput;
  where: UdinWhereUniqueInput;
};

export type UdinUpdateWithoutCaInput = {
  firm?: Maybe<CaFirmUpdateOneRequiredWithoutUdinNestedInput>;
  firstField?: Maybe<StringFieldUpdateOperationsInput>;
  itLogin?: Maybe<StringFieldUpdateOperationsInput>;
  itPass?: Maybe<StringFieldUpdateOperationsInput>;
  pan?: Maybe<StringFieldUpdateOperationsInput>;
  secondField?: Maybe<StringFieldUpdateOperationsInput>;
  stdDescription?: Maybe<StringFieldUpdateOperationsInput>;
  stdRemark?: Maybe<StringFieldUpdateOperationsInput>;
  thirdField?: Maybe<StringFieldUpdateOperationsInput>;
  udinLogin?: Maybe<StringFieldUpdateOperationsInput>;
  udinPass?: Maybe<StringFieldUpdateOperationsInput>;
};

export type UdinUpdateWithoutFirmInput = {
  ca?: Maybe<UserUpdateOneRequiredWithoutUdinNestedInput>;
  firstField?: Maybe<StringFieldUpdateOperationsInput>;
  itLogin?: Maybe<StringFieldUpdateOperationsInput>;
  itPass?: Maybe<StringFieldUpdateOperationsInput>;
  pan?: Maybe<StringFieldUpdateOperationsInput>;
  secondField?: Maybe<StringFieldUpdateOperationsInput>;
  stdDescription?: Maybe<StringFieldUpdateOperationsInput>;
  stdRemark?: Maybe<StringFieldUpdateOperationsInput>;
  thirdField?: Maybe<StringFieldUpdateOperationsInput>;
  udinLogin?: Maybe<StringFieldUpdateOperationsInput>;
  udinPass?: Maybe<StringFieldUpdateOperationsInput>;
};

export type UdinUpsertWithWhereUniqueWithoutCaInput = {
  create: UdinCreateWithoutCaInput;
  update: UdinUpdateWithoutCaInput;
  where: UdinWhereUniqueInput;
};

export type UdinUpsertWithWhereUniqueWithoutFirmInput = {
  create: UdinCreateWithoutFirmInput;
  update: UdinUpdateWithoutFirmInput;
  where: UdinWhereUniqueInput;
};

export type UdinWhereInput = {
  AND?: Maybe<Array<UdinWhereInput>>;
  NOT?: Maybe<Array<UdinWhereInput>>;
  OR?: Maybe<Array<UdinWhereInput>>;
  cAFirmId?: Maybe<IntFilter>;
  ca?: Maybe<UserRelationFilter>;
  firm?: Maybe<CaFirmRelationFilter>;
  firstField?: Maybe<StringFilter>;
  id?: Maybe<IntFilter>;
  itLogin?: Maybe<StringFilter>;
  itPass?: Maybe<StringFilter>;
  pan?: Maybe<StringFilter>;
  secondField?: Maybe<StringFilter>;
  stdDescription?: Maybe<StringFilter>;
  stdRemark?: Maybe<StringFilter>;
  thirdField?: Maybe<StringFilter>;
  udinLogin?: Maybe<StringFilter>;
  udinPass?: Maybe<StringFilter>;
  userId?: Maybe<IntFilter>;
};

export type UdinWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  CAFirm?: Maybe<CaFirm>;
  Email: Scalars['String'];
  Events: Array<Events>;
  Firm?: Maybe<CaFirm>;
  FirmId?: Maybe<Scalars['Int']>;
  FirstName: Scalars['String'];
  Form15CB: Array<Form15Cb>;
  Group?: Maybe<Group>;
  GroupId?: Maybe<Scalars['Int']>;
  Groups?: Maybe<Group>;
  IsEmailConfirmed: Scalars['Boolean'];
  IsPasswordChangeRequested: Scalars['Boolean'];
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request: Array<Request>;
  Type: Scalars['String'];
  Udin: Array<Udin>;
  UserAccess: Array<UserAccess>;
  _count?: Maybe<UserCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};


export type UserEventsArgs = {
  cursor?: Maybe<EventsWhereUniqueInput>;
  distinct?: Maybe<Array<EventsScalarFieldEnum>>;
  orderBy?: Maybe<Array<EventsOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<EventsWhereInput>;
};


export type UserForm15CbArgs = {
  cursor?: Maybe<Form15CbWhereUniqueInput>;
  distinct?: Maybe<Array<Form15CbScalarFieldEnum>>;
  orderBy?: Maybe<Array<Form15CbOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<Form15CbWhereInput>;
};


export type UserRequestArgs = {
  cursor?: Maybe<RequestWhereUniqueInput>;
  distinct?: Maybe<Array<RequestScalarFieldEnum>>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<RequestWhereInput>;
};


export type UserUdinArgs = {
  cursor?: Maybe<UdinWhereUniqueInput>;
  distinct?: Maybe<Array<UdinScalarFieldEnum>>;
  orderBy?: Maybe<Array<UdinOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UdinWhereInput>;
};


export type UserUserAccessArgs = {
  cursor?: Maybe<UserAccessWhereUniqueInput>;
  distinct?: Maybe<Array<UserAccessScalarFieldEnum>>;
  orderBy?: Maybe<Array<UserAccessOrderByWithRelationInput>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  where?: Maybe<UserAccessWhereInput>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  Branch?: Maybe<Branch>;
  BranchId?: Maybe<Scalars['Int']>;
  Company: Company;
  CompanyId: Scalars['Int'];
  Group: Group;
  GroupId: Scalars['Int'];
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  User: User;
  UserId: Scalars['Int'];
  id: Scalars['Int'];
};

export type UserAccessAvgAggregate = {
  __typename?: 'UserAccessAvgAggregate';
  BranchId?: Maybe<Scalars['Float']>;
  CompanyId?: Maybe<Scalars['Float']>;
  GroupId?: Maybe<Scalars['Float']>;
  UserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type UserAccessAvgOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type UserAccessCountAggregate = {
  __typename?: 'UserAccessCountAggregate';
  BranchId: Scalars['Int'];
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  MembershipNumber: Scalars['Int'];
  Role: Scalars['Int'];
  UserId: Scalars['Int'];
  _all: Scalars['Int'];
  id: Scalars['Int'];
};

export type UserAccessCountOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  MembershipNumber?: Maybe<SortOrder>;
  Role?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type UserAccessCreateInput = {
  Branch?: Maybe<BranchCreateNestedOneWithoutUserAccessInput>;
  Company: CompanyCreateNestedOneWithoutUserAccessInput;
  Group: GroupCreateNestedOneWithoutUserAccessInput;
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  User: UserCreateNestedOneWithoutUserAccessInput;
};

export type UserAccessCreateManyBranchInput = {
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  UserId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessCreateManyBranchInputEnvelope = {
  data: Array<UserAccessCreateManyBranchInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserAccessCreateManyCompanyInput = {
  BranchId?: Maybe<Scalars['Int']>;
  GroupId: Scalars['Int'];
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  UserId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessCreateManyCompanyInputEnvelope = {
  data: Array<UserAccessCreateManyCompanyInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserAccessCreateManyGroupInput = {
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId: Scalars['Int'];
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  UserId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessCreateManyGroupInputEnvelope = {
  data: Array<UserAccessCreateManyGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserAccessCreateManyInput = {
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  UserId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessCreateManyUserInput = {
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessCreateManyUserInputEnvelope = {
  data: Array<UserAccessCreateManyUserInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserAccessCreateNestedManyWithoutBranchInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutBranchInput>>;
  createMany?: Maybe<UserAccessCreateManyBranchInputEnvelope>;
};

export type UserAccessCreateNestedManyWithoutCompanyInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutCompanyInput>>;
  createMany?: Maybe<UserAccessCreateManyCompanyInputEnvelope>;
};

export type UserAccessCreateNestedManyWithoutGroupInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutGroupInput>>;
  createMany?: Maybe<UserAccessCreateManyGroupInputEnvelope>;
};

export type UserAccessCreateNestedManyWithoutUserInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutUserInput>>;
  createMany?: Maybe<UserAccessCreateManyUserInputEnvelope>;
};

export type UserAccessCreateOrConnectWithoutBranchInput = {
  create: UserAccessCreateWithoutBranchInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessCreateOrConnectWithoutCompanyInput = {
  create: UserAccessCreateWithoutCompanyInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessCreateOrConnectWithoutGroupInput = {
  create: UserAccessCreateWithoutGroupInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessCreateOrConnectWithoutUserInput = {
  create: UserAccessCreateWithoutUserInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessCreateWithoutBranchInput = {
  Company: CompanyCreateNestedOneWithoutUserAccessInput;
  Group: GroupCreateNestedOneWithoutUserAccessInput;
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  User: UserCreateNestedOneWithoutUserAccessInput;
};

export type UserAccessCreateWithoutCompanyInput = {
  Branch?: Maybe<BranchCreateNestedOneWithoutUserAccessInput>;
  Group: GroupCreateNestedOneWithoutUserAccessInput;
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  User: UserCreateNestedOneWithoutUserAccessInput;
};

export type UserAccessCreateWithoutGroupInput = {
  Branch?: Maybe<BranchCreateNestedOneWithoutUserAccessInput>;
  Company: CompanyCreateNestedOneWithoutUserAccessInput;
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  User: UserCreateNestedOneWithoutUserAccessInput;
};

export type UserAccessCreateWithoutUserInput = {
  Branch?: Maybe<BranchCreateNestedOneWithoutUserAccessInput>;
  Company: CompanyCreateNestedOneWithoutUserAccessInput;
  Group: GroupCreateNestedOneWithoutUserAccessInput;
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
};

export type UserAccessGroupBy = {
  __typename?: 'UserAccessGroupBy';
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId: Scalars['Int'];
  GroupId: Scalars['Int'];
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  UserId: Scalars['Int'];
  _avg?: Maybe<UserAccessAvgAggregate>;
  _count?: Maybe<UserAccessCountAggregate>;
  _max?: Maybe<UserAccessMaxAggregate>;
  _min?: Maybe<UserAccessMinAggregate>;
  _sum?: Maybe<UserAccessSumAggregate>;
  id: Scalars['Int'];
};

export type UserAccessListRelationFilter = {
  every?: Maybe<UserAccessWhereInput>;
  none?: Maybe<UserAccessWhereInput>;
  some?: Maybe<UserAccessWhereInput>;
};

export type UserAccessMaxAggregate = {
  __typename?: 'UserAccessMaxAggregate';
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  UserId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessMaxOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  MembershipNumber?: Maybe<SortOrder>;
  Role?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type UserAccessMinAggregate = {
  __typename?: 'UserAccessMinAggregate';
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  MembershipNumber?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
  UserId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessMinOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  MembershipNumber?: Maybe<SortOrder>;
  Role?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type UserAccessOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserAccessOrderByWithAggregationInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  MembershipNumber?: Maybe<SortOrder>;
  Role?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  _avg?: Maybe<UserAccessAvgOrderByAggregateInput>;
  _count?: Maybe<UserAccessCountOrderByAggregateInput>;
  _max?: Maybe<UserAccessMaxOrderByAggregateInput>;
  _min?: Maybe<UserAccessMinOrderByAggregateInput>;
  _sum?: Maybe<UserAccessSumOrderByAggregateInput>;
  id?: Maybe<SortOrder>;
};

export type UserAccessOrderByWithRelationInput = {
  Branch?: Maybe<BranchOrderByWithRelationInput>;
  BranchId?: Maybe<SortOrder>;
  Company?: Maybe<CompanyOrderByWithRelationInput>;
  CompanyId?: Maybe<SortOrder>;
  Group?: Maybe<GroupOrderByWithRelationInput>;
  GroupId?: Maybe<SortOrder>;
  MembershipNumber?: Maybe<SortOrder>;
  Role?: Maybe<SortOrder>;
  User?: Maybe<UserOrderByWithRelationInput>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export enum UserAccessScalarFieldEnum {
  BranchId = 'BranchId',
  CompanyId = 'CompanyId',
  GroupId = 'GroupId',
  MembershipNumber = 'MembershipNumber',
  Role = 'Role',
  UserId = 'UserId',
  Id = 'id'
}

export type UserAccessScalarWhereInput = {
  AND?: Maybe<Array<UserAccessScalarWhereInput>>;
  BranchId?: Maybe<IntNullableFilter>;
  CompanyId?: Maybe<IntFilter>;
  GroupId?: Maybe<IntFilter>;
  MembershipNumber?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<UserAccessScalarWhereInput>>;
  OR?: Maybe<Array<UserAccessScalarWhereInput>>;
  Role?: Maybe<StringNullableFilter>;
  UserId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
};

export type UserAccessScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserAccessScalarWhereWithAggregatesInput>>;
  BranchId?: Maybe<IntNullableWithAggregatesFilter>;
  CompanyId?: Maybe<IntWithAggregatesFilter>;
  GroupId?: Maybe<IntWithAggregatesFilter>;
  MembershipNumber?: Maybe<StringNullableWithAggregatesFilter>;
  NOT?: Maybe<Array<UserAccessScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserAccessScalarWhereWithAggregatesInput>>;
  Role?: Maybe<StringNullableWithAggregatesFilter>;
  UserId?: Maybe<IntWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
};

export type UserAccessSumAggregate = {
  __typename?: 'UserAccessSumAggregate';
  BranchId?: Maybe<Scalars['Int']>;
  CompanyId?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  UserId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type UserAccessSumOrderByAggregateInput = {
  BranchId?: Maybe<SortOrder>;
  CompanyId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  UserId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type UserAccessUpdateInput = {
  Branch?: Maybe<BranchUpdateOneWithoutUserAccessNestedInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutUserAccessNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutUserAccessNestedInput>;
  MembershipNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutUserAccessNestedInput>;
};

export type UserAccessUpdateManyMutationInput = {
  MembershipNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Role?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserAccessUpdateManyWithWhereWithoutBranchInput = {
  data: UserAccessUpdateManyMutationInput;
  where: UserAccessScalarWhereInput;
};

export type UserAccessUpdateManyWithWhereWithoutCompanyInput = {
  data: UserAccessUpdateManyMutationInput;
  where: UserAccessScalarWhereInput;
};

export type UserAccessUpdateManyWithWhereWithoutGroupInput = {
  data: UserAccessUpdateManyMutationInput;
  where: UserAccessScalarWhereInput;
};

export type UserAccessUpdateManyWithWhereWithoutUserInput = {
  data: UserAccessUpdateManyMutationInput;
  where: UserAccessScalarWhereInput;
};

export type UserAccessUpdateManyWithoutBranchNestedInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutBranchInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutBranchInput>>;
  createMany?: Maybe<UserAccessCreateManyBranchInputEnvelope>;
  delete?: Maybe<Array<UserAccessWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAccessScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  set?: Maybe<Array<UserAccessWhereUniqueInput>>;
  update?: Maybe<Array<UserAccessUpdateWithWhereUniqueWithoutBranchInput>>;
  updateMany?: Maybe<Array<UserAccessUpdateManyWithWhereWithoutBranchInput>>;
  upsert?: Maybe<Array<UserAccessUpsertWithWhereUniqueWithoutBranchInput>>;
};

export type UserAccessUpdateManyWithoutCompanyNestedInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutCompanyInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutCompanyInput>>;
  createMany?: Maybe<UserAccessCreateManyCompanyInputEnvelope>;
  delete?: Maybe<Array<UserAccessWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAccessScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  set?: Maybe<Array<UserAccessWhereUniqueInput>>;
  update?: Maybe<Array<UserAccessUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: Maybe<Array<UserAccessUpdateManyWithWhereWithoutCompanyInput>>;
  upsert?: Maybe<Array<UserAccessUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type UserAccessUpdateManyWithoutGroupNestedInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutGroupInput>>;
  createMany?: Maybe<UserAccessCreateManyGroupInputEnvelope>;
  delete?: Maybe<Array<UserAccessWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAccessScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  set?: Maybe<Array<UserAccessWhereUniqueInput>>;
  update?: Maybe<Array<UserAccessUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: Maybe<Array<UserAccessUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: Maybe<Array<UserAccessUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type UserAccessUpdateManyWithoutUserNestedInput = {
  connect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserAccessCreateOrConnectWithoutUserInput>>;
  create?: Maybe<Array<UserAccessCreateWithoutUserInput>>;
  createMany?: Maybe<UserAccessCreateManyUserInputEnvelope>;
  delete?: Maybe<Array<UserAccessWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserAccessScalarWhereInput>>;
  disconnect?: Maybe<Array<UserAccessWhereUniqueInput>>;
  set?: Maybe<Array<UserAccessWhereUniqueInput>>;
  update?: Maybe<Array<UserAccessUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: Maybe<Array<UserAccessUpdateManyWithWhereWithoutUserInput>>;
  upsert?: Maybe<Array<UserAccessUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserAccessUpdateWithWhereUniqueWithoutBranchInput = {
  data: UserAccessUpdateWithoutBranchInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessUpdateWithWhereUniqueWithoutCompanyInput = {
  data: UserAccessUpdateWithoutCompanyInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessUpdateWithWhereUniqueWithoutGroupInput = {
  data: UserAccessUpdateWithoutGroupInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessUpdateWithWhereUniqueWithoutUserInput = {
  data: UserAccessUpdateWithoutUserInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessUpdateWithoutBranchInput = {
  Company?: Maybe<CompanyUpdateOneRequiredWithoutUserAccessNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutUserAccessNestedInput>;
  MembershipNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutUserAccessNestedInput>;
};

export type UserAccessUpdateWithoutCompanyInput = {
  Branch?: Maybe<BranchUpdateOneWithoutUserAccessNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutUserAccessNestedInput>;
  MembershipNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutUserAccessNestedInput>;
};

export type UserAccessUpdateWithoutGroupInput = {
  Branch?: Maybe<BranchUpdateOneWithoutUserAccessNestedInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutUserAccessNestedInput>;
  MembershipNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Role?: Maybe<NullableStringFieldUpdateOperationsInput>;
  User?: Maybe<UserUpdateOneRequiredWithoutUserAccessNestedInput>;
};

export type UserAccessUpdateWithoutUserInput = {
  Branch?: Maybe<BranchUpdateOneWithoutUserAccessNestedInput>;
  Company?: Maybe<CompanyUpdateOneRequiredWithoutUserAccessNestedInput>;
  Group?: Maybe<GroupUpdateOneRequiredWithoutUserAccessNestedInput>;
  MembershipNumber?: Maybe<NullableStringFieldUpdateOperationsInput>;
  Role?: Maybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserAccessUpsertWithWhereUniqueWithoutBranchInput = {
  create: UserAccessCreateWithoutBranchInput;
  update: UserAccessUpdateWithoutBranchInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessUpsertWithWhereUniqueWithoutCompanyInput = {
  create: UserAccessCreateWithoutCompanyInput;
  update: UserAccessUpdateWithoutCompanyInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessUpsertWithWhereUniqueWithoutGroupInput = {
  create: UserAccessCreateWithoutGroupInput;
  update: UserAccessUpdateWithoutGroupInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessUpsertWithWhereUniqueWithoutUserInput = {
  create: UserAccessCreateWithoutUserInput;
  update: UserAccessUpdateWithoutUserInput;
  where: UserAccessWhereUniqueInput;
};

export type UserAccessWhereInput = {
  AND?: Maybe<Array<UserAccessWhereInput>>;
  Branch?: Maybe<BranchRelationFilter>;
  BranchId?: Maybe<IntNullableFilter>;
  Company?: Maybe<CompanyRelationFilter>;
  CompanyId?: Maybe<IntFilter>;
  Group?: Maybe<GroupRelationFilter>;
  GroupId?: Maybe<IntFilter>;
  MembershipNumber?: Maybe<StringNullableFilter>;
  NOT?: Maybe<Array<UserAccessWhereInput>>;
  OR?: Maybe<Array<UserAccessWhereInput>>;
  Role?: Maybe<StringNullableFilter>;
  User?: Maybe<UserRelationFilter>;
  UserId?: Maybe<IntFilter>;
  id?: Maybe<IntFilter>;
};

export type UserAccessWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
};

export type UserAvgAggregate = {
  __typename?: 'UserAvgAggregate';
  FirmId?: Maybe<Scalars['Float']>;
  GroupId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type UserAvgOrderByAggregateInput = {
  FirmId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type UserCount = {
  __typename?: 'UserCount';
  Events: Scalars['Int'];
  Form15CB: Scalars['Int'];
  Request: Scalars['Int'];
  Udin: Scalars['Int'];
  UserAccess: Scalars['Int'];
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  Email: Scalars['Int'];
  FirmId: Scalars['Int'];
  FirstName: Scalars['Int'];
  GroupId: Scalars['Int'];
  IsEmailConfirmed: Scalars['Int'];
  IsPasswordChangeRequested: Scalars['Int'];
  LastName: Scalars['Int'];
  Password: Scalars['Int'];
  Type: Scalars['Int'];
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type UserCountOrderByAggregateInput = {
  Email?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  FirstName?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsEmailConfirmed?: Maybe<SortOrder>;
  IsPasswordChangeRequested?: Maybe<SortOrder>;
  LastName?: Maybe<SortOrder>;
  Password?: Maybe<SortOrder>;
  Type?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserCreateInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateManyFirmInput = {
  Email: Scalars['String'];
  FirstName: Scalars['String'];
  GroupId?: Maybe<Scalars['Int']>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Type: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateManyFirmInputEnvelope = {
  data: Array<UserCreateManyFirmInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserCreateManyGroupInput = {
  Email: Scalars['String'];
  FirmId?: Maybe<Scalars['Int']>;
  FirstName: Scalars['String'];
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Type: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateManyGroupInputEnvelope = {
  data: Array<UserCreateManyGroupInput>;
  skipDuplicates?: Maybe<Scalars['Boolean']>;
};

export type UserCreateManyInput = {
  Email: Scalars['String'];
  FirmId?: Maybe<Scalars['Int']>;
  FirstName: Scalars['String'];
  GroupId?: Maybe<Scalars['Int']>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Type: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateNestedManyWithoutFirmInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutFirmInput>>;
  create?: Maybe<Array<UserCreateWithoutFirmInput>>;
  createMany?: Maybe<UserCreateManyFirmInputEnvelope>;
};

export type UserCreateNestedManyWithoutGroupInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<UserCreateWithoutGroupInput>>;
  createMany?: Maybe<UserCreateManyGroupInputEnvelope>;
};

export type UserCreateNestedOneWithoutCaFirmInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCaFirmInput>;
  create?: Maybe<UserCreateWithoutCaFirmInput>;
};

export type UserCreateNestedOneWithoutEventsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEventsInput>;
  create?: Maybe<UserCreateWithoutEventsInput>;
};

export type UserCreateNestedOneWithoutForm15CbInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<UserCreateWithoutForm15CbInput>;
};

export type UserCreateNestedOneWithoutGroupsInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutGroupsInput>;
  create?: Maybe<UserCreateWithoutGroupsInput>;
};

export type UserCreateNestedOneWithoutRequestInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRequestInput>;
  create?: Maybe<UserCreateWithoutRequestInput>;
};

export type UserCreateNestedOneWithoutUdinInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUdinInput>;
  create?: Maybe<UserCreateWithoutUdinInput>;
};

export type UserCreateNestedOneWithoutUserAccessInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<UserCreateWithoutUserAccessInput>;
};

export type UserCreateOrConnectWithoutCaFirmInput = {
  create: UserCreateWithoutCaFirmInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEventsInput = {
  create: UserCreateWithoutEventsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFirmInput = {
  create: UserCreateWithoutFirmInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutForm15CbInput = {
  create: UserCreateWithoutForm15CbInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutGroupInput = {
  create: UserCreateWithoutGroupInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutGroupsInput = {
  create: UserCreateWithoutGroupsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRequestInput = {
  create: UserCreateWithoutRequestInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUdinInput = {
  create: UserCreateWithoutUdinInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserAccessInput = {
  create: UserCreateWithoutUserAccessInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutCaFirmInput = {
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutEventsInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutFirmInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutForm15CbInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutGroupInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutGroupsInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutRequestInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutUdinInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  UserAccess?: Maybe<UserAccessCreateNestedManyWithoutUserInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateWithoutUserAccessInput = {
  CAFirm?: Maybe<CaFirmCreateNestedOneWithoutAdminInput>;
  Email: Scalars['String'];
  Events?: Maybe<EventsCreateNestedManyWithoutCreatedByInput>;
  Firm?: Maybe<CaFirmCreateNestedOneWithoutUsersInput>;
  FirstName: Scalars['String'];
  Form15CB?: Maybe<Form15CbCreateNestedManyWithoutCaInput>;
  Group?: Maybe<GroupCreateNestedOneWithoutUsersInput>;
  Groups?: Maybe<GroupCreateNestedOneWithoutAdminInput>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Request?: Maybe<RequestCreateNestedManyWithoutUserInput>;
  Type: Scalars['String'];
  Udin?: Maybe<UdinCreateNestedManyWithoutCaInput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserGroupBy = {
  __typename?: 'UserGroupBy';
  Email: Scalars['String'];
  FirmId?: Maybe<Scalars['Int']>;
  FirstName: Scalars['String'];
  GroupId?: Maybe<Scalars['Int']>;
  IsEmailConfirmed: Scalars['Boolean'];
  IsPasswordChangeRequested: Scalars['Boolean'];
  LastName: Scalars['String'];
  Password: Scalars['String'];
  Type: Scalars['String'];
  _avg?: Maybe<UserAvgAggregate>;
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
  _sum?: Maybe<UserSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type UserListRelationFilter = {
  every?: Maybe<UserWhereInput>;
  none?: Maybe<UserWhereInput>;
  some?: Maybe<UserWhereInput>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  Email?: Maybe<Scalars['String']>;
  FirmId?: Maybe<Scalars['Int']>;
  FirstName?: Maybe<Scalars['String']>;
  GroupId?: Maybe<Scalars['Int']>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserMaxOrderByAggregateInput = {
  Email?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  FirstName?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsEmailConfirmed?: Maybe<SortOrder>;
  IsPasswordChangeRequested?: Maybe<SortOrder>;
  LastName?: Maybe<SortOrder>;
  Password?: Maybe<SortOrder>;
  Type?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  Email?: Maybe<Scalars['String']>;
  FirmId?: Maybe<Scalars['Int']>;
  FirstName?: Maybe<Scalars['String']>;
  GroupId?: Maybe<Scalars['Int']>;
  IsEmailConfirmed?: Maybe<Scalars['Boolean']>;
  IsPasswordChangeRequested?: Maybe<Scalars['Boolean']>;
  LastName?: Maybe<Scalars['String']>;
  Password?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserMinOrderByAggregateInput = {
  Email?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  FirstName?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsEmailConfirmed?: Maybe<SortOrder>;
  IsPasswordChangeRequested?: Maybe<SortOrder>;
  LastName?: Maybe<SortOrder>;
  Password?: Maybe<SortOrder>;
  Type?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: Maybe<SortOrder>;
};

export type UserOrderByWithAggregationInput = {
  Email?: Maybe<SortOrder>;
  FirmId?: Maybe<SortOrder>;
  FirstName?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  IsEmailConfirmed?: Maybe<SortOrder>;
  IsPasswordChangeRequested?: Maybe<SortOrder>;
  LastName?: Maybe<SortOrder>;
  Password?: Maybe<SortOrder>;
  Type?: Maybe<SortOrder>;
  _avg?: Maybe<UserAvgOrderByAggregateInput>;
  _count?: Maybe<UserCountOrderByAggregateInput>;
  _max?: Maybe<UserMaxOrderByAggregateInput>;
  _min?: Maybe<UserMinOrderByAggregateInput>;
  _sum?: Maybe<UserSumOrderByAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  CAFirm?: Maybe<CaFirmOrderByWithRelationInput>;
  Email?: Maybe<SortOrder>;
  Events?: Maybe<EventsOrderByRelationAggregateInput>;
  Firm?: Maybe<CaFirmOrderByWithRelationInput>;
  FirmId?: Maybe<SortOrder>;
  FirstName?: Maybe<SortOrder>;
  Form15CB?: Maybe<Form15CbOrderByRelationAggregateInput>;
  Group?: Maybe<GroupOrderByWithRelationInput>;
  GroupId?: Maybe<SortOrder>;
  Groups?: Maybe<GroupOrderByWithRelationInput>;
  IsEmailConfirmed?: Maybe<SortOrder>;
  IsPasswordChangeRequested?: Maybe<SortOrder>;
  LastName?: Maybe<SortOrder>;
  Password?: Maybe<SortOrder>;
  Request?: Maybe<RequestOrderByRelationAggregateInput>;
  Type?: Maybe<SortOrder>;
  Udin?: Maybe<UdinOrderByRelationAggregateInput>;
  UserAccess?: Maybe<UserAccessOrderByRelationAggregateInput>;
  createdAt?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
  isActive?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type UserRelationFilter = {
  is?: Maybe<UserWhereInput>;
  isNot?: Maybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
  Email = 'Email',
  FirmId = 'FirmId',
  FirstName = 'FirstName',
  GroupId = 'GroupId',
  IsEmailConfirmed = 'IsEmailConfirmed',
  IsPasswordChangeRequested = 'IsPasswordChangeRequested',
  LastName = 'LastName',
  Password = 'Password',
  Type = 'Type',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  UpdatedAt = 'updatedAt'
}

export type UserScalarWhereInput = {
  AND?: Maybe<Array<UserScalarWhereInput>>;
  Email?: Maybe<StringFilter>;
  FirmId?: Maybe<IntNullableFilter>;
  FirstName?: Maybe<StringFilter>;
  GroupId?: Maybe<IntNullableFilter>;
  IsEmailConfirmed?: Maybe<BoolFilter>;
  IsPasswordChangeRequested?: Maybe<BoolFilter>;
  LastName?: Maybe<StringFilter>;
  NOT?: Maybe<Array<UserScalarWhereInput>>;
  OR?: Maybe<Array<UserScalarWhereInput>>;
  Password?: Maybe<StringFilter>;
  Type?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type UserScalarWhereWithAggregatesInput = {
  AND?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  Email?: Maybe<StringWithAggregatesFilter>;
  FirmId?: Maybe<IntNullableWithAggregatesFilter>;
  FirstName?: Maybe<StringWithAggregatesFilter>;
  GroupId?: Maybe<IntNullableWithAggregatesFilter>;
  IsEmailConfirmed?: Maybe<BoolWithAggregatesFilter>;
  IsPasswordChangeRequested?: Maybe<BoolWithAggregatesFilter>;
  LastName?: Maybe<StringWithAggregatesFilter>;
  NOT?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  OR?: Maybe<Array<UserScalarWhereWithAggregatesInput>>;
  Password?: Maybe<StringWithAggregatesFilter>;
  Type?: Maybe<StringWithAggregatesFilter>;
  createdAt?: Maybe<DateTimeWithAggregatesFilter>;
  id?: Maybe<IntWithAggregatesFilter>;
  isActive?: Maybe<BoolWithAggregatesFilter>;
  updatedAt?: Maybe<DateTimeWithAggregatesFilter>;
};

export type UserSumAggregate = {
  __typename?: 'UserSumAggregate';
  FirmId?: Maybe<Scalars['Int']>;
  GroupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type UserSumOrderByAggregateInput = {
  FirmId?: Maybe<SortOrder>;
  GroupId?: Maybe<SortOrder>;
  id?: Maybe<SortOrder>;
};

export type UserUpdateInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateManyMutationInput = {
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutFirmInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutGroupInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutFirmNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutFirmInput>>;
  create?: Maybe<Array<UserCreateWithoutFirmInput>>;
  createMany?: Maybe<UserCreateManyFirmInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutFirmInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutFirmInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutFirmInput>>;
};

export type UserUpdateManyWithoutGroupNestedInput = {
  connect?: Maybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: Maybe<Array<UserCreateOrConnectWithoutGroupInput>>;
  create?: Maybe<Array<UserCreateWithoutGroupInput>>;
  createMany?: Maybe<UserCreateManyGroupInputEnvelope>;
  delete?: Maybe<Array<UserWhereUniqueInput>>;
  deleteMany?: Maybe<Array<UserScalarWhereInput>>;
  disconnect?: Maybe<Array<UserWhereUniqueInput>>;
  set?: Maybe<Array<UserWhereUniqueInput>>;
  update?: Maybe<Array<UserUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: Maybe<Array<UserUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: Maybe<Array<UserUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type UserUpdateOneRequiredWithoutEventsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutEventsInput>;
  create?: Maybe<UserCreateWithoutEventsInput>;
  update?: Maybe<UserUpdateWithoutEventsInput>;
  upsert?: Maybe<UserUpsertWithoutEventsInput>;
};

export type UserUpdateOneRequiredWithoutRequestNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutRequestInput>;
  create?: Maybe<UserCreateWithoutRequestInput>;
  update?: Maybe<UserUpdateWithoutRequestInput>;
  upsert?: Maybe<UserUpsertWithoutRequestInput>;
};

export type UserUpdateOneRequiredWithoutUdinNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUdinInput>;
  create?: Maybe<UserCreateWithoutUdinInput>;
  update?: Maybe<UserUpdateWithoutUdinInput>;
  upsert?: Maybe<UserUpsertWithoutUdinInput>;
};

export type UserUpdateOneRequiredWithoutUserAccessNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutUserAccessInput>;
  create?: Maybe<UserCreateWithoutUserAccessInput>;
  update?: Maybe<UserUpdateWithoutUserAccessInput>;
  upsert?: Maybe<UserUpsertWithoutUserAccessInput>;
};

export type UserUpdateOneWithoutCaFirmNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutCaFirmInput>;
  create?: Maybe<UserCreateWithoutCaFirmInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateWithoutCaFirmInput>;
  upsert?: Maybe<UserUpsertWithoutCaFirmInput>;
};

export type UserUpdateOneWithoutForm15CbNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutForm15CbInput>;
  create?: Maybe<UserCreateWithoutForm15CbInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateWithoutForm15CbInput>;
  upsert?: Maybe<UserUpsertWithoutForm15CbInput>;
};

export type UserUpdateOneWithoutGroupsNestedInput = {
  connect?: Maybe<UserWhereUniqueInput>;
  connectOrCreate?: Maybe<UserCreateOrConnectWithoutGroupsInput>;
  create?: Maybe<UserCreateWithoutGroupsInput>;
  delete?: Maybe<Scalars['Boolean']>;
  disconnect?: Maybe<Scalars['Boolean']>;
  update?: Maybe<UserUpdateWithoutGroupsInput>;
  upsert?: Maybe<UserUpsertWithoutGroupsInput>;
};

export type UserUpdateWithWhereUniqueWithoutFirmInput = {
  data: UserUpdateWithoutFirmInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutGroupInput = {
  data: UserUpdateWithoutGroupInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutCaFirmInput = {
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutEventsInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutFirmInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutForm15CbInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutGroupInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutGroupsInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutRequestInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutUdinInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  UserAccess?: Maybe<UserAccessUpdateManyWithoutUserNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutUserAccessInput = {
  CAFirm?: Maybe<CaFirmUpdateOneWithoutAdminNestedInput>;
  Email?: Maybe<StringFieldUpdateOperationsInput>;
  Events?: Maybe<EventsUpdateManyWithoutCreatedByNestedInput>;
  Firm?: Maybe<CaFirmUpdateOneWithoutUsersNestedInput>;
  FirstName?: Maybe<StringFieldUpdateOperationsInput>;
  Form15CB?: Maybe<Form15CbUpdateManyWithoutCaNestedInput>;
  Group?: Maybe<GroupUpdateOneWithoutUsersNestedInput>;
  Groups?: Maybe<GroupUpdateOneWithoutAdminNestedInput>;
  IsEmailConfirmed?: Maybe<BoolFieldUpdateOperationsInput>;
  IsPasswordChangeRequested?: Maybe<BoolFieldUpdateOperationsInput>;
  LastName?: Maybe<StringFieldUpdateOperationsInput>;
  Password?: Maybe<StringFieldUpdateOperationsInput>;
  Request?: Maybe<RequestUpdateManyWithoutUserNestedInput>;
  Type?: Maybe<StringFieldUpdateOperationsInput>;
  Udin?: Maybe<UdinUpdateManyWithoutCaNestedInput>;
  createdAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: Maybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: Maybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpsertWithWhereUniqueWithoutFirmInput = {
  create: UserCreateWithoutFirmInput;
  update: UserUpdateWithoutFirmInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutGroupInput = {
  create: UserCreateWithoutGroupInput;
  update: UserUpdateWithoutGroupInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutCaFirmInput = {
  create: UserCreateWithoutCaFirmInput;
  update: UserUpdateWithoutCaFirmInput;
};

export type UserUpsertWithoutEventsInput = {
  create: UserCreateWithoutEventsInput;
  update: UserUpdateWithoutEventsInput;
};

export type UserUpsertWithoutForm15CbInput = {
  create: UserCreateWithoutForm15CbInput;
  update: UserUpdateWithoutForm15CbInput;
};

export type UserUpsertWithoutGroupsInput = {
  create: UserCreateWithoutGroupsInput;
  update: UserUpdateWithoutGroupsInput;
};

export type UserUpsertWithoutRequestInput = {
  create: UserCreateWithoutRequestInput;
  update: UserUpdateWithoutRequestInput;
};

export type UserUpsertWithoutUdinInput = {
  create: UserCreateWithoutUdinInput;
  update: UserUpdateWithoutUdinInput;
};

export type UserUpsertWithoutUserAccessInput = {
  create: UserCreateWithoutUserAccessInput;
  update: UserUpdateWithoutUserAccessInput;
};

export type UserWhereInput = {
  AND?: Maybe<Array<UserWhereInput>>;
  CAFirm?: Maybe<CaFirmRelationFilter>;
  Email?: Maybe<StringFilter>;
  Events?: Maybe<EventsListRelationFilter>;
  Firm?: Maybe<CaFirmRelationFilter>;
  FirmId?: Maybe<IntNullableFilter>;
  FirstName?: Maybe<StringFilter>;
  Form15CB?: Maybe<Form15CbListRelationFilter>;
  Group?: Maybe<GroupRelationFilter>;
  GroupId?: Maybe<IntNullableFilter>;
  Groups?: Maybe<GroupRelationFilter>;
  IsEmailConfirmed?: Maybe<BoolFilter>;
  IsPasswordChangeRequested?: Maybe<BoolFilter>;
  LastName?: Maybe<StringFilter>;
  NOT?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
  Password?: Maybe<StringFilter>;
  Request?: Maybe<RequestListRelationFilter>;
  Type?: Maybe<StringFilter>;
  Udin?: Maybe<UdinListRelationFilter>;
  UserAccess?: Maybe<UserAccessListRelationFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  id?: Maybe<IntFilter>;
  isActive?: Maybe<BoolFilter>;
  updatedAt?: Maybe<DateTimeFilter>;
};

export type UserWhereUniqueInput = {
  Email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ValidConfirmationTokenPayload = {
  __typename?: 'ValidConfirmationTokenPayload';
  isValid: Scalars['Boolean'];
  message: Scalars['String'];
};

export type ChangePasswordPayload = {
  __typename?: 'changePasswordPayload';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ForgotPasswordPayload = {
  __typename?: 'forgotPasswordPayload';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, createdAt: any, updatedAt: any, FirstName: string, LastName: string, Email: string, Password: string, Type: string } } | null | undefined };

export type GetAllBanksQueryVariables = Exact<{
  where?: Maybe<BankDetailWhereInput>;
}>;


export type GetAllBanksQuery = { __typename?: 'Query', bankDetails: Array<{ __typename?: 'BankDetail', id: number, BankName: string, BankBranch: string, BSRCode: string, AccountNumber: string, ifsc: string, AuthDealer: string }> };

export type CreateBeneficiaryMutationVariables = Exact<{
  data: BenefeciaryCreateInput;
}>;


export type CreateBeneficiaryMutation = { __typename?: 'Mutation', createOneBenefeciary: { __typename?: 'Benefeciary', id: number } };

export type DeleteBenefeciaryMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteBenefeciaryMutation = { __typename?: 'Mutation', deleteOneBenefeciary?: { __typename?: 'Benefeciary', id: number } | null | undefined };

export type GetAllBenefeciariesQueryVariables = Exact<{
  where?: Maybe<BenefeciaryWhereInput>;
  orderBy?: Maybe<Array<BenefeciaryOrderByWithRelationInput> | BenefeciaryOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAllBenefeciariesQuery = { __typename?: 'Query', benefeciaries: Array<{ __typename?: 'Benefeciary', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, BenefeciaryPrefix: string, BenefeciaryName: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, RelatedParty: boolean, BusinessPlace: string, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, OtherCountry?: string | null | undefined, BankName?: string | null | undefined, AccountNumber?: string | null | undefined, BankAddress?: string | null | undefined, PAN?: string | null | undefined, TaxID?: string | null | undefined, TRCAvailable: boolean, TRCDocumentDate?: any | null | undefined, TRCDocumentValidFrom?: any | null | undefined, TRCDocumentValidTill?: any | null | undefined, IsBussinessDeclaration: boolean, IsBenefeciaryOwner: boolean, PPTClauseSatisfied?: string | null | undefined, PEDocumentDate?: any | null | undefined, PEDocumentValidFrom?: any | null | undefined, PEDocumentValidTill?: any | null | undefined, IsCerticateObtained: boolean, Is10FAvailable: boolean, DocumentDate10F?: any | null | undefined, DocumentValidTill10F?: any | null | undefined, Company: { __typename?: 'Company', CompanyName: string }, Branch?: { __typename?: 'Branch', id: number, BranchName: string } | null | undefined, Certificates: Array<{ __typename?: 'BeneficiaryCertificate', id: number, CerticateRateTax?: string | null | undefined, NatureOfIncome?: string | null | undefined, CerticateSection: string, AssessingOfficerName?: string | null | undefined, AssessingOfficerDesignation?: string | null | undefined, CertificateNumber?: string | null | undefined, CertificateThreshold?: string | null | undefined, CertificateOrderDate?: any | null | undefined, CertificateValidFrom?: any | null | undefined, CerticateValidTill?: any | null | undefined }>, FolioNumbers: Array<{ __typename?: 'FolioNumber', id: number, FolioNumber?: string | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, title: string }> }>, aggregateBenefeciary: { __typename?: 'AggregateBenefeciary', _count?: { __typename?: 'BenefeciaryCountAggregate', _all: number } | null | undefined } };

export type GetBenefeciaryByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetBenefeciaryByIdQuery = { __typename?: 'Query', benefeciary?: { __typename?: 'Benefeciary', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, BenefeciaryPrefix: string, BenefeciaryName: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, BusinessPlace: string, RelatedParty: boolean, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, OtherCountry?: string | null | undefined, BankName?: string | null | undefined, AccountNumber?: string | null | undefined, BankAddress?: string | null | undefined, PAN?: string | null | undefined, TaxID?: string | null | undefined, TRCAvailable: boolean, TRCDocumentDate?: any | null | undefined, TRCDocumentValidFrom?: any | null | undefined, TRCDocumentValidTill?: any | null | undefined, IsBussinessDeclaration: boolean, IsBenefeciaryOwner: boolean, PPTClauseSatisfied?: string | null | undefined, PEDocumentDate?: any | null | undefined, PEDocumentValidFrom?: any | null | undefined, PEDocumentValidTill?: any | null | undefined, IsCerticateObtained: boolean, Is10FAvailable: boolean, DocumentDate10F?: any | null | undefined, DocumentValidTill10F?: any | null | undefined, Certificates: Array<{ __typename?: 'BeneficiaryCertificate', id: number, CerticateRateTax?: string | null | undefined, NatureOfIncome?: string | null | undefined, CerticateSection: string, AssessingOfficerName?: string | null | undefined, AssessingOfficerDesignation?: string | null | undefined, CertificateNumber?: string | null | undefined, CertificateThreshold?: string | null | undefined, CertificateOrderDate?: any | null | undefined, CertificateValidFrom?: any | null | undefined, CerticateValidTill?: any | null | undefined }>, FolioNumbers: Array<{ __typename?: 'FolioNumber', id: number, FolioNumber?: string | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> } | null | undefined };

export type UpdateBenefeciaryMutationVariables = Exact<{
  data: BenefeciaryUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateBenefeciaryMutation = { __typename?: 'Mutation', updateOneBenefeciary?: { __typename?: 'Benefeciary', id: number } | null | undefined };

export type CreateBranchMutationVariables = Exact<{
  data: BranchCreateInput;
}>;


export type CreateBranchMutation = { __typename?: 'Mutation', createOneBranch: { __typename?: 'Branch', id: number } };

export type DeleteBranchMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteBranchMutation = { __typename?: 'Mutation', deleteOneBranch?: { __typename?: 'Branch', id: number } | null | undefined };

export type GetAllBranchesQueryVariables = Exact<{
  where?: Maybe<BranchWhereInput>;
}>;


export type GetAllBranchesQuery = { __typename?: 'Query', branches: Array<{ __typename?: 'Branch', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, isActive: boolean, Honorific: string, BranchName: string, Status: string, ResidentialStatus: string, Email: string, Mobile: string, TAN: string, PAN: string, CertificateOption: string, BusinessPlace: string, ClientApproval: boolean, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string }> };

export type GetBranchByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetBranchByIdQuery = { __typename?: 'Query', branch?: { __typename?: 'Branch', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, Honorific: string, isActive: boolean, BranchName: string, Status: string, ResidentialStatus: string, Email: string, Mobile: string, TAN: string, PAN: string, CertificateOption: string, BusinessPlace: string, ClientApproval: boolean, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, ITPass: string, IorWe: string, VerifierName: string, VerifierFatherName: string, VerifierDesignation: string, VerifierPlace: string, BankDetail: Array<{ __typename?: 'BankDetail', BankName: string, BankBranch: string, AccountNumber: string, BSRCode: string, ifsc: string, id: number, AuthDealer: string }>, Company: { __typename?: 'Company', id: number, CompanyName: string }, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> } | null | undefined };

export type UpdateBranchMutationVariables = Exact<{
  data: BranchUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateBranchMutation = { __typename?: 'Mutation', updateOneBranch?: { __typename?: 'Branch', id: number } | null | undefined };

export type CreateCaFirmMutationVariables = Exact<{
  data: CaFirmCreateInput;
}>;


export type CreateCaFirmMutation = { __typename?: 'Mutation', createOneCAFirm: { __typename?: 'CAFirm', id: number } };

export type DeleteCaFirmMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteCaFirmMutation = { __typename?: 'Mutation', deleteOneCAFirm?: { __typename?: 'CAFirm', id: number } | null | undefined };

export type GetAllCaFirmsQueryVariables = Exact<{
  where?: Maybe<CaFirmWhereInput>;
}>;


export type GetAllCaFirmsQuery = { __typename?: 'Query', cAFirms: Array<{ __typename?: 'CAFirm', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, IorWe: string, FirmName: string, FirmRegisterNumber: string, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string }> };

export type GetCaFirmByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetCaFirmByIdQuery = { __typename?: 'Query', cAFirm?: { __typename?: 'CAFirm', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, IorWe: string, FirmName: string, FirmRegisterNumber: string, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, Admin?: { __typename?: 'User', id: number, FirstName: string, LastName: string, Email: string, isActive: boolean } | null | undefined, Users: Array<{ __typename?: 'User', id: number, FirstName: string, LastName: string, Email: string, Type: string, isActive: boolean }> } | null | undefined };

export type GetAllCAusersQueryVariables = Exact<{
  where?: Maybe<UserWhereInput>;
}>;


export type GetAllCAusersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, FirstName: string, LastName: string, UserAccess: Array<{ __typename?: 'UserAccess', id: number, Role?: string | null | undefined, GroupId: number, BranchId?: number | null | undefined, CompanyId: number, MembershipNumber?: string | null | undefined }> }> };

export type GetFirstCaFirmQueryVariables = Exact<{
  where?: Maybe<CaFirmWhereInput>;
}>;


export type GetFirstCaFirmQuery = { __typename?: 'Query', findFirstCAFirm?: { __typename?: 'CAFirm', IorWe: string, FirmName: string, FirmRegisterNumber: string, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, State: string, Country: string, Pincode: string } | null | undefined };

export type UpdateCaFirmMutationVariables = Exact<{
  data: CaFirmUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateCaFirmMutation = { __typename?: 'Mutation', updateOneCAFirm?: { __typename?: 'CAFirm', id: number } | null | undefined };

export type CreateCompanyMutationVariables = Exact<{
  data: CompanyCreateInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createOneCompany: { __typename?: 'Company', id: number } };

export type DeleteCompanyMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteOneCompany?: { __typename?: 'Company', id: number } | null | undefined };

export type GetAllCompaniesQueryVariables = Exact<{
  where?: Maybe<CompanyWhereInput>;
}>;


export type GetAllCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, Honorific: string, isActive: boolean, CompanyName: string, Status: string, ResidentialStatus: string, Email: string, Mobile: string, TAN?: string | null | undefined, PAN?: string | null | undefined, CertificateOption: string, BusinessPlace: string, ClientApproval: boolean, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string }> };

export type GetCompanyByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetCompanyByIdQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, Honorific: string, isActive: boolean, CompanyName: string, Status: string, ResidentialStatus: string, Email: string, Mobile: string, TAN?: string | null | undefined, PAN?: string | null | undefined, CertificateOption: string, BusinessPlace: string, ClientApproval: boolean, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, ITPass: string, IorWe: string, VerifierName: string, VerifierFatherName: string, VerifierDesignation: string, VerifierPlace: string, BankDetail: Array<{ __typename?: 'BankDetail', BankName: string, BankBranch: string, AccountNumber: string, BSRCode: string, ifsc: string, id: number, AuthDealer: string }>, Group: { __typename?: 'Group', id: number, GroupName: string }, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> } | null | undefined };

export type UpdateCompanyMutationVariables = Exact<{
  data: CompanyUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateOneCompany?: { __typename?: 'Company', id: number } | null | undefined };

export type DashboardDataQueryVariables = Exact<{
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  benefeciaryFilter?: Maybe<BenefeciaryRelationFilter>;
  requestWhereInput?: Maybe<RequestWhereInput>;
}>;


export type DashboardDataQuery = { __typename?: 'Query', aggregateForm15CB: { __typename?: 'AggregateForm15CB', _count?: { __typename?: 'Form15CBCountAggregate', _all: number } | null | undefined }, aggregateForm15CAA: { __typename?: 'AggregateForm15CAA', _count?: { __typename?: 'Form15CAACountAggregate', _all: number } | null | undefined }, aggregateForm15CAB: { __typename?: 'AggregateForm15CAB', _count?: { __typename?: 'Form15CABCountAggregate', _all: number } | null | undefined }, aggregateForm15CAC: { __typename?: 'AggregateForm15CAC', _count?: { __typename?: 'Form15CACCountAggregate', _all: number } | null | undefined }, aggregateForm15CAD: { __typename?: 'AggregateForm15CAD', _count?: { __typename?: 'Form15CADCountAggregate', _all: number } | null | undefined }, aggregateRequest: { __typename?: 'AggregateRequest', _count?: { __typename?: 'RequestCountAggregate', _all: number } | null | undefined }, TotalPaymentTDS_CB: Array<{ __typename?: 'Form15CB', amount: number, Events: Array<{ __typename?: 'Events', CertificateDate?: any | null | undefined, isLatest: boolean }> }>, TotalPaymentTDS_CAA: Array<{ __typename?: 'Form15CAA', amount: number, Events: Array<{ __typename?: 'Events', CertificateDate?: any | null | undefined, isLatest: boolean }> }>, TotalPaymentTDS_CAB: Array<{ __typename?: 'Form15CAB', amount: number, Events: Array<{ __typename?: 'Events', CertificateDate?: any | null | undefined, isLatest: boolean }> }>, TotalPaymentTDS_CAD: Array<{ __typename?: 'Form15CAD', amount: number, Events: Array<{ __typename?: 'Events', CertificateDate?: any | null | undefined, isLatest: boolean }> }>, TotalTDS_CB: Array<{ __typename?: 'Form15CB', amount?: number | null | undefined, Events: Array<{ __typename?: 'Events', CertificateDate?: any | null | undefined, isLatest: boolean }> }>, TotalTDS_CAA: Array<{ __typename?: 'Form15CAA', amount: number, Events: Array<{ __typename?: 'Events', CertificateDate?: any | null | undefined, isLatest: boolean }> }>, TotalTDS_CAB: Array<{ __typename?: 'Form15CAB', amount: number, Events: Array<{ __typename?: 'Events', CertificateDate?: any | null | undefined, isLatest: boolean }> }>, RemNatureCB: Array<{ __typename?: 'Form15CBGroupBy', NatureOfRemittance: string, _sum?: { __typename?: 'Form15CBSumAggregate', AmountPayableINR?: number | null | undefined } | null | undefined }>, RemNatureCAA: Array<{ __typename?: 'Form15CAAGroupBy', NatureOfRemittance: string, _sum?: { __typename?: 'Form15CAASumAggregate', AmountPayableINR?: number | null | undefined } | null | undefined }>, RemNatureCAB: Array<{ __typename?: 'Form15CABGroupBy', NatureOfRemittance: string, _sum?: { __typename?: 'Form15CABSumAggregate', AmountPayableINR?: number | null | undefined } | null | undefined }>, RemNatureCAD: Array<{ __typename?: 'Form15CADGroupBy', NatureOfRemittance: string, _sum?: { __typename?: 'Form15CADSumAggregate', AmountPayableINR?: number | null | undefined } | null | undefined }> };

export type SendApprovedEmailMutationVariables = Exact<{
  formType: Scalars['String'];
  formId: Scalars['Float'];
}>;


export type SendApprovedEmailMutation = { __typename?: 'Mutation', sendApprovedEmail?: { __typename?: 'EmailResponsePayload', message: string } | null | undefined };

export type SendRejectionEmailMutationVariables = Exact<{
  formType: Scalars['String'];
  formId: Scalars['Float'];
}>;


export type SendRejectionEmailMutation = { __typename?: 'Mutation', sendRejectionEmail?: { __typename?: 'EmailResponsePayload', message: string } | null | undefined };

export type CreateForm15CaaMutationVariables = Exact<{
  data: Form15CaaCreateInput;
}>;


export type CreateForm15CaaMutation = { __typename?: 'Mutation', createOneForm15CAA: { __typename?: 'Form15CAA', id: number } };

export type DeleteForm15CaaMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteForm15CaaMutation = { __typename?: 'Mutation', deleteOneForm15CAA?: { __typename?: 'Form15CAA', id: number } | null | undefined };

export type GetAllForm15CaasQueryVariables = Exact<{
  where?: Maybe<Form15CaaWhereInput>;
  orderBy?: Maybe<Array<Form15CaaOrderByWithRelationInput> | Form15CaaOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAllForm15CaasQuery = { __typename?: 'Query', form15CAAS: Array<{ __typename?: 'Form15CAA', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, BankDetailId: number, BankName: string, BranchName: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, CountryOfRemittance: string, CountryOfRemittanceOther?: string | null | undefined, AmountPayableBeforeINR: number, AggregateAmount: string, ProposedDate: any, RemittanceNameOnDocument: string, RemittanceNameOnDocumentOther?: string | null | undefined, PurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, RateOfTDS: string, AmountOfTDSInINR: number, DateOfDeduction?: any | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string, PAN?: string | null | undefined, Flat: string, Locality: string, Building?: string | null | undefined, Country: string, State: string, Street?: string | null | undefined, OtherCountry?: string | null | undefined, Pincode: string, BusinessPlace: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, RelatedParty: boolean, Branch?: { __typename?: 'Branch', id: number, BranchName: string } | null | undefined, Company: { __typename?: 'Company', id: number, CompanyName: string } }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> }>, aggregateForm15CAA: { __typename?: 'AggregateForm15CAA', _count?: { __typename?: 'Form15CAACountAggregate', _all: number } | null | undefined } };

export type GetAllForm15caaForDdQueryVariables = Exact<{
  where?: Maybe<Form15CaaWhereInput>;
}>;


export type GetAllForm15caaForDdQuery = { __typename?: 'Query', form15CAAS: Array<{ __typename?: 'Form15CAA', id: number }> };

export type GetForm15CaaByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetForm15CaaByIdQuery = { __typename?: 'Query', form15CAA?: { __typename?: 'Form15CAA', id: number, RevokedToId?: number | null | undefined, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, BankDetailId: number, BankName: string, BranchName: string, ifsc: string, AuthDealer: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, CountryOfRemittance: string, CountryOfRemittanceOther?: string | null | undefined, AmountPayableBeforeINR: number, AggregateAmount: string, ProposedDate: any, RemittanceNameOnDocument: string, RemittanceNameOnDocumentOther?: string | null | undefined, PurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, RateOfTDS: string, AmountOfTDSInINR: number, DateOfDeduction?: any | null | undefined, RevokedFrom?: { __typename?: 'Form15CAA', id: number } | null | undefined, RevokedToForm?: { __typename?: 'Form15CAA', id: number } | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, Document: Array<{ __typename?: 'Document', id: number, fileId?: number | null | undefined, Tag?: string | null | undefined, title: string, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', path: string } | null | undefined }> }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, UDIN?: string | null | undefined, createdAt: any, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> } | null | undefined };

export type UpdateForm15CaaMutationVariables = Exact<{
  data: Form15CaaUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateForm15CaaMutation = { __typename?: 'Mutation', updateOneForm15CAA?: { __typename?: 'Form15CAA', id: number } | null | undefined };

export type CreateForm15CabMutationVariables = Exact<{
  data: Form15CabCreateInput;
}>;


export type CreateForm15CabMutation = { __typename?: 'Mutation', createOneForm15CAB: { __typename?: 'Form15CAB', id: number } };

export type DeleteForm15CabMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteForm15CabMutation = { __typename?: 'Mutation', deleteOneForm15CAB?: { __typename?: 'Form15CAB', id: number } | null | undefined };

export type GetAllForm15CabsQueryVariables = Exact<{
  where?: Maybe<Form15CabWhereInput>;
  orderBy?: Maybe<Array<Form15CabOrderByWithRelationInput> | Form15CabOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAllForm15CabsQuery = { __typename?: 'Query', form15CABS: Array<{ __typename?: 'Form15CAB', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, CertificateSection: string, OfficerNameAO: string, OfficerDesignationAO: string, CertificateDateAO: any, CertificateNumberAO: string, CountryOfRemittance: string, CountryOfRemittanceOther?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, AmountPayable: string, ExchangeRate: string, AmountPayableINR: number, BankDetailId: number, BankName: string, BranchName: string, BSRCode: string, ProposedDate: any, RemittanceNameOnDocument: string, RemittanceNameOnDocumentOther?: string | null | undefined, PurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, RateOfTDS: string, AmountOfTDSInINR: number, DateOfDeduction?: any | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string, PAN?: string | null | undefined, Flat: string, Locality: string, Building?: string | null | undefined, Country: string, State: string, Street?: string | null | undefined, OtherCountry?: string | null | undefined, Pincode: string, BusinessPlace: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, RelatedParty: boolean, Branch?: { __typename?: 'Branch', id: number, BranchName: string } | null | undefined, Company: { __typename?: 'Company', id: number, CompanyName: string } }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> }>, aggregateForm15CAB: { __typename?: 'AggregateForm15CAB', _count?: { __typename?: 'Form15CABCountAggregate', _all: number } | null | undefined } };

export type GetAllForm15cabForDdQueryVariables = Exact<{
  where?: Maybe<Form15CabWhereInput>;
}>;


export type GetAllForm15cabForDdQuery = { __typename?: 'Query', form15CABS: Array<{ __typename?: 'Form15CAB', id: number }> };

export type GetForm15CabByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetForm15CabByIdQuery = { __typename?: 'Query', form15CAB?: { __typename?: 'Form15CAB', id: number, RevokedToId?: number | null | undefined, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, CertificateSection: string, OfficerNameAO: string, OfficerDesignationAO: string, CertificateDateAO: any, CertificateNumberAO: string, CountryOfRemittance: string, CountryOfRemittanceOther?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, AmountPayable: string, ExchangeRate: string, AmountPayableINR: number, BankDetailId: number, BankName: string, BranchName: string, BSRCode: string, ifsc: string, AuthDealer: string, ProposedDate: any, RemittanceNameOnDocument: string, RemittanceNameOnDocumentOther?: string | null | undefined, PurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, RateOfTDS: string, AmountOfTDSInINR: number, DateOfDeduction?: any | null | undefined, RevokedFrom?: { __typename?: 'Form15CAB', id: number } | null | undefined, RevokedToForm?: { __typename?: 'Form15CAB', id: number } | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, Document: Array<{ __typename?: 'Document', id: number, fileId?: number | null | undefined, Tag?: string | null | undefined, title: string, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', path: string } | null | undefined }> }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, UDIN?: string | null | undefined, createdAt: any, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> } | null | undefined };

export type UpdateForm15CabMutationVariables = Exact<{
  data: Form15CabUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateForm15CabMutation = { __typename?: 'Mutation', updateOneForm15CAB?: { __typename?: 'Form15CAB', id: number } | null | undefined };

export type CreateForm15CacMutationVariables = Exact<{
  data: Form15CacCreateInput;
}>;


export type CreateForm15CacMutation = { __typename?: 'Mutation', createOneForm15CAC: { __typename?: 'Form15CAC', id: number } };

export type DeleteForm15CacMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteForm15CacMutation = { __typename?: 'Mutation', deleteOneForm15CAC?: { __typename?: 'Form15CAC', id: number } | null | undefined };

export type GetAllForm15CacsQueryVariables = Exact<{
  where?: Maybe<Form15CacWhereInput>;
  orderBy?: Maybe<Array<Form15CacOrderByWithRelationInput> | Form15CacOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAllForm15CacsQuery = { __typename?: 'Query', form15CACS: Array<{ __typename?: 'Form15CAC', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Status: string, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, ResidentCountry: string, BusinessPlace: string, AccountantName: string, AccountantFirm: string, AccountantFlat: string, AccountantBuilding?: string | null | undefined, AccountantStreet?: string | null | undefined, AccountantLocality: string, AccountantCity: string, AccountantState: string, AccountantCountry: string, AccountantPincode: string, AccountantMembershipNumber: string, AccountantRegistrationNumber: string, AccountantCertificateDate: any, AccountantCertificateNumber: string, IsCertificateObtained: boolean, CertificateSection?: string | null | undefined, OfficerNameAO?: string | null | undefined, OfficerDesignationAO?: string | null | undefined, CertificateDateAO?: any | null | undefined, CertificateNumberAO?: string | null | undefined, RemittanceCountry: string, OtherRemittanceCountry?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, PayableAmountInForeign: number, ExchangeRate: string, PayableAmountINR: number, BankName: string, BranchName: string, BSRCode: string, ProposedDate: any, RemittanceNameOnDocument: string, OtherRemittanceNameOnDocument?: string | null | undefined, RBIPurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, IsRemittanceChargeableIndia: boolean, ReasonRemittanceNotChargeable?: string | null | undefined, SectionOfActRemittanceCovered?: string | null | undefined, IncomeChargeableToTax?: number | null | undefined, TaxLiability?: number | null | undefined, DeterminingTaxAndLiability?: string | null | undefined, ChargeableAndReliefDTAA: boolean, TaxResidencyCertificateObtained?: boolean | null | undefined, TaxResidencyCertificateMade?: boolean | null | undefined, CertificateDTAA?: string | null | undefined, CertificateArticleOfDTAA?: string | null | undefined, DTAATaxableIncome?: number | null | undefined, DTAATaxLiability?: number | null | undefined, IsWithPermanentEstablishment?: boolean | null | undefined, PermanentEstablishmentArticle?: string | null | undefined, PermanentEstablishmentRateOfTDS?: number | null | undefined, IsAccountOfBusinessIncome?: boolean | null | undefined, SuchIncomeLiableToTaxIN?: boolean | null | undefined, IfBasisOfTheRateOfDeduction?: string | null | undefined, NoReasonRelevantArticleDTAA?: string | null | undefined, IsRemittanceCapitalGains?: boolean | null | undefined, AmountOfCapitalGains?: number | null | undefined, AmountOfShortCapitalGains?: number | null | undefined, BasisOfTaxableIncome?: string | null | undefined, CapitalGainsRateOfTDS?: number | null | undefined, IsRemittanceCovered?: boolean | null | undefined, NatureOfRemittance?: string | null | undefined, TaxableInIndiaDTAA?: boolean | null | undefined, YesTaxableInIndiaDTAA?: number | null | undefined, NoTaxableInIndiaDTAA?: string | null | undefined, TransactionLengthPrice?: boolean | null | undefined, RateOfTDSIncomeTaxAct?: string | null | undefined, RateOfTDS?: string | null | undefined, AmountOfTDSInForeign?: number | null | undefined, AmountOfTDSInINR?: number | null | undefined, AmountAfterTDS?: number | null | undefined, DateOfDeduction?: any | null | undefined, BankDetailId: number, Beneficiary: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string, PAN?: string | null | undefined, Flat: string, Locality: string, Building?: string | null | undefined, Country: string, State: string, Street?: string | null | undefined, OtherCountry?: string | null | undefined, Pincode: string, BusinessPlace: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, RelatedParty: boolean, Branch?: { __typename?: 'Branch', id: number, BranchName: string } | null | undefined, Company: { __typename?: 'Company', id: number, CompanyName: string } }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Form15CB: { __typename?: 'Form15CB', id: number, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, State: string, Country: string, Pincode: string, AccountantMembershipNumber: string, AccountantRegistrationNumber: string, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, CertificateDate?: any | null | undefined, AckNumber?: string | null | undefined, UDIN?: string | null | undefined }> } }>, aggregateForm15CAC: { __typename?: 'AggregateForm15CAC', _count?: { __typename?: 'Form15CACCountAggregate', _all: number } | null | undefined } };

export type GetAllForm15cacForDdQueryVariables = Exact<{
  where?: Maybe<Form15CacWhereInput>;
}>;


export type GetAllForm15cacForDdQuery = { __typename?: 'Query', form15CACS: Array<{ __typename?: 'Form15CAC', id: number }> };

export type GetForm15CacByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetForm15CacByIdQuery = { __typename?: 'Query', form15CAC?: { __typename?: 'Form15CAC', id: number, RevokedToId?: number | null | undefined, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Status: string, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, ResidentCountry: string, BusinessPlace: string, AccountantName: string, AccountantFirm: string, AccountantFlat: string, AccountantBuilding?: string | null | undefined, AccountantStreet?: string | null | undefined, AccountantLocality: string, AccountantCity: string, AccountantState: string, AccountantCountry: string, AccountantPincode: string, AccountantMembershipNumber: string, AccountantRegistrationNumber: string, AccountantCertificateDate: any, AccountantCertificateNumber: string, IsCertificateObtained: boolean, CertificateSection?: string | null | undefined, OfficerNameAO?: string | null | undefined, OfficerDesignationAO?: string | null | undefined, CertificateDateAO?: any | null | undefined, CertificateNumberAO?: string | null | undefined, RemittanceCountry: string, OtherRemittanceCountry?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, PayableAmountInForeign: number, ExchangeRate: string, PayableAmountINR: number, BankName: string, BranchName: string, BSRCode: string, ProposedDate: any, ifsc: string, AuthDealer: string, RemittanceNameOnDocument: string, OtherRemittanceNameOnDocument?: string | null | undefined, RBIPurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, IsRemittanceChargeableIndia: boolean, ReasonRemittanceNotChargeable?: string | null | undefined, SectionOfActRemittanceCovered?: string | null | undefined, IncomeChargeableToTax?: number | null | undefined, TaxLiability?: number | null | undefined, DeterminingTaxAndLiability?: string | null | undefined, ChargeableAndReliefDTAA: boolean, TaxResidencyCertificateObtained?: boolean | null | undefined, TaxResidencyCertificateMade?: boolean | null | undefined, CertificateDTAA?: string | null | undefined, CertificateArticleOfDTAA?: string | null | undefined, DTAATaxableIncome?: number | null | undefined, DTAATaxLiability?: number | null | undefined, IsWithPermanentEstablishment?: boolean | null | undefined, PermanentEstablishmentArticle?: string | null | undefined, PermanentEstablishmentRateOfTDS?: number | null | undefined, IsAccountOfBusinessIncome?: boolean | null | undefined, SuchIncomeLiableToTaxIN?: boolean | null | undefined, IfBasisOfTheRateOfDeduction?: string | null | undefined, NoReasonRelevantArticleDTAA?: string | null | undefined, IsRemittanceCapitalGains?: boolean | null | undefined, AmountOfCapitalGains?: number | null | undefined, AmountOfShortCapitalGains?: number | null | undefined, BasisOfTaxableIncome?: string | null | undefined, CapitalGainsRateOfTDS?: number | null | undefined, IsRemittanceCovered?: boolean | null | undefined, NatureOfRemittance?: string | null | undefined, TaxableInIndiaDTAA?: boolean | null | undefined, YesTaxableInIndiaDTAA?: number | null | undefined, NoTaxableInIndiaDTAA?: string | null | undefined, IsRelatedParty?: boolean | null | undefined, TransactionLengthPrice?: boolean | null | undefined, RateOfTDSIncomeTaxAct?: string | null | undefined, RateOfTDS?: string | null | undefined, AmountOfTDSInForeign?: number | null | undefined, AmountOfTDSInINR?: number | null | undefined, AmountAfterTDS?: number | null | undefined, DateOfDeduction?: any | null | undefined, BankDetailId: number, AreaCode?: string | null | undefined, AoType?: string | null | undefined, RangeCode?: string | null | undefined, AoNumber?: string | null | undefined, RevokedFrom?: { __typename?: 'Form15CAC', id: number } | null | undefined, RevokedToForm?: { __typename?: 'Form15CAC', id: number } | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, BusinessPlace: string, Document: Array<{ __typename?: 'Document', id: number, fileId?: number | null | undefined, Tag?: string | null | undefined, title: string, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', path: string } | null | undefined }> }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, UDIN?: string | null | undefined, createdAt: any, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }> } | null | undefined };

export type UpdateForm15CacMutationVariables = Exact<{
  data: Form15CacUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateForm15CacMutation = { __typename?: 'Mutation', updateOneForm15CAC?: { __typename?: 'Form15CAC', id: number } | null | undefined };

export type CreateForm15CadMutationVariables = Exact<{
  data: Form15CadCreateInput;
}>;


export type CreateForm15CadMutation = { __typename?: 'Mutation', createOneForm15CAD: { __typename?: 'Form15CAD', id: number } };

export type DeleteForm15CadMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteForm15CadMutation = { __typename?: 'Mutation', deleteOneForm15CAD?: { __typename?: 'Form15CAD', id: number } | null | undefined };

export type GetAllForm15CadsQueryVariables = Exact<{
  where?: Maybe<Form15CadWhereInput>;
  orderBy?: Maybe<Array<Form15CadOrderByWithRelationInput> | Form15CadOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAllForm15CadsQuery = { __typename?: 'Query', form15CADS: Array<{ __typename?: 'Form15CAD', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, BankName: string, BranchName: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, ResidentCountry: string, CountryOfRemittance: string, CountryOfRemittanceOther?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, AmountPayable: string, ExchangeRate: string, AmountPayableINR: number, BSRCode: string, ProposedDate: any, RemittanceNameOnDocument: string, RemittanceNameOnDocumentOther?: string | null | undefined, PurposeCode: string, SubCategory: string, BankDetailId: number, Beneficiary: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string, PAN?: string | null | undefined, Flat: string, Locality: string, Building?: string | null | undefined, Country: string, State: string, Street?: string | null | undefined, OtherCountry?: string | null | undefined, Pincode: string, BusinessPlace: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, RelatedParty: boolean, Branch?: { __typename?: 'Branch', id: number, BranchName: string } | null | undefined, Company: { __typename?: 'Company', id: number, CompanyName: string } }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> }>, aggregateForm15CAD: { __typename?: 'AggregateForm15CAD', _count?: { __typename?: 'Form15CADCountAggregate', _all: number } | null | undefined } };

export type GetAllForm15cadForDdQueryVariables = Exact<{
  where?: Maybe<Form15CadWhereInput>;
}>;


export type GetAllForm15cadForDdQuery = { __typename?: 'Query', form15CADS: Array<{ __typename?: 'Form15CAD', id: number }> };

export type GetForm15CadByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetForm15CadByIdQuery = { __typename?: 'Query', form15CAD?: { __typename?: 'Form15CAD', id: number, RevokedToId?: number | null | undefined, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, RecipientName: string, RecipientPAN?: string | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, Pincode: string, State: string, Country: string, BankName: string, BranchName: string, Email?: string | null | undefined, PhoneNumber?: string | null | undefined, ResidentCountry: string, CountryOfRemittance: string, CountryOfRemittanceOther?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, AmountPayable: string, ExchangeRate: string, AmountPayableINR: number, BSRCode: string, ProposedDate: any, ifsc: string, AuthDealer: string, RemittanceNameOnDocument: string, RemittanceNameOnDocumentOther?: string | null | undefined, PurposeCode: string, SubCategory: string, BankDetailId: number, RevokedFrom?: { __typename?: 'Form15CAD', id: number } | null | undefined, RevokedToForm?: { __typename?: 'Form15CAD', id: number } | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, Document: Array<{ __typename?: 'Document', id: number, fileId?: number | null | undefined, Tag?: string | null | undefined, title: string, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', path: string } | null | undefined }> }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, AckNumber?: string | null | undefined, UDIN?: string | null | undefined, createdAt: any, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> } | null | undefined };

export type UpdateForm15CadMutationVariables = Exact<{
  data: Form15CadUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateForm15CadMutation = { __typename?: 'Mutation', updateOneForm15CAD?: { __typename?: 'Form15CAD', id: number } | null | undefined };

export type CreateForm15CbMutationVariables = Exact<{
  data: Form15CbCreateInput;
}>;


export type CreateForm15CbMutation = { __typename?: 'Mutation', createOneForm15CB: { __typename?: 'Form15CB', id: number } };

export type DeleteForm15CbMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteForm15CbMutation = { __typename?: 'Mutation', deleteOneForm15CB?: { __typename?: 'Form15CB', id: number } | null | undefined };

export type GetAllForm15CbsQueryVariables = Exact<{
  where?: Maybe<Form15CbWhereInput>;
  orderBy?: Maybe<Array<Form15CbOrderByWithRelationInput> | Form15CbOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAllForm15CbsQuery = { __typename?: 'Query', form15CBS: Array<{ __typename?: 'Form15CB', id: number, RequestId?: number | null | undefined, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, State: string, Country: string, Pincode: string, RemittanceCountry: string, OtherRemittanceCountry?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, PayableAmountInForeign: number, ExchangeRate: string, PayableAmountINR: number, BankName: string, BranchName: string, BSRCode: string, ProposedDate: any, RemittanceNameOnDocument: string, OtherRemittanceNameOnDocument?: string | null | undefined, RBIPurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, IsRemittanceChargeableIndia: boolean, ReasonRemittanceNotChargeable?: string | null | undefined, SectionOfActRemittanceCovered?: string | null | undefined, IncomeChargeableToTax?: number | null | undefined, TaxLiability?: number | null | undefined, DeterminingTaxAndLiability?: string | null | undefined, IncomeTaxRateOfTDS?: number | null | undefined, ChargeableAndReliefDTAA: boolean, TaxResidencyCertificateObtained: boolean, TaxResidencyCertificateMade?: boolean | null | undefined, CertificateDTAA?: string | null | undefined, CertificateArticleOfDTAA?: string | null | undefined, DTAATaxableIncome?: number | null | undefined, DTAATaxLiability?: number | null | undefined, IsWithPermanentEstablishment?: boolean | null | undefined, PermanentEstablishmentArticle?: string | null | undefined, PermanentEstablishmentRateOfTDS?: number | null | undefined, IsAccountOfBusinessIncome?: boolean | null | undefined, SuchIncomeLiableToTaxIN?: boolean | null | undefined, IfBasisOfTheRateOfDeduction?: string | null | undefined, NoReasonRelevantArticleDTAA?: string | null | undefined, IsRemittanceCapitalGains?: boolean | null | undefined, AmountOfCapitalGains?: number | null | undefined, AmountOfShortCapitalGains?: number | null | undefined, BasisOfTaxableIncome?: string | null | undefined, CapitalGainsRateOfTDS?: number | null | undefined, IsRemittanceCovered?: boolean | null | undefined, NatureOfRemittance?: string | null | undefined, TaxableInIndiaDTAA?: boolean | null | undefined, YesTaxableInIndiaDTAA?: number | null | undefined, NoTaxableInIndiaDTAA?: string | null | undefined, TransactionLengthPrice?: boolean | null | undefined, RateOfTDSIncomeTaxAct?: string | null | undefined, RateOfTDS?: string | null | undefined, AmountOfTDSInForeign?: number | null | undefined, AmountOfTDSInINR?: number | null | undefined, AmountAfterTDS?: number | null | undefined, DateOfDeduction?: any | null | undefined, AccountantName: string, AccountantFirmName: string, AccountantFlat: string, AccountantBuilding?: string | null | undefined, AccountantStreet?: string | null | undefined, AccountantLocality: string, AccountantCity: string, AccountantState: string, AccountantCountry: string, AccountantPincode: string, AccountantMembershipNumber: string, AccountantRegistrationNumber: string, BankDetailId: number, Form15CAC?: { __typename?: 'Form15CAC', id: number } | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string, PAN?: string | null | undefined, Flat: string, Locality: string, Building?: string | null | undefined, Country: string, State: string, Street?: string | null | undefined, OtherCountry?: string | null | undefined, Pincode: string, BusinessPlace: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, RelatedParty: boolean, Branch?: { __typename?: 'Branch', id: number, BranchName: string } | null | undefined, Company: { __typename?: 'Company', id: number, CompanyName: string } }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, createdAt: any, CertificateDate?: any | null | undefined, AckNumber?: string | null | undefined, UDIN?: string | null | undefined, CreatedBy: { __typename?: 'User', id: number, FirstName: string, LastName: string }, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }> }>, aggregateForm15CB: { __typename?: 'AggregateForm15CB', _count?: { __typename?: 'Form15CBCountAggregate', _all: number } | null | undefined } };

export type GetAllForm15cbForDdQueryVariables = Exact<{
  where?: Maybe<Form15CbWhereInput>;
}>;


export type GetAllForm15cbForDdQuery = { __typename?: 'Query', form15CBS: Array<{ __typename?: 'Form15CB', id: number }> };

export type GetForm15CbByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetForm15CbByIdQuery = { __typename?: 'Query', form15CB?: { __typename?: 'Form15CB', id: number, RevokedToId?: number | null | undefined, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, Flat: string, Building?: string | null | undefined, Street?: string | null | undefined, Locality: string, City: string, State: string, Country: string, Pincode: string, RemittanceCountry: string, OtherRemittanceCountry?: string | null | undefined, RemittanceCurrency: string, OtherRemittanceCurrency?: string | null | undefined, PayableAmountInForeign: number, ExchangeRate: string, PayableAmountINR: number, BankName: string, BranchName: string, BSRCode: string, ifsc: string, AuthDealer: string, ProposedDate: any, RemittanceNameOnDocument: string, OtherRemittanceNameOnDocument?: string | null | undefined, RBIPurposeCode: string, SubCategory: string, IsTaxPayableGrossedUp: boolean, IsRemittanceChargeableIndia: boolean, ReasonRemittanceNotChargeable?: string | null | undefined, SectionOfActRemittanceCovered?: string | null | undefined, IncomeChargeableToTax?: number | null | undefined, TaxLiability?: number | null | undefined, DeterminingTaxAndLiability?: string | null | undefined, IncomeTaxRateOfTDS?: number | null | undefined, ChargeableAndReliefDTAA: boolean, TaxResidencyCertificateObtained: boolean, TaxResidencyCertificateMade?: boolean | null | undefined, CertificateDTAA?: string | null | undefined, CertificateArticleOfDTAA?: string | null | undefined, DTAATaxableIncome?: number | null | undefined, DTAATaxLiability?: number | null | undefined, IsWithPermanentEstablishment?: boolean | null | undefined, PermanentEstablishmentArticle?: string | null | undefined, PermanentEstablishmentRateOfTDS?: number | null | undefined, IsAccountOfBusinessIncome?: boolean | null | undefined, SuchIncomeLiableToTaxIN?: boolean | null | undefined, IfBasisOfTheRateOfDeduction?: string | null | undefined, NoReasonRelevantArticleDTAA?: string | null | undefined, IsRemittanceCapitalGains?: boolean | null | undefined, AmountOfCapitalGains?: number | null | undefined, AmountOfShortCapitalGains?: number | null | undefined, BasisOfTaxableIncome?: string | null | undefined, CapitalGainsRateOfTDS?: number | null | undefined, IsRemittanceCovered?: boolean | null | undefined, NatureOfRemittance?: string | null | undefined, TaxableInIndiaDTAA?: boolean | null | undefined, YesTaxableInIndiaDTAA?: number | null | undefined, NoTaxableInIndiaDTAA?: string | null | undefined, IsRelatedParty?: boolean | null | undefined, TransactionLengthPrice?: boolean | null | undefined, RateOfTDSIncomeTaxAct?: string | null | undefined, RateOfTDS?: string | null | undefined, AmountOfTDSInForeign?: number | null | undefined, AmountOfTDSInINR?: number | null | undefined, AmountAfterTDS?: number | null | undefined, DateOfDeduction?: any | null | undefined, AccountantName: string, AccountantFirmName: string, AccountantFlat: string, AccountantBuilding?: string | null | undefined, AccountantStreet?: string | null | undefined, AccountantLocality: string, AccountantCity: string, AccountantState: string, AccountantCountry: string, AccountantPincode: string, AccountantMembershipNumber: string, AccountantRegistrationNumber: string, BankDetailId: number, RequestId?: number | null | undefined, Form15CAC?: { __typename?: 'Form15CAC', id: number } | null | undefined, RevokedFrom?: { __typename?: 'Form15CB', id: number } | null | undefined, RevokedToForm?: { __typename?: 'Form15CB', id: number } | null | undefined, Beneficiary: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string, PAN?: string | null | undefined, Flat: string, Locality: string, Building?: string | null | undefined, Country: string, State: string, Street?: string | null | undefined, OtherCountry?: string | null | undefined, Pincode: string, BusinessPlace: string, BenefeciaryStatus: string, BenefeciaryEmail?: string | null | undefined, BenefeciaryPhone?: string | null | undefined, Company: { __typename?: 'Company', id: number, ClientApproval: boolean }, Document: Array<{ __typename?: 'Document', id: number, fileId?: number | null | undefined, Tag?: string | null | undefined, title: string, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', path: string } | null | undefined }> }, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean, comments: string, createdAt: any, CertificateDate?: any | null | undefined, AckNumber?: string | null | undefined, UDIN?: string | null | undefined, CreatedBy: { __typename?: 'User', id: number, FirstName: string, LastName: string }, Document?: { __typename?: 'Document', file?: { __typename?: 'File', path: string, filename: string } | null | undefined } | null | undefined }>, Document: Array<{ __typename?: 'Document', id: number, title: string, fileId?: number | null | undefined, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }>, Request?: { __typename?: 'Request', id: number, Remarks?: string | null | undefined, createdAt: any, updatedAt: any, Status: string, IsNewBeneficiary: boolean, ProposedDate?: any | null | undefined, User: { __typename?: 'User', id: number, FirstName: string, LastName: string }, Beneficiary?: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string } | null | undefined } | null | undefined, CA?: { __typename?: 'User', id: number } | null | undefined } | null | undefined };

export type UpdateForm15CbMutationVariables = Exact<{
  data: Form15CbUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateForm15CbMutation = { __typename?: 'Mutation', updateOneForm15CB?: { __typename?: 'Form15CB', id: number } | null | undefined };

export type CreateGroupMutationVariables = Exact<{
  data: GroupCreateInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createOneGroup: { __typename?: 'Group', id: number } };

export type DeleteGroupMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteOneGroup?: { __typename?: 'Group', id: number } | null | undefined };

export type GetAllGroupsQueryVariables = Exact<{
  where?: Maybe<GroupWhereInput>;
}>;


export type GetAllGroupsQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, GroupName: string, Flat: string, Building?: string | null | undefined, Country: string, City: string, Street?: string | null | undefined, State: string, Locality: string, Pincode: string }> };

export type GetAllGroupsForNavigationQueryVariables = Exact<{
  where?: Maybe<GroupWhereInput>;
}>;


export type GetAllGroupsForNavigationQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: number, GroupName: string, Company: Array<{ __typename?: 'Company', id: number, CompanyName: string, ClientApproval: boolean, isActive: boolean, Branch: Array<{ __typename?: 'Branch', id: number, BranchName: string, ClientApproval: boolean, isActive: boolean }> }> }> };

export type GetGroupByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetGroupByIdQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: number, createdAt: any, updatedAt: any, CreatedBy: number, UpdatedBy?: number | null | undefined, GroupName: string, Flat: string, Building?: string | null | undefined, Country: string, City: string, Street?: string | null | undefined, State: string, Locality: string, Pincode: string, Firm: { __typename?: 'CAFirm', id: number }, Admin?: { __typename?: 'User', id: number, FirstName: string, LastName: string, Email: string, isActive: boolean } | null | undefined, Users: Array<{ __typename?: 'User', id: number, FirstName: string, LastName: string, Email: string, isActive: boolean }> } | null | undefined };

export type UpdateGroupMutationVariables = Exact<{
  data: GroupUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateOneGroup?: { __typename?: 'Group', id: number } | null | undefined };

export type CreateRequestMutationVariables = Exact<{
  data: RequestCreateInput;
}>;


export type CreateRequestMutation = { __typename?: 'Mutation', createOneRequest: { __typename?: 'Request', id: number } };

export type DeleteRequestMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteRequestMutation = { __typename?: 'Mutation', deleteOneRequest?: { __typename?: 'Request', id: number } | null | undefined };

export type GetAllRequestsQueryVariables = Exact<{
  where?: Maybe<RequestWhereInput>;
  orderBy?: Maybe<Array<RequestOrderByWithRelationInput> | RequestOrderByWithRelationInput>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type GetAllRequestsQuery = { __typename?: 'Query', requests: Array<{ __typename?: 'Request', id: number, createdAt: any, updatedAt: any, Status: string, IsNewBeneficiary: boolean, ProposedDate?: any | null | undefined, Remarks?: string | null | undefined, UserId: number, GroupId: number, CompanyId: number, Comment?: string | null | undefined, User: { __typename?: 'User', id: number, FirstName: string, LastName: string }, Document: Array<{ __typename?: 'Document', id: number, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, fileId?: number | null | undefined, title: string, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }>, Beneficiary?: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string } | null | undefined, Form15CB?: { __typename?: 'Form15CB', id: number, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean }> } | null | undefined }>, aggregateRequest: { __typename?: 'AggregateRequest', _count?: { __typename?: 'RequestCountAggregate', _all: number } | null | undefined } };

export type GetAllRequestByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetAllRequestByIdQuery = { __typename?: 'Query', request?: { __typename?: 'Request', id: number, createdAt: any, updatedAt: any, Status: string, IsNewBeneficiary: boolean, ProposedDate?: any | null | undefined, Comment?: string | null | undefined, User: { __typename?: 'User', id: number, FirstName: string, LastName: string }, Document: Array<{ __typename?: 'Document', id: number, Tag?: string | null | undefined, SpecifyTag?: string | null | undefined, fileId?: number | null | undefined, title: string, file?: { __typename?: 'File', id: number, filename: string, path: string } | null | undefined }>, Beneficiary?: { __typename?: 'Benefeciary', id: number, BenefeciaryName: string } | null | undefined, Form15CB?: { __typename?: 'Form15CB', id: number, Events: Array<{ __typename?: 'Events', id: number, status: string, isLatest: boolean }> } | null | undefined } | null | undefined };

export type RequestsByBeneficiaryIdQueryVariables = Exact<{
  where?: Maybe<RequestWhereInput>;
}>;


export type RequestsByBeneficiaryIdQuery = { __typename?: 'Query', requests: Array<{ __typename?: 'Request', id: number, User: { __typename?: 'User', FirstName: string, LastName: string }, Form15CB?: { __typename?: 'Form15CB', id: number } | null | undefined }> };

export type UpdateRequestMutationVariables = Exact<{
  data: RequestUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateRequestMutation = { __typename?: 'Mutation', updateOneRequest?: { __typename?: 'Request', id: number } | null | undefined };

export type CreateUdinMutationVariables = Exact<{
  data: UdinCreateInput;
}>;


export type CreateUdinMutation = { __typename?: 'Mutation', createOneUdin: { __typename?: 'Udin', id: number } };

export type GetAllUdinsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUdinsQuery = { __typename?: 'Query', udins: Array<{ __typename?: 'Udin', id: number, ca: { __typename?: 'User', FirstName: string, LastName: string }, firm: { __typename?: 'CAFirm', FirmName: string } }> };

export type GetUdinByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetUdinByIdQuery = { __typename?: 'Query', udin?: { __typename?: 'Udin', id: number, cAFirmId: number, userId: number, udinLogin: string, udinPass: string, itLogin: string, itPass: string, pan: string, firstField: string, secondField: string, thirdField: string, stdDescription: string, stdRemark: string } | null | undefined };

export type UpdateUdinMutationVariables = Exact<{
  data: UdinUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateUdinMutation = { __typename?: 'Mutation', updateOneUdin?: { __typename?: 'Udin', id: number } | null | undefined };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: { __typename?: 'changePasswordPayload', success: boolean, message: string } };

export type CreateUserMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createOneUser: { __typename?: 'User', id: number } };

export type DeleteUserMutationVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteOneUser?: { __typename?: 'User', id: number } | null | undefined };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'forgotPasswordPayload', success: boolean, message: string } };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, createdAt: any, updatedAt: any, FirstName: string, LastName: string, Email: string, Type: string, isActive: boolean, Firm?: { __typename?: 'CAFirm', FirmName: string, id: number } | null | undefined, Group?: { __typename?: 'Group', GroupName: string, id: number } | null | undefined }> };

export type GetBasicUserByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetBasicUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, FirstName: string, LastName: string, Type: string } | null | undefined };

export type GetUserAccessesQueryVariables = Exact<{
  where?: Maybe<UserAccessWhereInput>;
}>;


export type GetUserAccessesQuery = { __typename?: 'Query', userAccesses: Array<{ __typename?: 'UserAccess', id: number, Role?: string | null | undefined, MembershipNumber?: string | null | undefined, Group: { __typename?: 'Group', id: number, GroupName: string }, Company: { __typename?: 'Company', id: number, CompanyName: string, isActive: boolean }, Branch?: { __typename?: 'Branch', id: number, BranchName: string, isActive: boolean } | null | undefined }> };

export type GetUserByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['Int']>;
}>;


export type GetUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, createdAt: any, updatedAt: any, FirstName: string, LastName: string, Password: string, Email: string, Type: string, isActive: boolean, Firm?: { __typename?: 'CAFirm', FirmName: string, id: number } | null | undefined, Group?: { __typename?: 'Group', GroupName: string, id: number } | null | undefined } | null | undefined };

export type GetUserForAccessQueryVariables = Exact<{
  where?: Maybe<UserWhereInput>;
}>;


export type GetUserForAccessQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, FirstName: string, LastName: string, Email: string, UserAccess: Array<{ __typename?: 'UserAccess', id: number, GroupId: number, CompanyId: number, BranchId?: number | null | undefined, Role?: string | null | undefined, MembershipNumber?: string | null | undefined }> }> };

export type UpdateUserMutationVariables = Exact<{
  data: UserUpdateInput;
  id?: Maybe<Scalars['Int']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateOneUser?: { __typename?: 'User', id: number } | null | undefined };

export type ValidateConfirmTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidateConfirmTokenMutation = { __typename?: 'Mutation', validateConfirmToken: { __typename?: 'ValidConfirmationTokenPayload', isValid: boolean, message: string } };


export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    user {
      id
      createdAt
      updatedAt
      FirstName
      LastName
      Email
      Password
      Type
    }
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const GetAllBanksDocument = gql`
    query getAllBanks($where: BankDetailWhereInput) {
  bankDetails(where: $where) {
    id
    BankName
    BankBranch
    BSRCode
    AccountNumber
    ifsc
    AuthDealer
  }
}
    `;

/**
 * __useGetAllBanksQuery__
 *
 * To run a query within a React component, call `useGetAllBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBanksQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllBanksQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBanksQuery, GetAllBanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBanksQuery, GetAllBanksQueryVariables>(GetAllBanksDocument, options);
      }
export function useGetAllBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBanksQuery, GetAllBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBanksQuery, GetAllBanksQueryVariables>(GetAllBanksDocument, options);
        }
export type GetAllBanksQueryHookResult = ReturnType<typeof useGetAllBanksQuery>;
export type GetAllBanksLazyQueryHookResult = ReturnType<typeof useGetAllBanksLazyQuery>;
export type GetAllBanksQueryResult = Apollo.QueryResult<GetAllBanksQuery, GetAllBanksQueryVariables>;
export const CreateBeneficiaryDocument = gql`
    mutation createBeneficiary($data: BenefeciaryCreateInput!) {
  createOneBenefeciary(data: $data) {
    id
  }
}
    `;
export type CreateBeneficiaryMutationFn = Apollo.MutationFunction<CreateBeneficiaryMutation, CreateBeneficiaryMutationVariables>;

/**
 * __useCreateBeneficiaryMutation__
 *
 * To run a mutation, you first call `useCreateBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBeneficiaryMutation, { data, loading, error }] = useCreateBeneficiaryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBeneficiaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateBeneficiaryMutation, CreateBeneficiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBeneficiaryMutation, CreateBeneficiaryMutationVariables>(CreateBeneficiaryDocument, options);
      }
export type CreateBeneficiaryMutationHookResult = ReturnType<typeof useCreateBeneficiaryMutation>;
export type CreateBeneficiaryMutationResult = Apollo.MutationResult<CreateBeneficiaryMutation>;
export type CreateBeneficiaryMutationOptions = Apollo.BaseMutationOptions<CreateBeneficiaryMutation, CreateBeneficiaryMutationVariables>;
export const DeleteBenefeciaryDocument = gql`
    mutation deleteBenefeciary($id: Int) {
  deleteOneBenefeciary(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteBenefeciaryMutationFn = Apollo.MutationFunction<DeleteBenefeciaryMutation, DeleteBenefeciaryMutationVariables>;

/**
 * __useDeleteBenefeciaryMutation__
 *
 * To run a mutation, you first call `useDeleteBenefeciaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBenefeciaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBenefeciaryMutation, { data, loading, error }] = useDeleteBenefeciaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBenefeciaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBenefeciaryMutation, DeleteBenefeciaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBenefeciaryMutation, DeleteBenefeciaryMutationVariables>(DeleteBenefeciaryDocument, options);
      }
export type DeleteBenefeciaryMutationHookResult = ReturnType<typeof useDeleteBenefeciaryMutation>;
export type DeleteBenefeciaryMutationResult = Apollo.MutationResult<DeleteBenefeciaryMutation>;
export type DeleteBenefeciaryMutationOptions = Apollo.BaseMutationOptions<DeleteBenefeciaryMutation, DeleteBenefeciaryMutationVariables>;
export const GetAllBenefeciariesDocument = gql`
    query getAllBenefeciaries($where: BenefeciaryWhereInput, $orderBy: [BenefeciaryOrderByWithRelationInput!], $skip: Int, $take: Int) {
  benefeciaries(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    Company {
      CompanyName
    }
    Branch {
      id
      BranchName
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    BenefeciaryPrefix
    BenefeciaryName
    BenefeciaryStatus
    BenefeciaryEmail
    BenefeciaryPhone
    RelatedParty
    BusinessPlace
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    OtherCountry
    BankName
    AccountNumber
    BankAddress
    PAN
    TaxID
    TRCAvailable
    TRCDocumentDate
    TRCDocumentValidFrom
    TRCDocumentValidTill
    IsBussinessDeclaration
    IsBenefeciaryOwner
    PPTClauseSatisfied
    PEDocumentDate
    PEDocumentValidFrom
    PEDocumentValidTill
    IsCerticateObtained
    Certificates {
      id
      CerticateRateTax
      NatureOfIncome
      CerticateSection
      AssessingOfficerName
      AssessingOfficerDesignation
      CertificateNumber
      CertificateThreshold
      CertificateOrderDate
      CertificateValidFrom
      CerticateValidTill
    }
    Is10FAvailable
    DocumentDate10F
    DocumentValidTill10F
    FolioNumbers {
      id
      FolioNumber
    }
    Document {
      id
      fileId
      Tag
      SpecifyTag
      title
    }
  }
  aggregateBenefeciary(where: $where) {
    _count {
      _all
    }
  }
}
    `;

/**
 * __useGetAllBenefeciariesQuery__
 *
 * To run a query within a React component, call `useGetAllBenefeciariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBenefeciariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBenefeciariesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllBenefeciariesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBenefeciariesQuery, GetAllBenefeciariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBenefeciariesQuery, GetAllBenefeciariesQueryVariables>(GetAllBenefeciariesDocument, options);
      }
export function useGetAllBenefeciariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBenefeciariesQuery, GetAllBenefeciariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBenefeciariesQuery, GetAllBenefeciariesQueryVariables>(GetAllBenefeciariesDocument, options);
        }
export type GetAllBenefeciariesQueryHookResult = ReturnType<typeof useGetAllBenefeciariesQuery>;
export type GetAllBenefeciariesLazyQueryHookResult = ReturnType<typeof useGetAllBenefeciariesLazyQuery>;
export type GetAllBenefeciariesQueryResult = Apollo.QueryResult<GetAllBenefeciariesQuery, GetAllBenefeciariesQueryVariables>;
export const GetBenefeciaryByIdDocument = gql`
    query getBenefeciaryById($id: Int) {
  benefeciary(where: {id: $id}) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    BenefeciaryPrefix
    BenefeciaryName
    BenefeciaryStatus
    BenefeciaryEmail
    BenefeciaryPhone
    BusinessPlace
    RelatedParty
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    OtherCountry
    BankName
    AccountNumber
    BankAddress
    PAN
    TaxID
    TRCAvailable
    TRCDocumentDate
    TRCDocumentValidFrom
    TRCDocumentValidTill
    IsBussinessDeclaration
    IsBenefeciaryOwner
    PPTClauseSatisfied
    PEDocumentDate
    PEDocumentValidFrom
    PEDocumentValidTill
    IsCerticateObtained
    Certificates {
      id
      CerticateRateTax
      NatureOfIncome
      CerticateSection
      AssessingOfficerName
      AssessingOfficerDesignation
      CertificateNumber
      CertificateThreshold
      CertificateOrderDate
      CertificateValidFrom
      CerticateValidTill
    }
    Is10FAvailable
    DocumentDate10F
    DocumentValidTill10F
    FolioNumbers {
      id
      FolioNumber
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
}
    `;

/**
 * __useGetBenefeciaryByIdQuery__
 *
 * To run a query within a React component, call `useGetBenefeciaryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBenefeciaryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBenefeciaryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBenefeciaryByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetBenefeciaryByIdQuery, GetBenefeciaryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBenefeciaryByIdQuery, GetBenefeciaryByIdQueryVariables>(GetBenefeciaryByIdDocument, options);
      }
export function useGetBenefeciaryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBenefeciaryByIdQuery, GetBenefeciaryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBenefeciaryByIdQuery, GetBenefeciaryByIdQueryVariables>(GetBenefeciaryByIdDocument, options);
        }
export type GetBenefeciaryByIdQueryHookResult = ReturnType<typeof useGetBenefeciaryByIdQuery>;
export type GetBenefeciaryByIdLazyQueryHookResult = ReturnType<typeof useGetBenefeciaryByIdLazyQuery>;
export type GetBenefeciaryByIdQueryResult = Apollo.QueryResult<GetBenefeciaryByIdQuery, GetBenefeciaryByIdQueryVariables>;
export const UpdateBenefeciaryDocument = gql`
    mutation updateBenefeciary($data: BenefeciaryUpdateInput!, $id: Int) {
  updateOneBenefeciary(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateBenefeciaryMutationFn = Apollo.MutationFunction<UpdateBenefeciaryMutation, UpdateBenefeciaryMutationVariables>;

/**
 * __useUpdateBenefeciaryMutation__
 *
 * To run a mutation, you first call `useUpdateBenefeciaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBenefeciaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBenefeciaryMutation, { data, loading, error }] = useUpdateBenefeciaryMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateBenefeciaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBenefeciaryMutation, UpdateBenefeciaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBenefeciaryMutation, UpdateBenefeciaryMutationVariables>(UpdateBenefeciaryDocument, options);
      }
export type UpdateBenefeciaryMutationHookResult = ReturnType<typeof useUpdateBenefeciaryMutation>;
export type UpdateBenefeciaryMutationResult = Apollo.MutationResult<UpdateBenefeciaryMutation>;
export type UpdateBenefeciaryMutationOptions = Apollo.BaseMutationOptions<UpdateBenefeciaryMutation, UpdateBenefeciaryMutationVariables>;
export const CreateBranchDocument = gql`
    mutation createBranch($data: BranchCreateInput!) {
  createOneBranch(data: $data) {
    id
  }
}
    `;
export type CreateBranchMutationFn = Apollo.MutationFunction<CreateBranchMutation, CreateBranchMutationVariables>;

/**
 * __useCreateBranchMutation__
 *
 * To run a mutation, you first call `useCreateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBranchMutation, { data, loading, error }] = useCreateBranchMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateBranchMutation, CreateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBranchMutation, CreateBranchMutationVariables>(CreateBranchDocument, options);
      }
export type CreateBranchMutationHookResult = ReturnType<typeof useCreateBranchMutation>;
export type CreateBranchMutationResult = Apollo.MutationResult<CreateBranchMutation>;
export type CreateBranchMutationOptions = Apollo.BaseMutationOptions<CreateBranchMutation, CreateBranchMutationVariables>;
export const DeleteBranchDocument = gql`
    mutation deleteBranch($id: Int) {
  deleteOneBranch(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteBranchMutationFn = Apollo.MutationFunction<DeleteBranchMutation, DeleteBranchMutationVariables>;

/**
 * __useDeleteBranchMutation__
 *
 * To run a mutation, you first call `useDeleteBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBranchMutation, { data, loading, error }] = useDeleteBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBranchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBranchMutation, DeleteBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBranchMutation, DeleteBranchMutationVariables>(DeleteBranchDocument, options);
      }
export type DeleteBranchMutationHookResult = ReturnType<typeof useDeleteBranchMutation>;
export type DeleteBranchMutationResult = Apollo.MutationResult<DeleteBranchMutation>;
export type DeleteBranchMutationOptions = Apollo.BaseMutationOptions<DeleteBranchMutation, DeleteBranchMutationVariables>;
export const GetAllBranchesDocument = gql`
    query getAllBranches($where: BranchWhereInput) {
  branches(where: $where) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    isActive
    Honorific
    BranchName
    Status
    ResidentialStatus
    Email
    Mobile
    TAN
    PAN
    CertificateOption
    BusinessPlace
    ClientApproval
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
  }
}
    `;

/**
 * __useGetAllBranchesQuery__
 *
 * To run a query within a React component, call `useGetAllBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBranchesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllBranchesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBranchesQuery, GetAllBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBranchesQuery, GetAllBranchesQueryVariables>(GetAllBranchesDocument, options);
      }
export function useGetAllBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBranchesQuery, GetAllBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBranchesQuery, GetAllBranchesQueryVariables>(GetAllBranchesDocument, options);
        }
export type GetAllBranchesQueryHookResult = ReturnType<typeof useGetAllBranchesQuery>;
export type GetAllBranchesLazyQueryHookResult = ReturnType<typeof useGetAllBranchesLazyQuery>;
export type GetAllBranchesQueryResult = Apollo.QueryResult<GetAllBranchesQuery, GetAllBranchesQueryVariables>;
export const GetBranchByIdDocument = gql`
    query getBranchById($id: Int) {
  branch(where: {id: $id}) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    Honorific
    isActive
    BranchName
    Status
    ResidentialStatus
    Email
    Mobile
    TAN
    PAN
    CertificateOption
    BusinessPlace
    ClientApproval
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    ITPass
    IorWe
    VerifierName
    VerifierFatherName
    VerifierDesignation
    VerifierPlace
    BankDetail {
      BankName
      BankBranch
      AccountNumber
      BSRCode
      ifsc
      id
      AuthDealer
    }
    Company {
      id
      CompanyName
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
}
    `;

/**
 * __useGetBranchByIdQuery__
 *
 * To run a query within a React component, call `useGetBranchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBranchByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetBranchByIdQuery, GetBranchByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchByIdQuery, GetBranchByIdQueryVariables>(GetBranchByIdDocument, options);
      }
export function useGetBranchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchByIdQuery, GetBranchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchByIdQuery, GetBranchByIdQueryVariables>(GetBranchByIdDocument, options);
        }
export type GetBranchByIdQueryHookResult = ReturnType<typeof useGetBranchByIdQuery>;
export type GetBranchByIdLazyQueryHookResult = ReturnType<typeof useGetBranchByIdLazyQuery>;
export type GetBranchByIdQueryResult = Apollo.QueryResult<GetBranchByIdQuery, GetBranchByIdQueryVariables>;
export const UpdateBranchDocument = gql`
    mutation updateBranch($data: BranchUpdateInput!, $id: Int) {
  updateOneBranch(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateBranchMutationFn = Apollo.MutationFunction<UpdateBranchMutation, UpdateBranchMutationVariables>;

/**
 * __useUpdateBranchMutation__
 *
 * To run a mutation, you first call `useUpdateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBranchMutation, { data, loading, error }] = useUpdateBranchMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBranchMutation, UpdateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBranchMutation, UpdateBranchMutationVariables>(UpdateBranchDocument, options);
      }
export type UpdateBranchMutationHookResult = ReturnType<typeof useUpdateBranchMutation>;
export type UpdateBranchMutationResult = Apollo.MutationResult<UpdateBranchMutation>;
export type UpdateBranchMutationOptions = Apollo.BaseMutationOptions<UpdateBranchMutation, UpdateBranchMutationVariables>;
export const CreateCaFirmDocument = gql`
    mutation createCAFirm($data: CAFirmCreateInput!) {
  createOneCAFirm(data: $data) {
    id
  }
}
    `;
export type CreateCaFirmMutationFn = Apollo.MutationFunction<CreateCaFirmMutation, CreateCaFirmMutationVariables>;

/**
 * __useCreateCaFirmMutation__
 *
 * To run a mutation, you first call `useCreateCaFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaFirmMutation, { data, loading, error }] = useCreateCaFirmMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCaFirmMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaFirmMutation, CreateCaFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaFirmMutation, CreateCaFirmMutationVariables>(CreateCaFirmDocument, options);
      }
export type CreateCaFirmMutationHookResult = ReturnType<typeof useCreateCaFirmMutation>;
export type CreateCaFirmMutationResult = Apollo.MutationResult<CreateCaFirmMutation>;
export type CreateCaFirmMutationOptions = Apollo.BaseMutationOptions<CreateCaFirmMutation, CreateCaFirmMutationVariables>;
export const DeleteCaFirmDocument = gql`
    mutation deleteCAFirm($id: Int) {
  deleteOneCAFirm(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteCaFirmMutationFn = Apollo.MutationFunction<DeleteCaFirmMutation, DeleteCaFirmMutationVariables>;

/**
 * __useDeleteCaFirmMutation__
 *
 * To run a mutation, you first call `useDeleteCaFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaFirmMutation, { data, loading, error }] = useDeleteCaFirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCaFirmMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaFirmMutation, DeleteCaFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaFirmMutation, DeleteCaFirmMutationVariables>(DeleteCaFirmDocument, options);
      }
export type DeleteCaFirmMutationHookResult = ReturnType<typeof useDeleteCaFirmMutation>;
export type DeleteCaFirmMutationResult = Apollo.MutationResult<DeleteCaFirmMutation>;
export type DeleteCaFirmMutationOptions = Apollo.BaseMutationOptions<DeleteCaFirmMutation, DeleteCaFirmMutationVariables>;
export const GetAllCaFirmsDocument = gql`
    query getAllCAFirms($where: CAFirmWhereInput) {
  cAFirms(where: $where) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    IorWe
    FirmName
    FirmRegisterNumber
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
  }
}
    `;

/**
 * __useGetAllCaFirmsQuery__
 *
 * To run a query within a React component, call `useGetAllCaFirmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCaFirmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCaFirmsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllCaFirmsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCaFirmsQuery, GetAllCaFirmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCaFirmsQuery, GetAllCaFirmsQueryVariables>(GetAllCaFirmsDocument, options);
      }
export function useGetAllCaFirmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCaFirmsQuery, GetAllCaFirmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCaFirmsQuery, GetAllCaFirmsQueryVariables>(GetAllCaFirmsDocument, options);
        }
export type GetAllCaFirmsQueryHookResult = ReturnType<typeof useGetAllCaFirmsQuery>;
export type GetAllCaFirmsLazyQueryHookResult = ReturnType<typeof useGetAllCaFirmsLazyQuery>;
export type GetAllCaFirmsQueryResult = Apollo.QueryResult<GetAllCaFirmsQuery, GetAllCaFirmsQueryVariables>;
export const GetCaFirmByIdDocument = gql`
    query getCAFirmById($id: Int) {
  cAFirm(where: {id: $id}) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    IorWe
    FirmName
    FirmRegisterNumber
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    Admin {
      id
      FirstName
      LastName
      Email
      isActive
    }
    Users {
      id
      FirstName
      LastName
      Email
      Type
      isActive
    }
  }
}
    `;

/**
 * __useGetCaFirmByIdQuery__
 *
 * To run a query within a React component, call `useGetCaFirmByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaFirmByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaFirmByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaFirmByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCaFirmByIdQuery, GetCaFirmByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaFirmByIdQuery, GetCaFirmByIdQueryVariables>(GetCaFirmByIdDocument, options);
      }
export function useGetCaFirmByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaFirmByIdQuery, GetCaFirmByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaFirmByIdQuery, GetCaFirmByIdQueryVariables>(GetCaFirmByIdDocument, options);
        }
export type GetCaFirmByIdQueryHookResult = ReturnType<typeof useGetCaFirmByIdQuery>;
export type GetCaFirmByIdLazyQueryHookResult = ReturnType<typeof useGetCaFirmByIdLazyQuery>;
export type GetCaFirmByIdQueryResult = Apollo.QueryResult<GetCaFirmByIdQuery, GetCaFirmByIdQueryVariables>;
export const GetAllCAusersDocument = gql`
    query getAllCAusers($where: UserWhereInput) {
  users(where: $where) {
    id
    FirstName
    LastName
    UserAccess {
      id
      Role
      GroupId
      BranchId
      CompanyId
      MembershipNumber
    }
  }
}
    `;

/**
 * __useGetAllCAusersQuery__
 *
 * To run a query within a React component, call `useGetAllCAusersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCAusersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCAusersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllCAusersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCAusersQuery, GetAllCAusersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCAusersQuery, GetAllCAusersQueryVariables>(GetAllCAusersDocument, options);
      }
export function useGetAllCAusersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCAusersQuery, GetAllCAusersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCAusersQuery, GetAllCAusersQueryVariables>(GetAllCAusersDocument, options);
        }
export type GetAllCAusersQueryHookResult = ReturnType<typeof useGetAllCAusersQuery>;
export type GetAllCAusersLazyQueryHookResult = ReturnType<typeof useGetAllCAusersLazyQuery>;
export type GetAllCAusersQueryResult = Apollo.QueryResult<GetAllCAusersQuery, GetAllCAusersQueryVariables>;
export const GetFirstCaFirmDocument = gql`
    query getFirstCAFirm($where: CAFirmWhereInput) {
  findFirstCAFirm(where: $where) {
    IorWe
    FirmName
    FirmRegisterNumber
    Flat
    Building
    Street
    Locality
    City
    State
    Country
    Pincode
  }
}
    `;

/**
 * __useGetFirstCaFirmQuery__
 *
 * To run a query within a React component, call `useGetFirstCaFirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstCaFirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstCaFirmQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFirstCaFirmQuery(baseOptions?: Apollo.QueryHookOptions<GetFirstCaFirmQuery, GetFirstCaFirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstCaFirmQuery, GetFirstCaFirmQueryVariables>(GetFirstCaFirmDocument, options);
      }
export function useGetFirstCaFirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstCaFirmQuery, GetFirstCaFirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstCaFirmQuery, GetFirstCaFirmQueryVariables>(GetFirstCaFirmDocument, options);
        }
export type GetFirstCaFirmQueryHookResult = ReturnType<typeof useGetFirstCaFirmQuery>;
export type GetFirstCaFirmLazyQueryHookResult = ReturnType<typeof useGetFirstCaFirmLazyQuery>;
export type GetFirstCaFirmQueryResult = Apollo.QueryResult<GetFirstCaFirmQuery, GetFirstCaFirmQueryVariables>;
export const UpdateCaFirmDocument = gql`
    mutation updateCAFirm($data: CAFirmUpdateInput!, $id: Int) {
  updateOneCAFirm(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateCaFirmMutationFn = Apollo.MutationFunction<UpdateCaFirmMutation, UpdateCaFirmMutationVariables>;

/**
 * __useUpdateCaFirmMutation__
 *
 * To run a mutation, you first call `useUpdateCaFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaFirmMutation, { data, loading, error }] = useUpdateCaFirmMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCaFirmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaFirmMutation, UpdateCaFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaFirmMutation, UpdateCaFirmMutationVariables>(UpdateCaFirmDocument, options);
      }
export type UpdateCaFirmMutationHookResult = ReturnType<typeof useUpdateCaFirmMutation>;
export type UpdateCaFirmMutationResult = Apollo.MutationResult<UpdateCaFirmMutation>;
export type UpdateCaFirmMutationOptions = Apollo.BaseMutationOptions<UpdateCaFirmMutation, UpdateCaFirmMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($data: CompanyCreateInput!) {
  createOneCompany(data: $data) {
    id
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation deleteCompany($id: Int) {
  deleteOneCompany(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const GetAllCompaniesDocument = gql`
    query getAllCompanies($where: CompanyWhereInput) {
  companies(where: $where) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    Honorific
    isActive
    CompanyName
    Status
    ResidentialStatus
    Email
    Mobile
    TAN
    PAN
    CertificateOption
    BusinessPlace
    ClientApproval
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
  }
}
    `;

/**
 * __useGetAllCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompaniesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
      }
export function useGetAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
        }
export type GetAllCompaniesQueryHookResult = ReturnType<typeof useGetAllCompaniesQuery>;
export type GetAllCompaniesLazyQueryHookResult = ReturnType<typeof useGetAllCompaniesLazyQuery>;
export type GetAllCompaniesQueryResult = Apollo.QueryResult<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>;
export const GetCompanyByIdDocument = gql`
    query getCompanyById($id: Int) {
  company(where: {id: $id}) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    Honorific
    isActive
    CompanyName
    Status
    ResidentialStatus
    Email
    Mobile
    TAN
    PAN
    CertificateOption
    BusinessPlace
    ClientApproval
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    ITPass
    IorWe
    VerifierName
    VerifierFatherName
    VerifierDesignation
    VerifierPlace
    BankDetail {
      BankName
      BankBranch
      AccountNumber
      BSRCode
      ifsc
      id
      AuthDealer
    }
    Group {
      id
      GroupName
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
}
    `;

/**
 * __useGetCompanyByIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>(GetCompanyByIdDocument, options);
      }
export function useGetCompanyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>(GetCompanyByIdDocument, options);
        }
export type GetCompanyByIdQueryHookResult = ReturnType<typeof useGetCompanyByIdQuery>;
export type GetCompanyByIdLazyQueryHookResult = ReturnType<typeof useGetCompanyByIdLazyQuery>;
export type GetCompanyByIdQueryResult = Apollo.QueryResult<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($data: CompanyUpdateInput!, $id: Int) {
  updateOneCompany(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const DashboardDataDocument = gql`
    query DashboardData($startDate: DateTime, $endDate: DateTime, $benefeciaryFilter: BenefeciaryRelationFilter, $requestWhereInput: RequestWhereInput) {
  aggregateForm15CB(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    _count {
      _all
    }
  }
  aggregateForm15CAA(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    _count {
      _all
    }
  }
  aggregateForm15CAB(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    _count {
      _all
    }
  }
  aggregateForm15CAC(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    _count {
      _all
    }
  }
  aggregateForm15CAD(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    _count {
      _all
    }
  }
  aggregateRequest(where: $requestWhereInput) {
    _count {
      _all
    }
  }
  TotalPaymentTDS_CB: form15CBS(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    Events {
      CertificateDate
      isLatest
    }
    amount: PayableAmountINR
  }
  TotalPaymentTDS_CAA: form15CAAS(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    Events {
      CertificateDate
      isLatest
    }
    amount: AmountPayableBeforeINR
  }
  TotalPaymentTDS_CAB: form15CABS(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    Events {
      CertificateDate
      isLatest
    }
    amount: AmountPayableINR
  }
  TotalPaymentTDS_CAD: form15CADS(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    Events {
      CertificateDate
      isLatest
    }
    amount: AmountPayableINR
  }
  TotalTDS_CB: form15CBS(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    Events {
      CertificateDate
      isLatest
    }
    amount: AmountOfTDSInINR
  }
  TotalTDS_CAA: form15CAAS(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    Events {
      CertificateDate
      isLatest
    }
    amount: AmountOfTDSInINR
  }
  TotalTDS_CAB: form15CABS(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
  ) {
    Events {
      CertificateDate
      isLatest
    }
    amount: AmountOfTDSInINR
  }
  RemNatureCB: groupByForm15CB(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
    by: [RemittanceNameOnDocument]
  ) {
    NatureOfRemittance: RemittanceNameOnDocument
    _sum {
      AmountPayableINR: PayableAmountINR
    }
  }
  RemNatureCAA: groupByForm15CAA(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
    by: [RemittanceNameOnDocument]
  ) {
    NatureOfRemittance: RemittanceNameOnDocument
    _sum {
      AmountPayableINR: AmountOfTDSInINR
    }
  }
  RemNatureCAB: groupByForm15CAB(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
    by: [RemittanceNameOnDocument]
  ) {
    NatureOfRemittance: RemittanceNameOnDocument
    _sum {
      AmountPayableINR
    }
  }
  RemNatureCAD: groupByForm15CAD(
    where: {Beneficiary: $benefeciaryFilter, Events: {some: {status: {equals: "Uploaded"}, isLatest: {equals: true}, AND: [{CertificateDate: {gte: $startDate}}, {CertificateDate: {lte: $endDate}}]}}}
    by: [RemittanceNameOnDocument]
  ) {
    NatureOfRemittance: RemittanceNameOnDocument
    _sum {
      AmountPayableINR
    }
  }
}
    `;

/**
 * __useDashboardDataQuery__
 *
 * To run a query within a React component, call `useDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardDataQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      benefeciaryFilter: // value for 'benefeciaryFilter'
 *      requestWhereInput: // value for 'requestWhereInput'
 *   },
 * });
 */
export function useDashboardDataQuery(baseOptions?: Apollo.QueryHookOptions<DashboardDataQuery, DashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardDataQuery, DashboardDataQueryVariables>(DashboardDataDocument, options);
      }
export function useDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardDataQuery, DashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardDataQuery, DashboardDataQueryVariables>(DashboardDataDocument, options);
        }
export type DashboardDataQueryHookResult = ReturnType<typeof useDashboardDataQuery>;
export type DashboardDataLazyQueryHookResult = ReturnType<typeof useDashboardDataLazyQuery>;
export type DashboardDataQueryResult = Apollo.QueryResult<DashboardDataQuery, DashboardDataQueryVariables>;
export const SendApprovedEmailDocument = gql`
    mutation sendApprovedEmail($formType: String!, $formId: Float!) {
  sendApprovedEmail(formType: $formType, formId: $formId) {
    message
  }
}
    `;
export type SendApprovedEmailMutationFn = Apollo.MutationFunction<SendApprovedEmailMutation, SendApprovedEmailMutationVariables>;

/**
 * __useSendApprovedEmailMutation__
 *
 * To run a mutation, you first call `useSendApprovedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendApprovedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendApprovedEmailMutation, { data, loading, error }] = useSendApprovedEmailMutation({
 *   variables: {
 *      formType: // value for 'formType'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useSendApprovedEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendApprovedEmailMutation, SendApprovedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendApprovedEmailMutation, SendApprovedEmailMutationVariables>(SendApprovedEmailDocument, options);
      }
export type SendApprovedEmailMutationHookResult = ReturnType<typeof useSendApprovedEmailMutation>;
export type SendApprovedEmailMutationResult = Apollo.MutationResult<SendApprovedEmailMutation>;
export type SendApprovedEmailMutationOptions = Apollo.BaseMutationOptions<SendApprovedEmailMutation, SendApprovedEmailMutationVariables>;
export const SendRejectionEmailDocument = gql`
    mutation sendRejectionEmail($formType: String!, $formId: Float!) {
  sendRejectionEmail(formType: $formType, formId: $formId) {
    message
  }
}
    `;
export type SendRejectionEmailMutationFn = Apollo.MutationFunction<SendRejectionEmailMutation, SendRejectionEmailMutationVariables>;

/**
 * __useSendRejectionEmailMutation__
 *
 * To run a mutation, you first call `useSendRejectionEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRejectionEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRejectionEmailMutation, { data, loading, error }] = useSendRejectionEmailMutation({
 *   variables: {
 *      formType: // value for 'formType'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useSendRejectionEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendRejectionEmailMutation, SendRejectionEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRejectionEmailMutation, SendRejectionEmailMutationVariables>(SendRejectionEmailDocument, options);
      }
export type SendRejectionEmailMutationHookResult = ReturnType<typeof useSendRejectionEmailMutation>;
export type SendRejectionEmailMutationResult = Apollo.MutationResult<SendRejectionEmailMutation>;
export type SendRejectionEmailMutationOptions = Apollo.BaseMutationOptions<SendRejectionEmailMutation, SendRejectionEmailMutationVariables>;
export const CreateForm15CaaDocument = gql`
    mutation createForm15CAA($data: Form15CAACreateInput!) {
  createOneForm15CAA(data: $data) {
    id
  }
}
    `;
export type CreateForm15CaaMutationFn = Apollo.MutationFunction<CreateForm15CaaMutation, CreateForm15CaaMutationVariables>;

/**
 * __useCreateForm15CaaMutation__
 *
 * To run a mutation, you first call `useCreateForm15CaaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateForm15CaaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createForm15CaaMutation, { data, loading, error }] = useCreateForm15CaaMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateForm15CaaMutation(baseOptions?: Apollo.MutationHookOptions<CreateForm15CaaMutation, CreateForm15CaaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateForm15CaaMutation, CreateForm15CaaMutationVariables>(CreateForm15CaaDocument, options);
      }
export type CreateForm15CaaMutationHookResult = ReturnType<typeof useCreateForm15CaaMutation>;
export type CreateForm15CaaMutationResult = Apollo.MutationResult<CreateForm15CaaMutation>;
export type CreateForm15CaaMutationOptions = Apollo.BaseMutationOptions<CreateForm15CaaMutation, CreateForm15CaaMutationVariables>;
export const DeleteForm15CaaDocument = gql`
    mutation deleteForm15CAA($id: Int) {
  deleteOneForm15CAA(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteForm15CaaMutationFn = Apollo.MutationFunction<DeleteForm15CaaMutation, DeleteForm15CaaMutationVariables>;

/**
 * __useDeleteForm15CaaMutation__
 *
 * To run a mutation, you first call `useDeleteForm15CaaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForm15CaaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForm15CaaMutation, { data, loading, error }] = useDeleteForm15CaaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForm15CaaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForm15CaaMutation, DeleteForm15CaaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForm15CaaMutation, DeleteForm15CaaMutationVariables>(DeleteForm15CaaDocument, options);
      }
export type DeleteForm15CaaMutationHookResult = ReturnType<typeof useDeleteForm15CaaMutation>;
export type DeleteForm15CaaMutationResult = Apollo.MutationResult<DeleteForm15CaaMutation>;
export type DeleteForm15CaaMutationOptions = Apollo.BaseMutationOptions<DeleteForm15CaaMutation, DeleteForm15CaaMutationVariables>;
export const GetAllForm15CaasDocument = gql`
    query getAllForm15CAAS($where: Form15CAAWhereInput, $orderBy: [Form15CAAOrderByWithRelationInput!], $skip: Int, $take: Int) {
  form15CAAS(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    Beneficiary {
      id
      BenefeciaryName
      PAN
      Flat
      Locality
      Building
      Country
      State
      Street
      Country
      OtherCountry
      Pincode
      BusinessPlace
      BenefeciaryStatus
      BenefeciaryEmail
      BenefeciaryPhone
      RelatedParty
      Branch {
        id
        BranchName
      }
      Company {
        id
        CompanyName
      }
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    BankDetailId
    BankName
    BranchName
    Email
    PhoneNumber
    CountryOfRemittance
    CountryOfRemittanceOther
    AmountPayableBeforeINR
    AggregateAmount
    ProposedDate
    RemittanceNameOnDocument
    RemittanceNameOnDocumentOther
    PurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    RateOfTDS
    AmountOfTDSInINR
    DateOfDeduction
    Beneficiary {
      id
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
  aggregateForm15CAA(where: $where) {
    _count {
      _all
    }
  }
}
    `;

/**
 * __useGetAllForm15CaasQuery__
 *
 * To run a query within a React component, call `useGetAllForm15CaasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15CaasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15CaasQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllForm15CaasQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15CaasQuery, GetAllForm15CaasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15CaasQuery, GetAllForm15CaasQueryVariables>(GetAllForm15CaasDocument, options);
      }
export function useGetAllForm15CaasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15CaasQuery, GetAllForm15CaasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15CaasQuery, GetAllForm15CaasQueryVariables>(GetAllForm15CaasDocument, options);
        }
export type GetAllForm15CaasQueryHookResult = ReturnType<typeof useGetAllForm15CaasQuery>;
export type GetAllForm15CaasLazyQueryHookResult = ReturnType<typeof useGetAllForm15CaasLazyQuery>;
export type GetAllForm15CaasQueryResult = Apollo.QueryResult<GetAllForm15CaasQuery, GetAllForm15CaasQueryVariables>;
export const GetAllForm15caaForDdDocument = gql`
    query getAllForm15caaForDD($where: Form15CAAWhereInput) {
  form15CAAS(where: $where) {
    id
  }
}
    `;

/**
 * __useGetAllForm15caaForDdQuery__
 *
 * To run a query within a React component, call `useGetAllForm15caaForDdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15caaForDdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15caaForDdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllForm15caaForDdQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15caaForDdQuery, GetAllForm15caaForDdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15caaForDdQuery, GetAllForm15caaForDdQueryVariables>(GetAllForm15caaForDdDocument, options);
      }
export function useGetAllForm15caaForDdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15caaForDdQuery, GetAllForm15caaForDdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15caaForDdQuery, GetAllForm15caaForDdQueryVariables>(GetAllForm15caaForDdDocument, options);
        }
export type GetAllForm15caaForDdQueryHookResult = ReturnType<typeof useGetAllForm15caaForDdQuery>;
export type GetAllForm15caaForDdLazyQueryHookResult = ReturnType<typeof useGetAllForm15caaForDdLazyQuery>;
export type GetAllForm15caaForDdQueryResult = Apollo.QueryResult<GetAllForm15caaForDdQuery, GetAllForm15caaForDdQueryVariables>;
export const GetForm15CaaByIdDocument = gql`
    query getForm15CAAById($id: Int) {
  form15CAA(where: {id: $id}) {
    id
    RevokedToId
    RevokedFrom {
      id
    }
    RevokedToForm {
      id
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    BankDetailId
    BankName
    BranchName
    ifsc
    AuthDealer
    Email
    PhoneNumber
    CountryOfRemittance
    CountryOfRemittanceOther
    AmountPayableBeforeINR
    AggregateAmount
    ProposedDate
    RemittanceNameOnDocument
    RemittanceNameOnDocumentOther
    PurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    RateOfTDS
    AmountOfTDSInINR
    DateOfDeduction
    Beneficiary {
      id
      Document {
        id
        fileId
        Tag
        title
        SpecifyTag
        file {
          path
        }
      }
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      UDIN
      createdAt
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
}
    `;

/**
 * __useGetForm15CaaByIdQuery__
 *
 * To run a query within a React component, call `useGetForm15CaaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForm15CaaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForm15CaaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForm15CaaByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetForm15CaaByIdQuery, GetForm15CaaByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForm15CaaByIdQuery, GetForm15CaaByIdQueryVariables>(GetForm15CaaByIdDocument, options);
      }
export function useGetForm15CaaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForm15CaaByIdQuery, GetForm15CaaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForm15CaaByIdQuery, GetForm15CaaByIdQueryVariables>(GetForm15CaaByIdDocument, options);
        }
export type GetForm15CaaByIdQueryHookResult = ReturnType<typeof useGetForm15CaaByIdQuery>;
export type GetForm15CaaByIdLazyQueryHookResult = ReturnType<typeof useGetForm15CaaByIdLazyQuery>;
export type GetForm15CaaByIdQueryResult = Apollo.QueryResult<GetForm15CaaByIdQuery, GetForm15CaaByIdQueryVariables>;
export const UpdateForm15CaaDocument = gql`
    mutation updateForm15CAA($data: Form15CAAUpdateInput!, $id: Int) {
  updateOneForm15CAA(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateForm15CaaMutationFn = Apollo.MutationFunction<UpdateForm15CaaMutation, UpdateForm15CaaMutationVariables>;

/**
 * __useUpdateForm15CaaMutation__
 *
 * To run a mutation, you first call `useUpdateForm15CaaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForm15CaaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForm15CaaMutation, { data, loading, error }] = useUpdateForm15CaaMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateForm15CaaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForm15CaaMutation, UpdateForm15CaaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForm15CaaMutation, UpdateForm15CaaMutationVariables>(UpdateForm15CaaDocument, options);
      }
export type UpdateForm15CaaMutationHookResult = ReturnType<typeof useUpdateForm15CaaMutation>;
export type UpdateForm15CaaMutationResult = Apollo.MutationResult<UpdateForm15CaaMutation>;
export type UpdateForm15CaaMutationOptions = Apollo.BaseMutationOptions<UpdateForm15CaaMutation, UpdateForm15CaaMutationVariables>;
export const CreateForm15CabDocument = gql`
    mutation createForm15CAB($data: Form15CABCreateInput!) {
  createOneForm15CAB(data: $data) {
    id
  }
}
    `;
export type CreateForm15CabMutationFn = Apollo.MutationFunction<CreateForm15CabMutation, CreateForm15CabMutationVariables>;

/**
 * __useCreateForm15CabMutation__
 *
 * To run a mutation, you first call `useCreateForm15CabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateForm15CabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createForm15CabMutation, { data, loading, error }] = useCreateForm15CabMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateForm15CabMutation(baseOptions?: Apollo.MutationHookOptions<CreateForm15CabMutation, CreateForm15CabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateForm15CabMutation, CreateForm15CabMutationVariables>(CreateForm15CabDocument, options);
      }
export type CreateForm15CabMutationHookResult = ReturnType<typeof useCreateForm15CabMutation>;
export type CreateForm15CabMutationResult = Apollo.MutationResult<CreateForm15CabMutation>;
export type CreateForm15CabMutationOptions = Apollo.BaseMutationOptions<CreateForm15CabMutation, CreateForm15CabMutationVariables>;
export const DeleteForm15CabDocument = gql`
    mutation deleteForm15CAB($id: Int) {
  deleteOneForm15CAB(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteForm15CabMutationFn = Apollo.MutationFunction<DeleteForm15CabMutation, DeleteForm15CabMutationVariables>;

/**
 * __useDeleteForm15CabMutation__
 *
 * To run a mutation, you first call `useDeleteForm15CabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForm15CabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForm15CabMutation, { data, loading, error }] = useDeleteForm15CabMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForm15CabMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForm15CabMutation, DeleteForm15CabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForm15CabMutation, DeleteForm15CabMutationVariables>(DeleteForm15CabDocument, options);
      }
export type DeleteForm15CabMutationHookResult = ReturnType<typeof useDeleteForm15CabMutation>;
export type DeleteForm15CabMutationResult = Apollo.MutationResult<DeleteForm15CabMutation>;
export type DeleteForm15CabMutationOptions = Apollo.BaseMutationOptions<DeleteForm15CabMutation, DeleteForm15CabMutationVariables>;
export const GetAllForm15CabsDocument = gql`
    query getAllForm15CABS($where: Form15CABWhereInput, $orderBy: [Form15CABOrderByWithRelationInput!], $skip: Int, $take: Int) {
  form15CABS(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    Beneficiary {
      id
      BenefeciaryName
      PAN
      Flat
      Locality
      Building
      Country
      State
      Street
      Country
      OtherCountry
      Pincode
      BusinessPlace
      BenefeciaryStatus
      BenefeciaryEmail
      BenefeciaryPhone
      RelatedParty
      Branch {
        id
        BranchName
      }
      Company {
        id
        CompanyName
      }
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    Email
    PhoneNumber
    CertificateSection
    OfficerNameAO
    OfficerDesignationAO
    CertificateDateAO
    CertificateNumberAO
    CountryOfRemittance
    CountryOfRemittanceOther
    RemittanceCurrency
    OtherRemittanceCurrency
    AmountPayable
    ExchangeRate
    AmountPayableINR
    BankDetailId
    BankName
    BranchName
    BSRCode
    ProposedDate
    RemittanceNameOnDocument
    RemittanceNameOnDocumentOther
    PurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    RateOfTDS
    AmountOfTDSInINR
    DateOfDeduction
    Beneficiary {
      id
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
  aggregateForm15CAB(where: $where) {
    _count {
      _all
    }
  }
}
    `;

/**
 * __useGetAllForm15CabsQuery__
 *
 * To run a query within a React component, call `useGetAllForm15CabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15CabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15CabsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllForm15CabsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15CabsQuery, GetAllForm15CabsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15CabsQuery, GetAllForm15CabsQueryVariables>(GetAllForm15CabsDocument, options);
      }
export function useGetAllForm15CabsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15CabsQuery, GetAllForm15CabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15CabsQuery, GetAllForm15CabsQueryVariables>(GetAllForm15CabsDocument, options);
        }
export type GetAllForm15CabsQueryHookResult = ReturnType<typeof useGetAllForm15CabsQuery>;
export type GetAllForm15CabsLazyQueryHookResult = ReturnType<typeof useGetAllForm15CabsLazyQuery>;
export type GetAllForm15CabsQueryResult = Apollo.QueryResult<GetAllForm15CabsQuery, GetAllForm15CabsQueryVariables>;
export const GetAllForm15cabForDdDocument = gql`
    query getAllForm15cabForDD($where: Form15CABWhereInput) {
  form15CABS(where: $where) {
    id
  }
}
    `;

/**
 * __useGetAllForm15cabForDdQuery__
 *
 * To run a query within a React component, call `useGetAllForm15cabForDdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15cabForDdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15cabForDdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllForm15cabForDdQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15cabForDdQuery, GetAllForm15cabForDdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15cabForDdQuery, GetAllForm15cabForDdQueryVariables>(GetAllForm15cabForDdDocument, options);
      }
export function useGetAllForm15cabForDdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15cabForDdQuery, GetAllForm15cabForDdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15cabForDdQuery, GetAllForm15cabForDdQueryVariables>(GetAllForm15cabForDdDocument, options);
        }
export type GetAllForm15cabForDdQueryHookResult = ReturnType<typeof useGetAllForm15cabForDdQuery>;
export type GetAllForm15cabForDdLazyQueryHookResult = ReturnType<typeof useGetAllForm15cabForDdLazyQuery>;
export type GetAllForm15cabForDdQueryResult = Apollo.QueryResult<GetAllForm15cabForDdQuery, GetAllForm15cabForDdQueryVariables>;
export const GetForm15CabByIdDocument = gql`
    query getForm15CABById($id: Int) {
  form15CAB(where: {id: $id}) {
    id
    RevokedToId
    RevokedFrom {
      id
    }
    RevokedToForm {
      id
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    Email
    PhoneNumber
    CertificateSection
    OfficerNameAO
    OfficerDesignationAO
    CertificateDateAO
    CertificateNumberAO
    CountryOfRemittance
    CountryOfRemittanceOther
    RemittanceCurrency
    OtherRemittanceCurrency
    AmountPayable
    ExchangeRate
    AmountPayableINR
    BankDetailId
    BankName
    BranchName
    BSRCode
    ifsc
    AuthDealer
    ProposedDate
    RemittanceNameOnDocument
    RemittanceNameOnDocumentOther
    PurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    RateOfTDS
    AmountOfTDSInINR
    DateOfDeduction
    Beneficiary {
      id
      Document {
        id
        fileId
        Tag
        title
        SpecifyTag
        file {
          path
        }
      }
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      UDIN
      createdAt
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
}
    `;

/**
 * __useGetForm15CabByIdQuery__
 *
 * To run a query within a React component, call `useGetForm15CabByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForm15CabByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForm15CabByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForm15CabByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetForm15CabByIdQuery, GetForm15CabByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForm15CabByIdQuery, GetForm15CabByIdQueryVariables>(GetForm15CabByIdDocument, options);
      }
export function useGetForm15CabByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForm15CabByIdQuery, GetForm15CabByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForm15CabByIdQuery, GetForm15CabByIdQueryVariables>(GetForm15CabByIdDocument, options);
        }
export type GetForm15CabByIdQueryHookResult = ReturnType<typeof useGetForm15CabByIdQuery>;
export type GetForm15CabByIdLazyQueryHookResult = ReturnType<typeof useGetForm15CabByIdLazyQuery>;
export type GetForm15CabByIdQueryResult = Apollo.QueryResult<GetForm15CabByIdQuery, GetForm15CabByIdQueryVariables>;
export const UpdateForm15CabDocument = gql`
    mutation updateForm15CAB($data: Form15CABUpdateInput!, $id: Int) {
  updateOneForm15CAB(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateForm15CabMutationFn = Apollo.MutationFunction<UpdateForm15CabMutation, UpdateForm15CabMutationVariables>;

/**
 * __useUpdateForm15CabMutation__
 *
 * To run a mutation, you first call `useUpdateForm15CabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForm15CabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForm15CabMutation, { data, loading, error }] = useUpdateForm15CabMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateForm15CabMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForm15CabMutation, UpdateForm15CabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForm15CabMutation, UpdateForm15CabMutationVariables>(UpdateForm15CabDocument, options);
      }
export type UpdateForm15CabMutationHookResult = ReturnType<typeof useUpdateForm15CabMutation>;
export type UpdateForm15CabMutationResult = Apollo.MutationResult<UpdateForm15CabMutation>;
export type UpdateForm15CabMutationOptions = Apollo.BaseMutationOptions<UpdateForm15CabMutation, UpdateForm15CabMutationVariables>;
export const CreateForm15CacDocument = gql`
    mutation createForm15CAC($data: Form15CACCreateInput!) {
  createOneForm15CAC(data: $data) {
    id
  }
}
    `;
export type CreateForm15CacMutationFn = Apollo.MutationFunction<CreateForm15CacMutation, CreateForm15CacMutationVariables>;

/**
 * __useCreateForm15CacMutation__
 *
 * To run a mutation, you first call `useCreateForm15CacMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateForm15CacMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createForm15CacMutation, { data, loading, error }] = useCreateForm15CacMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateForm15CacMutation(baseOptions?: Apollo.MutationHookOptions<CreateForm15CacMutation, CreateForm15CacMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateForm15CacMutation, CreateForm15CacMutationVariables>(CreateForm15CacDocument, options);
      }
export type CreateForm15CacMutationHookResult = ReturnType<typeof useCreateForm15CacMutation>;
export type CreateForm15CacMutationResult = Apollo.MutationResult<CreateForm15CacMutation>;
export type CreateForm15CacMutationOptions = Apollo.BaseMutationOptions<CreateForm15CacMutation, CreateForm15CacMutationVariables>;
export const DeleteForm15CacDocument = gql`
    mutation deleteForm15CAC($id: Int) {
  deleteOneForm15CAC(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteForm15CacMutationFn = Apollo.MutationFunction<DeleteForm15CacMutation, DeleteForm15CacMutationVariables>;

/**
 * __useDeleteForm15CacMutation__
 *
 * To run a mutation, you first call `useDeleteForm15CacMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForm15CacMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForm15CacMutation, { data, loading, error }] = useDeleteForm15CacMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForm15CacMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForm15CacMutation, DeleteForm15CacMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForm15CacMutation, DeleteForm15CacMutationVariables>(DeleteForm15CacDocument, options);
      }
export type DeleteForm15CacMutationHookResult = ReturnType<typeof useDeleteForm15CacMutation>;
export type DeleteForm15CacMutationResult = Apollo.MutationResult<DeleteForm15CacMutation>;
export type DeleteForm15CacMutationOptions = Apollo.BaseMutationOptions<DeleteForm15CacMutation, DeleteForm15CacMutationVariables>;
export const GetAllForm15CacsDocument = gql`
    query getAllForm15CACS($where: Form15CACWhereInput, $orderBy: [Form15CACOrderByWithRelationInput!], $skip: Int, $take: Int) {
  form15CACS(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    Beneficiary {
      id
      BenefeciaryName
      PAN
      Flat
      Locality
      Building
      Country
      State
      Street
      Country
      OtherCountry
      Pincode
      BusinessPlace
      BenefeciaryStatus
      BenefeciaryEmail
      BenefeciaryPhone
      RelatedParty
      Branch {
        id
        BranchName
      }
      Company {
        id
        CompanyName
      }
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Status
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    Email
    PhoneNumber
    ResidentCountry
    BusinessPlace
    AccountantName
    AccountantFirm
    AccountantFlat
    AccountantBuilding
    AccountantStreet
    AccountantLocality
    AccountantCity
    AccountantState
    AccountantCountry
    AccountantPincode
    AccountantMembershipNumber
    AccountantRegistrationNumber
    AccountantCertificateDate
    AccountantCertificateNumber
    IsCertificateObtained
    CertificateSection
    OfficerNameAO
    OfficerDesignationAO
    CertificateDateAO
    CertificateNumberAO
    RemittanceCountry
    OtherRemittanceCountry
    RemittanceCurrency
    OtherRemittanceCurrency
    PayableAmountInForeign
    ExchangeRate
    PayableAmountINR
    BankName
    BranchName
    BSRCode
    ProposedDate
    RemittanceNameOnDocument
    OtherRemittanceNameOnDocument
    RBIPurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    IsRemittanceChargeableIndia
    ReasonRemittanceNotChargeable
    SectionOfActRemittanceCovered
    IncomeChargeableToTax
    TaxLiability
    DeterminingTaxAndLiability
    ChargeableAndReliefDTAA
    TaxResidencyCertificateObtained
    TaxResidencyCertificateMade
    CertificateDTAA
    CertificateArticleOfDTAA
    DTAATaxableIncome
    DTAATaxLiability
    IsWithPermanentEstablishment
    PermanentEstablishmentArticle
    PermanentEstablishmentRateOfTDS
    IsAccountOfBusinessIncome
    SuchIncomeLiableToTaxIN
    IfBasisOfTheRateOfDeduction
    NoReasonRelevantArticleDTAA
    IsRemittanceCapitalGains
    AmountOfCapitalGains
    AmountOfShortCapitalGains
    BasisOfTaxableIncome
    CapitalGainsRateOfTDS
    IsRemittanceCovered
    NatureOfRemittance
    TaxableInIndiaDTAA
    YesTaxableInIndiaDTAA
    NoTaxableInIndiaDTAA
    TransactionLengthPrice
    RateOfTDSIncomeTaxAct
    RateOfTDS
    AmountOfTDSInForeign
    AmountOfTDSInINR
    AmountAfterTDS
    DateOfDeduction
    BankDetailId
    Beneficiary {
      id
      BenefeciaryEmail
      BenefeciaryPhone
      BusinessPlace
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      Document {
        file {
          path
          filename
        }
      }
    }
    Form15CB {
      id
      Flat
      Building
      Street
      Locality
      City
      State
      Country
      Pincode
      AccountantMembershipNumber
      AccountantRegistrationNumber
      Events {
        id
        status
        isLatest
        CertificateDate
        AckNumber
        UDIN
      }
    }
  }
  aggregateForm15CAC(where: $where) {
    _count {
      _all
    }
  }
}
    `;

/**
 * __useGetAllForm15CacsQuery__
 *
 * To run a query within a React component, call `useGetAllForm15CacsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15CacsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15CacsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllForm15CacsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15CacsQuery, GetAllForm15CacsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15CacsQuery, GetAllForm15CacsQueryVariables>(GetAllForm15CacsDocument, options);
      }
export function useGetAllForm15CacsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15CacsQuery, GetAllForm15CacsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15CacsQuery, GetAllForm15CacsQueryVariables>(GetAllForm15CacsDocument, options);
        }
export type GetAllForm15CacsQueryHookResult = ReturnType<typeof useGetAllForm15CacsQuery>;
export type GetAllForm15CacsLazyQueryHookResult = ReturnType<typeof useGetAllForm15CacsLazyQuery>;
export type GetAllForm15CacsQueryResult = Apollo.QueryResult<GetAllForm15CacsQuery, GetAllForm15CacsQueryVariables>;
export const GetAllForm15cacForDdDocument = gql`
    query getAllForm15cacForDD($where: Form15CACWhereInput) {
  form15CACS(where: $where) {
    id
  }
}
    `;

/**
 * __useGetAllForm15cacForDdQuery__
 *
 * To run a query within a React component, call `useGetAllForm15cacForDdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15cacForDdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15cacForDdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllForm15cacForDdQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15cacForDdQuery, GetAllForm15cacForDdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15cacForDdQuery, GetAllForm15cacForDdQueryVariables>(GetAllForm15cacForDdDocument, options);
      }
export function useGetAllForm15cacForDdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15cacForDdQuery, GetAllForm15cacForDdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15cacForDdQuery, GetAllForm15cacForDdQueryVariables>(GetAllForm15cacForDdDocument, options);
        }
export type GetAllForm15cacForDdQueryHookResult = ReturnType<typeof useGetAllForm15cacForDdQuery>;
export type GetAllForm15cacForDdLazyQueryHookResult = ReturnType<typeof useGetAllForm15cacForDdLazyQuery>;
export type GetAllForm15cacForDdQueryResult = Apollo.QueryResult<GetAllForm15cacForDdQuery, GetAllForm15cacForDdQueryVariables>;
export const GetForm15CacByIdDocument = gql`
    query getForm15CACById($id: Int) {
  form15CAC(where: {id: $id}) {
    id
    RevokedToId
    RevokedFrom {
      id
    }
    RevokedToForm {
      id
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Status
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    Email
    PhoneNumber
    ResidentCountry
    BusinessPlace
    AccountantName
    AccountantFirm
    AccountantFlat
    AccountantBuilding
    AccountantStreet
    AccountantLocality
    AccountantCity
    AccountantState
    AccountantCountry
    AccountantPincode
    AccountantMembershipNumber
    AccountantRegistrationNumber
    AccountantCertificateDate
    AccountantCertificateNumber
    IsCertificateObtained
    CertificateSection
    OfficerNameAO
    OfficerDesignationAO
    CertificateDateAO
    CertificateNumberAO
    RemittanceCountry
    OtherRemittanceCountry
    RemittanceCurrency
    OtherRemittanceCurrency
    PayableAmountInForeign
    ExchangeRate
    PayableAmountINR
    BankName
    BranchName
    BSRCode
    ProposedDate
    ifsc
    AuthDealer
    RemittanceNameOnDocument
    OtherRemittanceNameOnDocument
    RBIPurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    IsRemittanceChargeableIndia
    ReasonRemittanceNotChargeable
    SectionOfActRemittanceCovered
    IncomeChargeableToTax
    TaxLiability
    DeterminingTaxAndLiability
    ChargeableAndReliefDTAA
    TaxResidencyCertificateObtained
    TaxResidencyCertificateMade
    CertificateDTAA
    CertificateArticleOfDTAA
    DTAATaxableIncome
    DTAATaxLiability
    IsWithPermanentEstablishment
    PermanentEstablishmentArticle
    PermanentEstablishmentRateOfTDS
    IsAccountOfBusinessIncome
    SuchIncomeLiableToTaxIN
    IfBasisOfTheRateOfDeduction
    NoReasonRelevantArticleDTAA
    IsRemittanceCapitalGains
    AmountOfCapitalGains
    AmountOfShortCapitalGains
    BasisOfTaxableIncome
    CapitalGainsRateOfTDS
    IsRemittanceCovered
    NatureOfRemittance
    TaxableInIndiaDTAA
    YesTaxableInIndiaDTAA
    NoTaxableInIndiaDTAA
    IsRelatedParty
    TransactionLengthPrice
    RateOfTDSIncomeTaxAct
    RateOfTDS
    AmountOfTDSInForeign
    AmountOfTDSInINR
    AmountAfterTDS
    DateOfDeduction
    BankDetailId
    AreaCode
    AoType
    RangeCode
    AoNumber
    Beneficiary {
      id
      BenefeciaryEmail
      BenefeciaryPhone
      BusinessPlace
      Document {
        id
        fileId
        Tag
        title
        SpecifyTag
        file {
          path
        }
      }
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      UDIN
      createdAt
      Document {
        file {
          path
          filename
        }
      }
    }
  }
}
    `;

/**
 * __useGetForm15CacByIdQuery__
 *
 * To run a query within a React component, call `useGetForm15CacByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForm15CacByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForm15CacByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForm15CacByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetForm15CacByIdQuery, GetForm15CacByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForm15CacByIdQuery, GetForm15CacByIdQueryVariables>(GetForm15CacByIdDocument, options);
      }
export function useGetForm15CacByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForm15CacByIdQuery, GetForm15CacByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForm15CacByIdQuery, GetForm15CacByIdQueryVariables>(GetForm15CacByIdDocument, options);
        }
export type GetForm15CacByIdQueryHookResult = ReturnType<typeof useGetForm15CacByIdQuery>;
export type GetForm15CacByIdLazyQueryHookResult = ReturnType<typeof useGetForm15CacByIdLazyQuery>;
export type GetForm15CacByIdQueryResult = Apollo.QueryResult<GetForm15CacByIdQuery, GetForm15CacByIdQueryVariables>;
export const UpdateForm15CacDocument = gql`
    mutation updateForm15CAC($data: Form15CACUpdateInput!, $id: Int) {
  updateOneForm15CAC(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateForm15CacMutationFn = Apollo.MutationFunction<UpdateForm15CacMutation, UpdateForm15CacMutationVariables>;

/**
 * __useUpdateForm15CacMutation__
 *
 * To run a mutation, you first call `useUpdateForm15CacMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForm15CacMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForm15CacMutation, { data, loading, error }] = useUpdateForm15CacMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateForm15CacMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForm15CacMutation, UpdateForm15CacMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForm15CacMutation, UpdateForm15CacMutationVariables>(UpdateForm15CacDocument, options);
      }
export type UpdateForm15CacMutationHookResult = ReturnType<typeof useUpdateForm15CacMutation>;
export type UpdateForm15CacMutationResult = Apollo.MutationResult<UpdateForm15CacMutation>;
export type UpdateForm15CacMutationOptions = Apollo.BaseMutationOptions<UpdateForm15CacMutation, UpdateForm15CacMutationVariables>;
export const CreateForm15CadDocument = gql`
    mutation createForm15CAD($data: Form15CADCreateInput!) {
  createOneForm15CAD(data: $data) {
    id
  }
}
    `;
export type CreateForm15CadMutationFn = Apollo.MutationFunction<CreateForm15CadMutation, CreateForm15CadMutationVariables>;

/**
 * __useCreateForm15CadMutation__
 *
 * To run a mutation, you first call `useCreateForm15CadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateForm15CadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createForm15CadMutation, { data, loading, error }] = useCreateForm15CadMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateForm15CadMutation(baseOptions?: Apollo.MutationHookOptions<CreateForm15CadMutation, CreateForm15CadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateForm15CadMutation, CreateForm15CadMutationVariables>(CreateForm15CadDocument, options);
      }
export type CreateForm15CadMutationHookResult = ReturnType<typeof useCreateForm15CadMutation>;
export type CreateForm15CadMutationResult = Apollo.MutationResult<CreateForm15CadMutation>;
export type CreateForm15CadMutationOptions = Apollo.BaseMutationOptions<CreateForm15CadMutation, CreateForm15CadMutationVariables>;
export const DeleteForm15CadDocument = gql`
    mutation deleteForm15CAD($id: Int) {
  deleteOneForm15CAD(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteForm15CadMutationFn = Apollo.MutationFunction<DeleteForm15CadMutation, DeleteForm15CadMutationVariables>;

/**
 * __useDeleteForm15CadMutation__
 *
 * To run a mutation, you first call `useDeleteForm15CadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForm15CadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForm15CadMutation, { data, loading, error }] = useDeleteForm15CadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForm15CadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForm15CadMutation, DeleteForm15CadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForm15CadMutation, DeleteForm15CadMutationVariables>(DeleteForm15CadDocument, options);
      }
export type DeleteForm15CadMutationHookResult = ReturnType<typeof useDeleteForm15CadMutation>;
export type DeleteForm15CadMutationResult = Apollo.MutationResult<DeleteForm15CadMutation>;
export type DeleteForm15CadMutationOptions = Apollo.BaseMutationOptions<DeleteForm15CadMutation, DeleteForm15CadMutationVariables>;
export const GetAllForm15CadsDocument = gql`
    query getAllForm15CADS($where: Form15CADWhereInput, $orderBy: [Form15CADOrderByWithRelationInput!], $skip: Int, $take: Int) {
  form15CADS(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    Beneficiary {
      id
      BenefeciaryName
      PAN
      Flat
      Locality
      Building
      Country
      State
      Street
      Country
      OtherCountry
      Pincode
      BusinessPlace
      BenefeciaryStatus
      BenefeciaryEmail
      BenefeciaryPhone
      RelatedParty
      Branch {
        id
        BranchName
      }
      Company {
        id
        CompanyName
      }
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    BankName
    BranchName
    Email
    PhoneNumber
    ResidentCountry
    CountryOfRemittance
    CountryOfRemittanceOther
    RemittanceCurrency
    OtherRemittanceCurrency
    AmountPayable
    ExchangeRate
    AmountPayableINR
    BankName
    BranchName
    BSRCode
    ProposedDate
    RemittanceNameOnDocument
    RemittanceNameOnDocumentOther
    PurposeCode
    SubCategory
    BankDetailId
    Beneficiary {
      id
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
  aggregateForm15CAD(where: $where) {
    _count {
      _all
    }
  }
}
    `;

/**
 * __useGetAllForm15CadsQuery__
 *
 * To run a query within a React component, call `useGetAllForm15CadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15CadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15CadsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllForm15CadsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15CadsQuery, GetAllForm15CadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15CadsQuery, GetAllForm15CadsQueryVariables>(GetAllForm15CadsDocument, options);
      }
export function useGetAllForm15CadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15CadsQuery, GetAllForm15CadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15CadsQuery, GetAllForm15CadsQueryVariables>(GetAllForm15CadsDocument, options);
        }
export type GetAllForm15CadsQueryHookResult = ReturnType<typeof useGetAllForm15CadsQuery>;
export type GetAllForm15CadsLazyQueryHookResult = ReturnType<typeof useGetAllForm15CadsLazyQuery>;
export type GetAllForm15CadsQueryResult = Apollo.QueryResult<GetAllForm15CadsQuery, GetAllForm15CadsQueryVariables>;
export const GetAllForm15cadForDdDocument = gql`
    query getAllForm15cadForDD($where: Form15CADWhereInput) {
  form15CADS(where: $where) {
    id
  }
}
    `;

/**
 * __useGetAllForm15cadForDdQuery__
 *
 * To run a query within a React component, call `useGetAllForm15cadForDdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15cadForDdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15cadForDdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllForm15cadForDdQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15cadForDdQuery, GetAllForm15cadForDdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15cadForDdQuery, GetAllForm15cadForDdQueryVariables>(GetAllForm15cadForDdDocument, options);
      }
export function useGetAllForm15cadForDdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15cadForDdQuery, GetAllForm15cadForDdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15cadForDdQuery, GetAllForm15cadForDdQueryVariables>(GetAllForm15cadForDdDocument, options);
        }
export type GetAllForm15cadForDdQueryHookResult = ReturnType<typeof useGetAllForm15cadForDdQuery>;
export type GetAllForm15cadForDdLazyQueryHookResult = ReturnType<typeof useGetAllForm15cadForDdLazyQuery>;
export type GetAllForm15cadForDdQueryResult = Apollo.QueryResult<GetAllForm15cadForDdQuery, GetAllForm15cadForDdQueryVariables>;
export const GetForm15CadByIdDocument = gql`
    query getForm15CADById($id: Int) {
  form15CAD(where: {id: $id}) {
    id
    RevokedToId
    RevokedFrom {
      id
    }
    RevokedToForm {
      id
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    RecipientName
    RecipientPAN
    Flat
    Building
    Street
    Locality
    City
    Pincode
    State
    Country
    BankName
    BranchName
    Email
    PhoneNumber
    ResidentCountry
    CountryOfRemittance
    CountryOfRemittanceOther
    RemittanceCurrency
    OtherRemittanceCurrency
    AmountPayable
    ExchangeRate
    AmountPayableINR
    BankName
    BranchName
    BSRCode
    ProposedDate
    ifsc
    AuthDealer
    RemittanceNameOnDocument
    RemittanceNameOnDocumentOther
    PurposeCode
    SubCategory
    BankDetailId
    Beneficiary {
      id
      Document {
        id
        fileId
        Tag
        title
        SpecifyTag
        file {
          path
        }
      }
    }
    Events {
      id
      status
      isLatest
      comments
      AckNumber
      UDIN
      createdAt
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
}
    `;

/**
 * __useGetForm15CadByIdQuery__
 *
 * To run a query within a React component, call `useGetForm15CadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForm15CadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForm15CadByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForm15CadByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetForm15CadByIdQuery, GetForm15CadByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForm15CadByIdQuery, GetForm15CadByIdQueryVariables>(GetForm15CadByIdDocument, options);
      }
export function useGetForm15CadByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForm15CadByIdQuery, GetForm15CadByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForm15CadByIdQuery, GetForm15CadByIdQueryVariables>(GetForm15CadByIdDocument, options);
        }
export type GetForm15CadByIdQueryHookResult = ReturnType<typeof useGetForm15CadByIdQuery>;
export type GetForm15CadByIdLazyQueryHookResult = ReturnType<typeof useGetForm15CadByIdLazyQuery>;
export type GetForm15CadByIdQueryResult = Apollo.QueryResult<GetForm15CadByIdQuery, GetForm15CadByIdQueryVariables>;
export const UpdateForm15CadDocument = gql`
    mutation updateForm15CAD($data: Form15CADUpdateInput!, $id: Int) {
  updateOneForm15CAD(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateForm15CadMutationFn = Apollo.MutationFunction<UpdateForm15CadMutation, UpdateForm15CadMutationVariables>;

/**
 * __useUpdateForm15CadMutation__
 *
 * To run a mutation, you first call `useUpdateForm15CadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForm15CadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForm15CadMutation, { data, loading, error }] = useUpdateForm15CadMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateForm15CadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForm15CadMutation, UpdateForm15CadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForm15CadMutation, UpdateForm15CadMutationVariables>(UpdateForm15CadDocument, options);
      }
export type UpdateForm15CadMutationHookResult = ReturnType<typeof useUpdateForm15CadMutation>;
export type UpdateForm15CadMutationResult = Apollo.MutationResult<UpdateForm15CadMutation>;
export type UpdateForm15CadMutationOptions = Apollo.BaseMutationOptions<UpdateForm15CadMutation, UpdateForm15CadMutationVariables>;
export const CreateForm15CbDocument = gql`
    mutation createForm15CB($data: Form15CBCreateInput!) {
  createOneForm15CB(data: $data) {
    id
  }
}
    `;
export type CreateForm15CbMutationFn = Apollo.MutationFunction<CreateForm15CbMutation, CreateForm15CbMutationVariables>;

/**
 * __useCreateForm15CbMutation__
 *
 * To run a mutation, you first call `useCreateForm15CbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateForm15CbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createForm15CbMutation, { data, loading, error }] = useCreateForm15CbMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateForm15CbMutation(baseOptions?: Apollo.MutationHookOptions<CreateForm15CbMutation, CreateForm15CbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateForm15CbMutation, CreateForm15CbMutationVariables>(CreateForm15CbDocument, options);
      }
export type CreateForm15CbMutationHookResult = ReturnType<typeof useCreateForm15CbMutation>;
export type CreateForm15CbMutationResult = Apollo.MutationResult<CreateForm15CbMutation>;
export type CreateForm15CbMutationOptions = Apollo.BaseMutationOptions<CreateForm15CbMutation, CreateForm15CbMutationVariables>;
export const DeleteForm15CbDocument = gql`
    mutation deleteForm15CB($id: Int) {
  deleteOneForm15CB(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteForm15CbMutationFn = Apollo.MutationFunction<DeleteForm15CbMutation, DeleteForm15CbMutationVariables>;

/**
 * __useDeleteForm15CbMutation__
 *
 * To run a mutation, you first call `useDeleteForm15CbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForm15CbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForm15CbMutation, { data, loading, error }] = useDeleteForm15CbMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForm15CbMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForm15CbMutation, DeleteForm15CbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForm15CbMutation, DeleteForm15CbMutationVariables>(DeleteForm15CbDocument, options);
      }
export type DeleteForm15CbMutationHookResult = ReturnType<typeof useDeleteForm15CbMutation>;
export type DeleteForm15CbMutationResult = Apollo.MutationResult<DeleteForm15CbMutation>;
export type DeleteForm15CbMutationOptions = Apollo.BaseMutationOptions<DeleteForm15CbMutation, DeleteForm15CbMutationVariables>;
export const GetAllForm15CbsDocument = gql`
    query getAllForm15CBS($where: Form15CBWhereInput, $orderBy: [Form15CBOrderByWithRelationInput!], $skip: Int, $take: Int) {
  form15CBS(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    Form15CAC {
      id
    }
    RequestId
    Beneficiary {
      id
      BenefeciaryName
      PAN
      Flat
      Locality
      Building
      Country
      State
      Street
      Country
      OtherCountry
      Pincode
      BusinessPlace
      BenefeciaryStatus
      BenefeciaryEmail
      BenefeciaryPhone
      RelatedParty
      Branch {
        id
        BranchName
      }
      Company {
        id
        CompanyName
      }
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    Flat
    Building
    Street
    Locality
    City
    State
    Country
    Pincode
    RemittanceCountry
    OtherRemittanceCountry
    RemittanceCurrency
    OtherRemittanceCurrency
    PayableAmountInForeign
    ExchangeRate
    PayableAmountINR
    BankName
    BranchName
    BSRCode
    ProposedDate
    RemittanceNameOnDocument
    OtherRemittanceNameOnDocument
    RBIPurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    IsRemittanceChargeableIndia
    ReasonRemittanceNotChargeable
    SectionOfActRemittanceCovered
    IncomeChargeableToTax
    TaxLiability
    DeterminingTaxAndLiability
    IncomeTaxRateOfTDS
    ChargeableAndReliefDTAA
    TaxResidencyCertificateObtained
    TaxResidencyCertificateMade
    CertificateDTAA
    CertificateArticleOfDTAA
    DTAATaxableIncome
    DTAATaxLiability
    IsWithPermanentEstablishment
    PermanentEstablishmentArticle
    PermanentEstablishmentRateOfTDS
    IsAccountOfBusinessIncome
    SuchIncomeLiableToTaxIN
    IfBasisOfTheRateOfDeduction
    NoReasonRelevantArticleDTAA
    IsRemittanceCapitalGains
    AmountOfCapitalGains
    AmountOfShortCapitalGains
    BasisOfTaxableIncome
    CapitalGainsRateOfTDS
    IsRemittanceCovered
    NatureOfRemittance
    TaxableInIndiaDTAA
    YesTaxableInIndiaDTAA
    NoTaxableInIndiaDTAA
    TransactionLengthPrice
    RateOfTDSIncomeTaxAct
    RateOfTDS
    AmountOfTDSInForeign
    AmountOfTDSInINR
    AmountAfterTDS
    DateOfDeduction
    AccountantName
    AccountantFirmName
    AccountantFlat
    AccountantBuilding
    AccountantStreet
    AccountantLocality
    AccountantCity
    AccountantState
    AccountantCountry
    AccountantPincode
    AccountantMembershipNumber
    AccountantRegistrationNumber
    BankDetailId
    Beneficiary {
      id
    }
    Events {
      id
      status
      isLatest
      comments
      createdAt
      CertificateDate
      AckNumber
      UDIN
      CreatedBy {
        id
        FirstName
        LastName
      }
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
  }
  aggregateForm15CB(where: $where) {
    _count {
      _all
    }
  }
}
    `;

/**
 * __useGetAllForm15CbsQuery__
 *
 * To run a query within a React component, call `useGetAllForm15CbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15CbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15CbsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllForm15CbsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15CbsQuery, GetAllForm15CbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15CbsQuery, GetAllForm15CbsQueryVariables>(GetAllForm15CbsDocument, options);
      }
export function useGetAllForm15CbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15CbsQuery, GetAllForm15CbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15CbsQuery, GetAllForm15CbsQueryVariables>(GetAllForm15CbsDocument, options);
        }
export type GetAllForm15CbsQueryHookResult = ReturnType<typeof useGetAllForm15CbsQuery>;
export type GetAllForm15CbsLazyQueryHookResult = ReturnType<typeof useGetAllForm15CbsLazyQuery>;
export type GetAllForm15CbsQueryResult = Apollo.QueryResult<GetAllForm15CbsQuery, GetAllForm15CbsQueryVariables>;
export const GetAllForm15cbForDdDocument = gql`
    query getAllForm15cbForDD($where: Form15CBWhereInput) {
  form15CBS(where: $where) {
    id
  }
}
    `;

/**
 * __useGetAllForm15cbForDdQuery__
 *
 * To run a query within a React component, call `useGetAllForm15cbForDdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllForm15cbForDdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllForm15cbForDdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllForm15cbForDdQuery(baseOptions?: Apollo.QueryHookOptions<GetAllForm15cbForDdQuery, GetAllForm15cbForDdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllForm15cbForDdQuery, GetAllForm15cbForDdQueryVariables>(GetAllForm15cbForDdDocument, options);
      }
export function useGetAllForm15cbForDdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllForm15cbForDdQuery, GetAllForm15cbForDdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllForm15cbForDdQuery, GetAllForm15cbForDdQueryVariables>(GetAllForm15cbForDdDocument, options);
        }
export type GetAllForm15cbForDdQueryHookResult = ReturnType<typeof useGetAllForm15cbForDdQuery>;
export type GetAllForm15cbForDdLazyQueryHookResult = ReturnType<typeof useGetAllForm15cbForDdLazyQuery>;
export type GetAllForm15cbForDdQueryResult = Apollo.QueryResult<GetAllForm15cbForDdQuery, GetAllForm15cbForDdQueryVariables>;
export const GetForm15CbByIdDocument = gql`
    query getForm15CBById($id: Int) {
  form15CB(where: {id: $id}) {
    id
    Form15CAC {
      id
    }
    RevokedToId
    RevokedFrom {
      id
    }
    RevokedToForm {
      id
    }
    Beneficiary {
      id
      BenefeciaryName
      PAN
      Flat
      Locality
      Building
      Country
      State
      Street
      Country
      OtherCountry
      Pincode
      BusinessPlace
      BenefeciaryStatus
      BenefeciaryEmail
      BenefeciaryPhone
      Company {
        id
        ClientApproval
      }
      Document {
        id
        fileId
        Tag
        title
        SpecifyTag
        file {
          path
        }
      }
    }
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    Flat
    Building
    Street
    Locality
    City
    State
    Country
    Pincode
    RemittanceCountry
    OtherRemittanceCountry
    RemittanceCurrency
    OtherRemittanceCurrency
    PayableAmountInForeign
    ExchangeRate
    PayableAmountINR
    BankName
    BranchName
    BSRCode
    ifsc
    AuthDealer
    ProposedDate
    RemittanceNameOnDocument
    OtherRemittanceNameOnDocument
    RBIPurposeCode
    SubCategory
    IsTaxPayableGrossedUp
    IsRemittanceChargeableIndia
    ReasonRemittanceNotChargeable
    SectionOfActRemittanceCovered
    IncomeChargeableToTax
    TaxLiability
    DeterminingTaxAndLiability
    IncomeTaxRateOfTDS
    ChargeableAndReliefDTAA
    TaxResidencyCertificateObtained
    TaxResidencyCertificateMade
    CertificateDTAA
    CertificateArticleOfDTAA
    DTAATaxableIncome
    DTAATaxLiability
    IsWithPermanentEstablishment
    PermanentEstablishmentArticle
    PermanentEstablishmentRateOfTDS
    IsAccountOfBusinessIncome
    SuchIncomeLiableToTaxIN
    IfBasisOfTheRateOfDeduction
    NoReasonRelevantArticleDTAA
    IsRemittanceCapitalGains
    AmountOfCapitalGains
    AmountOfShortCapitalGains
    BasisOfTaxableIncome
    CapitalGainsRateOfTDS
    IsRemittanceCovered
    NatureOfRemittance
    TaxableInIndiaDTAA
    YesTaxableInIndiaDTAA
    NoTaxableInIndiaDTAA
    IsRelatedParty
    TransactionLengthPrice
    RateOfTDSIncomeTaxAct
    RateOfTDS
    AmountOfTDSInForeign
    AmountOfTDSInINR
    AmountAfterTDS
    DateOfDeduction
    AccountantName
    AccountantFirmName
    AccountantFlat
    AccountantBuilding
    AccountantStreet
    AccountantLocality
    AccountantCity
    AccountantState
    AccountantCountry
    AccountantPincode
    AccountantMembershipNumber
    AccountantRegistrationNumber
    BankDetailId
    Beneficiary {
      id
    }
    Events {
      id
      status
      isLatest
      comments
      createdAt
      CertificateDate
      AckNumber
      UDIN
      CreatedBy {
        id
        FirstName
        LastName
      }
      Document {
        file {
          path
          filename
        }
      }
    }
    Document {
      id
      title
      fileId
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
    }
    RequestId
    Request {
      id
      Remarks
      createdAt
      updatedAt
      Status
      IsNewBeneficiary
      ProposedDate
      User {
        id
        FirstName
        LastName
      }
      Beneficiary {
        id
        BenefeciaryName
      }
    }
    CA {
      id
    }
  }
}
    `;

/**
 * __useGetForm15CbByIdQuery__
 *
 * To run a query within a React component, call `useGetForm15CbByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForm15CbByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForm15CbByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForm15CbByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetForm15CbByIdQuery, GetForm15CbByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForm15CbByIdQuery, GetForm15CbByIdQueryVariables>(GetForm15CbByIdDocument, options);
      }
export function useGetForm15CbByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForm15CbByIdQuery, GetForm15CbByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForm15CbByIdQuery, GetForm15CbByIdQueryVariables>(GetForm15CbByIdDocument, options);
        }
export type GetForm15CbByIdQueryHookResult = ReturnType<typeof useGetForm15CbByIdQuery>;
export type GetForm15CbByIdLazyQueryHookResult = ReturnType<typeof useGetForm15CbByIdLazyQuery>;
export type GetForm15CbByIdQueryResult = Apollo.QueryResult<GetForm15CbByIdQuery, GetForm15CbByIdQueryVariables>;
export const UpdateForm15CbDocument = gql`
    mutation updateForm15CB($data: Form15CBUpdateInput!, $id: Int) {
  updateOneForm15CB(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateForm15CbMutationFn = Apollo.MutationFunction<UpdateForm15CbMutation, UpdateForm15CbMutationVariables>;

/**
 * __useUpdateForm15CbMutation__
 *
 * To run a mutation, you first call `useUpdateForm15CbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForm15CbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForm15CbMutation, { data, loading, error }] = useUpdateForm15CbMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateForm15CbMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForm15CbMutation, UpdateForm15CbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForm15CbMutation, UpdateForm15CbMutationVariables>(UpdateForm15CbDocument, options);
      }
export type UpdateForm15CbMutationHookResult = ReturnType<typeof useUpdateForm15CbMutation>;
export type UpdateForm15CbMutationResult = Apollo.MutationResult<UpdateForm15CbMutation>;
export type UpdateForm15CbMutationOptions = Apollo.BaseMutationOptions<UpdateForm15CbMutation, UpdateForm15CbMutationVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($data: GroupCreateInput!) {
  createOneGroup(data: $data) {
    id
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($id: Int) {
  deleteOneGroup(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const GetAllGroupsDocument = gql`
    query getAllGroups($where: GroupWhereInput) {
  groups(where: $where) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    GroupName
    Flat
    Building
    Country
    City
    Street
    State
    Locality
    Pincode
  }
}
    `;

/**
 * __useGetAllGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGroupsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGroupsQuery, GetAllGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGroupsQuery, GetAllGroupsQueryVariables>(GetAllGroupsDocument, options);
      }
export function useGetAllGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGroupsQuery, GetAllGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGroupsQuery, GetAllGroupsQueryVariables>(GetAllGroupsDocument, options);
        }
export type GetAllGroupsQueryHookResult = ReturnType<typeof useGetAllGroupsQuery>;
export type GetAllGroupsLazyQueryHookResult = ReturnType<typeof useGetAllGroupsLazyQuery>;
export type GetAllGroupsQueryResult = Apollo.QueryResult<GetAllGroupsQuery, GetAllGroupsQueryVariables>;
export const GetAllGroupsForNavigationDocument = gql`
    query getAllGroupsForNavigation($where: GroupWhereInput) {
  groups(where: $where) {
    id
    GroupName
    Company {
      id
      CompanyName
      ClientApproval
      isActive
      Branch {
        id
        BranchName
        ClientApproval
        isActive
      }
    }
  }
}
    `;

/**
 * __useGetAllGroupsForNavigationQuery__
 *
 * To run a query within a React component, call `useGetAllGroupsForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGroupsForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGroupsForNavigationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllGroupsForNavigationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGroupsForNavigationQuery, GetAllGroupsForNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGroupsForNavigationQuery, GetAllGroupsForNavigationQueryVariables>(GetAllGroupsForNavigationDocument, options);
      }
export function useGetAllGroupsForNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGroupsForNavigationQuery, GetAllGroupsForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGroupsForNavigationQuery, GetAllGroupsForNavigationQueryVariables>(GetAllGroupsForNavigationDocument, options);
        }
export type GetAllGroupsForNavigationQueryHookResult = ReturnType<typeof useGetAllGroupsForNavigationQuery>;
export type GetAllGroupsForNavigationLazyQueryHookResult = ReturnType<typeof useGetAllGroupsForNavigationLazyQuery>;
export type GetAllGroupsForNavigationQueryResult = Apollo.QueryResult<GetAllGroupsForNavigationQuery, GetAllGroupsForNavigationQueryVariables>;
export const GetGroupByIdDocument = gql`
    query getGroupById($id: Int) {
  group(where: {id: $id}) {
    id
    createdAt
    updatedAt
    CreatedBy
    UpdatedBy
    GroupName
    Flat
    Building
    Country
    City
    Street
    State
    Locality
    Pincode
    Firm {
      id
    }
    Admin {
      id
      FirstName
      LastName
      Email
      isActive
    }
    Users {
      id
      FirstName
      LastName
      Email
      isActive
    }
  }
}
    `;

/**
 * __useGetGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
      }
export function useGetGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
        }
export type GetGroupByIdQueryHookResult = ReturnType<typeof useGetGroupByIdQuery>;
export type GetGroupByIdLazyQueryHookResult = ReturnType<typeof useGetGroupByIdLazyQuery>;
export type GetGroupByIdQueryResult = Apollo.QueryResult<GetGroupByIdQuery, GetGroupByIdQueryVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($data: GroupUpdateInput!, $id: Int) {
  updateOneGroup(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const CreateRequestDocument = gql`
    mutation createRequest($data: RequestCreateInput!) {
  createOneRequest(data: $data) {
    id
  }
}
    `;
export type CreateRequestMutationFn = Apollo.MutationFunction<CreateRequestMutation, CreateRequestMutationVariables>;

/**
 * __useCreateRequestMutation__
 *
 * To run a mutation, you first call `useCreateRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestMutation, { data, loading, error }] = useCreateRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequestMutation, CreateRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequestMutation, CreateRequestMutationVariables>(CreateRequestDocument, options);
      }
export type CreateRequestMutationHookResult = ReturnType<typeof useCreateRequestMutation>;
export type CreateRequestMutationResult = Apollo.MutationResult<CreateRequestMutation>;
export type CreateRequestMutationOptions = Apollo.BaseMutationOptions<CreateRequestMutation, CreateRequestMutationVariables>;
export const DeleteRequestDocument = gql`
    mutation deleteRequest($id: Int) {
  deleteOneRequest(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteRequestMutationFn = Apollo.MutationFunction<DeleteRequestMutation, DeleteRequestMutationVariables>;

/**
 * __useDeleteRequestMutation__
 *
 * To run a mutation, you first call `useDeleteRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequestMutation, { data, loading, error }] = useDeleteRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRequestMutation, DeleteRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRequestMutation, DeleteRequestMutationVariables>(DeleteRequestDocument, options);
      }
export type DeleteRequestMutationHookResult = ReturnType<typeof useDeleteRequestMutation>;
export type DeleteRequestMutationResult = Apollo.MutationResult<DeleteRequestMutation>;
export type DeleteRequestMutationOptions = Apollo.BaseMutationOptions<DeleteRequestMutation, DeleteRequestMutationVariables>;
export const GetAllRequestsDocument = gql`
    query getAllRequests($where: RequestWhereInput, $orderBy: [RequestOrderByWithRelationInput!], $skip: Int, $take: Int) {
  requests(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    createdAt
    updatedAt
    Status
    IsNewBeneficiary
    ProposedDate
    Remarks
    UserId
    GroupId
    CompanyId
    Comment
    User {
      id
      FirstName
      LastName
    }
    Document {
      id
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
      fileId
      title
    }
    Beneficiary {
      id
      BenefeciaryName
    }
    Form15CB {
      id
      Events {
        id
        status
        isLatest
      }
    }
  }
  aggregateRequest(where: $where) {
    _count {
      _all
    }
  }
}
    `;

/**
 * __useGetAllRequestsQuery__
 *
 * To run a query within a React component, call `useGetAllRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRequestsQuery, GetAllRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRequestsQuery, GetAllRequestsQueryVariables>(GetAllRequestsDocument, options);
      }
export function useGetAllRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRequestsQuery, GetAllRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRequestsQuery, GetAllRequestsQueryVariables>(GetAllRequestsDocument, options);
        }
export type GetAllRequestsQueryHookResult = ReturnType<typeof useGetAllRequestsQuery>;
export type GetAllRequestsLazyQueryHookResult = ReturnType<typeof useGetAllRequestsLazyQuery>;
export type GetAllRequestsQueryResult = Apollo.QueryResult<GetAllRequestsQuery, GetAllRequestsQueryVariables>;
export const GetAllRequestByIdDocument = gql`
    query getAllRequestById($id: Int) {
  request(where: {id: $id}) {
    id
    createdAt
    updatedAt
    Status
    IsNewBeneficiary
    ProposedDate
    Comment
    User {
      id
      FirstName
      LastName
    }
    Document {
      id
      Tag
      SpecifyTag
      file {
        id
        filename
        path
      }
      fileId
      title
    }
    Beneficiary {
      id
      BenefeciaryName
    }
    Form15CB {
      id
      Events {
        id
        status
        isLatest
      }
    }
  }
}
    `;

/**
 * __useGetAllRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetAllRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRequestByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllRequestByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRequestByIdQuery, GetAllRequestByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRequestByIdQuery, GetAllRequestByIdQueryVariables>(GetAllRequestByIdDocument, options);
      }
export function useGetAllRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRequestByIdQuery, GetAllRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRequestByIdQuery, GetAllRequestByIdQueryVariables>(GetAllRequestByIdDocument, options);
        }
export type GetAllRequestByIdQueryHookResult = ReturnType<typeof useGetAllRequestByIdQuery>;
export type GetAllRequestByIdLazyQueryHookResult = ReturnType<typeof useGetAllRequestByIdLazyQuery>;
export type GetAllRequestByIdQueryResult = Apollo.QueryResult<GetAllRequestByIdQuery, GetAllRequestByIdQueryVariables>;
export const RequestsByBeneficiaryIdDocument = gql`
    query requestsByBeneficiaryId($where: RequestWhereInput) {
  requests(where: $where) {
    id
    User {
      FirstName
      LastName
    }
    Form15CB {
      id
    }
  }
}
    `;

/**
 * __useRequestsByBeneficiaryIdQuery__
 *
 * To run a query within a React component, call `useRequestsByBeneficiaryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsByBeneficiaryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsByBeneficiaryIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRequestsByBeneficiaryIdQuery(baseOptions?: Apollo.QueryHookOptions<RequestsByBeneficiaryIdQuery, RequestsByBeneficiaryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestsByBeneficiaryIdQuery, RequestsByBeneficiaryIdQueryVariables>(RequestsByBeneficiaryIdDocument, options);
      }
export function useRequestsByBeneficiaryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestsByBeneficiaryIdQuery, RequestsByBeneficiaryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestsByBeneficiaryIdQuery, RequestsByBeneficiaryIdQueryVariables>(RequestsByBeneficiaryIdDocument, options);
        }
export type RequestsByBeneficiaryIdQueryHookResult = ReturnType<typeof useRequestsByBeneficiaryIdQuery>;
export type RequestsByBeneficiaryIdLazyQueryHookResult = ReturnType<typeof useRequestsByBeneficiaryIdLazyQuery>;
export type RequestsByBeneficiaryIdQueryResult = Apollo.QueryResult<RequestsByBeneficiaryIdQuery, RequestsByBeneficiaryIdQueryVariables>;
export const UpdateRequestDocument = gql`
    mutation updateRequest($data: RequestUpdateInput!, $id: Int) {
  updateOneRequest(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateRequestMutationFn = Apollo.MutationFunction<UpdateRequestMutation, UpdateRequestMutationVariables>;

/**
 * __useUpdateRequestMutation__
 *
 * To run a mutation, you first call `useUpdateRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestMutation, { data, loading, error }] = useUpdateRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequestMutation, UpdateRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequestMutation, UpdateRequestMutationVariables>(UpdateRequestDocument, options);
      }
export type UpdateRequestMutationHookResult = ReturnType<typeof useUpdateRequestMutation>;
export type UpdateRequestMutationResult = Apollo.MutationResult<UpdateRequestMutation>;
export type UpdateRequestMutationOptions = Apollo.BaseMutationOptions<UpdateRequestMutation, UpdateRequestMutationVariables>;
export const CreateUdinDocument = gql`
    mutation createUdin($data: UdinCreateInput!) {
  createOneUdin(data: $data) {
    id
  }
}
    `;
export type CreateUdinMutationFn = Apollo.MutationFunction<CreateUdinMutation, CreateUdinMutationVariables>;

/**
 * __useCreateUdinMutation__
 *
 * To run a mutation, you first call `useCreateUdinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUdinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUdinMutation, { data, loading, error }] = useCreateUdinMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUdinMutation(baseOptions?: Apollo.MutationHookOptions<CreateUdinMutation, CreateUdinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUdinMutation, CreateUdinMutationVariables>(CreateUdinDocument, options);
      }
export type CreateUdinMutationHookResult = ReturnType<typeof useCreateUdinMutation>;
export type CreateUdinMutationResult = Apollo.MutationResult<CreateUdinMutation>;
export type CreateUdinMutationOptions = Apollo.BaseMutationOptions<CreateUdinMutation, CreateUdinMutationVariables>;
export const GetAllUdinsDocument = gql`
    query getAllUdins {
  udins {
    id
    ca {
      FirstName
      LastName
    }
    firm {
      FirmName
    }
  }
}
    `;

/**
 * __useGetAllUdinsQuery__
 *
 * To run a query within a React component, call `useGetAllUdinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUdinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUdinsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUdinsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUdinsQuery, GetAllUdinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUdinsQuery, GetAllUdinsQueryVariables>(GetAllUdinsDocument, options);
      }
export function useGetAllUdinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUdinsQuery, GetAllUdinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUdinsQuery, GetAllUdinsQueryVariables>(GetAllUdinsDocument, options);
        }
export type GetAllUdinsQueryHookResult = ReturnType<typeof useGetAllUdinsQuery>;
export type GetAllUdinsLazyQueryHookResult = ReturnType<typeof useGetAllUdinsLazyQuery>;
export type GetAllUdinsQueryResult = Apollo.QueryResult<GetAllUdinsQuery, GetAllUdinsQueryVariables>;
export const GetUdinByIdDocument = gql`
    query getUdinById($id: Int) {
  udin(where: {id: $id}) {
    id
    cAFirmId
    userId
    udinLogin
    udinPass
    itLogin
    itPass
    pan
    firstField
    secondField
    thirdField
    stdDescription
    stdRemark
  }
}
    `;

/**
 * __useGetUdinByIdQuery__
 *
 * To run a query within a React component, call `useGetUdinByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUdinByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUdinByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUdinByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetUdinByIdQuery, GetUdinByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUdinByIdQuery, GetUdinByIdQueryVariables>(GetUdinByIdDocument, options);
      }
export function useGetUdinByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUdinByIdQuery, GetUdinByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUdinByIdQuery, GetUdinByIdQueryVariables>(GetUdinByIdDocument, options);
        }
export type GetUdinByIdQueryHookResult = ReturnType<typeof useGetUdinByIdQuery>;
export type GetUdinByIdLazyQueryHookResult = ReturnType<typeof useGetUdinByIdLazyQuery>;
export type GetUdinByIdQueryResult = Apollo.QueryResult<GetUdinByIdQuery, GetUdinByIdQueryVariables>;
export const UpdateUdinDocument = gql`
    mutation updateUdin($data: UdinUpdateInput!, $id: Int) {
  updateOneUdin(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateUdinMutationFn = Apollo.MutationFunction<UpdateUdinMutation, UpdateUdinMutationVariables>;

/**
 * __useUpdateUdinMutation__
 *
 * To run a mutation, you first call `useUpdateUdinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUdinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUdinMutation, { data, loading, error }] = useUpdateUdinMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUdinMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUdinMutation, UpdateUdinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUdinMutation, UpdateUdinMutationVariables>(UpdateUdinDocument, options);
      }
export type UpdateUdinMutationHookResult = ReturnType<typeof useUpdateUdinMutation>;
export type UpdateUdinMutationResult = Apollo.MutationResult<UpdateUdinMutation>;
export type UpdateUdinMutationOptions = Apollo.BaseMutationOptions<UpdateUdinMutation, UpdateUdinMutationVariables>;
export const SetPasswordDocument = gql`
    mutation setPassword($password: String!, $token: String!) {
  setPassword(password: $password, token: $token) {
    success
    message
  }
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($data: UserCreateInput!) {
  createOneUser(data: $data) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: Int) {
  deleteOneUser(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(Email: $email) {
    success
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetAllUsersDocument = gql`
    query getAllUsers {
  users {
    id
    createdAt
    updatedAt
    FirstName
    LastName
    Email
    Type
    Firm {
      FirmName
      id
    }
    Group {
      GroupName
      id
    }
    isActive
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetBasicUserByIdDocument = gql`
    query getBasicUserById($id: Int) {
  user(where: {id: $id}) {
    id
    FirstName
    LastName
    Type
  }
}
    `;

/**
 * __useGetBasicUserByIdQuery__
 *
 * To run a query within a React component, call `useGetBasicUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBasicUserByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetBasicUserByIdQuery, GetBasicUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicUserByIdQuery, GetBasicUserByIdQueryVariables>(GetBasicUserByIdDocument, options);
      }
export function useGetBasicUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicUserByIdQuery, GetBasicUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicUserByIdQuery, GetBasicUserByIdQueryVariables>(GetBasicUserByIdDocument, options);
        }
export type GetBasicUserByIdQueryHookResult = ReturnType<typeof useGetBasicUserByIdQuery>;
export type GetBasicUserByIdLazyQueryHookResult = ReturnType<typeof useGetBasicUserByIdLazyQuery>;
export type GetBasicUserByIdQueryResult = Apollo.QueryResult<GetBasicUserByIdQuery, GetBasicUserByIdQueryVariables>;
export const GetUserAccessesDocument = gql`
    query getUserAccesses($where: UserAccessWhereInput) {
  userAccesses(where: $where) {
    id
    Group {
      id
      GroupName
    }
    Company {
      id
      CompanyName
      isActive
    }
    Branch {
      id
      BranchName
      isActive
    }
    Role
    MembershipNumber
  }
}
    `;

/**
 * __useGetUserAccessesQuery__
 *
 * To run a query within a React component, call `useGetUserAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccessesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserAccessesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAccessesQuery, GetUserAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccessesQuery, GetUserAccessesQueryVariables>(GetUserAccessesDocument, options);
      }
export function useGetUserAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccessesQuery, GetUserAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccessesQuery, GetUserAccessesQueryVariables>(GetUserAccessesDocument, options);
        }
export type GetUserAccessesQueryHookResult = ReturnType<typeof useGetUserAccessesQuery>;
export type GetUserAccessesLazyQueryHookResult = ReturnType<typeof useGetUserAccessesLazyQuery>;
export type GetUserAccessesQueryResult = Apollo.QueryResult<GetUserAccessesQuery, GetUserAccessesQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($id: Int) {
  user(where: {id: $id}) {
    id
    createdAt
    updatedAt
    FirstName
    LastName
    Password
    Email
    Type
    Firm {
      FirmName
      id
    }
    Group {
      GroupName
      id
    }
    isActive
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUserForAccessDocument = gql`
    query getUserForAccess($where: UserWhereInput) {
  users(where: $where) {
    id
    FirstName
    LastName
    Email
    UserAccess {
      id
      GroupId
      CompanyId
      BranchId
      Role
      MembershipNumber
    }
  }
}
    `;

/**
 * __useGetUserForAccessQuery__
 *
 * To run a query within a React component, call `useGetUserForAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForAccessQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserForAccessQuery(baseOptions?: Apollo.QueryHookOptions<GetUserForAccessQuery, GetUserForAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForAccessQuery, GetUserForAccessQueryVariables>(GetUserForAccessDocument, options);
      }
export function useGetUserForAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForAccessQuery, GetUserForAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForAccessQuery, GetUserForAccessQueryVariables>(GetUserForAccessDocument, options);
        }
export type GetUserForAccessQueryHookResult = ReturnType<typeof useGetUserForAccessQuery>;
export type GetUserForAccessLazyQueryHookResult = ReturnType<typeof useGetUserForAccessLazyQuery>;
export type GetUserForAccessQueryResult = Apollo.QueryResult<GetUserForAccessQuery, GetUserForAccessQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($data: UserUpdateInput!, $id: Int) {
  updateOneUser(data: $data, where: {id: $id}) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ValidateConfirmTokenDocument = gql`
    mutation validateConfirmToken($token: String!) {
  validateConfirmToken(token: $token) {
    isValid
    message
  }
}
    `;
export type ValidateConfirmTokenMutationFn = Apollo.MutationFunction<ValidateConfirmTokenMutation, ValidateConfirmTokenMutationVariables>;

/**
 * __useValidateConfirmTokenMutation__
 *
 * To run a mutation, you first call `useValidateConfirmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateConfirmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateConfirmTokenMutation, { data, loading, error }] = useValidateConfirmTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateConfirmTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateConfirmTokenMutation, ValidateConfirmTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateConfirmTokenMutation, ValidateConfirmTokenMutationVariables>(ValidateConfirmTokenDocument, options);
      }
export type ValidateConfirmTokenMutationHookResult = ReturnType<typeof useValidateConfirmTokenMutation>;
export type ValidateConfirmTokenMutationResult = Apollo.MutationResult<ValidateConfirmTokenMutation>;
export type ValidateConfirmTokenMutationOptions = Apollo.BaseMutationOptions<ValidateConfirmTokenMutation, ValidateConfirmTokenMutationVariables>;